const messagesDE = {
    code: "de",
    messages: {
        zoho: {
            SETTING_GROUP: "Einstellungen",
            usermapping: "Benutzerzuordnung",
        },
        chatWindow: {
            descending: "Absteigend",
            ascending: "Aufsteigend",
            filterTable:"Filtern",
            thereIsNoChatContent: "Kein Chat-Inhalt verfügbar.",
            thereIsNoChatContentDsc: "Hier können Sie den Chat-Inhalt anzeigen und Nachrichten senden.",
            interactions: "Interaktionen:",
            departments: "Abteilungen",
            channels: "Kanäle",
            date: "Datum",
            lastChatStatus: "Letzter Chat-Status",
            all: "Alle",
            queued: "Warteschlange",
            open: "Offen",
            closed: "Geschlossen",
            private: "Privat",
            chatbot: "Chatbot",
            lostMissed: "Verloren / Verpasst",
            interaction: "Interaktion",
            myActiveInbox: "Mein aktiver Posteingang",
            activeQueueInbox: "Aktiv + Warteschlange Posteingang",
            chatbotActiveInbox: "Chatbot aktiver Posteingang",
            myDepartmentsActiveInbox: "Aktiver Posteingang meiner Abteilungen",
            notInteractedYesterday: "Gestern keine Interaktionen",
            queueInbox: "Warteschlange Posteingang",
            whatsappActiveInbox: "WhatsApp aktiver Posteingang",
            socialMediaActiveInbox: "Social Media aktiver Posteingang",
            missedThisMonth: "Diesen Monat verpasste Chats",
            chooseAFileOrDragItHere: "Wählen Sie eine Datei oder ziehen Sie sie hierher!",
            watching: "Beobachten",
            selectFilter: "Filter auswählen",
            clearAll: "Alles löschen",
            me: "Ich",
            today: "Heute",
            yesterday: "Gestern",
            thisWeek: "Diese Woche",
            lastWeek: "Letzte Woche",
            last7Days: "Letzte 7 Tage",
            last30Days: "Letzte 30 Tage",
            thisMonth: "Diesen Monat",
            lastMonth: "Letzten Monat",
            last24h: "Letzte 24 Stunden",
            custom: "Benutzerdefiniert",
            startMessage: "Nachricht starten",
            goToAgentReport: "Zum Agentenbericht gehen",
            agentDetail: "Agenten-Detail",
            agentList: "Agentenliste",
            selectedFilter: "Ausgewählter Filter",
            groupBy: "Gruppieren",
            none: "Keine Gruppe",
            agent: "Vertreter",
            department: "Abteilung",
            tag: "Tag",
            website: "Website",
            channel: "Kanal",
            platform: "Plattform",
            answerStatus: "Antwortstatus",
            sortBy: "Sortieren",
            lastPostAbove: "Letzter Beitrag oben",
            newChatsAbove: "Neue Chats oben",
            oldChatsAbove: "Alte Chats oben",
            live: "Live",
            systemStatus: "Systemstatus",
            refresh: "Aktualisieren",
            close: "Schließen",
            totalCustomers: "Gesamtkunden",
            totalAnswered: "Insgesamt beantwortet",
            waitingAnswer: "Wartet auf Antwort",
            totalAgentInChat: "Gesamtzahl der Agenten im Chat",
            onlineAgentCount: "Anzahl der Online-Agenten",
            totalCustomer: "Gesamtkunde",
            answered: "Beantwortet",
            unanswered: "Unbeantwortet",
            noContactWasFoundMatchingTheCurrentFilters:
                "Es wurde kein Kontakt gefunden, der den aktuellen Filtern entspricht.",
            you: "Du",
            others: "Andere",
            queue: "Warteschlange",
            chatbotContact: "Chatbot",
            closedContact: "Geschlossen",
            myInteractions: "Meine Interaktionen",
            special: "Spezial",
            allInteractions: "Alle Kontakte",
            waiting: "Ausstehend",
            departmentToWhichItIsAffiliated: "Abteilung, der es zugeordnet ist",
            owner: "Besitzer",
        },
        chat: {
            inbox: "Posteingang",
            layouts: {
                chat: "Chat-Layout",
                table: "Tabellen-Layout",
                kanban: "Kanban-Layout",
            },
            filters: {
                allContacts: "Alle Kontakte",
                myInbox: "Mein Posteingang",
                myContacts: "Meine Kontakte",
                missed: "Verpasst",
                unanswered: "Unbeantwortet",
                unassigned: "Nicht Zugewiesen",
                chatbot: "Chatbot",
            },
            groups: {
                views: "Ansichten",
                customFilters: "Benutzerdefinierte Filter",
                team: "Team",
                contacts: "Kontakte",
                system: "System",
            },
            gridContactList: {
                emptyConversationsTitle: "Kein Chat gefunden",
                emptyConversationsDescription: "Sie haben noch keinen aktiven Chat. Sie können einen neuen Chat von der Kundenseite starten.",
                markAsUnanswered: "Als unbeantwortet markieren",
                markAsAnswered: "Als beantwortet markieren",
                removeVIP: "VIP entfernen",
                markAsVIP: "Als VIP markieren",
                markAsRead: "Als gelesen markieren",
                markAsUnread: "Als ungelesen markieren",
                closeChat: "Chat schließen",
                markedAsAnswered: "Als beantwortet markiert",
                markedAsUnanswered: "Als unbeantwortet markiert",
                operationFailed: "Vorgang fehlgeschlagen",
                markedAsVIP: "Als VIP markiert",
                vipRemoved: "VIP entfernt",
                markedAsUnread: "Als ungelesen markiert",
                markedAsRead: "Als gelesen markiert",
                confirmCloseChat: "Sind Sie sicher, dass Sie den Chat beenden möchten?",
                chatClosed: "Chat geschlossen",
            },
            gridContactListToolBar: {
                chatStatus: "Chat-Status",
                sortBy: "Sortieren nach",
                all: "Alle",
                open: "Offen",
                closed: "Geschlossen",
                allStatus: "Alle",
                lastActivity: "Letzte Aktivität",
                createdAt: "Erstellt am",
                unknown: "Unbekannt",
            },
            contactDetail: {
                removeVIPTooltip: "VIP entfernen",
                markAsVIPTooltip: "Als VIP markieren (VIP-markierte Benutzer werden in Chats immer oben angezeigt).",
                customerOwnership: "Kundenbesitz",
                ownershipDescription: "Wenn der Kundenbesitz zugewiesen wird, können nur der Besitzer und Volladministratoren ihn sehen",
                unowned: "Nicht zugewiesen",
                assignToMe: "Mir zuweisen",
                removeOwnership: "Besitz entfernen",
                dragPlaceholder: "Hierher verschieben",
                currentConversationDepartment: "Aktuelles Gesprächsdepartement",
                pastInteractionDepartments: "Vergangene Interaktionsdepartements",
                createdAt: "Erstellt am",
                updatedAt: "Aktualisiert am",
                zohoSync: "Zoho-Synchronisierung",
                zohoSyncQuestion: "Möchten Sie Kontaktänderungsvorgänge auch in Zoho durchführen?",
                basicInfo: "Kontaktinformationen",
                loginInfo: "Kontaktformularinformationen",
                profileFields: "Profilfelder",
                systemInfo: "Systeminformationen",
            },
            contactDetailItem: {
                removeOwnership: "Besitz entfernen",
                assignOwnershipToMe: "Besitz mir zuweisen",
                vipCustomer: "VIP-Kunde",
                contentCopiedSuccess: "Inhalt erfolgreich kopiert!",
                invalidEmail: "Ungültige E-Mail-Adresse!",
                invalidValue: "Ungültiger Wert!",
            },
            filtersSection: {
                addFilter: "Filter Hinzufügen",
                all: "Alle",
                open: "Offen",
                closed: "Geschlossen",
                relevance: "Relevanz",
                lastActivityNewest: "Neueste Aktivität",
                lastActivityOldest: "Älteste Aktivität",
                noParticipant: "Kein Teilnehmer",
                ownershipFilter: "Besitzfilter",
                metaReferral: "Meta-Verweis",
                userStatus: "Benutzerstatus",
                unowned: "Nicht zugewiesen",
                fromAds: "Von Werbung",
                notFromAds: "Nicht von Werbung",
                blockedUsers: "Blockierte Benutzer",
                unblockedUsers: "Nicht blockierte Benutzer",
                unread: "Ungelesen",
                read: "Gelesen",
                yes: "Ja",
                no: "Nein",
                answered: "Beantwortet",
                unanswered: "Unbeantwortet",
                active: "Aktiv",
                lost: "Verloren",
                new: "Neu",
                chatbot: "Chatbot",
                closedStatus: "Geschlossen",
                platform: "Plattform",
                channel: "Kanal",
                department: "Abteilung",
                tag: "Tag",
                participant: "Teilnehmer",
                ownership: "Besitz",
                lastActivityTime: "Letzte Aktivitätszeit",
                fullName: "Vollständiger Name",
                email: "E-Mail",
                phone: "Telefon",
                vipCustomer: "VIP-Kunde",
                hasVIP: "Hat VIP",
                noVIP: "Kein VIP",
                operatingSystem: "Betriebssystem",
                browser: "Browser",
                ipAddress: "IP-Adresse",
                visitingPage: "Besuchte Seite",
                adInteraction: "Werbeinteraktion",
                blockedStatus: "Blockierungsstatus",
                connectionTime: "Verbindungszeit",
                createdAt: "Erstellt am",
                updatedAt: "Aktualisiert am",
                readStatus: "Lesestatus",
                missedChat: "Verpasster Chat",
                answerStatus: "Antwortstatus",
                lastConversationStatus: "Letzter Gesprächsstatus",
                lastTriggerState: "Letzter Trigger-Status",
                type: "Typ",
                name: "Name",
                enterTriggerName: "Trigger-Name eingeben...",
                zohoInfo: "Zoho-Info",
                id: "ID",
                enterContactOrLeadId: "Kontakt- oder Lead-ID eingeben...",
                broadcastMessage: "Broadcast-Nachricht",
                today: "Heute",
                yesterday: "Gestern",
                thisWeek: "Diese Woche",
                lastWeek: "Letzte Woche",
                last7Days: "Letzte 7 Tage",
                last30Days: "Letzte 30 Tage",
                thisMonth: "Diesen Monat",
                lastMonth: "Letzten Monat",
            },
            filterChip: {
                operator: "Operator:",
                enterText: "Text eingeben...",
                enterNumber: "Zahl eingeben...",
                type: "Typ",
                value: "Wert",
                enterValue: "Wert eingeben...",
                addFilter: "Filter Hinzufügen",
                equals: "Gleich",
                contains: "Enthält",
                startsWith: "Beginnt mit",
                endsWith: "Endet mit",
                greaterThan: "Größer als",
                lessThan: "Kleiner als",
                greaterThanOrEqual: "Größer oder gleich",
                lessThanOrEqual: "Kleiner oder gleich",
                between: "Zwischen",
                custom: "Benutzerdefiniert",
                select: "Auswählen",
            },
            filterPanel: {
                backToChat: "Zurück zur Chat-Ansicht",
                publicFilter: "Öffentlicher Filter",
                privateFilter: "Privater Filter",
                editFilterName: "Filtername bearbeiten",
                contactsFound: " Kontakte gefunden",
                enterFilterName: "Filtername eingeben",
                filterSuggestions: "Filtervorschläge",
                private: "Privat",
                public: "Öffentlich",
                createFilter: "Filter Erstellen",
                update: "Aktualisieren",
                changeToPublic: "Auf Öffentlich ändern",
                changeToPrivate: "Auf Privat ändern",
                delete: "Löschen",
                clearSearch: "Suche löschen",
                previous: "Zurück",
                next: "Weiter",
                searchTerm: "Suchbegriff:",
                whichFieldToSearch: "In welchem Feld möchten Sie suchen?",
                contactId: "Kontakt-ID",
                conversationId: "Konversations-ID",
                noSearchAllFields: "Nein, in allen Feldern suchen",
                yesSearchOnlyField: "Ja, nur in {field} suchen",
                search: "Suchen",
                allFields: "Alle Felder",
                fullname: "Vollständiger Name",
                email: "E-Mail",
                whatsappNumber: "WhatsApp-Nummer",
                phone: "Telefon",
                contactIdField: "Kontakt-ID",
                conversationIdField: "Konversations-ID",
                searchAllFieldsPlaceholder: "Geben Sie ein, wonach Sie in allen Feldern suchen möchten",
                searchFullnamePlaceholder: "Geben Sie ein, wonach Sie nach vollständigem Namen suchen möchten",
                searchEmailPlaceholder: "Geben Sie ein, wonach Sie nach E-Mail suchen möchten",
                searchWhatsappPlaceholder: "Geben Sie ein, wonach Sie nach WhatsApp suchen möchten",
                searchPhonePlaceholder: "Geben Sie ein, wonach Sie nach Telefon suchen möchten",
                searchContactIdPlaceholder: "Geben Sie die Kontakt-ID ein, nach der Sie suchen möchten",
                searchConversationIdPlaceholder: "Geben Sie die Konversations-ID ein, nach der Sie suchen möchten",
                searchPlaceholder: "Suchen",
                edited: " (Bearbeitet)",
                unnamedFilter: "Unbenannter Filter",
                all: "Alle",
                open: "Offen",
                closed: "Geschlossen",
                unknown: "Unbekannt",
                filterUpdatedSuccess: "Filter erfolgreich aktualisiert",
                filterUpdatedDescription: 'Filter "{name}" wurde aktualisiert.',
                filterUpdateFailed: "Filter konnte nicht aktualisiert werden",
                filterUpdateError: "Beim Aktualisieren des Filters ist ein Fehler aufgetreten.",
                filterSavedSuccess: "Filter erfolgreich gespeichert",
                filterSavedDescription: 'Der Name "{createName}" wurde bereits verwendet. Filter wurde als "{filterName}" erstellt.',
                filterCreatedDescription: 'Filter "{filterName}" wurde erstellt.',
                filterSaveFailed: "Filter konnte nicht gespeichert werden",
                filterSaveError: "Beim Speichern des Filters ist ein Fehler aufgetreten.",
                aiFilterCreatedSuccess: "AI-Filter erfolgreich erstellt",
                aiFilterCreatedDescription: 'Der Name "{createName}" wurde bereits verwendet. Filter wurde als "{filterName}" erstellt und angewendet.',
                aiFilterCreatedApplied: 'Filter "{filterName}" wurde erstellt und angewendet.',
                aiFilterCreateFailed: "Filter konnte nicht erstellt werden",
                aiFilterCreateError: "Beim Erstellen des AI-Filters ist ein Fehler aufgetreten.",
                phoneDetected: "Telefonnummer erkannt",
                emailDetected: "E-Mail-Adresse erkannt",
                idFormatDetected: "ID-Format erkannt",
                contactIdDetected: "Kontakt-ID erkannt",
                conversationIdDetected: "Konversations-ID erkannt",
                searchMode: "Suchmodus",
                phoneDetectedMessage: "Der eingegebene Wert sieht wie eine Telefonnummer aus. Möchten Sie nur im Telefonnummerfeld suchen?",
                emailDetectedMessage: "Der eingegebene Wert sieht wie eine E-Mail-Adresse aus. Möchten Sie nur im E-Mail-Feld suchen?",
                idFormatDetectedMessage: "Der eingegebene Wert sieht wie ein ID-Format aus. In welchem Feld möchten Sie suchen?",
                phoneField: "Telefonnummerfeld",
                emailField: "E-Mail-Feld",
                contactIdField: "Kontakt-ID-Feld",
                conversationIdFieldName: "Konversations-ID-Feld",
                idField: "ID-Feld",
                deleteFilter: "Filter Löschen",
                deleteFilterConfirm: 'Sind Sie sicher, dass Sie den Filter "{name}" löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
                delete: "Löschen",
                cancel: "Abbrechen",
                filterDeletedSuccess: "Filter erfolgreich gelöscht",
                filterDeletedDescription: 'Filter "{name}" wurde gelöscht.',
                filterDeleteFailed: "Filter konnte nicht gelöscht werden",
                filterDeleteError: "Beim Löschen des Filters ist ein Fehler aufgetreten.",
                visibilityUpdatedSuccess: "Sichtbarkeit erfolgreich aktualisiert",
                visibilityUpdatedDescription: 'Filter wurde auf "{visibility}" gesetzt.',
                visibilityUpdateFailed: "Sichtbarkeit konnte nicht aktualisiert werden",
                visibilityUpdateError: "Beim Aktualisieren des Filters ist ein Fehler aufgetreten.",
                publicVisibility: "öffentlich",
                privateVisibility: "privat",
            },
            contactList: {
                noContactsFound: "Keine Kontakte gefunden",
                unknownContact: "Unbekannter Kontakt",
                unknown: "Unbekannt",
                fullName: "Vollständiger Name",
                platform: "Plattform",
                email: "E-Mail",
                phone: "Telefon",
                tags: "Tags",
                status: "Status",
                lastActivity: "Letzte Aktivität",
                answerStatus: "Antwortstatus",
                channel: "Kanal",
                owner: "Besitzer",
                vip: "VIP",
                connectionTime: "Verbindungszeit",
                unread: "Ungelesen",
                departments: "Abteilungen",
                operatingSystem: "Betriebssystem",
                browser: "Browser",
                countryCity: "Land - Stadt",
                ipAddress: "IP-Adresse",
                visitingPage: "Besuchte Seite",
                lastConversationDate: "Datum der letzten Unterhaltung",
                blockedStatus: "Blockierungsstatus",
                lastConversationParticipants: "Teilnehmer der letzten Unterhaltung",
                preferredLanguage: "Bevorzugte Sprache",
                createdAt: "Erstellt am",
                updatedAt: "Aktualisiert am",
                broadcastStatus: "Broadcast-Status",
                broadcastAnswer: "Broadcast-Antwort",
                zohoContactId: "Zoho Kontakt-ID",
                zohoLeadId: "Zoho Lead-ID",
                profileFields: "Profilfelder",
                closed: "Geschlossen",
                open: "Offen",
                unknownStatus: "Unbekannt",
                answered: "Beantwortet",
                unanswered: "Unbeantwortet",
                unreadStatus: "Ungelesen",
                readStatus: "Gelesen",
                vipStatus: "VIP",
                normal: "Normal",
                blocked: "Blockiert",
                today: "Heute",
                yesterday: "Gestern",
                enqueued: "In Warteschlange",
                sent: "Gesendet",
                delivered: "Zugestellt",
                read: "Gelesen",
                deleted: "Gelöscht",
                failed: "Fehlgeschlagen",
                replied: "Geantwortet",
                notReplied: "Nicht geantwortet",
                jsonProperty: "JSON-Eigenschaft",
                jsonCopiedSuccess: "JSON-Inhalt erfolgreich kopiert!",
            },
        },
        form: {
            title: {
                titleSettings: "Titel-Einstellungen",
                fullNameSettings: "Einstellungen für den vollständigen Namen",
                emailSettings: "Einstellungen für E-Mail",
                addressSettings: "Adresseinstellungen",
                phoneSettings: "Telefoneinstellungen",
                datePickerSettings: "Datumsauswahl-Einstellungen",
                shortTextSettings: "Einstellungen für kurzen Text",
                longTextSettings: "Einstellungen für langen Text",
                dropDownListSettings: "Einstellungen für Dropdown-Liste",
                singleChoiceSettings: "Einstellungen für Einzelauswahl",
                multipleSelectionSettings: "Einstellungen für Mehrfachauswahl",
                numberSettings: "Zahleneinstellungen",
                hourSettings: "Stundeneinstellungen",
                spinnerSettings: "Spinner-Einstellungen",
                sendSettings: "Sende-Einstellungen",
                starRatingSettings: "Sternebewertungseinstellungen",
                ratingScaleSettings: "Bewertungsskala-Einstellungen",
                separationElementSettings: "Einstellungen für Trennelement",
                fileUploadSettings: "Einstellungen für Datei-Upload",
                imageSettings: "Bildeinstellungen",
            },
            lineColor: "Linienfarbe",
            separatorColorInfo: "Wählen Sie die Farbe des Trenners oder geben Sie sie ein (z. B. #RRGGBB)",
            separatorHeight: "Trennhöhe",
            separatorHeightInfo: "Geben Sie die Höhe des Trenners ein",
            bottomSpace: "Unterer Abstand",
            bottomSpaceInfo: "Fügen Sie unter dem Trennzeichen Abstand hinzu",
            topSpace: "Oberer Abstand",
            topSpaceInfo: "Fügen Sie über dem Trennzeichen Abstand hinzu",
            sideSpace: "Seitenabstand",
            sideSpaceInfo: "Fügen Sie Abstand links und rechts vom Trenner hinzu",
            onlyImageUpload: "Sie können nur ein Bild hochladen!",
            imageSizeLimit: "Die Größe Ihres Bildes darf maximal 5 MB betragen!",
            image: "Bild",
            size: "Größe",
            width: "Breite",
            height: "Höhe",
            imageAlignment: "Bildausrichtung",
            wide: "Weit",
            small: "Klein",
            textAlignment: "Textausrichtung",
            chooseHorizontalAlignment: "Wählen Sie, wie dieser Titel horizontal ausgerichtet werden soll.",
            headerSize: "Überschriftengröße",
            addSmallTextBelowHeader: "Fügen Sie einen kleineren Text unterhalb der Überschrift hinzu",
            subHeaderText: "Unterüberschrift Text",
            subLabel1: "Unterbezeichner(1)",
            subLabel2: "Unterbezeichner(2)",
            validPhoneNumber: "Bitte geben Sie eine gültige Telefonnummer ein",
            masked: "Maskiert",
            copyField: "Feld kopieren",
            copyFieldDescription:
                "Erstellen Sie eine Kopie dieses Feldes und behalten Sie alle gespeicherten Einstellungen bei",
            enterQuestion: "Stellen Sie eine Frage",
            notRequired: "Nicht erforderlich",
            addDescriptionBelowField: "Fügen Sie eine kurze Beschreibung unter dem Feld hinzu",
            setDefault: "Als Standard festlegen",
            pleaseSelect: "Bitte wählen Sie",
            placeholder: "Platzhalter",
            required: "Erforderlich",
            fieldEmptyError: "Das Formular darf nicht gesendet werden, wenn dieses Feld leer ist",
            subLabels: "Unterbeschriftungen",
            addressLine1: "Adresszeile 1",
            addressLine2: "Adresszeile 2",
            postalCode: "Postleitzahl",
            stateProvince: "Bundesland / Region",
            chooseLabelAlignment: "Wählen Sie, wie der Etikettentext horizontal ausgerichtet werden soll",
            right: "RECHTS",
            left: "LINKS",
            top: "OBEN",
            labelAlignment: "Etikettenausrichtung",
            fieldLabel: "Feldbezeichnung",
            read: "Gelesen",
            itemsPerPage: "Einträge/Seite",
            downloadAllDataAsPDF: "Alle Daten als PDF herunterladen",
            downloadAllDataAsExcel: "Alle Daten als Excel herunterladen",
            downloadSelectedDataAsPDF: "Ausgewählte Daten als PDF herunterladen",
            downloadSelectedDataAsExcel: "Ausgewählte Daten als Excel herunterladen",
            selectItemToViewDetails: "Wählen Sie ein Element aus, um Details anzuzeigen.",
            deleteFormConfirm:
                "Wenn Sie dieses Formular löschen, werden alle damit verbundenen Daten dauerhaft gelöscht. Sind Sie sicher, dass Sie fortfahren möchten?",
            redicetFormAnswer: "FORWARD FORM ANSWERS",
            redicetFormAnswerDesc:
                "Wenn Sie Formularantworten an das Ticketsystem weiterleiten, stellen Sie sicher, dass Sie eine Telefonnummer oder E-Mail-Adresse vom Benutzer im Formular anfordern. Diese Informationen sind wichtig für eine schnellere und effektivere Kommunikation mit dem Benutzer.",
            redicetFormAnswerDesc2: "Formularantworten werden als Tickets an das System weitergeleitet",
            rediectAnswersToTicket: "Eingehende Antworten auf Ticket umleiten",
            errorTicketMode: "Fehler beim Aktualisieren des Ticketmodus:",
            formView: "Formular anzeigen",
            formEdit: "Formular aktualisieren",
            totalResponse: "Antwort insgesamt",
            totalUnreadResponse: "Ungelesene Antworten insgesamt",
            totalReadResponse: "Gesamte Leseantwort",
            totalArchivedResponse: "Gesamte archivierte Antwort",
            singleChoice: "Einzelne Wahl",
            _delete: "Löschen",
            inbox: "Posteingang",
            edit: "bearbeiten",
            forms: "Formulare",
            formsDesc: "Hier können Sie Ihre Formulare verwalten.",
            createaForm: "Formular erstellen",
            allForms: "alle Formen",
            formPublish: {
                shareFast: "SCHNELL TEILEN",
                shareFastDesc: "Direkter Formular-Link und Social Sharing",
                add: "ADD",
                addDesc: "Verschiedene Optionen zum Einbetten von Webseiten",
                assignForm: "FORMULAR ZUWEISEN",
                assignFormDesc: "Weisen Sie Ihre Formulare anderen zu",
                emails: "E-MAILS",
                emailsDesc: "Erinnerungen und sofortige Freigabe",
                prefill: "PREFILL",
                prefillDesc: "Formulare vorausgefüllt",
                pdf: "PDF",
                pdfDesc: "Ausfüllbares PDF herunterladen",
                platforms: "PLATFORMS",
                platformsDesc: "Veröffentlichungsoptionen für Drittanbieter",
                linkToYour: "LINK-ADRESSE IHRES FORMULARS",
                linkToYourDesc:
                    "Ihr Formular wurde sicher veröffentlicht und steht unter dieser Adresse zur Verwendung bereit.",
                shareWithLink: "MIT LINK TEILEN",
                publicForm: "Öffentliches Formular",
                copyLink: "LINK KOPIEREN",
                openInNewTab: "IN NEUER REGISTERKARTE ÖFFNEN",
                linkCopied: "Link Kopiert",
                codeCopied: "Kopierter Code",
                iframe: "IFRAME",
                iframeDesc: "Fügen Sie das Formular mit iFrame zu Ihrer Seite hinzu",
                openWindow: "OFFENES FENSTER",
                openWindowDesc: "Link zu einem Pop-up-Formular",
                formAddDesc:
                    "Kopieren Sie dieses Snippet, fügen Sie es in Ihren Code ein und platzieren Sie Ihr Formular auf Ihrer Website.",
            },
            formSettings: {
                enterNameForm: "Geben Sie einen Namen für dieses Formular ein",
                selectStatusForm: "Wählen Sie den Status Ihres Formulars",
                disabled: "Behinderte",
                disableSpecifiedTime: "Deaktivieren zu einer bestimmten Zeit",
                disableFormResponse: "Deaktivieren, wenn das Formularantwortlimit erreicht ist",
                pageShownAfterForm: "Die Seite, die nach dem Absenden des Formulars angezeigt wird",
                formNotFound: "Formular nicht gefunden.",
                errorLoadingform: "Beim Laden des Formulars ist ein Fehler aufgetreten.",
                formUpdated: "Der Formulartitel wurde erfolgreich aktualisiert.",
                formErrorUpdated: "Beim Aktualisieren des Formulartitels ist ein Fehler aufgetreten",
                formSettings: "FORM EINSTELLUNGEN",
                changeFormStateAndProperties: "Formularstatus und -eigenschaften ändern",
                title: "Titel",
                newFormSettings: "Neue Formulareinstellungen",
                formStatus: "Formular Status",
                activateOrDeactivate: "Aktivieren, deaktivieren oder bedingt aktivieren Sie Ihr Formular",
                effective: "EFFEKTIV",
                yourFromIsVisible: "Ihr Formular ist nun sichtbar und kann Antworten empfangen",
                emails: "E-MAILS",
                emailsDesc: "Senden von Autoresponder-E-Mails und Benachrichtigungs-E-Mails",
                conditions: "BEDINGUNGEN",
                conditionsDesc:
                    "Abschnitt mit bedingter Logik, der auf der Grundlage von Formulareingaben Aktionen auslöst",
                thankYouPage: "DANKESCHÖN-SEITE",
                thankYouPageDesc: "Die Seite, die nach dem Absenden des Formulars angezeigt wird",
                integretions: "INTEGRATIONEN",
                integretionsDesc: "Verbinden Sie Ihr Formular mit anderen Anwendungen",
            },
            clickToDeleteYourLogo: "Klicken Sie, um Ihr Logo zu löschen",
            create: "erstellen.",
            settings: "Einstellungen",
            load: "Laden Sie",
            insertFormField: "Formularfeld einfügen",
            addYourLogo: "Ihr Logo hinzufügen",
            surveyElements: {
                surveyElements: "Umfrage-Elemente",
                dataTable: "Daten-Tabelle",
                starRating: "Sterne Bewertung",
                evaluationScale: "Bewertungsskala",
            },
            pageElements: {
                pageElements: "Elemente der Seite",
                separationElement: "Trennungselement",
                partitionCollapse: "Zusammenbruch der Teilung",
                pageBreak: "Ende der Seite",
            },
            basicElements: {
                basicElements: "Grundlegende Elemente",
                shortText: "Kurzer Text",
                longText: "Langer Text",
                paragraph: "Absatz",
                dropDownList: "Auswahlliste",
                singleChoice: "Einzige Wahlmöglichkeit",
                multipleSelection: "Mehrfache Auswahl",
                number: "Nummer",
                image: "İBild",
                fileUpload: "Hochladen von Dateien",
                hour: "Stunde",
                spinner: "Spinner",
                send: "Senden Sie",
            },
            formElements: {
                formElements: "Formular-Elemente",
                title: "Titel",
                fullName: "Voller Name",
                email: "Email",
                address: "Adresse",
                phone: "Telefon",
                datePicker: "Datumspicker",
                appointment: "Ernennung",
                signature: "Unterschrift",
                productList: "Produktliste",
            },
            startWithaBlankForm: "Beginnen Sie mit einem leeren Formular",
            startFromScratch: "Ganz von vorne anfangen",
            createOrTransferaForm: "Erstellen oder Übertragen eines Formulars zum Starten der Datenerfassung",
            createForm: "Formular erstellen",
        },
        automation: {
            deleteAutomationsTitle: "Automatisierungen Löschen",
            deleteAutomationsConfirmation: "Sind Sie sicher, dass Sie {count} Automatisierungen löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
            automationsMoveError: "Fehler beim Verschieben der Automatisierungen",
            noAutomationToMove: "Keine Automatisierung zum Verschieben gefunden",
            deleteCategoryConfirmation: "Sind Sie sicher, dass Sie die Kategorie \"{categoryName}\" löschen möchten? Die Automatisierungen in dieser Kategorie werden in die Kategorie \"Allgemein\" verschoben.",
            automationsMovedToCategory: "{count} Automatisierungen in die Kategorie \"{categoryName}\" verschoben",
            automationImportedSuccessfully: "Automatisierung {name} erfolgreich importiert",
            automationPasteError: "Fehler beim Einfügen der Automatisierung",
            invalidAutomationExport: "Kein gültiger Supsis Automatisierungs-Export in der Zwischenablage gefunden",
            invalidAutomationJSON: "Kein gültiges Automatisierungs-JSON in der Zwischenablage gefunden",
            clipboardNotSupported: "Zugriff auf die Zwischenablage wird in diesem Browser nicht unterstützt",
            automationJSONCopyError: "Fehler beim Kopieren der Automatisierung",
            automationCopiedToClipboardFallback: "Automatisierung als JSON in die Zwischenablage kopiert (Fallback-Methode)",
            automationCopiedToClipboard: "Automatisierung als JSON in die Zwischenablage kopiert. Sie können sie mit Strg+V in einem anderen Kunden-Panel einfügen.",
            automationCopyError: "Fehler beim Kopieren der Automatisierung",
            automationCopied: "Automatisierung kopiert",
            automationMoveError: "Fehler beim Verschieben der Automatisierung",
            automationMovedToCategory: "Automatisierung in die Kategorie \"{categoryName}\" verschoben",
            categoryDeletedSuccessfully: "Kategorie erfolgreich gelöscht",
            categoryDeleteError: "Fehler beim Löschen der Kategorie",
            automationsDeleteError: "Fehler beim Löschen der Automatisierungen",
            automationsDeletedSuccessfully: "{count} Automatisierungen erfolgreich gelöscht",
            categoryUpdatedSuccessfully: "Kategorie aktualisiert",
            categoryUpdateError: "Fehler beim Aktualisieren der Kategorie",
            categorySaveError: "Fehler beim Speichern der Kategorie",
            categoryCreatedSuccessfully: "Kategorie erstellt. Sie können Automatisierungen in diese Kategorie ziehen.",
            categoryNameAlreadyExists: "Eine Kategorie mit diesem Namen existiert bereits",
            categoryNameRequired: "Kategoriename darf nicht leer sein",
            moveAllAutomations: "Alle Automatisierungen Verschieben",
            deleteAutomations: "{count} Automatisierungen gelöscht",
            selectedAutomations: "{count} Automatisierungen ausgewählt",
            pasteInfoMessage: "In die Zwischenablage kopierte Automatisierung erkannt! Erstellen Sie sofort eine neue Automatisierung, indem Sie sie mit <strong>Strg+V</strong> einfügen.",
            categoryName: "Kategoriename",
            categoryNamePlaceholder: "Kategoriename eingeben",
            editCategory: "Kategorie Bearbeiten",
            deleteCategory: "Kategorie Löschen",
            createCategory: "Kategorie Hinzufügen",
            publishAutomation: "Veröffentlicht",
            unpublishAutomation: "Gestoppt",
            timerAutomation: "Geplant",
            eventAutomation: "Ereignis",
            deleteAutomation: "Automatisierung Löschen",
            changeCategory: "Kategorie Ändern",
            copyAutomation: "Automatisierung Kopieren",
            copyAutomationAsJSON: "Als JSON Kopieren",
            emptyCategoryMessage: "Sie können Automatisierungen zur Kategorie hinzufügen, indem Sie sie hierher ziehen",
            whenFormSubmitted: "Wenn ein Formular eingereicht wird",
            taskCreated2: "Aufgabe erstellt",
            waitingTaskCreation: "Warte auf die Erstellung der Aufgabe...",
            calendarEventCreated: "Ereignis im Kalender erstellt",
            calendarEventUpdated: "Ereignis im Kalender aktualisiert",
            calendarEventDeleted: "Ereignis aus dem Kalender gelöscht",
            reservationCreated: "Reservierung erstellt",
            reservationDateChanged: "Reservierungsdatum geändert",
            reservationDeleted: "Reservierung gelöscht",
            chatLost: "Wenn der Chat verloren geht",
            webchatCompleted: "Wenn der Web-Chat abgeschlossen ist",
            instagramCompleted: "Wenn der Chat vom Instagram-Kanal abgeschlossen ist",
            messengerCompleted: "Wenn der Chat vom Messenger-Kanal abgeschlossen ist",
            whatsappCompleted: "Wenn der Chat vom WhatsApp-Kanal abgeschlossen ist",
            telegramCompleted: "Wenn der Chat vom Telegram-Kanal abgeschlossen ist",
            chatAssignedToAgent: "Wenn der Chat einem Agenten zugewiesen wird",
            profileButtonClicked: "Wenn die Automatisierungsschaltfläche im Profil gedrückt wird",
            operatedTask: "Aufgabe wird ausgeführt",
            tableSelection: "Tabellenauswahl",
            selectTable: "Tabelle auswählen",
            whichTableAutomationAddRecords:
                "Welche Tabelle soll automatisiert werden, wenn ein Datensatz hinzugefügt wird? Bitte auswählen.",
            whichTableAutomationUpdateRecords:
                "In welcher Tabelle soll die Automatisierung ausgeführt werden, wenn ein Datensatz aktualisiert wird? Bitte wählen Sie.",
            whichTableAutomationDeletedRecords:
                "Aus welcher Tabelle möchten Sie die Automatisierung ausführen, wenn ein Datensatz gelöscht wird? Bitte wählen Sie aus.",
            whichTableAutomationClickRecords:
                "In welcher Tabelle soll die Automatisierung ausgeführt werden, wenn auf die Automatisierungsschaltfläche eines Datensatzes geklickt wird? Bitte auswählen.",
            planStatus: "Planstatus",
            scheduled: "Geplant",
            completed: "Abgeschlossen",
            cancelled: "Abgebrochen",
            startTest: "Test starten",
            unpublish: "Unpublish",
            whenMessagePicked: "Wenn eine Nachricht über die Chat-Schnittstelle ausgewählt wird",
            whenTaskCompleted: "Wenn eine Aufgabe abgeschlossen wird",
            whenTaskDeleted: "Wenn eine Aufgabe gelöscht wird",
            whenTaskAssigneeChanged: "Wenn ein Aufgabenzuweiser geändert wird",
            whenTaskPriorityChanged: "Wenn die Priorität einer Aufgabe geändert wird",
            whenTaskDueDateChanged: "Wenn das Fälligkeitsdatum einer Aufgabe geändert wird",
            whenTaskStatusChanged: "Wenn sich der Status einer Aufgabe ändert",
            whenTaskArchived: "Wenn eine Aufgabe archiviert wird",
            whenTagAdded: "Wenn der Aufgabe ein Tag hinzugefügt wird",
            whenTagRemovedTask: "Wenn eine Markierung von einer Aufgabe entfernt wird",
            whenTagChecklist: "Wenn eine Aufgaben-Checkliste abgeschlossen wird",
            whenReminderActivated: "Wenn eine Erinnerung aktiviert wird",
            whenTicketCreated: "Wenn ein Ticket erstellt wurde",
            whenTicketStageChanged: "Wenn eine Ticketstufe geändert wird",
            whenTicketAssigneeChanged: "Wenn ein Ticket-Empfänger geändert wird",
            whenTicketClosed: "Wenn eine Anfrage geschlossen wird",
            whenTicketUpdated: "Wenn eine Anfrage aktualisiert wird",
            archivingDate: "Datum der Archivierung",
            autoPlanAndTaskHistory: "Automatisierungsplan und Aufgabenverlauf",
            automation: "Automatisierung",
            botScenario: "Bot-Szenario",
            nameSurname: "NameNachname",
            phone164: "*Eingabe im E164-Format. Zum Beispiel: 905396667744",
            whichWpChannels: "Welche Whatsapp-Kanäle sollen hinzugefügt werden?",
            findContact: "Kontakt finden",
            findContacts: "Kontakte finden",
            offsetDesc:
                "Überspringe die ersten N Kontakte. Standardwert ist '0'. Verwenden Sie diesen Wert, um durch die Kontakte zu blättern.",
            limitDesc:
                "Maximale Anzahl von Kontakten, die nach dem Offset zurückgegeben werden. Standardwert ist '10'. Verwenden Sie dies, um zu paginieren",
            contact: "Kontakt",
            selectAction: "Aktion auswählen",
            addMethod: "Methode hinzufügen",
            selectField: "Feld auswählen",
            schedulerRunningPlanEx: "Beispiel für einen laufenden Plan des Planers",
            schedulerPlanner: "Planer für die Planung",
            taskCreated: "Aufgabe erstellt?",
            taskStatus: "Status der Aufgabe",
            terminateReason: "Grund für die Beendigung",
            taskDuration: "Aufgabendauer",
            taskWakeUpCount: "Anzahl der Aufwachvorgänge der Aufgabe",
            completedAt: "Abgeschlossen",
            cancelledAt: "Abgebrochen",
            nextRunAt: "Nächster Lauf",
            configSchedulerAuto: "Zeitgeber für Automatisierung konfigurieren",
            saveChanges: "Änderungen speichern",
            catchAllWebhooks: "Alle Webhooks von dieser URL abfangen",
            webhookDataExPreview: "Webhook Data Sample Preview (wird nach dem Senden der Anfrage angezeigt)",
            webhookUrlCopied: "Webhook-URL in die Zwischenablage kopiert",
            selectAnBlock: "Einen Block auswählen",
            dataFormats: "Datenformate",
            whenRecordCreated: "Wenn ein Datensatz erstellt wird",
            whenRecordUpdated: "Wenn ein Datensatz aktualisiert wird",
            whenRecordDelete: "Wenn ein Datensatz gelöscht wird",
            whenRecordAutomation: "Wenn eine Schaltfläche zur Datensatzautomatisierung angeklickt wird",
            whenWebhookTriggered: "Wenn ein Webhook ausgelöst wird",
            whenChatCreated: "Wenn ein Chat erstellt wird",
            whenChatClosed: "Wenn ein Chat geschlossen wird",
            whenChatRated: "Wenn ein Chat bewertet wird",
            whenNewContactCreated: "Wenn ein neuer Kontakt erstellt wird",
            whenContactUpdate: "Wenn ein Kontakt aktualisiert wird",
            whenContactPropUpdate: "Wenn eine Kontakteigenschaft aktualisiert wird",
            whenNewTagAdded: "Wenn ein neuer Tag hinzugefügt wird",
            whenTagRemoved: "Wenn ein Tag entfernt wird",
            whenNewEmailReceived: "Wenn eine neue E-Mail empfangen wird",
            whenNewTaskCreated: "Wenn eine neue Aufgabe erstellt wird",
            whenNewMetaleadCreated: "Wenn ein neuer Meta-Lead erstellt wird",
            whenNewAgentCreated: "Wenn ein neuer Agent erstellt wird",
            whenNewInvoiceCreated: "Wenn eine neue Rechnung erstellt wird",
            whenNewWpReceived: "Wenn eine neue Whatsapp-Nachricht eingegangen ist",
            whenNewReservationCreated: "Wenn eine neue Reservierung erstellt wird",
            whenNewChatbotReceived: "Wenn eine neue Chatbot-Nachricht eingeht",
            chatWebhookAutomation: "Einen Webhook abfangen und eine Automatisierung ausführen",
            automationName: "Automatisierungsname",
            supsisObject: "Supsis-Objekt",
            selectModule: "Modell auswählen",
            bodyType: "Körpertyp",
            selectBodyType: "Körpertyp auswählen",
            selectMethod: "Methode auswählen",
            trigger: "Auslöser",
            published: "Veröffentlicht",
            createdAt: "Erstellt am",
            action: "Aktion",
            type: "Typ",
            view: "Siehe",
            createTimerAutomation: "Timer-Automatisierung erstellen",
            createEventBasedAutomation: "Ereignisbasierte Automatisierung erstellen",
            createWebhookAutomation: "Webhook-Automatisierung erstellen",
            automationsDeletedSuccessfully: "Erfolgreich gelöschte Automationen",
            automationsCouldNotBeDeleted: "Automatisierungen konnten nicht gelöscht werden",
            timerAutomationCreatedSuccessfully: "Timer-Automatisierung erfolgreich erstellt",
            eventAutomationCreatedSuccessfully: "Ereignisautomatisierung erfolgreich erstellt",
            webhookAutomationCreatedSuccessfully: "Webhook-Automatisierung erfolgreich erstellt",
            automationsCouldNotBeFetched: "Automatisierungen konnten nicht abgerufen werden",
            automationPublishedStateUpdatedSuccessfully: "Automation Published State Updated Successfully",
            automationPublishedStateCouldNotBeUpdated:
                "Der veröffentlichte Status der Automatisierung konnte nicht aktualisiert werden",
            createAnEventAutomation: "Erstellen einer Ereignisautomatisierung",
            automations: "Automatisierungen",
            allAutomations: "Alle Automatisierungen",
            scheduledAutomations: "Geplante Automatisierungen",
            eventBasedAutomations: "Ereignisbasierte Automatisierungen",
            buttonAutomations: "Schaltflächen-Automatisierungen",
            webhookAutomations: "Webhook-Automatisierungen",
            blocks: {
                ASSIGN_OWNER: "Eigentümer Zuweisen",
                autoForwardToOwnerForce: "Automatische Weiterleitung an Eigentümer (auch bei aktivem Chatbot)",
                SHOW_WIDGET: "Widget anzeigen",
                REPLY_TRENDYOL_QUESTION: "Trendyol-Frage beantworten",
                START_POINT: "STARTPUNKT",
                AI_ASSISTANT: "KI-ASSISTENT",
                BOT_RESPONSE: "BOT-ANTWORT",
                AI_BOT_RESPONSE: "KI-RESPONSE (GPT-4o)",
                AI_CLASSIFICATION: "KI-KLASSIFIZIERUNG",
                AI_MENU_FLOW: "KI-MENÜ",
                OTP_WHATSAPP_FLOW: "OTP Whatsapp",
                OTP_SMS_FLOW: "OTP SMS",
                OTP_MAIL_FLOW: "OTP MAIL",
                AI_INSTAGRAM_FLOW: "AI INSTAGRAM KOMMENTAR",
                PLATTFORM_FLOW: "PLATTFORM",
                DEFAULT_FALLBACK: "STANDARD-FALLBACK",
                DEFAULT_TIMEOUT: "STANDARDMÄSSIGE ZEITÜBERSCHREITUNG",
                AI_FUNCTIONS: "KI-FUNKTIONEN",
                FILTER: "FILTER",
                FLOW: "FLOW",
                ATTACHMENT_INPUT: "ANHANG-EINGABE",
                USER_INPUT: "BENUTZEREINGABE",
                GO_TO_STEP: "GEHE ZU SCHRITT",
                WEBHOOK: "WEBHAKEN",
                SET_ATTRIBUTE: "ATTRIBUT SETZEN",
                QUESTION: "FRAGE",
                CLOSE_CHAT: "CHAT SCHLIESSEN",
                CREATE_TICKET: "TICKET ERSTELLEN",
                TRANSFER_CHAT: "CHAT ÜBERTRAGEN",
                TRANSFER_TO_CHATBOT: "AN CHATBOT WEITERLEITEN",
                TAG_CHAT: "TAG HINZUFÜGEN",
                REMOVE_TAG: "TAG ENTFERNEN",
                SET_DEPARTMENT: "ABTEILUNG FESTLEGEN",
                SEND_TRANSCRIPT: "ABSCHRIFT SENDEN",
                SEND_SMS: "SMS SENDEN",
                SEND_MAIL: "SEND MAIL",
                CREATE_EVENT: "EREIGNIS ERSTELLEN",
                CREATE_RESERVATION: "RESERVIERUNG ERSTELLEN",
                RESERVATION_OPEN_URL: "RESERVIERUNG ÖFFNEN URL",
                RESERVATION_SELECT_DAY: "RESERVIERUNGSTAG AUSWÄHLEN",
                RESERVATION_EVENT_LIST: "RESERVIERUNGSLISTE BESUCHER",
                RESERVATION_SELECT_TIME: "RESERVIERUNGSZEIT AUSWÄHLEN",
                CREATE_TASK: "AUFGABE ERSTELLEN",
                UPDATE_TASK: "UPDATE-AUFGABE",
                SHOPIFY_SHOW_PRODUCTS: "SHOPIFY SHOW PRODUCTS",
                SHOPIFY_PRODUCT_AVAILABILITY: "SHOPIFY PRODUKTVERFÜGBARKEIT",
                SHOPIFY_ORDER_STATUS: "SHOPIFY BESTELLSTATUS",
                AKINON_SHOW_PRODUCTS: "AKINON SHOW PRODUCTS",
                AKINON_FIND_PRODUCT: "AKINON PRODUKT FINDEN",
                AKINON_ORDER_STATUS: "AKINON BESTELLSTATUS",
                AKINON_SELECT_ORDER: "AKINON SELECT ORDER",
                AKINON_SELECT_SIZE: "AKINON GRÖSSE AUSWÄHLEN",
                AKINON_FIND_NEAREST_STOCK: "LADENBESTAND ANZEIGEN",
                AKINON_FIND_NEAREST_STORES: "NÄCHSTGELEGENE GESCHÄFTE ANZEIGEN",
                AKINON_SHOW_DISCOUNT_CODES: "ZEIGE RABATTCODES",
                SUPPRESSION_ADD: "KONTAKT BLOCKIEREN",
                SUPPRESSION_REMOVE: "KONTAKT FREISCHALTEN",
                ADD_TO_SEGMENT: "SEGMENT HINZUFÜGEN",
                REMOVE_FROM_SEGMENT: "AUS SEGMENT ENTFERNEN",

                IDEASOFT_SELECT_ORDER: "BESTELLUNG AUSWÄHLEN",
                IDEASOFT_ORDER_STATUS: "BESTELLSTATUS ABFRAGEN",
                IDEASOFT_GET_MEMBER_INFO: "MITGLIEDERINFO AUSFÜLLEN",
                TICKET_UPDATE: "TICKET UPDATE",

                TSOFT_SELECT_ORDER: "BESTELLUNG AUSWÄHLEN",
                TSOFT_ORDER_STATUS: "BESTELLSTATUS ABFRAGEN",

                TICIMAX_V2_SELECT_ORDER: "BESTELLUNG AUSWÄHLEN",
                TICIMAX_V2_ORDER_STATUS: "BESTELLSTATUS ABFRAGEN",

                IKAS_GET_MEMBER_INFO: "Mitgliederdetails abrufen",
                IKAS_SELECT_ORDER: "Bestellung auswählen",
                IKAS_ORDER_STATUS: "Bestellstatus abrufen",

                GET_LOCATION: "STANDORT ABRUFEN",
                FALLBACK: "AUSWEICHENDE OPTION",
                TIMEOUT: "ZEITÜBERSCHREITUNG",
                SUCCESS: "ERFOLGREICH",
                FAILURE: "FEHLER",

                PROBEL_SELECT_BRANCH: "Filiale auswählen",
                PROBEL_SELECT_CLINIC: "Poliklinik auswählen",
                PROBEL_SELECT_DAY: "Tag des Termins auswählen",
                PROBEL_SELECT_HOUR: "Uhrzeit des Termins auswählen",
                PROBEL_MAKE_APPOINTMENT: "Termin vereinbaren",
                PROBEL_CANCEL_APPOINTMENT: "Termin stornieren",
                PROBEL_GET_PATIENT_TOKEN: "Patienten-Token abrufen",
                PROBEL_FILL_INFO: "MERNIS-Informationen abrufen",
                PROBEL_SELECT_APPOINTMENT: "Termin auswählen",

                SEND_WP_BUSINESS_MESSAGE: "WHATSAPP-NACHRICHT SENDEN",
                MESSENGER_SEND_MESSAGE: "MESSENGER-NACHRICHT SENDEN",
                INSTAGRAM_SEND_MESSAGE: "INSTAGRAM-NACHRICHT SENDEN",
                INSTAGRAM_COMMENT_REPLY: "KOMMENTAR BEANTWORTEN",
                INSTAGRAM_COMMENT_DELETE: "KOMMENTAR LÖSCHEN",
                INSTAGRAM_COMMENT_SHOW: "KOMMENTAR ANZEIGEN",
                INSTAGRAM_COMMENT_HIDE: "KOMMENTAR AUSBLENDEN",
                INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "ANTWORT ALS PRIVAT",
                LOOP: "SCHLEIFEN",
                LOOP_NEXT: "NÄCHSTES ELEMENT IN DER SCHLEIFE",
                LOOP_BREAK: "SCHLEIFE UNTERBRECHEN",
                LOOP_CONTINUE: "SCHLEIFE FORTSETZEN",
                LOOP_FINISH: "SCHLEIFE BEENDEN",
                SLEEP: "PAUSE",
                NOOP: "NOOP",
                CATCH_WEBHOOK: "WEBHOOK ABFANGEN",
                TERMINATE_AUTOMATION: "AUTOMATISIERUNG BEENDEN",
                CREATE_CONTACT: "KONTAKT ERSTELLEN",
                UPDATE_CONTACT: "KONTAKT AKTUALISIEREN",
                FIND_CONTACTS: "KONTAKTE FINDEN",
                FIND_CONTACT: "KONTAKT FINDEN",
                FIND_CHATS: "CHATS FINDEN",
                FIND_CHAT: "CHAT FINDEN",
                WAIT_FOR: "WARTEN AUF",
                STRING_FORMAT: "STRING FORMATIEREN",
                NUMBER_FORMAT: "ZAHL FORMATIEREN",
                DATE_FORMAT: "DATUM FORMATIEREN",
                RECORDS_FROM_CSV: "DATENSÄTZE AUS DER CSV",
                MESSAGE_RECEIVED: "EMPFOHLENE NACHRICHT",

                ASK_AI: "Künstliche Intelligenz",

                TABLE_CREATE_RECORD: "Datensatz erstellen",
                TABLE_DELETE_RECORD: "Datensatz löschen",
                TABLE_UPDATE_RECORD: "Datensatz aktualisieren",
                TABLE_FIND_RECORD: "Datensatz finden",
                TABLE_FIND_RECORDS: "Datensätze auflisten",

                ZOHO_FIND_RECORDS_BY_PHONE: "Zoho Datensatz finden (nach Telefon)",
                ZOHO_ADD_ATTACHMENT_TO_RECORD: "Zoho Datei zum Datensatz hinzufügen",
                ZOHO_UPLOAD_IMAGE_TO_RECORD_FIELD: "Zoho Bild in benutzerdefiniertes Feld hochladen",
                ZOHO_CREATE_RECORD: "Zoho Datensatz erstellen",

                GET_SUPSIS_RECORD_BY_ID: "Supsis Datensatz finden (nach ID)",
            },
        },
        modules: {
            kanbanSettings: {
                title: "Einstellungen",
                column: "Spalteneinstellungen",
                selectField: "Wählen Sie ein Feld",
                selectFieldPlaceholder: "Wählen Sie ein Feld",
                card: "Karteinstellungen",
                selectFields: "Wählen Sie Felder, die auf der Karte angezeigt werden sollen",
                cancel: "Abbrechen",
                save: "Speichern",
                kanban: "Kanban-Einstellungen",
            },
            createFailed: "Modulerstellung fehlgeschlagen",
            createSuccess: "Modul erfolgreich erstellt",
            moduleDeletedSuccessfully: "Modul erfolgreich gelöscht",
            deleteModuleTitle: "Modul löschen",
            deleteModuleContent: "Sind Sie sicher, dass Sie dieses Modul löschen wollen?",
            modules: "Module",
            modulesSettings: "Moduleinstellungen",
            displayName: "Anzeigename",
            description: "Beschreibung",
            table: "Tabelle",
            menuApiSettings: "Menü- und API-Einstellungen",
            icon: "Symbol",
            save: "Speichern",
            exampleIcon: "Beispiel: extension, home",
            newModule: "Neues Modul",
            moduleName: "Modulname",
            apiName: "API-Name",
            type: "Typ",
            apiAccess: "API-Zugriff",
            actions: "Aktionen",
            module: "Modul",
            relation: "Beziehung",
            moduleRelationName: "Modul/Beziehungsname",
            moduleRelationTable: "Modul/Beziehungsname",
            showInMainMenu: "Im Hauptmenü anzeigen",
            apiEnabled: "API aktiviert",
            settings: "Einstellungen",
            createModule: "Modul erstellen",
            relationType: "Beziehungsart",
            standartModule: "Standardmodul",
            customTable: "Benutzerdefiniertes Tabellen",
            localField: "Lokales Feld",
            showingRemoteFieldInList: "Feld in der Liste anzeigen",
            relationSettings: "Beziehungseinstellungen",
            remoteField: "Entferntes Feld",
            localFieldType: "Typ des lokalen Feldes",
            standart: "Standard",
            custom: "Benutzerdefiniert",
            contact: "Kontakt",
            viewRecord: "Datensatz anzeigen",
            recordDetail: "Datensatz Detail",
            recordNotFound: "Datensatz oder Tabelleninformationen nicht gefunden",
            recordViewer: "Datensatz-Viewer",
        },
        tables: {
            enterWidgetName: "Widget-Namen eingeben",
            widgetName: "Widget-Name",
            renameWidget: "Widget umbenennen",
            assistantCapabilities: "Assistentenfähigkeiten",
            addNewFieldsToTable: "Kann neue Felder zur Tabelle hinzufügen",
            editExistingFields: "Kann vorhandene Felder bearbeiten",
            deleteUnnecessaryFields: "Kann unnötige Felder löschen",
            filterRecords: "Kann Datensätze filtern",
            groupRecords: "Kann Datensätze gruppieren",
            hideFieldsCapability: "Kann Felder ausblenden",
            createConditionalFormatting: "Kann bedingte Formatierung erstellen",
            createCalculationFormulas: "Kann Berechnungsformeln erstellen",
            createSampleRecords: "Kann Beispieldatensätze erstellen",
            examplePrompt: "Beispiel: Fügen Sie dieser Tabelle die Felder Name, Nachname, E-Mail und Telefon für Kundeninformationen hinzu...",
            supsisAssistantTables: "Supsis Assistent: Tabellen",
            supsisAssistantWritePrompt: "Beschreiben Sie, was der Supsis Assistent tun soll",
            supsisAssistantExamplePrompt: "Erstellen Sie eine Tabelle zur Verfolgung von Besprechungen. Fügen Sie Felder wie Besprechungsthema, Datum, Teilnehmer, verantwortliche Person, getroffene Entscheidungen und Folgeaktionen hinzu.",
            sendSupsisAssistant: "An Supsis Assistent senden",
            examplePromptsTitle: "Beispielanfragen:",
            examplePrompts: {
                addCustomerInfoFields: "Füge dieser Tabelle die Felder Vorname, Nachname, E-Mail und Telefon für Kundeninformationen hinzu.",
                addOrderFields: "Füge der Bestelltabelle die Felder Produktname, Menge, Stückpreis, Gesamtbetrag und Bestelldatum hinzu.",
                addBirthDateField: "Füge dieser Tabelle ein Geburtsdatum-Feld hinzu und stelle das Datumsformat auf TT/MM/JJJJ ein.",
                updateStatusField: "Aktualisiere das Statusfeld, mache es zu einem Dropdown mit den Optionen: Ausstehend, In Bearbeitung, Abgeschlossen, Storniert.",
                replaceAddressFields: "Lösche das Adressfeld und füge stattdessen die Felder Adresszeile 1, Adresszeile 2, Bezirk, Stadt und Postleitzahl hinzu.",
                alignTextFields: "Zentriere alle Textfelder und begrenze die maximale Textlänge auf 100 Zeichen.",
                addAutoIncrementID: "Füge ein automatisch fortlaufendes ID-Feld hinzu und verwende das Präfix PRD- für das Produkt.",
                addTotalAmountFormula: "Füge das Feld Gesamtbetrag als Formel hinzu, um das Produkt aus Menge und Stückpreis zu berechnen.",
                createActiveCustomersFilter: "Erstelle einen Filter, um nur aktive Kunden anzuzeigen.",
                filterRecentUsers: "Filtere Benutzer, die sich in den letzten 30 Tagen registriert haben.",
                groupByStatus: "Gruppiere Datensätze nach der Status-Spalte.",
                hideAllExceptDeliveryAndOrderNo: "Blende alle Felder außer Lieferdatum und Bestellnummer aus.",
                colorCodeOrders: "Markiere verspätete Bestellungen rot, heutige Lieferungen gelb und abgeschlossene grün.",
                highlightHighPaymentRecords: "Hebe Datensätze mit einem Zahlungsbetrag über 1000 TL in Lila hervor.",
                groupAndHighlightUnpaidOrders: "Gruppiere nach Bestelldatum und markiere unbezahlte Bestellungen rot.",
                createSampleRecords: "Erstelle 10 Beispieldatensätze in dieser Tabelle.",
                addSampleRecordsForAliAndAhmet: "Füge 5 Beispieldatensätze mit den Kundennamen Ali und Ahmet hinzu.",
                createRandomSampleOrders: "Erstelle 20 zufällige Bestellungen mit zufällig festgelegtem Status.",
                hrCandidateTracking: "Ich möchte eine Software zur Kandidatenverfolgung (ATS) für unsere HR-Prozesse erstellen. Alles, was ein ATS haben sollte, einschließen. Verwenden Sie türkische Feldnamen.",
                crmModuleCreation: "Erstellen Sie alle notwendigen Module für das Kundenbeziehungsmanagement (CRM). Fügen Sie Kundeninformationen, Besprechungsprotokolle und Chancenmanagement hinzu.",
                realEstatePortfolioManagement: "Ich möchte ein Immobilienportfoliomanagementsystem einrichten. Es sollte Immobiliendetails, Kundenanfragen und Verkaufsverfolgung verwalten.",
                schoolManagementSystem: "Ich möchte die Verfolgung von Schülern, Lehrern und Stundenplänen für ein Schulverwaltungssystem verwalten. Verwenden Sie türkische Feldnamen.",
                projectManagementSystem: "Ich möchte ein Projektmanagementsystem erstellen. Aufgaben, Teammitglieder, Zeiterfassung und Berichtsfunktionen einschließen.",
                inventoryAndWarehouseManagement: "Ich möchte ein System für Lager- und Bestandsverwaltung aufbauen. Es sollte Produkt-Ein- und Ausgänge, Bestandsniveaus und Lieferantenverfolgung verwalten.",
                serviceAndMaintenanceTracking: "Ich möchte ein System zur Verfolgung von Service und Wartung. Es sollte Kundengeräte, Wartungshistorie und Technikerzuweisungen verwalten.",
                restaurantManagementSystem: "Ich möchte ein Restaurantverwaltungssystem einrichten. Tischverfolgung, Bestellmanagement, Küchendisplay und Abrechnungsoperationen einschließen.",
            },
            createAppWithSupsisAssistant: "App mit Supsis Assistant erstellen",
            noWidgets: "Noch keine Widgets hinzugefügt",
            widgetLoadError: "Widget konnte nicht geladen werden",
            createDashboardSupsisAssistant: "Dashboard mit Supsis Assistant erstellen",
            youtubeDesc: "Fügen Sie Youtube-Videos in Ihr Panel ein",
            iframeDesc: "Fügen Sie externe Webinhalte in Ihr Panel ein",
            countdownDesc: "Fügen Sie einen Zähler hinzu, um wichtige Fristen zu verfolgen",
            countdown: "Zähler",
            textDesc: "Fügen Sie benutzerdefinierte Textinhalte zu Ihrem Panel hinzu",
            numbersDesc: "Erhalten Sie einen schnellen Überblick über alle Zahlenspalten",
            numbers: "Zahlen",
            addWidget: "Widget hinzufügen",
            graphDesc: "Erstellen Sie einen Diagramm-Widget, um Daten in Ihren Tabellen zu visualisieren",
            graph: "Diagramm",
            suggested: "Vorgeschlagene",
            creationDate: "Erstellungsdatum",
            today: "Heute",
            month: "Monat",
            week: "Woche",
            day: "Tag",
            table: "Tabelle",
            kanban: "Kanban",
            calendar: "Kalender",
            calendarSettings: "Kalendereinstellungen",
            colorBy: "Farbe nach",
            startDateField: "Startdatumsfeld",
            endDateField: "Enddatumsfeld (Optional)",
            eventCardFields: "Ereigniskarten-Felder",
            selectColorField: "Farbfeld auswählen",
            selectStartDateField: "Startdatumsfeld auswählen",
            selectEndDateField: "Enddatumsfeld auswählen",
            cancel: "Abbrechen",
            save: "Speichern",
            kanbanNotAvailable: "Kanban-Ansicht nicht verfügbar",
            needDropdownField:
                "Um die Kanban-Ansicht zu verwenden, benötigen Sie mindestens ein statisches Dropdown-Feld in Ihrer Tabelle. Sie können in den Tabelleneinstellungen ein neues Feld hinzufügen oder ein vorhandenes bearbeiten.",
            notAvailable: "Kalenderansicht nicht verfügbar",
            needDateField:
                "Sie benötigen mindestens ein Datumsfeld in Ihrer Tabelle, um die Kalenderansicht zu verwenden. Sie können in den Tabelleneinstellungen ein neues Feld hinzufügen oder ein vorhandenes bearbeiten.",
            switchToTable: "Zur Tabellenansicht wechseln",
            operator: "Operator",
            conditionalColor: "Bedingte Farbe",
            groupField: "Gruppenfeld",
            selectDirection: "Auswahlrichtung",
            showEmptyGroups: "Leere Gruppen anzeigen",
            clearGrouping: "Gruppierung löschen",
            applyGrouping: "Gruppierung anwenden",
            sortDirection: "Sortierungsrichtung",
            downloadSelectedRecords: "Ausgewählte Datensätze herunterladen",
            viewName: "Ansichtsname",
            enterViewName: "Ansichtsname eingeben",
            enterDesc: "Beschreibung eingeben",
            viewNameRequired: "Ansichtsname erforderlich",
            runWebhookAutomation: "Webhook-Automatisierung ausführen",
            downloadAllRecords: "Alle Datensätze herunterladen",
            deleteRecords: "Datensätze löschen",
            editRecords: "Datensätze aktualisieren",
            duplicateRecords: "Datensätze duplizieren",
            selected: "Ausgewählt",
            sureDeleteRecords: "Sind Sie sicher, dass Sie Datensätze löschen wollen?",
            selectedRecordSucs: "Ausgewählte Datensätze wurden erfolgreich gelöscht.",
            errorDeletingRecords: "Beim Löschen von Datensätzen ist ein Fehler aufgetreten.",
            sureCopyRecords: "Sind Sie sicher, dass Sie die Datensätze kopieren wollen?",
            copyRecords: "Datensätze kopieren",
            recordsCopiedSucs: "Die ausgewählten Datensätze wurden erfolgreich kopiert.",
            recordsCopiedError: "Beim Kopieren der ausgewählten Datensätze ist ein Fehler aufgetreten.",
            viewSucsCreated: "Die Ansicht wurde erfolgreich erstellt.",
            editMultipleRecords: "Mehrere Datensätze bearbeiten",
            importRecords: "Datensätze importieren",
            importHasStarted:
                "Der Import hat begonnen. Je nach Umfang Ihrer Daten kann dies einige Minuten dauern. Bitte warten Sie...",
            anErrorImport: "Während des Imports ist ein Fehler aufgetreten.",
            recordCreated: "Datensatz erstellt",
            recordUpdated: "Datensatz aktualisiert",
            recordDeleted: "Datensatz gelöscht",
            noAutomationDefined: "Es ist noch keine Automatisierung definiert",
            nameTheAutomationAdd:
                "Nennen Sie die Automatisierung, die ausgeführt wird, wenn ein Datensatz zu dieser Tabelle hinzugefügt wird:",
            nameTheAutomationUpdate:
                "Nennen Sie die Automatisierung, die ausgeführt wird, wenn ein Datensatz in dieser Tabelle aktualisiert wird:",
            nameTheAutomationDelete:
                "Nennen Sie die Automatisierung, die ausgeführt wird, wenn ein Datensatz aus dieser Tabelle gelöscht wird:",
            editField: "Feld bearbeiten",
            sort: "Sortieren",
            ascending: "Aufsteigend",
            descending: "Absteigend",
            createField: "Feld erstellen",
            insertBefore: "Vorher einfügen",
            insertAfter: "Nachher einfügen",
            goToRelatedAuto: "Zur verwandten Automatisierung gehen",
            permission: "Erlaubnis",
            lockField: "Feld sperren",
            hideField: "Feld ausblenden",
            deleteField: "Feld löschen",
            watchVideo: "Video ansehen",
            uploadError: "Fehler beim Hochladen",
            updateError: "Fehler beim Aktualisieren",
            invalidValue: "Ungültiger Wert. Bitte verwenden Sie das richtige Format.",
            errorUpdatingRecord: "Beim Aktualisieren des Datensatzes ist ein Fehler aufgetreten.",
            errorCreatingView: "Beim Erstellen der Ansicht ist ein Fehler aufgetreten.",
            datetimeOptions: "Datum/Uhrzeit Optionen",
            numberOptions: "Zahlen Optionen",
            currencyOptions: "Währungsoptionen",
            dropdownOptions: "Dropdown-Optionen",
            automationButtonOptions: "Automatisierungsschaltflächenoptionen",
            defaultLabel: "Standardbezeichnung",
            disableWhenClicked: "Bei Klick deaktivieren",
            fieldSucsCreate: "Feld erfolgreich erstellt",
            fieldCreatingFailed: "Beim Erstellen des Feldes ist ein Fehler aufgetreten",
            fieldSucsUpdate: "Feld erfolgreich aktualisiert",
            fieldUpdatingFailed: "Beim Aktualisieren des Feldes ist ein Fehler aufgetreten",
            showAll: "Alle anzeigen",
            hideAll: "Alle ausblenden",
            searchFields: "Suchfelder",
            firstRowHeader: "Die erste Zeile enthält die Überschrift",
            seperatorCharacter: "Trennzeichen",
            comma: "Komma",
            semicolan: "Semikolon",
            tableFieldOrFileColumns: "Zuordnung von Tabellenfeldern / Dateispalten",
            exampleResultPreview: "Vorschau des Beispielergebnisses",
            newView: "Neue Ansicht",
            createViewaFiltering:
                "Erstellen Sie Ansichten, um die Filterung, Sortierung und Ausblendung von Feldern fortzusetzen, ohne die Haupttabelle zu ändern.",
            pleaseUpdateSelected:
                "Bitte wählen Sie das Feld aus, das Sie für die ausgewählten Datensätze aktualisieren möchten",
            pleaseSelectedNewValue: "Bitte geben Sie einen neuen Wert für das ausgewählte Feld ein.",
            selectedMenuItem: "Ausgewählter Menüpunkt:",
            deleteTable: "Tabelle löschen",
            sureDeleteTable: "Sind Sie sicher, dass Sie diese Tabelle löschen wollen?",
            deleteTableSucs: "Die Tabelle wurde erfolgreich gelöscht.",
            deleteTableError: "Fehler beim Löschen der Tabelle:",
            editTable: "Tabelle bearbeiten",
            createNewField: "Neues Feld erstellen",
            tables: "Tabellen",
            tableName: "Tabellenname",
            description: "Beschreibung",
            createTable: "Tabelle erstellen",
            createNewTable: "Neue Tabelle erstellen",
            allTables: "Alle Tabellen",
            myTables: "Meine Tabellen",
            myFavorites: "Meine Favoriten",
            errorCreatingTable: "Fehler beim Erstellen der Tabelle:",
            customerTable: "Kundentabelle",
            customerTableDesc: "Standard-Kundentabelle",
            leadTracking: "Lead Tracking",
            leadTrackingDesc: "Tabelle zur Lead-Verfolgung",
            todoList: "Aufgabenliste",
            todoListDesc: "Liste zur Verfolgung von Aufgaben",
            approvalReq: "Genehmigungsanfrage",
            approvalReqDesc: "Verwaltung von Genehmigungsanträgen",
            eventSchedule: "Veranstaltungskalender",
            eventScheduleDesc: "Planung anstehender Ereignisse",
            inventoryList: "Inventarliste",
            inventoryListDesc: "Übersicht über die Produktbestände",
            bookingForm: "Buchungsformular",
            bookingFormDesc: "Verfolgt Buchungen",
            bugTracker: "Fehlerverfolger",
            bugTrackerDesc: "Verfolgung von Software-Fehlern",
            employeeDirectory: "Mitarbeiterverzeichnis",
            employeeDirectoryDesc: "Enthält Mitarbeiterinformationen",
            errorPullTable: "Fehler beim Ziehen von Tabellendaten",
            newRecordSucs: "Neuer Datensatz erfolgreich erstellt.",
            failedNewRecord: "Die Erstellung eines neuen Datensatzes ist fehlgeschlagen:",
            newRecordCreateError: "Beim Erstellen eines neuen Datensatzes ist ein Fehler aufgetreten.",
            recordCount: "Anzahl der Datensätze",
            increaseLimit: "Erhöhungsgrenze",
            newRecord: "Neuer Datensatz",
            imports: "Importieren",
            exports: "Exportieren",
            download: "Herunterladen",
            automateYourData: "Automatisieren Sie Ihre Daten",
            recordUpdatedSucs: "Datensatz erfolgreich aktualisiert",
            failedToUpdateRecord: "Datensatz konnte nicht aktualisiert werden",
            recordUpdatingError: "Fehler beim Aktualisieren des Datensatzes",
            mainTable: "Haupttabelle",
            filter: "Filter",
            hideFields: "Felder ausblenden",
            saveAsView: "Als Ansicht speichern",
            search: "Suchen",
            create: "Erstellen",
            left: "Links",
            center: "Mittel",
            rechts: "Rechts",
            selectTimezone: "Zeitzone auswählen",
            createFieldSucs: "Feld erfolgreich erstellt.",
            failedCreateField: "Feld konnte nicht erstellt werden:",
            createFieldError: "Beim Erstellen des Feldes ist ein Fehler aufgetreten.",
            addCondition: "Bedingung hinzufügen",
            applyFilter: "Filter anwenden",
            fieldType: "Feldtyp",
            alignment: "Ausrichtung",
            blankTable: "Leere Tabelle",
            templates: "Vorlagen",
            timezone: "Zeitzone",
            timeFormat: "Zeitformat",
            includeTime: "Einschließlich Zeit",
            decimalFormat: "Dezimalformat",
            currencySymbol: "Währungssymbol",
            mode: "Modus",
            statics: "Statisch",
            dynamisch: "Dynamisch",
            multipleSelection: "Mehrfachauswahl",
            addOption: "Option hinzufügen",
            text: "Text",
            longText: "Langer Text",
            number: "Zahl",
            currency: "Währung",
            datetime: "Datum & Uhrzeit",
            dropdown: "Dropdown-Liste",
            checkbox: "Kontrollkästchen",
            email: "E-Mail",
            phone: "Telefon",
            file: "Datei",
            image: "Bild",
            video: "Video",
            audio: "Audio",
            colour: "Farbe",
            automationButton: "Automatisierungsschaltfläche",
        },
        plans: {
            manageWithChatbot: "Manage with Chatbot",
            manageInbox: "Manage Inbox",
            commentManagement: "Manage Comments",
            privateReplyMessage: "Private Reply Comments",
            mentionTicket: "Convert Mentions to Tickets",
            week: "Woche",
            readyContents: "Fertige Inhalte",
            webhookIntegration: "Webhook-Integration",
            businessChannel: "WhatsApp Business Kanal",
            confirmationFeature: "Bestätigungsfunktion",
            specialReporting: "Spezielle Berichterstattung",
            aiAssistant: "KI-Assistent",
            flexibleBilling: "Flexible Abrechnung",
            automaticReservation: "Automatische Reservierung",
            taskManagement: "Aufgabenverwaltung",
            calendarIntegration: "Kalenderintegration",
            activeChatbot: "Aktiver Chatbot",
            smsIntegration: "SMS-Integration",
            mailIntegration: "E-Mail-Integration",
            startChatWithVisitor: "Chat mit Besucher starten",
            whatsappManaging: "Whatsapp-Verwaltung",
            automaticChatbotButton: "Automatischer Button/Chatbot",
            personalizedBroadcasts: "Personalisierte Rundsendungen",
            chatWithNonContacts: "Chat mit Nicht-Kontakten",
            broadcastMessaging: "Broadcast-Nachrichten",
            perBroadcast: "Pro Sendung",
            extraPricePerMessage: "Zusätzlicher Preis pro Nachricht",
            smartTrigger: "Intelligenter Auslöser",
            telegramIntegration: "Telegram Integration",
            instagramIntegration: "Instagram Integration",
            ticketFeature: "Ticket-Funktion",
            storage: "Speicher",
            onePanelManagement: "Einzelne Panelverwaltung",
            isolatedDatabaseConnection: "Isolierte Datenbankverbindung",
            removeLogo: "Supis-Logo entfernen",
            chatBaloonCustomization: "Chat-Ballon-Anpassung",
            chatAndNotifications: "Chat und Benachrichtigungen",
            unlimited: "Unbegrenzt",
            specialCustomerSupport: "Spezieller Kundensupport",
            softwareSupport: "Software-Support",
            standardSupport: "Standard-Support",
            teamChatIntegration: "Team-Chat-Integration",
            fileAndVoiceShare: "Datei- und Sprachfreigabe",
            instantVisitor: "Instant-Besuchertracking",
            detailedReporting: "Detaillierte Berichterstattung",
            normalreporting: "Normale Berichterstattung",
            noExtraCosts: "Keine zusätzlichen Kosten",
            accessibleToAllAgents: "Zugänglich für alle Agenten",
            dataSecurity: "Datensicherheit",
            autoTranslate: "Automatische Übersetzung",
            chatbotVersionHistory: "Chatbot-Versionenverlauf",
            chatbotStory: "Chatbot-Geschichte",
            freeAgent: "Kostenloser Agent",
            stableAgentCount: "Stabile Agentenanzahl",
            stableChannelCount: "Stable Channel Count",
            chipPlans: "Günstige Pläne",
            generalPlan: "Allgemeiner Plan",
            specialPlan: "Spezieller Plan",
            currentPlan: "Aktueller Plan",
            selected: "Ausgewählt",
            popular: "Beliebt",
            trialPkg: "Testpaket",
            support: "24/7 Support",
            flexiblePricing: "Flexible Preisgestaltung",
            rightToCancel: "Recht auf jederzeitige Kündigung",
            unlimitedCBScenario: "Unbegrenzte Chatbot-Szenarien",
            freeFirstScenario: "Kostenloses erstes Szenario",
            unlimitedLearn: "Unbegrenztes Chatbot-Training",
            allPlatformIntegration: "Integration mit allen Plattformen",
            detailedReports: "Detaillierte Berichte",
            aiSupport: "KI-Unterstützung",
            creativeAI: "Schneller und realistischer KI-Chat-Assistent",
            unlimitedSession: "Unbegrenzte Sitzungen gleichzeitig",
            assistantFromWebsite: "Erstellen eines Assistenten von der Website",
            assistantFromDoc: "Erstellen eines Chatbots aus dem Dokument",
            mobileApp: "Mobile App",
        },
        messenger: {
            channel: "Messenger-Kanal",
            manageChannel: "Kanal verwalten",
            channelDetail: "Kanaldetail",
            integrationTitle: "Messenger Integration",
            deleteDesc: "Möchten Sie den Messenger-Kanal wirklich löschen?",
            channels: "Messenger-Kanäle",
            connectMessenger: "Mit Messenger verbinden",
            detail: "Detail",
            visibility: "Sichtbarkeit",
            settings_group: "Einstellungen",
            commentsettings: "Kommentarverwaltung",
            commentSettingsTitle: "Messenger-Kommentarverwaltung",
            commentSettingsDesc: "Verwalten Sie Ihre Messenger-Kommentare",
        },
        instagram: {
            channel: "Instagram-Kanal",
            detail: "Detail",
            visibility: "Sichtbarkeit",
            settings_group: "Einstellungen",
            commentsettings: "Kommentarverwaltung",
            commentSettingsTitle: "Instagram-Kommentarverwaltung",
            commentSettingsDesc: "Verwalten Sie Ihre Instagram-Kommentare",
            commentSettingsTicket: "Stellt sicher, dass eingehende Kommentare im System als Tickets erfasst werden.",
            commentSettingsChatbot:
                "Wählen Sie, zu welchem Chatbot-Szenario eingehende Kommentare weitergeleitet werden sollen.",
            leads: "Leads",
            forms: "Forms",
            showAllInstagramChannels: "Alle Instagram-Kanäle anzeigen",
        },
        calendar: {
            calendarsDesc: "Vermeiden Sie Terminkonflikte.",
            generalAvailability: "Allgemeine Verfügbarkeit",
            generalAvailabilityDesc:
                "Geben Sie die Zeiten an, zu denen Sie regelmäßig für Termine zur Verfügung stehen.",
            appointDuration: "Dauer des Termins",
            appointDurationDesc: "Wie lange soll jeder Termin dauern?",
            customDuration: "Benutzerdefinierte Dauer",
            descriptionDesc:
                "Fügen Sie eine Notiz hinzu, die Ihre Dienstleistung beschreibt. Die von Ihnen hinzugefügte Notiz erscheint auf Ihrer Buchungsseite und in Bestätigungs-E-Mails.",
            resForm: "Buchungsformular",
            resFormDesc: "Passen Sie das Formular an, das die Benutzer für die Buchung eines Termins verwenden werden.",
            addField: "Feld hinzufügen",
            addAnItem: "Ein Element hinzufügen",
            saveItem: "Element speichern",
            planningTimeframe: "Planungszeitrahmen",
            planningTimeframeDesc: "Begrenzen Sie den Zeitrahmen, in dem ein Termin vereinbart werden kann.",
            availableAtMoment: "Jetzt verfügbar",
            startAndEndDate: "Start- und Enddatum",
            maxNumberAppoint: "Maximale Anzahl von Tagen, nach denen ein Termin vereinbart werden kann",
            howLongMinAppoint: "Wie lange, bevor der Termin gebucht werden kann",
            planningIntervalStartEnd: "Start- und Enddatum des Planungsintervalls",
            startTime: "Startzeit",
            done: "Erledigt",
            receivedAppointInterval: "Intervall des empfangenen Termins",
            receivedAppointIntervalDesc: "Empfangene Termine verwalten, damit sie in Ihrem Kalender erscheinen",
            interimTime: "Zwischenzeit",
            interimTimeDesc: "Zeit zwischen den Terminintervallen hinzufügen",
            dayMaxRes: "Maximale Anzahl von Buchungen pro Tag",
            dayMaxResDesc:
                "Begrenzen Sie die Anzahl der gebuchten Termine, die an einem einzigen Tag angenommen werden können",
            customise: "Benutzerdefiniert einstellen",
            noAvatar: "Kein Avatar",
            organizationName: "Name der Organisation",
            enterFullAdress: "Vollständige Adresse eingeben",
            noCoverPhoto: "Kein Titelfoto",
            enterAboutInfo: "Geben Sie Informationen über den Dienst ein",
            service: "Dienst",
            deleteService: "Dienst löschen",
            enterGoogleMapsUrl: "Google Maps URL eingeben",
            enterLatitude: "Breitengrad eingeben",
            enterLongitude: "Geben Sie den Längengrad ein",
            enterNumber: "Telefonnummer eingeben",
            uploadAvatar: "Avatar hochladen",
            teamMemberDeleteError: "Fehler beim Löschen eines Teammitglieds:",
            setupBookingWebsite: "Buchungswebsite einrichten",
            bookingLandingPageBuilder: "Booking Landing Page Builder",
            coverPhoto: "Titelfoto",
            enterOrganisationName: "Name der Organisation eingeben",
            about: "Über",
            services: "Dienstleistungen",
            deleteServices: "Dienstleistung löschen",
            selectReservationPlan: "Reservierungsplan auswählen",
            addNewService: "Neue Dienstleistung hinzufügen",
            addNewMember: "Neues Mitglied hinzufügen",
            fullAddress: "Vollständige Adresse",
            latitude: "Breitengrad",
            longitude: "Längengrad",
            contactDetails: "Kontaktdetails",
            emailAddress: "E-Mail Adresse",
            enterEmail: "E-Mail-Adresse eingeben",
            websiteURL: "Website-URL",
            enterWebsiteURL: "Website-URL eingeben",
            reservationPolicy: "Reservierungsrichtlinie",
            enterResPolicy: "Geben Sie die Buchungspolitik ein",
            workingHours: "Arbeitszeiten",
            selectEndHour: "Endzeit auswählen",
            addNewHour: "Neue Stunde hinzufügen",
            updateMemberInfo: "Mitgliederinformationen aktualisieren",
            errorRecevingData: "Fehler beim Abrufen von Daten:",
            anonymService: "Anonymer Dienst",
            unknownPlan: "Unbekannter Plan",
            errorCreatingMockPage: "Fehler beim Erstellen der Mock-Seite:",
            failedToCreateBookingPage: "Fehler beim Erstellen der Buchungsseite",
            fileSizeToolLarge: "Dateigröße zu groß",
            errorLoadingTheLogo: "Fehler beim Laden des Logos:",
            failedToLoadLogo: "Das Logo konnte nicht geladen werden",
            errorUpdating: "Fehler beim Aktualisieren:",
            failedToUpdate: "Aktualisierung fehlgeschlagen",
            newMember: "Neues Mitglied",
            errorLoadingAvatar: "Fehler beim Laden des Avatars:",
            avatarFailedToLoad: "Avatar konnte nicht geladen werden",
            teamMemberSuccessfullyDeleted: "Teammitglied erfolgreich gelöscht",
            teamMemberNotDeleted: "Teammitglied konnte nicht gelöscht werden",
            yesDelete: "Ja, löschen",
            sureReservationDelete: "Sind Sie sicher, dass Sie diese Buchung löschen wollen?",
            reservationDetails: "Buchungsdetails",
            infoPersonMakingReservation: "Informationen über die Person, die die Reservierung vornimmt",
            appointmentSchedule: "Zeitplan für den Termin",
            goToAppointmentSettings: "Zu den Einstellungen des Terminprogramms",
            resPlanCreateSuccess: "Reservierungsplan erfolgreich erstellt",
            pleaseEnterTitle: "Bitte Titel eingeben",
            sureContinueSaving: "Sind Sie sicher, dass Sie ohne Speichern fortfahren wollen?",
            appointProgram: "BUCHUNGSPROGRAMM",
            everyMonth: "Jeden Monat",
            firstEveryMonth: "Erster eines jeden Monats",
            dayOf: "Tag",
            notRepeat: "Wird nicht wiederholt",
            daily: "Jeden Tag",
            weekly: "Einmal pro Woche",
            monthly: "Einmal im Monat",
            annually: "Einmal im Jahr",
            custom: "Speziell",
            eventSaved: "Gespeicherte Veranstaltung",
            createAppoint: "Termin erstellen",
            calendarSetting: "Kalendereinstellungen",
            notAuthezord: "Sie sind nicht berechtigt, diese Operation auszuführen",
            reservationWebPage: "Reservierungs-Webseite",
            reservationPrograms: "Reservierungsprogramme",
            addReservationProgram: "Reservierungsprogramm hinzufügen",
            resPlanError: "Fehler beim Empfangen der Reservierungsprogramme:",
            resDeleteSure: "Sind Sie sicher, dass Sie dieses Reservierungsprogramm löschen möchten?",
            resDeleteSuccess: "Das Reservierungsprogramm wurde erfolgreich gelöscht.",
            resDeleteError: "Fehler beim Löschen des Reservierungsprogramms:",
            unkownUser: "Unbekannter Benutzer",
            eventNotFound: "Ereignis nicht gefunden",
            reservations: "Reservierungen",
            events: "Veranstaltungen",
            upcoming: "kommende",
            past: "Vergangenheit",
            setting: "Einstellungen",
            delete: "Löschen",
            cancel: "Abbrechen",
            save: "Speichern",
            close: "Schließen",
            deleteRepeatEvent: "Wiederholendes Ereignis löschen",
            thisEvent: "Dieses Ereignis",
            thisAndOtherEvent: "Dieses und folgende Ereignisse",
            allEvent: "Alle Ereignisse",
            ok: "OK",
            googleCalendarLink: "Zum Google Kalender hinzufügen",
            yahooCalendarLink: "Zum Yahoo Kalender hinzufügen",
            subject: "Betreff",
            visitor: "Besucher",
            allDay: "Ganztägig",
            title: "Titel",
            deleteEvent: "Ereignis löschen",
            deleteEvents: "Ereignisse löschen",
            deleteEventsSure: "Sind Sie sicher, dass Sie die Ereignisse in diesem Kalender löschen möchten?",
            deleteEventConfirm: "Sind Sie sicher, dass Sie dieses Ereignis löschen möchten?",
            notEmptyTitle: "Der Titel darf nicht leer sein!",
            tasks: "Aufgaben",
            googleConnect: "Google-Integration",
            googleDisconnect: "Google-Integration trennen",
            sure: "Sind Sie sicher?",
            disconnectGoogleSure: "Sind Sie sicher, dass Sie die Google-Verbindung trennen möchten?",
            yes: "Ja",
            no: "Nein",
            customRepeat: "Benutzerdefinierte Wiederholung",
            recurrenceFrequency: "Wiederholungsfrequenz",
            repeatDays: "An diesen Tagen wiederholen:",
            never: "Niemals",
            thisDate: "An diesem Datum:",
            recurrenceCount: "Anzahl der Wiederholungen:",
            end: "Ende",
            event: "Ereignis",
            calendars: "Kalender",
            newCalendar: "Neuen Kalender erstellen",
            changeColor: "Farbe ändern",
            addCalendar: "Kalender hinzufügen",
            nameCalendar: "Kalendername",
            description: "Beschreibung",
            change: "Ändern",
            deleteCalendar: "Kalender löschen",
            deleteCalendarSure: "Sind Sie sicher, dass Sie diesen Kalender löschen möchten?",
            notEmptyCalendarName: "Der Kalendername darf nicht leer sein",
            myEvents: "Meine Ereignisse",
            everyoneEvents: "Alle Ereignisse",
            haveEvent: "Ereignisse des Vertreters",
            goCalendar: "Zum Kalender gehen",
            goReservation: "Reservierung erstellen",
            agents: "Vertreter",
            today: "Heute",
            month: "Monat",
            week: "Woche",
            day: "Tag",
            list: "Liste",
        },
        ticimax: {
            segment: "Segment",
            settings_group: "Einstellungen",
            waitDayFromLastSend: "Wartezeit in Tagen seit der letzten gesendeten Nachricht",
            automationRuleName: "Name der Automatisierungsregel",
            time: "Zeit",
            year: "Jahr",
            month: "Monat",
            dayOfMonth: "Tag des Monats",
            day: "Tag",
            bySecond: "Pro Sekunde",
            byMinute: "Pro Minute",
            byHour: "Pro Stunde",
            byWeekNo: "Nach Wochennummer",
            byYearDay: "Nach Tag im Jahr",
            byMonthDay: "Nach Tag im Monat",
            byMonth: "Nach Monat",
            december: "Dezember",
            november: "November",
            october: "Oktober",
            september: "September",
            august: "August",
            july: "Juli",
            june: "Juni",
            may: "Mai",
            april: "April",
            march: "März",
            february: "Februar",
            january: "Januar",
            byWeekDay: "Nach Wochentag",
            interval: "Intervall",
            seconds: "Sekunden",
            minutes: "Minuten",
            hourly: "Stündlich",
            daily: "Täglich",
            weekly: "Wöchentlich",
            monthly: "Monatlich",
            yearly: "Jährlich",
            frequency: "Frequenz",
            attributes: {
                vip: "VIP",
                segment: "Segment",
                province: "Provinz",
                country: "Land",
                phone: "Telefon",
                email: "E-Mail",
                fullname: "Vollständiger Name",
                couponPercent: "% Rabatt",
                lastOrderDate: "Letzte Bestellung",
                firstOrderDate: "Erste Bestellung",
                county: "Landkreis",
                lastSource: "Letzte Quelle",
                firstSource: "Erste Quelle",
                lastPaymentType: "Letzte Zahlungsmethode",
                firstPaymentType: "Erste Zahlungsmethode",
                maxOrderAmount: "Maximaler Bestellbetrag",
                minOrderAmount: "Minimaler Bestellbetrag",
                totalOrderAmount: "Gesamtbestellmenge",
                totalOrderCount: "Gesamtanzahl der Bestellungen",
                usedCouponAmount: "Verwendeter Gutscheinbetrag",
                usedCouponCount: "Anzahl der verwendeten Gutscheine",
                tookDayFromLastOrder: "Tage seit der letzten Bestellung",
                isCouponUser: "Ist Gutscheinbenutzer",
            },
            createAutomation: "Automatisierung erstellen",
            previous: "Zurück",
            createAutomationDesc: "Erstellen und verwalten Sie die Automatisierung von Nachrichten",
            newTicimaxChannel: "Neuer Ticimax-Kanal",
            connextToTicimaxXml: "Mit Ticimax XML-Dienst verbinden",
            connectTicimax: "Mit Ticimax verbinden",
            examplePreview: "Beispielvorschau",
            completeAutomationRule: "Automatisierungsregel abschließen",
            configureMessage: "Nachricht konfigurieren",
            automationTimer: "Automatisierungs-Timer",
            findTargetMembers: "Zielmitglieder finden",
            createAutomationRule: "Automatisierungsregel erstellen",
            action: "Aktion",
            status: "Status",
            triggeredUserCount: "Ausgelöste Benutzeranzahl",
            nextScheduled: "Nächste geplante",
            timerRule: "Timer-Regel",
            automationRules: "Automatisierungsregeln",
            apply: "Anwenden",
            searchAMember: "Mitglied suchen",
            segmentedMembersDesc: "Listen und automatisieren Sie segmentierte Mitglieder",
            manageVisibilityDesc: "Verwalten Sie die Sichtbarkeit des Kanals",
            xmlOrderListURL: "URL der XML-Bestellliste",
            manageIntegrationDesc: "Verwalten Sie Ihre Ticimax-Integration",
            detail: "Detail",
            ticimaxChannelsTitle: "Ticimax-Kanäle",
            ticimaxDetail: "Ticimax-Detail",
            settingsGroup: "Einstellungen",
            visibility: "Sichtbarkeit",
            members: "Mitglieder",
            automation: "Automatisierung",
            integrationChannel: "Integrationskanal",
            channelUpdated: "Kanal erfolgreich aktualisiert",
            channelUpdateFailed: "Aktualisierung des Kanals fehlgeschlagen",
        },
        notification: {
            taskArchive: "Benachrichtigung wird gesendet, wenn eine Aufgabe archiviert wird.",
            taskComplet: "Benachrichtigung wird gesendet, wenn eine abgeschlossene Aufgabe geschlossen wird.",
            adjustNow: "Jetzt anpassen",
            chatAssignedMe: "Wenn ein Chat mir zugewiesen wird.",
            ticketAssignedMe: "Wenn ein Ticket mir zugewiesen wird.",
            myChatClosed: "Wenn ein Chat, den ich besitze, geschlossen wird.",
            contactOwner: "Wenn der Eigentümer des Chats wechselt, wenn das Eigentum zugewiesen oder entfernt wird.",
            tagActionsToVisitor: "Wenn ein Tag zu einem Besucher hinzugefügt oder entfernt wird.",
            ticketCreated: "Wenn ein Besucher oder Chatbot ein Ticket erstellt.",
            notesActions: "Wenn eine Notiz zu einem Kunden hinzugefügt oder entfernt wird.",
            visitorProfileUpdated: "Wenn das Profil eines Besuchers aktualisiert wird.",
            chatStartedByAnyPlatform: "Wenn ein Chat von einem beliebigen Kanal gestartet wird.",
            userActions: "Wenn ein Benutzer erstellt, aktualisiert oder gelöscht wird.",
            departmentActions: "Wenn eine Abteilung erstellt, aktualisiert oder gelöscht wird.",
            settingsActions: "Wenn Einstellungen erstellt, aktualisiert oder gelöscht werden.",
            integrationsActions: "Wenn ein Integrationskanal erstellt, aktualisiert oder gelöscht wird.",
            loginFormActions: "Wenn das Anmeldeformular aktualisiert oder aktiviert wird.",
            bannedWordActions: "Wenn ein verbotenes Wort erstellt, aktualisiert oder gelöscht wird.",
            emailActions: "Wenn ein E-Mail-Konto erstellt, aktualisiert oder gelöscht wird.",
            preparedContentActions: "Wenn vorbereiteter Inhalt erstellt, aktualisiert oder gelöscht wird.",
            roleActions: "Wenn eine Rolle erstellt, aktualisiert oder gelöscht wird.",
            tagActions: "Wenn ein Tag erstellt, aktualisiert oder gelöscht wird.",
            welcomeMessageActions: "Wenn eine Willkommensnachricht erstellt, aktualisiert oder gelöscht wird.",
            webhookActions: "Wenn ein Webhook erstellt, aktualisiert oder gelöscht wird.",
            billingEvents: "Wenn eine Rechnung erstellt oder ihr Status aktualisiert wird.",
            systemStatus: "Wenn der Status des Live-Support-Systems aktualisiert wird.",
            reservationMessageCrud: "Wenn eine Reservierung erstellt, aktualisiert oder gelöscht wird.",
            ipAddressWhiteListEvents: "Wenn eine erlaubte IP-Adresse hinzugefügt, aktualisiert oder gelöscht wird.",
            taskAssignedMe: "Wenn mir eine Aufgabe zugewiesen wird.",
            workflowCreated: "Wenn ein Workflow erstellt wird.",
            workflowDeleted: "Wenn ein Workflow gelöscht wird.",
            createdTask: "Wenn eine Aufgabe erstellt wird.",
            deletedTask: "Wenn eine Aufgabe gelöscht wird.",
            chatbotStoryCrud: "Wenn eine Chatbot-Geschichte erstellt, aktualisiert oder gelöscht wird.",
            chatbotForwardAgent: "Der Chatbot leitet einen Chat an einen Agenten weiter.",
            userSegmentCrud: "Wenn ein Benutzersegment erstellt, aktualisiert oder gelöscht wird.",
            chatbotCreditLow: "Wenn das Guthaben des Chatbots niedrig ist.",
            wpCreditLow: "Wenn das WhatsApp-Guthaben unter 100 TL fällt.",
            wpCustomerGroupCrud: "Wenn eine WhatsApp-Kundengruppe erstellt, aktualisiert oder gelöscht wird.",
            wpBroadcastMessageStatus:
                "Wenn das Senden einer WhatsApp-Broadcast-Nachricht gestartet, abgeschlossen oder abgebrochen wird.",
            wpTemplateMesssageCrud: "Wenn eine WhatsApp-Vorlagen-Nachricht erstellt, aktualisiert oder gelöscht wird.",
            whatsappQrChannelStatusUpdated: "Wenn der Verbindungsstatus des WhatsApp QR-Kanals aktualisiert wird.",
            activityTypeLabels: {
                "chat-assign": "Wenn mir ein Chat zugewiesen wird",
                "ticket-assign": "Wenn mir ein Ticket zugewiesen wird",
                "task-assign": "Wenn mir eine Aufgabe zugewiesen wird",
                "task-complet": "Wenn eine Aufgabe abgeschlossen wird",
                "chat-close-own": "Wenn ein Chat, der mir gehört, geschlossen wird",
                "tag-actions-to-visitor": "Tags werden zu einem Kontakt hinzugefügt oder entfernt",
                "create-ticket": "Ticket wird von Besucher oder Chatbot erstellt. Auch wenn eine Offline-Nachricht aus dem Chat-Fenster gesendet wird",
                "note-actions-to-visitor": "Notizen werden zu einem Kontakt hinzugefügt oder entfernt",
                "visitor-profile-updates": "Besucherprofil wird aktualisiert",
                "chat-start": "Chat wird auf einer beliebigen Plattform von Kontakt oder Agent gestartet",
                "user-crud": "Benutzer wird erstellt, aktualisiert oder gelöscht",
                "department-crud": "Abteilung wird erstellt, aktualisiert oder gelöscht",
                "settings-crud": "Einstellungen werden erstellt, aktualisiert oder gelöscht",
                "integration-channel-crud": "Integrationskanal wird erstellt, aktualisiert oder gelöscht",
                "login-form-crud": "Anmeldeformular wird aktualisiert, aktiviert oder deaktiviert",
                "banned-word-crud": "Verbotenes Wort wird erstellt, aktualisiert oder gelöscht",
                "email-account-crud": "E-Mail-Konto wird erstellt oder gelöscht",
                "prepared-content-crud": "Vorbereiteter Inhalt wird erstellt oder gelöscht",
                "role-crud": "Rolle wird erstellt, aktualisiert oder gelöscht",
                "tag-crud": "Tag wird erstellt, aktualisiert oder gelöscht",
                "welcome-message-crud": "Begrüßungsnachricht wird erstellt, aktualisiert oder gelöscht",
                "webhook-crud": "Webhook wird erstellt, aktualisiert oder gelöscht",
                "automation-created": "Automatisierung wird erstellt",
                "automation-deleted": "Automatisierung wird gelöscht",
                "automation-published": "Automatisierung wird veröffentlicht",
                "automation-unpublished": "Automatisierung wird nicht mehr veröffentlicht",
                "automation-updated": "Automatisierung wird aktualisiert",
                "billing-events": "Abrechnungsereignisse",
                "task-workflow-crud": "Aufgaben-Workflow wird erstellt, aktualisiert oder gelöscht",
                "task-crud": "Aufgabe wird erstellt, aktualisiert oder gelöscht",
                "system-status": "System online oder offline Statusänderungen",
                "chatbot-story-crud": "Chatbot-Geschichte wird erstellt, aktualisiert oder gelöscht",
                "chatbot-forward-chat": "Chatbot leitet einen Chat an einen Agenten weiter",
                "chatbot-user-segment-crud": "Benutzersegment wird erstellt, aktualisiert oder gelöscht",
                "chatbot-credit-low": "Wenn Chatbot-Guthaben niedrig ist",
                "whatsapp-credit-low": "Wenn WhatsApp-Guthaben niedrig ist",
                "whatsapp-customer-group-crud": "Wenn WhatsApp-Kundengruppe erstellt, aktualisiert oder gelöscht wird",
                "whatsapp-broadcast-message-crud": "Wenn WhatsApp-Broadcast-Nachricht gesendet, abgeschlossen oder abgebrochen wird",
                "whatsapp-template-message-crud": "Wenn WhatsApp-Vorlagennachricht erstellt, aktualisiert oder gelöscht wird",
                "form-created": "Formular wird erstellt",
                "form-updated": "Formular wird aktualisiert",
                "form-deleted": "Formular wird gelöscht",
                "form-restored": "Formular wird wiederhergestellt",
                "form-downloaded": "Formular wird heruntergeladen",
                "user-role-changed": "Benutzerrolle wird geändert",
                "user-password-changed": "Benutzerpasswort wird geändert",
                "user-email-changed": "Benutzer-E-Mail-Adresse wird geändert",
                "user-name-changed": "Benutzername wird geändert",
                "user-phone-changed": "Benutzertelefon wird geändert",
                "user-disabled": "Benutzer wird deaktiviert/aktiviert",
                "role-updated": "Rolle wird aktualisiert",
                "task-workflow-updated": "Aufgaben-Workflow wird aktualisiert",
                "task-workflow-pipeline-stage-added": "Aufgaben-Workflow-Pipeline-Stufe wird hinzugefügt",
                "task-workflow-pipeline-stage-updated": "Aufgaben-Workflow-Pipeline-Stufe wird aktualisiert",
                "task-workflow-pipeline-stage-deleted": "Aufgaben-Workflow-Pipeline-Stufe wird gelöscht",
                "drive-folder-created": "Drive-Ordner wird erstellt",
                "drive-folder-deleted": "Drive-Ordner wird gelöscht",
                "drive-folder-renamed": "Drive-Ordner wird umbenannt",
                "drive-file-added": "Datei wird zu Drive hinzugefügt",
                "drive-file-deleted": "Datei wird aus Drive gelöscht",
                "task-module-rules-enabled": "Aufgabenmodul-Regeln werden aktiviert",
                "task-module-rules-disabled": "Aufgabenmodul-Regeln werden deaktiviert",
                "task-module-rules-rule-added": "Regel wird zum Aufgaben-Workflow hinzugefügt",
                "task-module-rules-rule-deleted": "Regel wird aus Aufgaben-Workflow gelöscht",
                "task-module-rules-rule-updated": "Regel wird im Aufgaben-Workflow aktualisiert",
                "task-module-rules-rule-enabled": "Regel wird im Aufgaben-Workflow aktiviert",
                "task-module-rules-rule-disabled": "Regel wird im Aufgaben-Workflow deaktiviert",
                "contact-module-rules-enabled": "Kontaktmodul-Regeln werden aktiviert",
                "contact-module-rules-disabled": "Kontaktmodul-Regeln werden deaktiviert",
                "contact-module-rules-rule-added": "Regel wird zum Kontaktmodul hinzugefügt",
                "contact-module-rules-rule-updated": "Regel wird im Kontaktmodul aktualisiert",
                "contact-module-rules-rule-deleted": "Regel wird aus Kontaktmodul gelöscht",
                "contact-module-rules-rule-enabled": "Regel wird im Kontaktmodul aktiviert",
                "contact-module-rules-rule-disabled": "Regel wird im Kontaktmodul deaktiviert",
                "developer-token-changed": "Entwickler-Token wird aktualisiert",
                "table-created": "Tabelle wird erstellt",
                "table-field-added": "Feld wird zur Tabelle hinzugefügt",
                "table-field-updated": "Feld wird in Tabelle aktualisiert",
                "table-field-deleted": "Feld wird aus Tabelle gelöscht",
                "table-view-added": "Ansicht wird zur Tabelle hinzugefügt",
                "table-view-updated": "Ansicht wird in Tabelle aktualisiert",
                "table-view-deleted": "Ansicht wird aus Tabelle gelöscht",
                "table-page-added": "Seite wird zur Tabelle hinzugefügt",
                "table-page-updated": "Seite wird in Tabelle aktualisiert",
                "table-page-deleted": "Seite wird aus Tabelle gelöscht",
                "table-widget-added": "Widget wird zur Tabellenseite hinzugefügt",
                "table-widget-updated": "Widget wird auf Tabellenseite aktualisiert",
                "table-widget-deleted": "Widget wird von Tabellenseite gelöscht",
                "table-privacy-changed": "Tabellendatenschutzeinstellungen werden aktualisiert",
                "web-app-created": "Webanwendung wird erstellt",
                "web-app-updated": "Webanwendung wird aktualisiert",
                "web-app-deleted": "Webanwendung wird gelöscht",
                "web-tab-created": "Web-Tab wird erstellt",
                "web-tab-updated": "Web-Tab wird aktualisiert",
                "web-tab-deleted": "Web-Tab wird gelöscht",
                "module-created": "Modul wird erstellt",
                "module-updated": "Modul wird aktualisiert",
                "module-deleted": "Modul wird gelöscht",
                "relation-created": "Beziehung wird erstellt",
                "relation-updated": "Beziehung wird aktualisiert",
                "voice-agent-created": "Sprach-Agent wird erstellt",
                "voice-agent-updated": "Sprach-Agent wird aktualisiert",
                "voice-agent-deleted": "Sprach-Agent wird gelöscht",
                "voice-agent-phone-number-inbound-agent-changed": "Telefonnummer eingehender Anruf-Agent wird geändert",
                "voice-agent-phone-number-outbound-agent-changed": "Telefonnummer ausgehender Anruf-Agent wird geändert",
                "voice-agent-batch-call-created": "Batch-Anruf wird erstellt",
                "voice-agent-knowledge-base-created": "Wissensdatenbank wird erstellt",
                "voice-agent-knowledge-base-deleted": "Wissensdatenbank wird gelöscht",
                "table-data-downloaded": "Tabellendaten werden heruntergeladen",
                "table-data-imported": "Massenimport von Daten in Tabelle",
                "table-data-batch-updated": "Tabellendaten werden stapelweise aktualisiert",
                "table-data-batch-deleted": "Tabellendaten werden stapelweise gelöscht",
                "contact-batch-updated": "Kontakte werden stapelweise aktualisiert",
                "chat-data-downloaded": "Chat-Verlauf wird heruntergeladen"
            },
            crmActions: "CRM-Aktionen",
            mobileApp: "Mobile App",
            webPanel: "Web-Panel",
            notifications: "Benachrichtigungen",
            whatsappActions: "Whatsapp-Aktionen",
            chatbotActions: "Chatbot-Aktionen",
            companyActions: "Unternehmensaktionen",
            basicActions: "Grundlegende Aktionen",
            notificationSettingsDesc:
                "Wählen Sie aus, welche Benachrichtigungen Sie erhalten möchten und wo Sie sie erhalten möchten.",
            noNotificationDesc2:
                "Hier sehen Sie alle Benachrichtigungen zu den Stellenangeboten, Bewerbern und Talentpools, die Sie verfolgen. Sie können Benachrichtigungen anpassen, indem Sie die Einstellungen anpassen.",
            noNotificationTitle2: "Noch keine Benachrichtigungen.",
            noNotificationTitle1: "Keine Benachrichtigungen. Genießen Sie die Stille.",
            adjustSettings: "Einstellungen anpassen",
            showAll: "Alle anzeigen",
            showOnlyUnread: "Nur Ungelesene anzeigen",
            mailWasSent: "E-Mail wurde gesendet.",
            mailAdressRemoved: "E-Mail-Adresse entfernt.",
            chatbotPublished: "Version <b>{version}</b> des Chatbots wurde von <b>{user}</b> veröffentlicht.",
            chatbotDeleted: "Der Chatbot <b>{chatbot}</b> wurde von <b>{user}</b> gelöscht.",
            settingsUpdatedWoDetail: "Die Einstellungen wurden von <b>{user}</b> aktualisiert.",
            noActivityDesc: "Derzeit gibt es keine Aktivität im System. Ein paar Ereignisse müssen eintreten",
            noActivityTitle: "Bisher keine Aktivität",
            actionType: "Aktionsart",
            dateBetween: "Datum zwischen",
            selectActor: "Benutzer auswählen",
            activities: "Aktivitäten",
            chatbotCreated: "Der Chatbot mit dem Namen <b>{chatbot}</b> wurde von <b>{user}</b> erstellt.",
            taskAddedTags: "<b>{user}</b> hat diese Tags zur Aufgabe (<b>{taskTitle}</b>) hinzugefügt: <b>{tags}</b>",
            taskStageChanged:
                "Die Stufe der Aufgabe <b>{task}</b> wurde von <b>{user}</b> von <b>{oldStage}</b> auf <b>{newStage}</b> geändert.",
            taskCreated: "Die Aufgabe <b>{task}</b> wurde von <b>{user}</b> erstellt.",
            contactPropRemoved: "Das Besucherattribut <b>{prop}</b> wurde von <b>{user}</b> entfernt.",
            contactPropAdded: "Das Besucherattribut <b>{prop}</b> wurde von <b>{user}</b> hinzugefügt.",
            userRemoved: "<b>{oldUser}</b> Benutzer wurde von <b>{user}</b> entfernt.",
            loginFormUpdated: "Das Anmeldeformular für Besucher wurde von <b>{user}</b> aktualisiert.",
            loginFormDeactivated: "Le formulaire de connexion de l'utilisateur a été désactivé par <b>{user}</b>.",
            loginFormActivated: "Das Benutzeranmeldeformular wurde von <b>{user}</b> aktiviert.",
            invoiceRefunded: "Die Rückerstattung wurde von <b>{user}</b> vorgenommen.",
            paymentMethodAdded: "Eine neue Zahlungsmethode wurde von <b>{user}</b> hinzugefügt.",
            invoicePaymentFailed: "Die Rechnungszahlung wurde von <b>{user}</b> nicht akzeptiert.",
            invoicePaymentReceived: "Die Rechnungszahlung wurde von <b>{user}</b> akzeptiert.",
            planStarted: "<b>{user}</b> Пользователь начал подписку на <b>{title}</b> (<b>{altTitle}</b>).",
            planStartedAgent:
                "<b>{user}</b> Пользователь начал подписку на <b>{title}</b> <b>{altTitle}</b> (<b>{details} Представитель</b>).",
            planStartedChatbot:
                "<b>{user}</b> Пользователь начал подписку на <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} Сессия</b>).",
            planStartedWhatsapp:
                "<b>{user}</b> Пользователь начал подписку на <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} Whatsapp Каналы</b>).",
            planStartedWhatsappApi:
                "<b>{user}</b> Пользователь начал подписку на <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} Whatsapp Бизнес Каналы</b>).",
            PlanCanceled: "<b>{user}</b> Пользователь отменил подписку на <b>{title}</b> (<b>{altTitle}</b>).",
            planCanceledAgent:
                "<b>{user}</b> Пользователь отменил подписку на <b>{title}</b> <b>{altTitle}</b> (<b>{details} Представитель</b>).",
            planCanceledChatbot:
                "<b>{user}</b> Пользователь отменил подписку на <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} Сессия</b>).",
            planCanceledWhatsapp:
                "<b>{user}</b> Пользователь отменил подписку на <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} Whatsapp Каналы</b>).",
            planCanceledWhatsappApi:
                "<b>{user}</b> Пользователь отменил подписку на <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} Whatsapp Бизнес Каналы</b>).",
            invoiceCreated: "Rechnung wurde von <b>{user}</b> erstellt.",
            billingAddressUpdated: "Adressinformationen wurden von <b>{user}</b> aktualisiert.",
            taskWorkflowDeleted: "Workflow <b>{workflow}</b> wurde von <b>{user}</b> gelöscht.",
            whatsappBroadcastFailed: "Der Versand der Rundnachricht mit dem Titel <b>{title}</b> ist fehlgeschlagen.",
            whatsappBroadcastCancelled: "Der Versand der Rundnachricht mit dem Titel <b>{title}</b> wurde abgebrochen.",
            whatsappBroadcastCompleted:
                "Eine Rundnachricht mit dem Titel <b>{title}</b> wurde erfolgreich an <b>{numbers}</b> Empfänger gesendet.",
            whatsappBroadcastCreated:
                "Eine Rundnachricht mit dem Titel <b>{title}</b> wurde an <b>{numbers}</b> Empfänger von <b>{user}</b> gesendet.",
            ticketAssigned: "Ein Ticket wurde <b>{user1}</b> an <b>{user2}</b> zugewiesen.",
            userLoggedIn: "<b>{user}</b> hat sich bei SUPSIS angemeldet.",
            chatJoined: "<b>{agent}</b> ist dem Chat mit <b>{visitor}</b> beigetreten.",
            chatForwarded: "Der Chat mit <b>{visitor}</b> wurde von <b>{user}</b> an <b>{agent}</b> weitergeleitet.",
            chatAssigned: "Der Chat mit <b>{visitor}</b> wurde von dem System <b>{agent}</b> zugewiesen.",
            customerGroupUpdated: "Gruppe <b>{group}</b> wurde von <b>{user}</b> aktualisiert.",
            customerGroupRemoved: "Gruppe <b>{group}</b> wurde von <b>{user}</b> entfernt.",
            customerGroupAdded: "Gruppe <b>{group}</b> wurde von <b>{user}</b> erstellt.",
            contentRemoved: "Fertiger Inhalt <b>{content}</b> wurde von <b>{user}</b> entfernt.",
            contentAdded: "Fertiger Inhalt <b>{content}</b> wurde von <b>{user}</b> hinzugefügt.",
            channelVisibilityChanged:
                "Die Sichtbarkeit des Integrationskanals <b>{channel}</b> wurde von <b>{user}</b> geändert.",
            taskDeleted: "Die Aufgabe <b>{task}</b> wurde von <b>{user}</b> gelöscht.",
            taskCompleted: "<b>{task}</b> Aufgabe wurde von <b>{user}</b> abgeschlossen.",
            taskArchived: "<b>{user}</b> von <b>{task}</b> wurde archiviert.",
            userRemovedToDepartment:
                "<b>{user2}</b> Benutzer wurde von <b>{user1}</b> aus der <b>{department}</b> Abteilung entfernt.",
            userAddedToDepartment:
                "<b>{user2}</b> Benutzer wurde von <b>{user1}</b> zur <b>{department}</b> Abteilung hinzugefügt.",
            mailAddressAdded: "<b>{email}</b> E-Mail-Adresse hinzugefügt von <b>{user}</b>",
            settingUpdate: "Aktualisiert von <b>{user}</b>:",
            taskWFlowCreated: "<b>{Wflow}</b> Aufgabenworkflow erstellt von <b>{user}</b>.",
            bannedWordRemoved: "<b>{bWord}</b> verbotenes Wort wurde von <b>{user}</b> entfernt.",
            bannedWordCreated: "<b>{bWord}</b> verbotenes Wort wurde von <b>{user}</b> erstellt.",
            taskPriorityUpdated: "<b>{user}</b> hat die Priorität der Aufgabe <b>{taskTitle}</b> von <b>{oldPriority}</b> auf <b>{newPriority}</b> geändert",
            welcomeMessageRemoved: "<b>{welcome}</b> Willkommensnachricht wurde von <b>{user}</b> entfernt.",
            welcomeMessageAdded: "<b>{welcome}</b> Willkommensnachricht erstellt von <b>{user}</b>.",
            tagRemoved: "Tag <b>{tag}</b> entfernt von <b>{user}</b>.",
            tagAdded: "Tag <b>{tag}</b> hinzugefügt von <b>{user}</b>.",
            roleRemoved: "Rolle <b>{role}</b> entfernt von <b>{user}</b>.",
            roleAdded: "Rolle <b>{role}</b> hinzugefügt von <b>{user}</b>.",
            departmentRemoved: "Abteilung <b>{department}</b> entfernt von <b>{user}</b>.",
            departmentAdded: "Abteilung <b>{department}</b> hinzugefügt von <b>{user}</b>.",
            triggerUpdated: "Ein Trigger aktualisiert von <b>{user}</b>.",
            triggerRemoved: "Ein Trigger entfernt von <b>{user}</b>.",
            triggerAdded: "Ein neuer Trigger erstellt von <b>{user}</b>.",
            webhookRemoved: "Webhook von <b>{user1}</b>, entfernt von <b>{user2}</b>",
            webhookAdded: "Webhook hinzugefügt von <b>{user1}</b>, hinzugefügt von <b>{user2}</b>.",
            chatClosed: "Der Chat mit <b>{visitor}</b> wurde von <b>{agent}</b> beendet.",
            chatOwnerUpdated:
                "<b>{agent}</b> hat <b>{visitor}</b> von <b>{oldOwner}</b> zu <b>{newOwner}</b> neu zugewiesen.",
            customerOwnershipRemoved:
                "<b>{actor}</b> hat die Eigentümerschaft von <b>{visitor}</b> von <b>{oldOwner}</b> entfernt und unzugeordnet gelassen.",
            customerOwnershipAssigned:
                "<b>{actor}</b> hat die Eigentümerschaft von <b>{visitor}</b> von unzugeordnet zu <b>{newOwner}</b> zugewiesen.",
            customerOwnershipReassigned:
                "<b>{actor}</b> hat die Eigentümerschaft von <b>{visitor}</b> von <b>{oldOwner}</b> zu <b>{newOwner}</b> neu zugewiesen.",
            chatOpenedByAgent: "<b>{agent}</b> hat einen <b>{platform}</b>-Chat mit <b>{visitor}</b> gestartet.",
            chatOpenedByVisitor: "Ein <b>{platform}</b>-Chat wurde von <b>{visitor}</b> gestartet.",
            channelRemoved: "<b>{channel}</b>-Kanal wurde von <b>{agent}</b> entfernt.",
            userAdded: "<b>{agent}</b> hat einen Vertreter namens <b>{newAgent}</b> erstellt.",
            visitorUnblocked: "Besucher <b>{visitor}</b> wurde von Benutzer <b>{agent}</b> entsperrt.",
            visitorBlocked: "Besucher <b>{visitor}</b> wurde von <b>{agent}</b> blockiert.",
            userStatusChanged:
                "Benutzer <b>{name}</b> hat den Status von <b>{oldStatus}</b> auf <b>{newStatus}</b> geändert.",
            channelCreated: "Kanal <b>{channel}</b> wurde von <b>{name}</b> erstellt.",
            reservationCreatedPlan:
                "<b>{name}</b> Benutzer hat den Termin mit dem Namen <b>{title}</b> für den <b>{date}</b> geplant.",
            reservationUpdatedPlan: "<b>{name}</b> Benutzer hat den Termin mit dem Namen <b>{title}</b> aktualisiert.",
            reservationDeletedPlan: "<b>{name}</b> Benutzer hat den Termin mit dem Namen <b>{title}</b> gelöscht.",
            reservationCreated:
                "Eine Reservierung wurde für Benutzer <b>{name}</b> und Besucher <b>{visitor}</b> am <b>{date}</b> erstellt.",
            reservationDeleted:
                "Der Termin zwischen Benutzer <b>{name}</b> und Besucher <b>{visitor}</b> am <b>{date}</b> wurde storniert.",
            taskStatusChanged: "Wenn sich der Aufgabenstatus ändert",
            taskWorkflowCrud: "Aufgabenworkflow wird erstellt, aktualisiert oder gelöscht",
            taskCrud: "Aufgabe wird erstellt, aktualisiert oder gelöscht",
        },
        search: {
            prefix: {
                jump: "Git",
                new: "Neu",
                visitor: "Person",
                dm: "DM",
                chatbot: "Chatbot",
                automation: "Automatisierung",
                table: "Tisch",
                module: "Modul",
                message: "Nachricht",
            },
            kalender: "Kalender",
            soundSettings: "Audio-Benachrichtigungen",
            allNotificationSettings: "Benachrichtigungseinstellungen",
            allAuditLogs: "Audit-Protokolle",
            allNotifications: "Alle Benachrichtigungen",
            allActivities: "Alle Aktivitäten",
            workFlow: "Arbeitsablauf",
            editTask: "Aufgabe bearbeiten",
            tasks: "Aufgaben",
            todo: "Zu erledigende Aufgaben",
            tapTo: "Drücken Sie ⇥ für ‚{Präfix}‘-Vorgänge",
            newUsers: "Neuer ⇥ Benutzer",
            newTags: "Neuer ⇥ Tag",
            newRole: "Neue ⇥ Rolle",
            newTrigger: "Neuer ⇥ Trigger",
            newDepartment: "Neue ⇥ Abteilung",
            newTicket: "Neues ⇥ Ticket",
            jumpSettings: "Gehe ⇥ Einstellungen",
            jumpIntegrations: "Gehe ⇥ Integrationen",
            jumpTeam: "Gehe zu ⇥ Team",
            jumpUsers: "Gehe zu ⇥ Benutzer",
            jumpReport: "Gehe zu ⇥ Bericht",
            timingSettings: "Timing-Einstellungen",
            exampleVisitorMail: "Ziyaretçi@mail.com",
            languageAndRegion: "Sprache und Region",
            theme: "Thema",
            appearance: "Erscheinungsbild",
            color: "Farbe",
            background: "Hintergrund",
            intelligent: "Intelligent",
            teamChat: "Team-Chat",
            chatbot: "ChatBot",
            chatbotTraining: "Chatbot-Schulung",
            chatbotUserSegments: "Chatbot-Benutzersegmente",
            chatbotIntegration: "Chatbot-Integration",
            chatbotEntities: "Chatbot-Entitäten",
            chatbotIntegrationWebHook: "Chatbot-WebHook-Integration",
            chatbotArchiv: "Chatbot-Archiv",
            chatbotTemplatesAI: "Chatbot-Vorlagen für künstliche Intelligenz",
            chatbotTemplates: "Chatbot-Vorlagen",
            chatbotReportsOverall: "Chatbot-Gesamtberichte",
            chatbotReportsAllChats: "Chatbot-Berichte über alle Chats",
            chatbotReportsRatingDistribution: "Bewertungsverteilung von Chatbot-Berichten",
            chatbotReportsPaidChats: "Chatbot-Berichte über bezahlte Chats",
            chatbotReportsBusiestPeriod: "Geschäftigster Zeitraum des Chatbots",
            chatbotTemplatesAllMessages: "Chatbot-Vorlagen für alle Nachrichten",
            chatbotTemplatesAverage: "Chatbot-Vorlagen Durchschnitt",
            chatbotTemplatesPopularity: "Beliebtheit von Chatbot-Vorlagen",
            chatbotTemplatesAllUser: "Chatbot-Vorlagen für alle Benutzer",
            ticket: "Supportanfragen",
            archives: "Archiv",
            tags: "Tags",
            offlineSupportRequests: "Offline-Support-Anfragen",
            roles: "Rollen",
            users: "Benutzer",
            departments: "Abteilungen",
            contents: "Sofortige Inhalte",
            welcomeMessages: "Systemnachrichten",
            catalog: "Katalog",
            bannedWords: "Verbotene Wörter",
            bannedVisitors: "Verbotene Besucher",
            application: "Anwendung",
            mails: "Mailer",
            visitors: "Besucher",
            integrationsWebhook: "Webhook-Integration",
            billing: "Rechnung",
            reportNew: "Neuer Bericht",
            integrations: "Integrationen",
            chatbotStory: "Chatbot-Geschichten",
            searchPlaceHolder: "Suchen, Gehen oder Hinzufügen...",
            searchAreaTitle: "Supsis suchen",
            searchAreaDesc1: "Sie können nach allem suchen. Nur",
            searchAreaDesc2: "oder",
            searchAreaDesc3: "Tippen Sie oder suchen Sie nach irgendetwas.",
            navigateBtn: "Navigieren",
            selectBtn: "Auswählen",
            cancelBtn: "Abbrechen",
            integration: {
                shouldByInstaPack:
                    "Sie sollten Instagram-Pakete kaufen, um einen Instagram-Kanal zu erstellen. Sie können die Pakete mit erschwinglichen Preisen sofort erreichen.",
                createInstaLimitMax: "Sie haben das Limit für die Erstellung eines Instagram-Kanals erreicht. Maximun",
                createInstaContinue:
                    "Sie können einen Instagram-Kanal erstellen. Um fortzufahren, aktualisieren Sie Ihr Paket oder löschen Sie einige Ihrer Instagram-Kanäle.",
                privatePolicy: "Private Policy",
                termsAndCondition: "Allgemeine Geschäftsbedingungen",
                readAndAgree: "Ich habe gelesen und stimme zu",
                shouldByMessengerPack:
                    "Sie müssen ein Messenger-Paket erwerben, um einen Messenger-Kanal zu erstellen. Sie können die Pakete mit erschwinglichen Preisen sofort erreichen.",
                createMessengerLimitMax:
                    "Sie haben das Limit für die Erstellung von Messenger-Kanälen erreicht. Maximun",
                createMessengerContinue:
                    "Sie können einen Messenger-Kanal erstellen. Um fortzufahren, aktualisieren Sie Ihr Paket oder löschen Sie einige Ihrer Messenger-Channels.",
                selectMessengerAccount: "Messenger-Konto auswählen",
                forwardLiveAgents: "👉 Forward Live Agents",
                allDepartments: "Alle Abteilungen",
                deleteAll: "Alle löschen",
                wpBusinessAPI: "Integrationen - Whatsapp Business API-Kanäle",
                wpV1: "Integrationen - Mehrere Whatsapp-Kanäle",
                instagram: "Integrationen - Instagram",
                instagramContactList: "Integrationen - Instagram Kontaktliste",
                mail: "Integrationen - Mail",
                whatsapp: "Integrationen - Whatsapp",
                whatsappContactList: "Integrationen - Whatsapp-Kontaktliste",
                wpBCRequests: "Integrationen - Whatsapp Bulk Message Requests",
                wpBCCustomerGroups: "Integrationen - Whatsapp Massenkundengruppen",
                wpBCTemplates: "Integrationen - Whatsapp Massen-Nachrichtenvorlagen",
                chatbot: "Integrationen - ChatBot",
            },
            settings: {
                settings: "Einstellungen",
                features: "Einstellungen - Funktionen",
                languageAndRegion: "Einstellungen - Sprache und Region",
                bubbleSettings: "Einstellungen - Sprechblaseneinstellungen",
                bubbleActions: "Einstellungen - Sprechblasen-Aktionen",
                themeSettings: "Einstellungen - Themen-Einstellungen",
                visitorLoginForm: "Einstellungen - Anmeldeformular für Besucher",
                visitorAttribute: "Einstellungen - Besucherattribute",
                talkSettings: "Einstellungen - Sprech-Einstellungen",
                autoAssign: "Einstellungen - Automatische Zuweisung",
                chatTimingSettings: "Einstellungen - Chat-Zeiteinstellungen",
                availability: "Einstellungen - Verfügbarkeit",
                websiteIntegration: "Einstellungen - Website-Integration",
                developer: "Einstellungen - Entwickler",
            },
        },
        mail: {
            errorStatus: "Fehlerstatus",
            mailSendErrorTitle: "Nicht zugestellte E-Mails",
            mailSendErrorDescription: "Gesamtzahl der nicht zugestellten E-Mails",
            fixGrammarTitle: "Grammatik-Korrektur",
            expandTextTitle: "Texterweiterung",
            summaryTitle: "Zusammenfassung",
            changeToneTitle: "Ton ändern",
            translationTitle: "Übersetzung",
            replyTitle: "Antwort",
            customRequestTitle: "Antwort auf Sonderwunsch",
            viewMode: "Ansichtsmodus",
            singleView: "Einzelansicht",
            splitView: "Geteilte Ansicht",
            folders: "Ordner",
            sendError: "Beim Senden der E-Mail ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
            visitorCreationError: "Fehler beim Erstellen des Besuchers. Bitte versuchen Sie es später erneut.",
            onlyImageAllowed: "Nur Bilddateien sind erlaubt.",
            imageFileTooLarge: "Die Bilddatei ist zu groß. Die maximale Größe beträgt 10 MB.",
            imageUploaded: "Bild erfolgreich hochgeladen.",
            imageUploadError: "Beim Hochladen des Bildes ist ein Fehler aufgetreten.",
            mailAiAssistant: {
                aiCreateSummarized: "KI-Zusammenfassung erstellen",
                aiSentimentAnalysis: "KI-Stimmungsanalyse",
                contentRequired: "E-Mail-Inhalt ist erforderlich, um diese Funktion zu nutzen",
                grammarFixed: "Grammatik wurde korrigiert",
                aiError: "Der KI-Assistent ist auf einen Fehler gestoßen",
                contentExpanded: "E-Mail-Inhalt wurde erweitert",
                emailSummarized: "E-Mail wurde zusammengefasst",
                toneChanged: "Ton geändert zu {tone}",
                emailTranslated: "E-Mail wurde ins {language} übersetzt",
                replyGenerated: "Automatische Antwort wurde erstellt",
                contentUpdated: "Inhalt wurde aktualisiert",
                contentRebuilt: "Inhalt wurde neu erstellt",
                contentRebuildFailed: "Neuerstellung des Inhalts fehlgeschlagen",
                customRequestEmpty: "Bitte geben Sie eine Anfrage ein",
                customRequestApplied: "Benutzerdefinierter Inhalt wurde angewendet",
                loadingText: "KI arbeitet",
                loadingDescription: "Text wird analysiert, bitte warten...",
                aiTitle: "E-Mail KI-Assistent",
                aiDescription: "KI-Tools zum Verbessern, Bearbeiten und Analysieren Ihrer E-Mail",
                emptyContentTitle: "Kein E-Mail-Inhalt gefunden",
                emptyContentDescription: "Zum Verwenden der KI-Funktionen ist E-Mail-Inhalt erforderlich.",
                limitedAccessDescription: "Nur eingeschränkte Funktionen verfügbar, da kein Inhalt vorhanden ist.",
                resultEmotions: "Erkannte Emotionen",
                analysisDescription: "Analysebeschreibung",
                recommendationsList: "Verbesserungsvorschläge",
                mailSummarize: "E-Mail-Zusammenfassung",
                aiResponse: "Von KI generiert",
                rebuild: "Neu erstellen",
                applyText: "Text übernehmen",
                specialRequest: "Benutzerdefinierte Anfrage",
                specialRequestPlaceholder: "Geben Sie hier Ihre benutzerdefinierten Anweisungen ein...",
                sendRequest: "Anfrage senden",
                fixGrammarTitle: "Grammatik korrigieren",
                fixGrammardescription: "Rechtschreib- und Grammatikfehler automatisch korrigieren",
                expandTextTitle: "Text erweitern",
                expandTextDescription: "Macht Ihren Text umfassender und detaillierter",
                changeToneTitle: "Ton ändern",
                changeToneDescription: "Ändert Ton und Stil des Textes entsprechend Ihrem Wunsch",
                changeTone_ProfessionalTitle: "Professionell",
                changeTone_ProfessionalDescription: "Formeller und professioneller Ton für den Arbeitsplatz",
                changeTone_FriendlyTitle: "Freundlich",
                changeTone_FriendlyDescription: "Herzlicher und freundlicher Ansatz",
                changeTone_CasualTitle: "Locker",
                changeTone_CasualDescription: "Entspannter und umgangssprachlicher Ton",
                changeTone_FormalTitle: "Formell",
                changeTone_FormalDescription: "Sehr formeller und geschäftlicher Stil",
                changeTone_ConfidentTitle: "Selbstbewusst",
                changeTone_ConfidentDescription: "Starker und eindrucksvoller Ausdrucksstil",
                translateTitle: "Übersetzen",
                translateDescription: "Übersetzt Ihren Text in verschiedene Sprachen",
                generateReplyTitle: "Antwort generieren",
                generateReplyDescription: "Erstellt automatisch eine passende Antwort auf die empfangene E-Mail",
                customPromptTitle: "Benutzerdefinierte Anfrage",
                customPromptDescription: "Erstellt E-Mail-Inhalt basierend auf Ihren benutzerdefinierten Anweisungen"
            },
            searchEmail: "E-Mail suchen...",
            emailAttachments: "Anhänge ({count})",
            signatureMessage: "Ihre E-Mail-Signatur ist vorhanden. Möchten Sie sie dem Inhalt hinzufügen?",
            emailSubject: "E-Mail-Betreff",
            takeItBack: "Rückgängig",
            fastForward: "Wiederholen",
            addEmoji: "Emoji hinzufügen",
            addLink: "Link hinzufügen",
            bold: "Fett",
            italic: "Kursiv",
            underline: "Unterstrichen",
            fontFamily: "Schriftart",
            textColor: "Textfarbe",
            stringFormats: "Textformate",
            alignLeft: "Links ausrichten",
            alignRight: "Rechts ausrichten",
            alignCenter: "Zentrieren",
            normalText: "Normaler Text",
            participantList: "{first}, {second}, {third} +{remaining} weitere",
            noMailFound: "Keine E-Mails gefunden",
            selectedMail: "{count} E-Mail ausgewählt",
            recipientEmailAddress: "E-Mail-Adresse des Empfängers",
            CCreceivers: "CC-Empfänger",
            BCCreceivers: "BCC-Empfänger",
            emptyStateMessage: "Wählen Sie eine E-Mail oder erstellen Sie eine neue",
            FromName: "Name des Absenders",
            broadcastCreatedSuccess: "Übertragung erfolgreich erstellt",
            confirmArchive: "Sind Sie sicher, dass Sie diese Übertragung archivieren möchten?",
            archive: "Archivieren",
            cancel: "Abbrechen",
            archiveSuccess: "Übertragung erfolgreich archiviert",
            archiveError: "Fehler beim Archivieren der Übertragung",
            empty: "Leer",
            summerDiscounts: "Sommerangebote",
            opportunities: "Möglichkeiten",
            newMailTemplateCreated: "Neue E-Mail-Vorlage erstellen.",
            dateRange: "Datumsbereich",
            templateName: "Name der Vorlage",
            category: "Kategorie",
            templateUpdateSucs: "Die Vorlage wurde erfolgreich aktualisiert.",
            templateUpdateError: "Bei der Aktualisierung der Vorlage ist ein Fehler aufgetreten.",
            marketing: "Marketing",
            operativ: "Operativ",
            custom: "Speziell",
            pleaseEnterTemplateName: "Bitte geben Sie den Vorlagennamen ein",
            pleaseEnterTemplateSubject: "Bitte geben Sie den Betreff der Vorlage ein",
            pleaseSelectTemplateCategories: "Bitte wählen Sie die Kategorie der Vorlage",
            representMails: "Repräsentative Mails",
            otherRepresentMails:
                "Sie können eingehende und ausgehende E-Mails an und von den E-Mail-Adressen anderer Vertreter verfolgen.",
            signatureAutoAdd: "Der Status des automatischen Hinzufügens von Unterschriften wurde erfolgreich geändert",
            autoAdd: "Automatisches Hinzufügen",
            forwardEmailAddSucs: "Weiterleitungs-E-Mail-Adresse erfolgreich hinzugefügt.",
            errorAddingForwardEmail: "Beim Hinzufügen einer Weiterleitungs-E-Mail-Adresse ist ein Fehler aufgetreten",
            mailAddForward: "Manuelles Hinzufügen (Weiterleitung abgeschlossen)",
            mailAddForwarding: "Manuelles Hinzufügen (ich habe die Weiterleitung abgeschlossen)",
            broadcast: "Veröffentlichungen",
            templates: "Vorlagen",
            newMailArrived: "Neue E-Mail eingetroffen.",
            mailSentSucs: "Mail erfolgreich gesendet",
            representativeMails: "Repräsentative Mail",
            composeNewEmail: "Neue E-Mail verfassen",
            couldNotUserMail: "Konnte keine E-Mail senden, weil es keine Benutzer-Mail gibt",
            mailAddressReq: "Mail-Adresse erforderlich.",
            emailAddressInvalid: "Mail-Adresse ungültig.",
            departmentIsNotValid: "Abteilung nicht gültig",
            mailSendNotValid: "Ungültige Mailadresse",
            routingSteps: "Routing-Schritte",
            owner: "Besitzer",
            whereHeDirected: "Wohin er geleitet hat",
            forwardingEmailAddress: "Weiterleitungs-E-Mail-Adresse",
            deleteMailDesc: "Dieser Vorgang kann nicht rückgängig gemacht werden.",
            deleteMailTitle: "Möchten Sie diese E-Mail-Adresse wirklich löschen?",
            gmailForwardMail: "Gmail E-Mail-Weiterleitung",
            senderMailAddressDesc: "Bitte geben Sie die E-Mail-Adresse des Absenders ein",
            verified: "Verifiziert",
            notForwarded: "Nicht weitergeleitet",
            notVerified: "Nicht verifiziert",
            default: "Standard",
            isVerified: "Verifiziert",
            forwarding: "Weiterleitung",
            mailAdress: "E-Mail-Adresse",
            addSenderAddress: "Absenderadresse hinzufügen",
            outlookForward: "Microsoft (Outlook/Exchange) Weiterleitung",
            gmailForward: "Google (Gmail) Weiterleitung",
            senderMail: "Absendermail",
            mailDetail: "E-Mail-Detail",
            mailNotFound: "E-Mail nicht gefunden",
            mailSelecting: "E-Mail-Auswahl",
            newMail: "Neue E-Mail",
            myMails: "Meine E-Mails",
            inbox: "Posteingang",
            sent: "Gesendet",
            departmentMails: "Abteilungsemails",
            newTemplate: "Neue Vorlage",
            unread: "Ungelesen",
            unreply: "Unanswered",
            reply: "Antworten",
            attachments: "E-Mail-Anhänge",
            To: "An",
            From: "Von",
            placeHolders: "Platzhalter",
            attacheFiles: "Dateien anhängen",
            replyAll: "Allen antworten",
            forward: "Weiterleiten",
            deleteThread: "Thread löschen",
            markAsRead: "Als gelesen markieren",
            markAsAllRead: "Alle als gelesen markieren",
            emailEditor: "E-Mail-Editor",
            integrateYourMail: "Integrieren Sie Ihre E-Mail",
            connect: "Verbinden",
            departmentMail: "Abteilungs-E-Mail",
            createMailAddress: "E-Mail-Adresse erstellen",
            createNewMail: "Neue E-Mail erstellen",
        },
        visitor: {
            ownership: "Eigentum",
            visitors: "Besucher",
            bannedVisitors: "Gesperrte Besucher",
            tags: "Tags",
            profileFields: "Profilfelder",
            downloadAll: "Alle herunterladen",
            saveAsCustomerGroup: "Als Kundengruppe speichern",
            saveSearchFavorite: "Suche als Favorit speichern",
            mail: "Mail",
            visitorDetail: "Besucherdetails",
            selectedUser: "{selectedUser} von {totalUsers} Benutzern ausgewählt",
            uncheck: "Alle abwählen",
            checkAll: "Alle auswählen",
            matchedUsers: "{checkedCount} Benutzer übereinstimmend",
            more: "Mehr",
            exportUsers: "Ausgewählte Benutzer exportieren",
            exportAllUsers: "Alle Benutzer exportieren",
            addSegment: "Segment hinzufügen",
            deleteCheckedUser: "Ausgewählte Benutzer löschen",
            deleteAllUser: "Alle Benutzer löschen",
            matchedFilter: "Alle Filter übereinstimmend",
            visitor: "Besucher",
            deleteUser: "Benutzer löschen",
            userData: "Benutzerdaten",
            lastSession: "Letzte Sitzung",
            notUserData: "Keine Benutzerdaten gefunden",
            segments: "Segmenten",
            addTag: "Tag hinzufügen",
            userChats: "Benutzer-Chats",
            seeAll: "Alle anzeigen",
            confirm: "Bestätigen",
            manageSegments: "Segment verwalten",
            search: "Suchen",
            manageTags: "Tags verwalten",
            allAttributes: "Alle Attribute anzeigen",
            noData: "Keine Daten",
            noEmail: "Keine E-Mail",
            noIpAddress: "IP-Adresse nicht gefunden.",
            noWpNumber: "Nummer nicht gefunden.",
            filterName: "Filtername..",
            matchedContacts: "{chechkedCount} Kontakte abgeglichen",
        },
        chatbotv2: {
            Ticket_Actions: "Ticket-Aktionen",
            Task_Actions: "Aufgaben-Aktionen",
            Contact_Actions: "Personen-Aktionen",
            Calendar_Actions: "Kalender-Aktionen",
            "T-Soft_Actions": "T-Soft-Aktionen",
            "Ticimax-V2_Actions": "Ticimax Aktionen",
            TSOFT_SELECT_ORDER: "BESTELLUNG AUSWÄHLEN",
            TSOFT_ORDER_STATUS: "BESTELLSTATUS ABFRAGEN",
            TICIMAX_V2_SELECT_ORDER: "BESTELLUNG AUSWÄHLEN",
            TICIMAX_V2_ORDER_STATUS: "BESTELLSTATUS ABFRAGEN",
            Ikas_Actions: "Ikas Aktionen",
            IKAS_GET_MEMBER_INFO: "Mitgliederdetails abrufen",
            IKAS_SELECT_ORDER: "Bestellung auswählen",
            IKAS_ORDER_STATUS: "Bestellstatus abrufen",
            IDEASOFT_PRODUCT_SEARCH: "Produktsuche",
            privateMessageDescription: "Private Nachrichten können nur von Vertretern eingesehen werden und bleiben für Besucher verborgen.",
            AI_RANDOM_TEXT: "KI-Zufallstext",
            AI_IMAGE: "KI-Bild",
            PRIVATE_MESSAGE: "Private Nachricht",
            aiPrompt: "Aufforderung",
            variants: "Varianten",
            Zoho_Actions: "Zoho-Aktionen",
            Table_Actions: "Tabellenaktionen",
            File_Actions: "Dateiaktionen",
            Data_Formatters: "Datenformatierer",
            Loop_Actions: "Schleifenaktionen",
            importSuccess: "Vorlage erfolgreich importiert",
            importFailed: "Fehler beim Importieren der Vorlage",
            creatingBlank: "Leerer ChatBOT wird erstellt...",
            untitledChatbot: "Unbenannter ChatBOT",
            errorCreating: "Fehler beim Erstellen des ChatBOT",
            typeAutomationTitle: "Geben Sie den Automatisierungstitel ein",
            typeStoryTitle: "Schreiben Sie einen Geschichten-Titel",
            setUpYourChatbot: "Richten Sie Ihren Chatbot ein",
            setUpYourChatbotDesc:
                "Trainieren Sie Ihren Chatbot mit Daten, verwenden Sie unsere gebrauchsfertigen Vorlagen oder fangen Sie ganz von vorne an.",
            blankBot: "Leerer Bot",
            blankBotDesc: "Erstellen Sie einen leeren Chatbot, den Sie später trainieren und anpassen können.",
            websiteDesc: "Scannen Sie den Inhalt Ihrer Website, um Antworten auf beliebte Nutzerfragen zu erhalten.",
            yourNeedEnterYourOpenAi:
                "Sie müssen Ihren OpenAI-API-Schlüssel eingeben, um einen automatisierten Chatbot durch Crawlen Ihrer Website zu erstellen.",
            createOpenAiKey: "Api-Schlüssel erstellen",
            aiKnowledge: "Wissen über künstliche Intelligenz",
            modalUsage: "Modale Verwendung",
            usedContentSources: "Verwendete Inhaltsquellen",
            websites: "Websites",
            articles: "Artikel",
            faq: "Häufig gestellte Fragen",
            files: "Dateien",
            functions: "Funktionen",
            settings: "Einstellungen",
            disableAi: "KI deaktivieren",
            enableAi: "Künstliche Intelligenz einschalten",
            lastEdited: "Zuletzt bearbeitet",
            state: "Status",
            frequentlyAskedQuestions: "Häufig gestellte Fragen (FAQ)",
            faqIsCreated: "FAQ erstellt",
            selectKnowEnabled: "Aktivieren der ausgewählten Wissensdatenbanken...",
            selectKnowDisabled: "Die ausgewählten Wissensdatenbanken sind deaktiviert...",
            selectKnowNotEnabled: "Die ausgewählten Wissensbasen sind nicht aktiviert...",
            selectKnowNotDisabled: "Die ausgewählten Wissensdatenbanken sind nicht deaktiviert.",
            answered: "Beantwortet",
            answer: "Antwort",
            addFile: "Datei hinzufügen",
            fileDeleted: "Dateien gelöscht",
            fileDeletedFailed: "Es gab ein Problem beim Löschen von Dateien",
            noFileAdded: "Keine Datei hinzugefügt",
            aiFunctions: "AI-Funktionen",
            addFunction: "Funktion hinzufügen",
            parameterCount: "Anzahl der Parameter",
            auto: "Auto",
            usedByAI: "Von KI verwendet",
            usedByAi: "Von der KI verwendet",
            notUsed: "Nicht benutzt",
            saveAndClose: "Speichern und schließen",
            contentPreview: "Inhaltsvorschau",
            addContent: "Inhalt hinzufügen",
            populerUserQuestion:
                "Durchsucht den Inhalt Ihrer Website, um Antworten auf beliebte Nutzerfragen zu erhalten.",
            enterUrlAddress: "Geben Sie eine URL-Adresse ein",
            sharingYourUrl:
                "Indem Sie Ihre URL freigeben, bestätigen Sie, dass Sie die notwendigen Rechte haben, um den Inhalt freizugeben.",
            pageSelected: "Ausgewählte Seiten",
            trainChatbot: "Den Chatbot trainieren",
            thereAreOnePages: "Es befindet sich 1 Seite darin",
            categoryDesc: "Kategorie. Wählen Sie, welche Sie zum Trainieren Ihres KI-Modells verwenden möchten.",
            scarpOrAddContent:
                "Scannen oder Hinzufügen von Inhalten, die AI Assist verwenden kann, um die Anfragen Ihrer Kunden zu beantworten",
            noContentAdded: "Kein Inhalt hinzugefügt",
            howItWorks: "Wie es funktioniert",
            editEntries: "Einträge bearbeiten",
            newEntries: "Neue Einträge",
            chatbotManagement: "Chatbot-Verwaltung",
            chatbotScenarioList: "Chatbot Schenerio Liste",
            exportDiagramToClipboard: "Diagramm in die Zwischenablage exportieren",
            selectedStory: "{count} Geschichte ausgewählt",
            Meta_Actions: "Meta Actions",
            suppressionRemoved: "Unterdrückung entfernt",
            suppressionAdded: "Unterdrückung hinzugefügt",
            didntSuppression: "Sie haben keine Unterdrückung vorgenommen.",
            whatsappIntegrationTitle: "WhatsApp V1 und WhatsApp V2 Integration",
            whatsappApiIntegrationTitle: "WhatsApp Business API Integration",
            ReadyTemplateBadge: "Fertige Vorlage",
            readyTemplates: "Fertige Vorlagen",
            regex: "Regex",
            regexDescription: "Regex ile herşeyi yakala",
            chatbotLogo: "ChatBot-Logo",
            chatbotName: "ChatBot-Name",
            allSecnario: "Liste der Chatbot-Szenarien",
            ChatbotScenarioList: "Liste der Chatbot-Szenarien",
            Scenario: "Szenario",
            filters: {
                equal: "gleich",
                not_equal: "nicht gleich",
                contain: "enthält",
                not_contain: "beteiligt",
                starts_with: "Beginnt mit",
                ends_with: "endet mit",
                empty: "Wenn es leer ist",
                non_empty: "Wenn nicht leer",
                longer_than: "Wenn länger",
                shorter_than: "Wenn kürzer",
                less_than: "Wenn klein",
                less_or_equal: "Wenn klein oder gleich",
                greater_than: "Wenn groß",
                greater_or_equal: "Wenn groß oder gleich",
            },
            planRequired: "{integratable} Plan ist erforderlich.",
            noDefaultStoryTitle: "Standardgeschichte",
            noDefaultStory: "Sie haben nicht die Standardgeschichte.",
            noMessage: "Keine Nachricht",
            loading: "Wird geladen",
            loadMore: "Mehr",
            hostname: "Hostname",
            allTemplates: "Alle Vorlagen",
            allAITemplates: "Alle KI-Vorlagen",
            templatesFromTheIndustry: "Vorlagen aus der Industrie",
            basicTemplate: "Grundlegende Vorlage",
            proTemplate: "Erweiterte Vorlage",
            goToStory: "in die Geschichte gehen",
            noResultFound: "Es wurden keine Ergebnisse gefunden",
            checkYourFilterCombination: "Überprüfen Sie die Filterkombination",
            clearYourSearch: "Reinigen Sie die Suche",
            andTryAgain: "und versuche es erneut",
            withBot: "& Stiefel",
            userWithBot: "Benutzer & Bot",
            chatDetail: "Chat -Details",
            allUserDetail: "Siehe alle Benutzerdetails",
            sessionData: "Sitzungsdaten",
            supsisChatWidget: "SUPSIS -Chat -Tool",
            integratedWith: "Integriert in Folgendes:",
            integration: "Integration",
            Users: "Benutzer",
            user_id: "Benutzer-ID",
            botStory: "Bootsgeschichte",
            categories: "Kategorien",
            worksWith: "Arbeitet mit",
            importBot: "Verwenden Sie Bot",
            keyFeatures: "HAUPTEIGENSCHAFTEN",
            importing: "hinzugefügt",
            comingSoon: "Bald zu Ihrem Service",
            pickStory: "Wählen Sie Geschichte",
            conversationId: "Sprachausweise",
            integrateStoryWithSupsisWidget: "Integrieren Sie das Supisis -Widget in die Chatbot -Geschichte",
            integrateStoryWithWhatsapp: "Integrieren Sie WhatsApp in Chatbot Story",
            integrateStoryWithInstagram: "Integrieren Sie Instagram in die Chatbot -Geschichte",
            selectIntegratingStory: "Wählen Sie die integrierte Geschichte aus",
            install: "Belastung",
            attr: {
                weekday: "Weekday",
                channelId: "Channel",
                email: "Email",
                phone: "Phone",
                language: "Sprache",
                timezone: "Zeitzone",
                gender: "Geschlecht",
                country: "Land",
                referrer: "Referenz",
                url: "Adresse besuchen",
                ip: "SEIL",
                last_seen: "Zuletzt gesehen",
                name: "Name",
                user_id: "Benutzernummer",
                department: "Abteilung",
                message: "Nachricht",
                akinon_brand: "Marke",
                akinon_order_id: "Bestellnummer",
                akinon_product_id: "Produktnummer",
                akinon_user_id: "Benutzer-ID",
                akinon_user_name: "Nutzername",
                akinon_user_email: "Benutzer Email",
                akinon_invoice_url: "Rechnungs -URL",
                akinon_order_status: "Bestellstatus",
                akinon_order_price: "Bestellpreis",
                akinon_shipper_name: "Cargo Firmenname",
                akinon_product_size: "Produktkörper",
                akinon_sku: "Skue",
                akinon_product_url: "Produkt -URL",
                akinon_product_title: "Produktüberschrift",
                akinon_product_image: "Produktbild",
                akinon_product_stock: "Produktbestand",
                akinon_order_date: "Auftragsdatum",
                akinon_track_number: "Versandnummer",
                akinon_track_url: "Frachtverfolgungs -URL",
                akinon_latitude: "Breitengrad (Ort)",
                akinon_longitude: "Länge (Ort)",

                ideasoft_user_id: "Member Id",
                ideasoft_invoice_url: "Invoice Url",
                ideasoft_order_id: "Sipariş Numarası",
                ideasoft_order_status: "Order Status",
                ideasoft_order_price: "Order Price",
                ideasoft_shipper_name: "Shipper Name",
                ideasoft_product_size: "Product Size",
                ideasoft_sku: "Sku",
                ideasoft_product_url: "Product Url",
                ideasoft_product_title: "Product Title",
                ideasoft_product_image: "Product Image",
                ideasoft_product_stock: "Product Stock",
                ideasoft_order_date: "Order Date",
                ideasoft_track_number: "Track Number",
                ideasoft_track_url: "Track Url",
                idleUserTime: "User Last Action (Second)",
                ai_class_result: "AI Class Result",
                meta_comment_id: "Meta Comment ID",
                meta_comment: "Meta Comment",
                meta_post_id: "Meta Post ID",
                last_meta_post_id: "Letzte Meta-Post-ID",
                last_meta_post_caption: "Letzte Meta-Post-Beschriftung",
                last_meta_post_type: "Letzter Meta-Post-Typ",
                visitor_trigger_type: "Besucher-Triggertyp",
                visitor_trigger_name: "Name des Besucher-Triggers",
                offline_mode: "Offline-Modus",
                available_agents: "Geeignete Vertreter",
                platform: "Plattform",
                hour: "Stunde",
                segments: "Segments",
                tags: "Tags",
                ticket: "Fahrkarte",
                metaReferrals: "Meta-Verweise",
            },
            storyList: "Story List",
            douYouWannaDeleteItem: "Möchten Sie diesen Artikel löschen?",
            douYouWannaDeleteWithChildren: "Möchten Sie dieses Element mit den Sub -Elementen löschen?",
            stories: "Geschichten",
            templates: "Vorlagen",
            aitemplates: "KI-Vorlagen",
            integrations: "Integrationen",
            all: "Alle",
            installed: "Hochgeladen",
            installationOK: "Geladen",
            uninstall: "Aufzug",
            remainingMessageDesc: "Verbleibende kostenlose Nachricht:",
            openAISiteRoutingDescStart: "Einen Apikey bekommen",
            openAISiteRoutingDescEnd: "Sie können auf den Link klicken.",
            integrationOK: "Integriert",
            chatWidget: "SUPSIS -Chat -Ballon",
            artificialIntelligence: "Künstliche Intelligenz",
            integratePlatform: "Chatbot kann in {integretable} integriert werden.",
            integrateOpenAIWithChatbot: "Integrieren Sie Chat GPT-4 in Chatbot",
            integrateChatBotWithChatGPT3: "Integration von Chatbot mit CHAT GPT-4",
            integrateStoryWithTelegram: "Integration mit Telegramm -Chatbot",
            webhooks: "Webhaken",
            archive: "Archiv",
            reports: "Berichte",
            uncheckAll: "Lassen Sie alle",
            userSegments: "Benutzerabschnitte",
            addSegment: "Abschnitt hinzufügen",
            addToSegment: "Zum Abschnitt hinzufügen",
            removeFromSegment: "Aus der Abteilung weglassen",
            plansVTippyContent:
                "Die Abrechnung für dieses Paket erfolgt zu Beginn jeden Monats, und falls Sie kündigen möchten, wird Ihr Verbrauch bis zum Monatsbeginn berechnet und Ihr Paket läuft ab.<br><br>Der Paketpreis ist exklusive Mehrwertsteuer.<br><br>Paketänderungen werden am nächsten Tag auf der Rechnung ausgewiesen.",
            segmentName: "Abteilungsname",
            sameSegment: "Es gibt einen Segment mit demselben Namen!",
            usersInSegment: "Benutzer im Abschnitt",
            noUsersAdded: "Benutzer nicht hinzugefügt",
            updateSegment: "Aktualisieren Sie den Abschnitt Aktualisieren",
            newSegment: "Neues Kapitel",
            selectAll: "Wählen Sie Alle",
            queriesSelected: "Fragen ausgewählt",
            noBlocksFound: "Der Block wurde nicht gefunden!",
            userQuery: "Benutzerabfrage",
            date: "Geschichte",
            unmatched: "Unverkennbar",
            goToChat: "Geh zum Chat",
            selectStory: "Wählen Sie Geschichte",
            selectBlock: "Wählen Sie Block",
            training: "Bot -Training",
            trainingAlert:
                "Um die Änderungen, die Sie auf der Bot-Trainingsseite vorgenommen haben, umzusetzen, müssen Sie die neue Version des von Ihnen modifizierten Szenarios veröffentlichen.",
            unmatchedPhrases: "Nicht zusammenfassende Ausdrücke",
            ignored: "Unbedeutend",
            story: "Geschichte",
            timePeriod: "Zeitraum",
            wholeTimeSpan: "Jederzeit",
            selectAStory: "Wählen Sie eine Geschichte",
            searchUserQuery: "Suchen Sie die Benutzerabfrage",
            time: {
                today: "Heute",
                yesterday: "Gestern",
                last7: "Letzten 7 Tage",
                last30: "Letzte 30 Tage",
                "this-month": "Diesen Monat",
                "last-month": "Im vergangenen Monat",
                "last-3-month": "Letzte 3 Monate",
                "this-year": "Dieses Jahr",
                "last-year": "Letztes Jahr",
                custom: "Wählen Sie ein anderes Datum",
            },
            emailProvider: "E-Mail-Anbieter",
            triggerFromAnywhere: "Kann von überall aus ausgelöst werden",
            editWebhook: "Webhook bearbeiten",
            newWebhook: "Neues Webhook",
            webhookTitle: "Webhook -Titel",
            webhookUrl: "Webhook URL",
            webhookToken: "Webhook Token",
            webhookUsername: "Webhook Benutzername",
            webhookPassword: "Webhook Passwort",
            allIntegrations: "Alle Integrationen",
            integrateYourCBwithChatWidget: "Integriert in Chatbothe Chat -Widget.",
            integrateYourCBwithChatGpt3:
                "Chatbot kann in GPT-4 integriert werden. GPT-4-API-Schlüssel ist erforderlich.",
            integrateYourCBwithWebHook:
                "Leiten Sie die Chat -Informationen zwischen Chatbot und Webdiensten einfach weiter.",
            integrateYourCBwithIntegratable:
                "Leicht die Chat -Informationen zwischen Chatbot und {integratable} einfach weiter weiter weiter weiterzuleiten.",
            addWebhook: "Fügen Sie Webhook hinzu",
            editBlock: "Bearbeiten",
            moveBlock: "Umzug",
            copyBlock: "Kopieren",
            chatbot: "Chatbot",
            addFilter: "Filter hinzufügen",
            addFilterGroup: "Filtergruppe hinzufügen",
            clearFilter: "klarer Filter",
            in: "innen",
            and: "Und",
            or: "oder",
            allStories: "Alle Geschichten",
            addBot: "Erstellen Sie einen Bot",
            testBot: "Testen Sie den Bot",
            publish: "Veröffentlichen",
            editName: "Namen bearbeiten",
            search: "Rufen Sie in Ihrer Geschichte an ...",
            typeMoreThan3Char: "Geben Sie mindestens 3 Zeichen ein",
            expand: "Erweiterung",
            expandAll: "Alle erweitern",
            noMatchingItem: "Kein passender Artikel",
            hint: "Hinweis",
            select: "Wählen",
            navigate: "Reisen",
            dismiss: "aufgeben",
            choseAttribute: "Wählen Sie den Filtertyp",
            selectReply: "Wählen Sie den Antworttyp",
            preview: "Vorschau",
            draft: "Entwurf",
            lastUpdate: "Letztes Update",
            published: "Es wurde veröffentlicht",
            newStory: "Neue Geschichte",
            updateStory: "Aktualisieren Sie die Geschichte",
            storyDescription: "Geschichte Beschreibung",
            storyTitle: "Geschichtenentitel",
            deleteSingleBlock: "Einen Block löschen",
            deleteWithChildren: "Mit inneren Zweigen löschen",
            startTestFromHere: "Starten Sie den Test hier",
            copyBlockId: "Block -ID kopieren",
            gotoLiveLink: "Erstellen Sie einen Live -Link von hier aus",
            copyBlockIdSuccessfull: "Copped Block ID",
            collapse: "Verengung",
            collapseAll: "Beschränken Sie alle",
            snDelay: "{delay} Sn Delay",
            blockUpdated: "Block aktualisiert",
            addPayload: "Antwort hinzufügen",
            previewModeCaution:
                "Sie sehen sich momentan eine der Versionen Ihrer Geschichte vor. Sie können Änderungen im Vorschaudermodus nicht aufzeichnen!",
            enterText: "Hier schreiben ...",
            trackpad: "Trackpad",
            navigation: "Navigation",
            navigationDesc:
                "Bitte wählen Sie Ihren Navigationsmodus. Sie können wählen, ob Sie Rechteck- oder Mausoptionen ansehen können.",
            botSetting: "Starteinstellung",
            botSettingDesc:
                "Bitte bestimmen Sie das Vertrauensniveau. Dies ist ein Prozentsatz von 0 bis 100 und definiert die Genauigkeit von Chatbot -Kommentaren zu Benutzereingaben.",
            languageSettingsDesc:
                "Bitte stellen Sie sicher, dass die Sprache, auf die Sie antworten, die Sprache ist, die Sie bevorzugen.",
            mouse: "Maus",
            Interactions: "Interaktionen",
            Actions: "Aktionen",
            Supsis_Actions: "SUPSiS -Aktionen",
            Shopify_Actions: "Shopify -Aktionen",
            Akinon_Actions: "Akinon -Aktionen",
            IdeaSoft_Actions: "Ideasoft Actions",
            START_POINT: "STARTPUNKT",
            AI_ASSISTANT: "AI ASSISTANT",
            BOT_RESPONSE: "Bots Antwort",
            AI_BOT_RESPONSE: "Künstliche Intelligenz Antwort (GPT-4o)",
            AI_CLASSIFICATION: "AI CLASSIFICATION",
            Templates: "Template Blocks",
            AI_MENU_FLOW: "AI MENU",
            OTP_WHATSAPP_FLOW: "OTP Whatsapp",
            OTP_SMS_FLOW: "OTP SMS",
            OTP_MAIL_FLOW: "OTP MAIL",
            AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
            PLATFORM_FLOW: "PLATFORM",
            DEFAULT_FALLBACK: "Standardend ansonsten",
            FILTER: "FILTER",
            addNewFilter: "Neuen Filter hinzufügen",
            FLOW: "FLUSS",
            ATTACHMENT_INPUT: "Dateieinführung",
            USER_INPUT: "BENUTZER-ANMELDUNG",
            GO_TO_STEP: "Gehen Sie zu Schritt",
            WEBHOOK: "Webhaken",
            SET_ATTRIBUTE: "Feature festlegen",
            QUESTION: "FRAGE",
            CLOSE_CHAT: "Schließen Sie Chat",
            CREATE_TICKET: "Erstellen Sie ein Ticket",
            TRANSFER_CHAT: "Chat übertragen",
            TRANSFER_TO_CHATBOT: "FORWARD TO CHATBOT",
            TAG_CHAT: "ADD TAG",
            REMOVE_TAG: "REMOVE TAG",
            SET_DEPARTMENT: "Auf die Abteilung einstellen",
            SEND_TRANSCRIPT: "Transkript senden",
            SEND_SMS: "SEND SMS", //todo translate
            SEND_MAIL: "SEND MAIL", //todo translate
            CREATE_EVENT: "CREATE EVENT", //todo translate
            CREATE_RESERVATION: "CREATE RESERVATION",
            RESERVATION_OPEN_URL: "Reservation Open Url",
            RESERVATION_SELECT_DAY: "Select reservation day",
            RESERVATION_EVENT_LIST: "Reservation list visitor",
            RESERVATION_SELECT_TIME: "Select reservation time",
            CREATE_TASK: "CREATE TASK",
            SHOPIFY_SHOW_PRODUCTS: "Shopıfy Show -Produkte",
            SHOPIFY_PRODUCT_AVAILABILITY: "Shopify -Immobilie",
            SHOPIFY_ORDER_STATUS: "Bestellstatus speichern",
            AKINON_SHOW_PRODUCTS: "Das Akinon -Produkt zeigen",
            AKINON_FIND_PRODUCT: "Finden Sie das Akinon -Produkt",
            AKINON_ORDER_STATUS: "Akinon -Bestellstatus",
            AKINON_SELECT_ORDER: "Akınon wählt Reihenfolge aus",
            AKINON_SELECT_SIZE: "Akınon wählen Sie Größe",
            AKINON_FIND_NEAREST_STOCK: "SHOP STORE Aktie",
            AKINON_FIND_NEAREST_STORES: "Zeigen Sie in engen Geschäfte",
            AKINON_SHOW_DISCOUNT_CODES: "Rabattcode anzeigen",

            IDEASOFT_SELECT_ORDER: "SELECT ORDER",
            IDEASOFT_ORDER_STATUS: "GET ORDER STATUS",
            IDEASOFT_GET_MEMBER_INFO: "FILL MEMBER INFO",
            MESSENGER_SEND_MESSAGE: "MESSENGER-NACHRICHT SENDEN",
            INSTAGRAM_SEND_MESSAGE: "INSTAGRAM-NACHRICHT SENDEN",
            INSTAGRAM_COMMENT_REPLY: "KOMMENTAR BEANTWORTEN",
            INSTAGRAM_COMMENT_DELETE: "KOMMENTAR LÖSCHEN",
            INSTAGRAM_COMMENT_SHOW: "KOMMENTAR ANZEIGEN",
            INSTAGRAM_COMMENT_HIDE: "KOMMENTAR VERBERGEN",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "ALS PRIVAT ANTWORTEN",
            followingAttributesFilled: "Die folgenden Qualifikationen werden voll sein.",
            GET_LOCATION: "Standort nehmen",
            FALLBACK: "Ansonsten",
            SUCCESS: "ERFOLGREICH",
            FAILURE: "ERFOLGLOS",
            Probel_Actions: "Probelaktionen",
            PROBEL_SELECT_BRANCH: "Wählen Sie Branch",
            PROBEL_SELECT_CLINIC: "Wählen Sie Polyclinic",
            PROBEL_SELECT_DAY: "Wählen Sie einen Termin am Tag",
            PROBEL_SELECT_HOUR: "Wählen Sie eine Terminzeit",
            PROBEL_MAKE_APPOINTMENT: "Einen Termin erstellen",
            PROBEL_CANCEL_APPOINTMENT: "Termin stornieren",
            PROBEL_GET_PATIENT_TOKEN: "Patient zum Token",
            PROBEL_FILL_INFO: "MERNIS Fill Info",
            PROBEL_SELECT_APPOINTMENT: "Wählen Sie einen Termin",
            message: "Nachricht",
            condition: "Zustand",
            score: "Punktzahl",
            equal: "gleich",
            not_equal: "nicht gleich",
            contain: "enthält",
            not_contain: "beteiligt",
            starts_with: "Beginnt mit",
            ends_with: "endet mit",
            empty: "leer",
            longer_than: "Größer",
            shorter_than: "kürzer",
            less_than: "weniger",
            less_than_equal: "Klein gleich",
            greater_than: "ist toll",
            greater_than_equal: "Großartig gleich",
            value: "Wert",
            failures: "Erfolglos",
            email: "Email",
            name: "Name",
            username: "Nutzername",
            source: "Quelle",
            language: "Sprache",
            timezone: "Zeitzone",
            region: "Bereich",
            country: "Land",
            referrer: "Orientierung",
            url: "URL",
            ip: "SEIL",
            city: "Stadt",
            lastSeen: "Zuletzt gesehen",
            userId: "Benutzer-ID",
            selectStep: "Wählen Sie Schritt",
            keywords: "Stichwort",
            userSays: "Was der Benutzer sagt",
            addKeyword: "Keyword hinzufügen",
            addUserMessage: "Benutzerpost hinzufügen",
            set: "Besonderheit",
            to: "mit",
            gender: "Geschlecht",
            go_to_failure: "Gehen Sie zum erfolglosen Antwortschritt",
            go_to_success: "Gehen Sie zum erfolgreichen Antwortschritt",
            untilFilled: "ständig",
            time1: "Einmal",
            time2: "2 mal",
            time3: "dreimal",
            time4: "4 Mal",
            time5: "5 mal",
            any: "Irgendetwas",
            anytext: "Any Text",
            anytextDescription: "Matches only words + spaces",
            alphanumeric: "Buchstaben und Zahlen",
            integer: "Ganze Zahl",
            no: "NEIN",
            number: "Nummer",
            phone: "Telefon",
            yes: "Ja",
            yesNo: "ja Nein",
            anyDescription: "Übereinstimmung mit allem, was nicht leer ist.",
            alphanumericDescription: "Es entspricht sowohl Buchstaben als auch Zahlen.",
            integerDescription: "Passen Sie eine ganze ganze Zahl überein.",
            noDescription: "Es entspricht nicht mit Synonymwörtern.",
            numberDescription: "Es stimmt mit sequentiellen Grundlagen überein.",
            phoneDescription: "Passen Sie die Telefonnummer an.",
            yesDescription: "Ja, es passt zu den Synonymen des Wortes.",
            yesNoDescription: "Ja und nein, dass keine Wörter mit den Synonymen der Wörter übereinstimmen.",
            emailDescription: "Passen Sie es mit E-Mail an.",
            urlDescription: "Match URL.",
            temperature: "Hitze",
            askWhenInvalid: "Fragen Sie, ob es ungültig ist",
            applyFilter: "Filter hinzufügen",
            notificationMessageStartSuccess: "Block",
            notificationMessageEndSuccess: "Hinzugefügt",
            notificationMessageStartError: "Es ist ein Fehler aufgetreten, Block",
            notificationMessageEndError: "konnte nicht hinzugefügt werden",
            blockChangedWannaUpdate: "Möchten Sie das Update speichern?",
            TEXT: "Schreiben",
            IMAGE: "Bild",
            GALLERY: "Galerie",
            BUTTON: "Taste",
            RANDOM_TEXT: "Willkürlich",
            QUICK_REPLY: "Schnelle Antwort",
            FILE: "Datei",
            responses: "Reaktionen",
            flow: "Fluss",
            active: "Aktiv",
            passive: "Passiv",
            chooseAttributeType: "Wählen Sie den Funktionstyp",
            imageAttachment: "Bild hinzuzufügen",
            audioAttachment: "Klang",
            videoAttachment: "Video hinzufügen",
            documentAttachment: "Hinzufügen von Dokument",
            anyAttachment: "Irgendwelche zusätzlichen",
            typeAttributeValue: "Geben Sie den Funktionswert ein",
            typeSearchValue: "Schreiben Sie den Suchwert",
            male: "Männlich",
            addAttribute: "Feature hinzufügen",
            addAttributeDescription:
                "Der Name des Attributs kann nur A-Z-Buchstaben, 0-9 Zahlen und Alphaysalzeichen mit Reifen oder unterer Linie enthalten.",
            USER_DATA: "Nutzerinformation",
            CUSTOM_ATTRIBUTES: "Besondere Attribute",
            enterBotResponseHere: "Schreiben Sie die Frage, die Bot hier stellen wird ...",
            enterPrivateBotResponseHere: "Geben Sie die private Nachricht ein, die der Bot senden wird ...",
            addCard: "Karte hinzufügen",
            addButton: "Taste hinzufügen",
            typeCardTitle: "Kartenkopf",
            typeCardDescription: "Kartenabrechnung",
            dragAndDropBrowse: "Laden Sie ein Bild hoch",
            dragAndDropBrowseFile: "Datei hochladen",
            button: "Taste",
            enterYourMessage: "Gib deine Nachricht ein",
            imageView: "Bildansicht",
            imageUploading: "Das Bild lädt ...",
            fileUploading: "Datei hochladen ...",
            clickToChooseNewImage: "Klicken Sie hier, um ein neues Bild auszuwählen",
            clickToChooseNewFile: "Klicken Sie hier, um eine neue Datei auszuwählen",
            removeTheExistingOne: "Entfernen Sie, was verfügbar ist",
            validateResponseWithEntity: "Überprüfen Sie die Antwort",
            actionOnFailureInput: "Was sollte bei falscher Rechtschreibung getan werden?",
            askNextQuestion: "Die nächste Frage stellen",
            goToSuccessBlock: "Gehen Sie zum erfolgreichen Blog",
            goToFailureBlock: "Gehen Sie zum erfolglosen Block",
            saveResposeToAttribute: "Notieren Sie die Antwort",
            selectReplyType: "Wählen Sie den Antworttyp aus",
            questionVariants: "Arten von Fragen",
            systemEntities: "Definierte Verifizierungsausdrücke",
            delay: "Verzögerung",
            retrySectionTextPart: "Herr.",
            retrySectionText: "Wenn die Antwort des Benutzers ungültig ist",
            addNextQuestion: "Fügen Sie die nächste Frage hinzu",
            typeBlockTitle: "Blockkopf",
            versionHistory: "Versionsgeschichte",
            restore: "Aktualisieren",
            versionName: "Versionsname",
            restoreModalText:
                "Diese Aktion stellt die ausgewählte Version wieder her. Sind Sie sicher, dass Sie diese Version wiederherstellen möchten?",
            restoreVersion: "Update-Version",
            newVersion: "Neue Version",
            synonymMustBeUnique: "Es gibt nicht mehr als ein Wort mit demselben Synonym",
            save: "Speichern",
            entries: "Eingänge",
            youHaveNoEntries: "Eingabe nicht gefunden",
            inputsCantBeEmpty: "Die Felder können nicht leer gelassen werden",
            entryNamesMustBeUnique: "Das Schlüsselwort kann nicht das gleiche sein!",
            entityNameCantBeEmpty: "Der Name des Vermögenswerts kann nicht leer gelassen werden",
            entityNameMustBeUnique: "Der Name des Vermögenswerts kann nicht der gleiche sein",
            synonyms: "Synonyme",
            title: "Stichwort",
            entryName: "Name eingeben",
            entities: "Vermögenswerte",
            entityhasbeenUpdatedSuccessfully: "Erfolgreich aufgenommen werden",
            emptyError: "Die erforderlichen Bereiche können nicht leer bleiben",
            allChats: "Alle Gespräche",
            paidChats: "Bezahlte Chats",
            busiestPeriod: "Die intensivste Zeit",
            ratingDistribution: "Bewertungsverteilung",
            allMessages: "Alle Artikel",
            avarageMessages: "Durchschnittliche Nachrichten",
            popularity: "Popularität",
            allUsers: "Alle Nutzer",
            interactionName: "Interaktionsname",
            numberOfMessage: "Anzahl der Nachrichten",
            ofAllUsersMessage: "% Alle Benutzernachrichten",
            totalData: "Gesamtdaten",
            avgData: "Durchschnittliche Daten",
            exportToCsv: "Übertragung zu CSV",
            exportToExcel: "Übertragung zu Excel",
            inMaintenance: "Im Bau",
            ADD_TO_SEGMENT: "Zum Abschnitt hinzufügen",
            REMOVE_FROM_SEGMENT: "Aus der Abteilung weglassen",
            users: "Benutzer",
            webhookName: "Webhook Name",
            webHookUrl: "Webhook URL",
            webHookToken: "Webhook Token",
            delete: "Löschen",
            basicAuth: "Basic auth",
            requiredFieldsCannotBeLeftBlank: "Obligatorische Bereiche können nicht leer bleiben",
            yourVerificationToken: "Zeichen",
            yourWebHookName: "Ihr Webhook -Name",
            yourWebHookUrl: "Ihre Webhook -URL",
            enterKey: "Taste",
            password: "Passwort",
            headerValue: "Wert",
            saveSuccessfully: "Ihre Transaktion wurde erfolgreich aufgezeichnet.",
            urlTypeError: "Bitte füllen Sie das Feld korrekt aus (https://api.example.com/webhook)",
            gpt3: {
                apiKeyRequired: "API-Schalter für OpenAI-Chat GPT-4 erforderlich.",
                apiKeyDesc:
                    "API-Schlüssel ist für Chatbot + Chat GPT-4-Integration erforderlich. Bitte entfernen Sie Ihren API -Switch oder verwenden Sie den folgenden API -Switch für die Testversion. Sie können nur 20 Nachrichten für Testzwecke verwenden.",
                getApiKey: "Holen Sie sich einen offenen API -Switch",
                typeApiKey: "Schreiben Sie den API -Schlüssel",
                ownApiKey: "Openai API -Schlüssel haben",
                trialApiKey: "Test -API -Schlüssel (begrenzt als 20 Nachrichten)",
                useOurTrial: "Verwenden Sie unsere kostenlose Testversion",
                twentyMessages: "Sie können 20 Nachrichten kostenlos verwenden.",
                enableChatGpt3: "Aktivieren Sie Chat GPT-4",
            },
        },
        coupon: {
            code: "Code",
            discount: "Rabatt",
            endDate: "Endtermin",
            name: "Name",
            email: "Email",
            phone: "Telefon",
            add: "Gutschein hinzufügen",
            coupons: "Gutscheine",
            couponDeleted: "Gutschein gelöscht",
            limit: "Grenze",
            visitorBan: "Besucher wurde gesperrt.",
            visitorUnBlock: "Sperrung aufgehoben.",
        },
        instagramTitle: "Klicken Sie auf die Schaltfläche unten, um die Instagram-Funktionen zu aktivieren.",
        instegramFunctionActive: "Aktivieren Sie die Instagram Funktion",
        ChatBOT: "Chat-Bot",
        WhatsappContacts: "WhatsApp Kontakte",
        InstagramContacts: "Instagram Kontakte",
        MessengerContacts: "Messenger Contacts",
        volumeUp: "Lautstärke",
        minimize: "Schrumpfen",
        maximize: "Erweiterung",
        auditLogs: {
            auditLogsTitle: "Audit-Logs",
            auditLogsSub:
                "Audit-Logs ermöglichen es Ihnen, Ereignisse zu verfolgen, die in Ihrem Unternehmen in den letzten 30 Tagen stattgefunden haben.",
        },
        task: {
            taskID: "Aufgabe ID",
            completeTask: "Aufgabe abschließen",
            closedTasks: "Geschlossene Aufgaben",
            moveToArchive: "In Archiv verschieben",
            changeWorkflow: "In einen anderen Workflow verschieben",
            selectWorkflow: "Arbeitsablauf auswählen",
            taskNumber: "Aufgabe #",
            priority_lowest: "Niedrigste",
            priority_low: "Niedrig",
            priority_medium: "Mittel",
            priority_high: "Hoch",
            priority_highest: "Höchste",
            workflowActions: "Workflow-Aktionen",
            workflowTitle: "Workflow-Titel",
            deleteTask: "Aufgabe löschen",
            archivingDate: "Datum der Archivierung",
            selectOption: "Wählen Sie eine Option",
            notAuthorisedCreateTask: "Sie sind nicht berechtigt, eine Aufgabe zu erstellen",
            notAuthorisedCreateTaskDesc: "Sie sind nicht befugt, diese Aufgabe auszuführen",
            goToMessage: "Zur Nachricht gehen",
            goToChat: "Zum Chat gehen",
            showVisitor: "Besucher anzeigen",
            closeTheTask: "Aufgabe schließen",
            sureAddCompletedList: "Sind Sie sicher, dass Sie die Aufgabe zur Erledigungsliste hinzufügen möchten?",
            success: "Erfolg",
            successDesc: "Neues Feld erfolgreich hinzugefügt.",
            moveAndDeleteTask: "Aufgaben verschieben und löschen",
            justDelete: "Einfach löschen",
            selectColumnMoveTask: "Wählen Sie die Spalte aus, in die Sie die Aufgaben verschieben möchten",
            todos: "Zu erledigende Aufgaben",
            inProgress: "In Bearbeitung",
            approval: "Genehmigt",
            addAComment: "Einen Kommentar hinzufügen...",
            deleteComment: "Sind Sie sicher, dass Sie den Kommentar löschen möchten?",
            edited: "Bearbeitet",
            comments: "Kommentare",
            addComment: "Kommentar hinzufügen",
            workflow: "Arbeitsablauf",
            workflowDetail: "Arbeitsablauf Details",
            workflowPerm: "Arbeitsablauf Berechtigungen",
            perm: "Berechtigungen",
            detail: "Details",
            userPerm: "Benutzerberechtigungen",
            deleteCard: "Karte löschen",
            createCard: "Karte erstellen",
            editCard: "Karte bearbeiten",
            dragCard: "Karte verschieben",
            allWorkflow: "Alle Arbeitsabläufe",
            createworkflow: "Arbeitsablauf erstellen",
            deleteWorkflow: "Sind Sie sicher, dass Sie diesen Arbeitsablauf löschen möchten?",
            permEditTask: "Sie haben keine Berechtigung, diese Aufgabe zu bearbeiten",
            permEditTaskDes: "Wenden Sie sich an Ihren Administrator, um Bearbeitungsberechtigungen zu erhalten.",
            createTaskError: "Sie haben keine Berechtigung, Aufgaben zu erstellen",
            createTaskErrorDesc:
                "Wenden Sie sich an Ihren Administrator, um Berechtigungen zum Erstellen von Aufgaben zu erhalten.",
            moveTaskError: "Sie haben keine Berechtigung, den Aufgabenstatus zu ändern",
            moveTaskErrorDesc:
                "Wenden Sie sich an Ihren Administrator, um Berechtigungen zur Änderung des Aufgabenstatus zu erhalten.",
            deleteTaskError: "Sie haben keine Berechtigung, Aufgaben zu löschen",
            deleteTaskErrorDesc:
                "Wenden Sie sich an Ihren Administrator, um Berechtigungen zum Löschen von Aufgaben zu erhalten.",
            permissionError: "Sie haben keine Berechtigung, Aufgaben zu erstellen",
            permissionErrorDesc:
                "Bitte wenden Sie sich an Ihren Administrator, um Berechtigungen zur Aufgabenerstellung zu erhalten",
            whatsappContactProfileTitle: "{name} / {number} Profil",
            createTaskVisitor: "Aufgabe erstellen (Besucher)",
            editWorkflow: "Workflow bearbeiten",
            visitor: "Besucherprofil",
            createTaskMessage: "Aufgabe erstellen (Nachricht)",
            createStage: "Stufe erstellen",
            stagesAndStatuses: "Phasen und Status",
            workflowCreateDesc: "Workflow-Beschreibung",
            subTasks: "Teilaufgaben",
            followers: "Anhänger",
            collaborators: "Mitarbeiter",
            addRelations: "Beziehungen hinzufügen",
            relations: "Beziehungen",
            main: "Haupt",
            name: "Name",
            completedOfCheck: "{completed} von {total} Aufgaben abgeschlossen",
            workflowUpdateMs: "Workflow erfolgreich aktualisiert",
            taskUpdateMs: "Aufgabe erfolgreich aktualisiert",
            workflowCreatedMs: "Workflow erfolgreich erstellt",
            workflowCreateError: "Der Workflow konnte nicht erstellt werden",
            taskCreatedMs: "Aufgabe erfolgreich erstellt",
            settingsDesc3:
                "Darüber hinaus ermöglicht Ihnen das Supsis-Aufgabenmodul, Ihren eigenen Workflow mit anpassbarer Automatisierung zu erstellen, sodass Sie Aufgaben effektiver verwalten und die Zusammenarbeit im Team verbessern können.",
            settingsDesc4:
                "Auf diese Weise können Sie jede Ihrer Aufgaben im Detail verfolgen, Aufgaben an Teammitglieder zuweisen und insgesamt Ihre Geschäftsprozesse effizienter verwalten. Das Supsis-Aufgabenmodul bietet Ihnen eine umfassende Lösung für die Aufgabenverwaltung und Teamkoordination.",
            settingsDesc2:
                "Das Supsis-Aufgabenmodul lässt keine Aufgabe unbeachtet. Sie können Aufgaben basierend auf jedem Parameter filtern, Arbeitslasten für jeden Workflow-Schritt verfolgen und Ihren Kalender organisieren, um sich an Ihre Zeitpläne anzupassen.",
            settingsDesc1:
                "Das Aufgabenmodul ermöglicht es Ihnen, die Zusammenarbeit zu organisieren, Aufgaben zu delegieren und den Fortschritt Ihres Teams zu verfolgen. Sie können Ihre Aufgaben nach Bedarf anpassen, indem Sie eine beliebige Ansicht auswählen und Ihre eigenen benutzerdefinierten Workflows mit Automatisierungen erstellen.",
            taskModuleSettingsTitle: "Aufgabenmodul-Einstellungen",
            high: "Hoch",
            medium: "Mittel",
            low: "Niedrig",
            priority: "Priorität",
            addExistsSubtask: "Vorhandene Teilaufgabe hinzufügen",
            addSubtask: "Teilaufgabe hinzufügen",
            add: "Hinzufügen",
            newCheckList: "Neue Checkliste",
            subtaskTitle: "Teilaufgabentitel",
            view: "Anzeigen",
            attachFiles: "Dateien anhängen",
            createTaskDesc: "Aufgabenbeschreibung",
            title: "Titel",
            createWorkflow: "Workflow erstellen",
            editTask: "Aufgabe bearbeiten",
            createTask: "Aufgabe erstellen",
            deleteColumnCont: "Sind Sie sicher, dass Sie diese Spalte löschen möchten?",
            changeStage: "Status ändern",
            assignees: "Beauftragte",
            owner: "Besitzer",
            stage: "Status",
            writeSomething: "Schreiben Sie etwas",
            selectAssginee: "Zuweisung auswählen",
            assignee: "Beauftragter",
            enterNewTaskDesc: "Neue Aufgabenbeschreibung eingeben",
            enterNewTaskTitle: "Neuen Aufgabentitel eingeben",
            task: "Aufgabe",
            deleteTaskCont: "Möchten Sie diese Aufgaben wirklich löschen?",
            deleteWorkFlowCont: "Sind Sie sicher, dass Sie diesen Workflow löschen möchten?",
            completed: "Abgeschlossen",
            todo: "Zu erledigen",
            kanbanBoard: "Kanban-Board",
            listView: "Listenansicht",
        },
        permissionErrors: {
            userCreate:
                "Sie haben keine Berechtigung, Benutzer hinzuzufügen. Bitte konsultieren Sie Ihren Administrator.",
            userRead: "Sie haben keine Berechtigung, Benutzer anzuzeigen. Bitte konsultieren Sie Ihren Administrator.",
            userUpdate:
                "Sie haben keine Berechtigung, Benutzer zu aktualisieren. Bitte konsultieren Sie Ihren Administrator.",
            userDelete:
                "Sie haben keine Berechtigung, Benutzer zu löschen. Bitte konsultieren Sie Ihren Administrator.",
            visitorBlock:
                "Sie haben keine Berechtigung, Besucher zu blockieren. Bitte konsultieren Sie Ihren Administrator.",
            visitorUnblock:
                "Sie haben keine Berechtigung, Besucher zu entsperren. Bitte konsultieren Sie Ihren Administrator.",
            visitorDetailRead:
                "Sie haben keine Berechtigung, Besucherdetails anzuzeigen. Bitte konsultieren Sie Ihren Administrator.",
            visitorListRead:
                "Sie haben keine Berechtigung, die Besucherliste anzuzeigen. Bitte konsultieren Sie Ihren Administrator.",
            visitorDelete:
                "Sie haben keine Berechtigung, Besucher zu löschen. Bitte konsultieren Sie Ihren Administrator.",
            visitorExcel:
                "Sie haben keine Berechtigung, Excel-Ausgabe zu erhalten. Bitte konsultieren Sie Ihren Administrator.",
            visitorUpdate:
                "Sie haben keine Berechtigung, Besucher zu aktualisieren. Bitte konsultieren Sie Ihren Administrator.",
            bannedVisitorRead:
                "Sie haben keine Berechtigung, die Liste der gesperrten Besucher anzuzeigen. Bitte konsultieren Sie Ihren Administrator.",
            bannedWordCreate:
                "Sie haben keine Berechtigung, gesperrte Wörter hinzuzufügen. Bitte konsultieren Sie Ihren Administrator.",
            bannedWordRead:
                "Sie haben keine Berechtigung, gesperrte Wörter anzuzeigen. Bitte konsultieren Sie Ihren Administrator.",
            bannedWordDelete:
                "Sie haben keine Berechtigung, gesperrte Wörter zu löschen. Bitte konsultieren Sie Ihren Administrator.",
            chatRead: "Sie haben keine Berechtigung, Chats anzuzeigen. Bitte konsultieren Sie Ihren Administrator.",
            chatUpdate:
                "Sie haben keine Berechtigung, Chats zu bearbeiten. Bitte wenden Sie sich an Ihren Administrator.",
            archiveRead:
                "Sie haben keine Berechtigung, Archive anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            roleCreate:
                "Sie haben keine Berechtigung, Rollen hinzuzufügen. Bitte wenden Sie sich an Ihren Administrator.",
            roleRead: "Sie haben keine Berechtigung, Rollen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            roleUpdate:
                "Sie haben keine Berechtigung, Rollen zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            roleDelete:
                "Sie haben keine Berechtigung, Rollen zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            departmentCreate:
                "Sie haben keine Berechtigung, Abteilungen hinzuzufügen. Bitte wenden Sie sich an Ihren Administrator.",
            departmentRead:
                "Sie haben keine Berechtigung, Abteilungen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            departmentUpdate:
                "Sie haben keine Berechtigung, Abteilungen zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            departmentDelete:
                "Sie haben keine Berechtigung, Abteilungen zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            preparedContentCreate:
                "Sie haben keine Berechtigung, vorbereiteten Inhalt zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            preparedContentRead:
                "Sie haben keine Berechtigung, vorbereiteten Inhalt anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            preparedContentUpdate:
                "Sie haben keine Berechtigung, vorbereiteten Inhalt zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            preparedContentDelete:
                "Sie haben keine Berechtigung, vorbereiteten Inhalt zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            welcomeCreate:
                "Sie haben keine Berechtigung, Begrüßungsnachrichten zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            welcomeRead:
                "Sie haben keine Berechtigung, Begrüßungsnachrichten anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            welcomeUpdate:
                "Sie haben keine Berechtigung, Begrüßungsnachrichten zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            welcomeDelete:
                "Sie haben keine Berechtigung, Begrüßungsnachrichten zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            settingCreate:
                "Sie haben keine Berechtigung, Einstellungen zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            settingRead:
                "Sie haben keine Berechtigung, Einstellungen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            settingUpdate:
                "Sie haben keine Berechtigung, Einstellungen zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            settingDelete:
                "Sie haben keine Berechtigung, Einstellungen zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            reportCreate:
                "Sie haben keine Berechtigung, Berichte zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            reportRead:
                "Sie haben keine Berechtigung, Berichte anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            reportUpdate:
                "Sie haben keine Berechtigung, Berichte zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            reportDelete:
                "Sie haben keine Berechtigung, Berichte zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            offlineSupportRequestCreate:
                "Sie haben keine Berechtigung, Offline-Supportanfragen zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            offlineSupportRequestRead:
                "Sie haben keine Berechtigung, Offline-Supportanfragen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            offlineSupportRequestUpdate:
                "Sie haben keine Berechtigung, auf Offline-Supportanfragen zu antworten. Bitte wenden Sie sich an Ihren Administrator.",
            offlineSupportRequestDelete:
                "Sie haben keine Berechtigung, Offline-Supportanfragen zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            catalogCreate:
                "Sie haben keine Berechtigung, Kataloge zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            catalogRead:
                "Sie haben keine Berechtigung, Kataloge anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            catalogUpdate:
                "Sie haben keine Berechtigung, Kataloge zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            catalogDelete:
                "Sie haben keine Berechtigung, Kataloge zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotStoryCreate:
                "Sie haben keine Berechtigung, Chatbot-Geschichten zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotStoryRead:
                "Sie haben keine Berechtigung, Chatbot-Geschichten anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotStoryUpdate:
                "Sie haben keine Berechtigung, Chatbot-Geschichten zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotStoryDelete:
                "Sie haben keine Berechtigung, Chatbot-Geschichten zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotTemplateRead:
                "Sie haben keine Berechtigung, Chatbot-Vorlagen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotTemplateAiRead:
                "Sie haben keine Berechtigung, KI-Chatbot-Vorlagen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotIntegrationsRead:
                "Sie haben keine Berechtigung, Chatbot-Integrationen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotArchiveRead:
                "Sie haben keine Berechtigung, Chatbot-Archive anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotEntitiesRead:
                "Sie haben keine Berechtigung, Chatbot-Entitäten anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotEntitiesCreate:
                "Sie haben keine Berechtigung, Chatbot-Entitäten zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotEntitiesUpdate:
                "Sie haben keine Berechtigung, Chatbot-Entitäten zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotEntitiesDelete:
                "Sie haben keine Berechtigung, Chatbot-Entitäten zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotReportRead:
                "Sie haben keine Berechtigung, Chatbot-Berichte anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotTrainRead:
                "Sie haben keine Berechtigung, das Training des Chatbots anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotSegmentCreate:
                "Sie haben keine Berechtigung, Chatbot-Benutzersegmente zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotSegmentRead:
                "Sie haben keine Berechtigung, Chatbot-Benutzersegmente anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotSegmentUpdate:
                "Sie haben keine Berechtigung, Chatbot-Benutzersegmente zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotSegmentDelete:
                "Sie haben keine Berechtigung, Chatbot-Benutzersegmente zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            integrationsRead:
                "Sie haben keine Berechtigung, die Integrationsseite anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            whatsappIntegrationRead:
                "Sie haben keine Berechtigung, die WhatsApp-Integrationsseite anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            instagramIntegrationRead:
                "Sie haben keine Berechtigung, die Instagram-Integrationsseite anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            telegramIntegrationRead:
                "Sie haben keine Berechtigung, die Telegramm-Integrationsseite anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            integrationCreate:
                "Sie haben keine Berechtigung, Integrationen zu aktivieren. Bitte wenden Sie sich an Ihren Administrator.",
            triggerCreate:
                "Sie haben keine Berechtigung, Trigger zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            triggerRead:
                "Sie haben keine Berechtigung, Trigger anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            triggerUpdate:
                "Sie haben keine Berechtigung, Trigger zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            triggerDelete:
                "Sie haben keine Berechtigung, Trigger zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            billingRead:
                "Sie haben keine Berechtigung, die Rechnungen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            taskCreate:
                "Sie haben keine Berechtigung, Aufgaben zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            taskRead:
                "Sie haben keine Berechtigung, Aufgaben anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            taskUpdate:
                "Sie haben keine Berechtigung, Aufgaben zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            taskDelete:
                "Sie haben keine Berechtigung, Aufgaben zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            calendarCreate:
                "Sie haben keine Berechtigung, Kalender/Reservierungen zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            calendarRead:
                "Sie haben keine Berechtigung, den Kalender/die Reservierungen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            calendarUpdate:
                "Sie haben keine Berechtigung, den Kalender/die Reservierungen zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            calendarDelete:
                "Sie haben keine Berechtigung, den Kalender/die Reservierungen zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            mailCreate:
                "Sie haben keine Berechtigung, E-Mails zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            mailRead: "Sie haben keine Berechtigung, E-Mails anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            mailUpdate:
                "Sie haben keine Berechtigung, E-Mails zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            mailDelete:
                "Sie haben keine Berechtigung, E-Mails zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
        },
        message: {
            confirmDeleteRedStationIntegration: "Sind Sie sicher, dass Sie diesen Kırmızı Santral-Kanal löschen möchten?",
            enterRedStationIntegration: "Geben Sie Ihre Kırmızı Santral API-Anmeldedaten ein",
            redStationIntegration: "Kırmızı Santral Integration",
            copyChannelID: "Kanal-ID kopieren",
            redStationChannels: "Kırmızı Santral Kanäle",
            bannedUserError: "Beim Hinzufügen der Sperre ist ein Fehler aufgetreten.",
            bannedUserSuccess: "Sperre erfolgreich hinzugefügt.",
            selectAtLeastOneOption: "Bitte wählen Sie mindestens eine Option aus.",
            enterValidValue: "Bitte geben Sie einen gültigen Wert ein.",
            enterValidIpAddress: "Bitte geben Sie eine gültige IP-Adresse ein.",
            enterValidVisitorId: "Bitte geben Sie eine gültige Besucher-ID ein.",
            enterValidWhatsappNumber: "Bitte geben Sie eine gültige WhatsApp-Nummer ein.",
            invalidEmailAddress: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
            bannedUser: "Gesperrt",
            unbannedUser: "Nicht gesperrt",
            banModalDescription: "Geben Sie Plattform und Wert ein, um den Benutzer zu sperren.",
            exampleNumber: "Beispielnummer: 905551111111",
            clearSelectedFiltersTooltip: "Löscht die ausgewählten Filterwerte auf der Seite",
            minutesText: "{count} Minuten",
            secondsText: "{count} Sekunden",
            downloadCooldownWarning: "Bitte warten Sie {time}, um eine neue Download-Anfrage zu erstellen.",
            excelExportReceiveQuestion: "Wie möchten Sie die Excel-Datei erhalten?",
            sendToMe: "An mich senden",
            sendToSomeoneElse: "An jemand anderen senden",
            enterEmailAddress: "E-Mail-Adresse eingeben",
            exportRequestSuccess: "Ihre Anfrage wurde erstellt, wir werden sie Ihnen so schnell wie möglich per E-Mail zusenden",
            maxDateRangeWarning: "Der ausgewählte Datumsbereich kann maximal 45 Tage betragen",
            ticketOnlyMail: "Diese Anfrage kann nur per E-Mail beantwortet werden. Über WhatsApp gesendete Nachrichten können nicht weitergeleitet werden.",
            cardInfoUpdateError: "Beim Aktualisieren der Kartendaten ist ein Fehler aufgetreten",
            billingInfoSavedSuccessfully: "Ihre Abrechnungsinformationen wurden erfolgreich gespeichert",
            billingInfoSaveError: "Fehler beim Speichern der Abrechnungsinformationen:",
            paymentInfoSavedSuccessfully: "Ihre Zahlungsinformationen wurden erfolgreich gespeichert",
            annualDiscount: "Erhalten Sie 20% Rabatt auf jährliche Käufe",
            annualDiscountDescription: "Sie können durch die Wahl eines Jahresabonnements erheblich sparen.",
            payOnlyForUsedFeatures: "Zahlen Sie nur für das, was Sie nutzen",
            payOnlyForUsedFeaturesDescription: "Zahlen Sie nur für die Funktionen, die Sie nutzen, nicht für mehr.",
            cancelAnytime: "Jederzeit kündbar",
            cancelAnytimeDescription: "Keine langfristigen Verträge erforderlich, Sie können jederzeit kündigen.",
            noPermissionDescription: "Sie haben <strong>keine Berechtigung</strong> für diese Operation. Bitte wenden Sie sich an Ihren Administrator.",
            creditCardRequired: "Kreditkarteninformationen erforderlich",
            creditCardRequiredDescription: "Sie haben kostenpflichtige Abonnements. Sie können fortfahren, indem Sie Ihre Kreditkarteninformationen eingeben oder Ihre Abonnements kündigen.",
            creditCardRequiredDescription2: "Sie müssen Kreditkarteninformationen eingeben, da Sie kostenpflichtige Abonnements in Ihrem Konto haben.",
            subscriptionManagement: "Abonnementverwaltung",
            addCreditCard: "Kreditkarteninformationen hinzufügen",
            transferOwnership: "Eigentum Übertragen und Weiterleiten",
            errorLoadingAgents: "Ein Fehler ist beim Laden der Agenten aufgetreten",
            pleaseFillRequiredFields: "Bitte füllen Sie die erforderlichen Felder aus",
            callStartedSuccessfully: "Anruf erfolgreich gestartet",
            errorStartingCall: "Ein Fehler ist beim Starten des Anrufs aufgetreten",
            errorLoadingData: "Ein Fehler ist beim Laden der Daten aufgetreten",
            errorLoadingDataPhoneNumbers: "Ein Fehler ist beim Laden der Telefonnummern aufgetreten",
            noVariablesFound: "Keine Variablen im Prompt gefunden. Variablen sollten im Format <code v-pre>{{ variablen_name }}</code> sein.",
            aiVoiceAgentSpecialVariables: "Spezielle Variablenwerte",
            addAiVoiceAgentChannel: "Kanal Hinzufügen",
            multiLanguageSupport: "Mehrsprachige Unterstützung",
            customerService247: "24/7 Kundendienst",
            autoCallAnswer: "Automatische Anrufannahme",
            aiVoiceAgentChannelRequired: "KI-Sprachagent-Kanal Erforderlich",
            aiVoiceAgentChannelRequiredDescription: "Sie müssen einen KI-Sprachagent-Kanal hinzufügen, um diese Funktion zu nutzen.",
            aiVoiceAgentChannelRequiredDescription2: "Der KI-Sprachagent ist ein KI-gestützter Assistent, der Telefongespräche mit Ihren Kunden führen kann.",
            startCall: "Anruf Starten",
            selectContactFieldPlaceholder: "Kontaktinformationen auswählen",
            aiVoiceAgentVariableValuePlaceholder: "Wert eingeben",
            aiVoiceAgentVariables: "Variableninformationen des Agenten",
            aiVoiceAgentVariableManual: "Manuell",
            aiVoiceAgentVariableContact: "Kontaktinformationen",
            toNumberHelpText: "Muss im E.164-Format sein. Beispiel: +905321234567",
            toNumber: "Anzurufende Nummer",
            selectAiVoiceAgentHelpText: "Falls nicht ausgewählt, wird der Standard-Ausgangsagent der Nummer verwendet",
            selectAiVoiceAgent: "Agent auswählen (optional)",
            aiVoiceAgent: "Agent",
            selectFromNumber: "Anrufernummer auswählen",
            fromNumber: "Anrufernummer",
            startAiCall: "Anruf mit KI-Sprachagent Starten",
            aiCall: "Anruf mit KI-Sprachagent Durchführen",
            groupByNone: "Keine Gruppierung angewendet",
            groupByAgent: "Kontakte nach den Agenten ihrer letzten Sitzung gruppieren",
            groupByDepartment: "Kontakte nach der in ihrer letzten Sitzung ausgewählten Abteilung gruppieren",
            groupByChannel: "Kontakte nach dem Kanal gruppieren, von dem sie kommen",
            groupByPlatform: "Kontakte nach der Plattform gruppieren, von der sie kommen",
            groupByWebsite: "Kontakte nach der Website gruppieren, von der sie kommen",
            groupByTag: "Kontakte nach ihren Tags gruppieren",
            groupByAnswerStatus: "Kontakte nach ihrem Antwortstatus ihrer letzten Sitzung gruppieren",
            groupByOwner: "Kontakte nach ihren Besitzern gruppieren",
            changeGroupBy: "Gruppierungsmodus Ändern",
            changeSortMode: "Sortiermodus Ändern",
            selectIcon: "Symbol Auswählen",
            iconPickerTitle: "Symbol-Auswahl",
            searchIconPlaceholder: "Symbol suchen...",
            profileFieldsDescriptionChat: "Klicken Sie, um Ihre Profilfelder anzupassen",
            createCommentSuccess: "Kommentar erfolgreich erstellt",
            createCommentError: "Fehler beim Erstellen des Kommentars",
            updateCommentSuccess: "Kommentar erfolgreich aktualisiert",
            updateCommentError: "Fehler beim Aktualisieren des Kommentars",
            deleteCommentSuccess: "Kommentar erfolgreich gelöscht",
            deleteCommentError: "Fehler beim Löschen des Kommentars",
            formSubmission: "Formularübermittlung",
            selectForm: "Formular auswählen",
            updateOwnerUsers: "Eigentümer aktualisieren",
            updateOwnerUsersDesc: "Möchten Sie die Eigentümer dieses Benutzers aktualisieren? Sie können sie einem anderen Benutzer zuweisen oder die Eigentümerlosigkeit entfernen.",
            deposit: "Einzahlung",
            creditUsage: "Kreditnutzung",
            businessMarketing: "Marketing",
            businessUtility: "Nützlichkeit",
            businessAuthentication: "Authentifizierung",
            businessService: "Dienst",
            incomingSessionMessage: "Eingehende Nachricht",
            outgoingSessionMessage: "Ausgehende Nachricht",
            freeTierConversation: "Kostenloses Gespräch (FTC)",
            chatStart: "Chat starten",
            wpMessage: "Whatsapp QR Massen-Nachricht",
            pin: "Anheften",
            rename: "Umbenennen",
            browserSpeechRecognitionNotSupported: "Ihr Browser unterstützt keine Spracherkennung. Wir empfehlen die Verwendung des Chrome-Browsers.",
            spaceKeyReleaseToSave: "Es wird gespeichert, wenn Sie die Leertaste loslassen",
            spaceKeyHint: "Sie können sprechen, indem Sie die Leertaste gedrückt halten",
            listeningInProgress: "Zuhören...",
            speakNow: "Jetzt sprechen...",
            toggleAllPermissions: "Alle Rolle Berechtigungen aktivieren/deaktivieren",
            rolePermissions: "Rolle Berechtigungen",
            roleSaved: "Rolle gespeichert",
            creatingRole: "Rolle wird erstellt...",
            savingRole: "Rolle wird gespeichert...",
            editRole: "Rolle bearbeiten",
            newRoleCreate: "Neue Rolle erstellen",
            descriptionEmail: "Fügt die E-Mail-Adresse des Besuchers im Chat automatisch in das Nachrichtenfeld ein und ermöglicht das Senden",
            exampleEmail: "Beispiel: @email hallo",
            nameDescription: "Fügt den Namen des Besuchers im Chat automatisch in das Nachrichtenfeld ein und ermöglicht das Senden",
            exampleName: "Beispiel: @name hallo",
            pmDescription: "Ermöglicht das Senden einer privaten Nachricht. Diese Nachrichten können nur andere Kundendienstmitarbeiter sehen, Besucher nicht.",
            examplePm: "Beispiel: pm: Diese Nachricht ist privat",
            chatShortcuts: "Chat-Shortcuts",
            showSystemStatus: "Systemstatus anzeigen",
            endChatWizard: "Sitzungsbeendigung-Assistent",
            terminationError: "Fehler beim Beenden der Sitzung",
            profileFieldsUpdateError: "Fehler beim Aktualisieren der Profilfelder",
            profileFieldsUpdated: "Profilfelder aktualisiert",
            aiSuggestionError: "AI Vorschläge konnten nicht abgerufen werden",
            profileFieldsDescription: "Sie können dieser Person zusätzliche Informationen hinzufügen, um Ihrem Team mehr Informationen zu geben.",
            categoryTags: "Sie können dieser Person Tags hinzufügen, um sie schnell zu kategorisieren.",
            manageTags: "Tags verwalten",
            enterNote: "Not eingeben",
            noteDescription: "Sie können Notizen zu dieser Person hinzufügen. Diese Notizen werden auch nach der Konversation angezeigt.",
            suggestedProfileFields: "Vorgeschlagene Profilfelder:",
            suggestedTags: "Vorgeschlagene Tags",
            suggestedNote: "Vorgeschlagene Notiz:",
            applyAll: "Alle anwenden",
            aiSuggestionTitle: "Künstliche Intelligenz Vorschläge",
            aiSuggestion: "Supsis Asistan-Vorschläge",
            searchItem: "Suche nach Element",
            makeSelection: "Auswahl Treffen",
            FromName: "Name des Absenders",
            taskClosingDate: "Aufgabenabschlussdatum",
            confirmDeleteTask: "Sind Sie sicher, dass Sie diese Aufgabe löschen möchten?",
            taskDeletedSuccess: "Aufgabe erfolgreich gelöscht",
            taskDeleteError: "Fehler beim Löschen der Aufgabe",
            selectColumns: "Wählen Sie die Spalten aus, die Sie in der Tabelle sehen möchten",
            linkedinChannels: "LinkedIn-Kanäle",
            updateLinkedinChannelDesc: "Aktualisieren Sie Ihren LinkedIn-Kanal",
            deleteLinkedinChannel: "LinkedIn-Kanal Löschen",
            confirmDeleteLinkedinChannel: "Sind Sie sicher, dass Sie diesen LinkedIn-Kanal löschen möchten?",
            contactIdPlaceholder: "Kontakt-ID",
            contactId: "Kontakt-ID",
            enterOwnerId: "Besitzer-ID eingeben",
            selectOwner: "Besitzer auswählen",
            dynamic: "Dynamisch",
            owner: "Besitzer",
            addCollaborator: "Mitarbeiter hinzufügen",
            dynamicValue: "Dynamischer Wert",
            selectCollaborator: "Mitarbeiter auswählen",
            collaborator: "Mitarbeiter",
            collaborators: "Mitarbeiter",
            addFollower: "Follower hinzufügen",
            selectFollower: "Follower auswählen",
            followers: "Follower",
            follower: "Follower",
            addAssignee: "Zugewiesenen hinzufügen",
            selectUser: "Benutzer auswählen",
            assignees: "Zugewiesene",
            assignee: "Zugewiesener",
            pipelineStage: "Pipeline-Phase",
            selectPipelineStage: "Pipeline-Phase auswählen",
            title: "Titel",
            taskTitle: "Aufgabentitel",
            description: "Beschreibung",
            taskDescription: "Aufgabenbeschreibung",
            priority: "Priorität",
            selectPriority: "Priorität auswählen",
            workflow: "Workflow",
            selectWorkflow: "Workflow auswählen",
            packagePurchase: "Paketkauf",
            upcomingInvoice: "Kommende Rechnung",
            invoiceUpdated: "Rechnung aktualisiert",
            invoiceMarkedInvalid: "Rechnung als ungültig markiert.",
            invoiceUpdateError: "Fehler bei der Rechnungsaktualisierung",
            invoiceMarkInvalidError: "Beim Markieren der Rechnung als ungültig ist ein Fehler aufgetreten.",
            refunded: "Erstattet",
            paid: "Bezahlt",
            pending: "Ausstehend",
            unpaid: "Unbezahlt",
            paymentFailed: "Zahlung fehlgeschlagen",
            paymentProcessError: "Während des Zahlungsvorgangs ist ein Fehler aufgetreten.",
            paymentSuccessful: "Zahlung erfolgreich",
            paymentProcessSuccessful: "Der Zahlungsvorgang wurde erfolgreich abgeschlossen.",
            invoiceRefund: "Rechnungserstattung",
            invoiceRefundedSuccessfully: "Die Rechnung wurde erfolgreich erstattet.",
            invoicePaymentError: "Fehler bei der Rechnungszahlung",
            invoicePaymentProcessError: "Während der Rechnungszahlung ist ein Fehler aufgetreten.",
            invoicePaid: "Rechnung bezahlt",
            invoiceMarkedAsPaid: "Die Rechnung wurde erfolgreich als bezahlt markiert.",
            invoicePriceUpdateError: "Beim Aktualisieren des Rechnungspreises ist ein Fehler aufgetreten.",
            invoicePriceUpdatedSuccessfully: "Der Rechnungspreis wurde erfolgreich aktualisiert.",
            invoicePdf: "Rechnung PDF",
            viewInvoice: "Rechnung anzeigen",
            makePayment: "Zahlung durchführen",
            autoForwardToOwnerForceDescription:
                "In allen Fällen werden Kontakte mit Eigentümer automatisch an ihren Eigentümer weitergeleitet. Sie werden weder in der Warteschlange gehalten noch an den Chatbot übertragen. Selbst wenn diese Einstellung deaktiviert ist, werden sie an ihren Eigentümer weitergeleitet, wenn der Chatbot im System nicht aktiv ist.",
            utoForwardToOwnerForce: "Automatische Weiterleitung an Eigentümer (auch bei aktivem Chatbot)",
            socialMedia: "Soziale Medien",
            web: "Web",
            email: "E-Mail",
            sms: "SMS",
            crm: "CRM",
            ecommerce: "E-Commerce",
            utilities: "Dienstprogramme",
            advertising: "Werbung",
            cancelPlanTitle: "Planabbrechung",
            cancelPlanDescription: "Nach der Planabbrechung wird Ihr Paket bis zum Ende des Tages weiter verwendet.",
            voteSuccess: "Abstimmung erfolgreich gespeichert",
            voteSuccessDescription:
                "Wir haben Ihre Anfrage erhalten, die Integration {integrationName} zu Supsis hinzuzufügen.",
            companyName: "Name des Unternehmens",
            company: "Unternehmen",
            languageTitle1: "Standardsprache des Panels",
            languageTitle2: "Standardsprache der Nachrichten",
            languageTitle3: "Region & Zeitzone",
            languageTitle4: "Automatische Spracheinstellung für Kunden",
            languageTitle5: "Auswahl der Sprache für Kunden-Nachrichten im WebChat",
            languageDesc1: "Legt die Sprache des Supsis AI-Panels fest",
            languageDesc2: "Hier können Sie die Standardsprache der Nachrichten ändern.",
            languageDesc3: "Legt die Region und die Zeitzone fest",
            languageDesc4:
                "Ermöglicht die automatische Erkennung der Sprache der Kunden-Nachrichten mit Unterstützung von KI.",
            languageDesc5:
                "Aktiviert die Funktion, die es dem Kunden ermöglicht, seine gesprochene Sprache im WebChat-Kanal auszuwählen.",
            featuresTitle1: "Abteilungswahl",
            featuresTitle2: "Anzahl der wartenden Kunden anzeigen",
            featuresTitle3: "Einschränkung verbotener Wörter",
            featuresTitle4: "Kunden das Erstellen von Tickets erlauben",
            featuresTitle5: "Sprachanruf",
            featuresTitle6: "Videoanruf",
            featuresTitle7: "Sprachnachricht senden (Agent)",
            featuresTitle8: "Sprachnachricht senden (Kunde)",
            featuresTitle9: "Automatische Anrufweiterleitung",
            featuresTitle10: "Chat zwischen Vertretern anzeigen",
            featuresTitle11: "Datei senden (Agent)",
            featuresTitle12: "Datei senden im WebChat (Kunde)",
            featuresTitle13: "Nachrichtensenden vor der Verbindung des Vertreters erlauben",
            featuresTitle14: "Systemnachrichten von Vertretern ausblenden",
            featuresTitle15: "Kunden das Löschen persönlicher Informationen erlauben",
            featuresTitle16: "Benachrichtigung über Online-Status des Kunden",
            featuresTitle17: "Automatische Übersetzung",
            featuresTitle18: "Automatische Anmeldung des Besuchers",
            featuresTitle19: "Standortfreigabe im WebChat (Kunde)",
            featuresTitle20: "Standortfreigabe (Vertreter)",
            featuresTitle21: "Chat AI Copilot",
            featuresTitle22: "Warteschlange für unbesessene Gespräche",
            featuresTitle23: "Kontaktinformationen ausblenden",
            featuresDesc1:
                "Verpflichtende Weiterleitung zu Abteilungen basierend auf den vom Kunden ausgewählten Themen.",
            featuresDesc2: "Zeigt Kunden ihre Position in der Warteschlange, wenn die Vertreter beschäftigt sind.",
            featuresDesc3:
                "Verhindert, dass Vertreter verbotene Wörter, die im System definiert sind, an Kunden senden, wenn die Einschränkung verbotener Wörter aktiv ist.",
            featuresDesc4: "Aktiviert die Option, ein Ticket im WebChat-Fenster zu erstellen.",
            featuresDesc5: "Aktiviert die Sprachruf-Funktion im WebChat-Fenster.",
            featuresDesc6: "Aktiviert die Videoanruf-Funktion im WebChat-Fenster.",
            featuresDesc7: "Ermöglicht es Vertretern, Sprachnachrichten zu senden.",
            featuresDesc8: "Ermöglicht es Kunden, Sprachnachrichten im WebChat-Kanal zu senden.",
            featuresDesc9: "Weist wartende Anrufe automatisch verfügbaren Vertretern zu.",
            featuresDesc10: "Zeigt das Gesprächsfenster zwischen Vertretern an.",
            featuresDesc11: "Ermöglicht es Vertretern, Dateien zu senden.",
            featuresDesc12: "Ermöglicht es Kunden, Dateien im WebChat-Kanal zu senden.",
            featuresDesc13: "Ermöglicht es Kunden, Nachrichten zu senden, bevor ein Vertreter sich verbindet.",
            featuresDesc14: "Blendet Systemnachrichten von Vertretern aus, sodass Kunden diese nicht sehen können.",
            featuresDesc15:
                "Aktiviert die Möglichkeit für Kunden, ihre persönlichen Informationen mit einem Klick im WebChat-Fenster zu löschen.",
            featuresDesc16:
                "Benachrichtigt Vertreter mit einer Systemnachricht, wenn ein Kunde den WebChat-Kanal verlässt oder zurückkehrt.",
            featuresDesc17: "Übersetzt automatisch Nachrichten von Kunden in die Sprache des Vertreters.",
            featuresDesc18: "Beginnt das Gespräch, sobald der Besucher auf das Fenster klickt.",
            featuresDesc19: "Aktiviert die Möglichkeit für Kunden, ihren Standort im WebChat-Kanal zu teilen.",
            featuresDesc20: "Aktiviert die Möglichkeit für Vertreter, ihren Standort zu teilen.",
            featuresDesc21:
                "Aktiviert die Nutzung von KI-Hilfe für Vertreter zur Korrektur von Tippfehlern, zur Änderung des Tons von Nachrichten und zur Generierung von KI-unterstützten Antworten.",
            featuresDesc22: "Aktiviert diese Funktion, um Personen ohne Eigentum in der Warteschlange zu halten.",
            featuresDesc23: "Verhindert, dass Vertreter die Telefonnummern und E-Mail-Adressen der Kunden sehen.",
            groupBy: "Gruppieren",
            privacyPolicyAndTerms: "Datenschutzrichtlinie / Nutzungsbedingungen",
            privacyPolicyTitle: "Datenschutzrichtlinie für Supsis Live Support & Chatbot-Systeme",
            privacyPolicyDescription:
                "Diese Datenschutzrichtlinie beschreibt, wie Softcand Yazılım Hizmetleri A.S. („Softcand“, „wir“, „uns“ oder „unser“) Informationen über Benutzer („Sie“ oder „Ihr“) der Supsis-Webanwendung („Supsis“) sammelt, verwendet und offenlegt. Diese Datenschutzrichtlinie gilt für die Informationen, die wir sammeln, wenn Sie Supsis verwenden; diese Informationen sind gültig, wenn sie über unsere Website, mobile Anwendungen oder andere Plattformen, auf denen die Datenschutzrichtlinie veröffentlicht ist, abgerufen werden.",
            informationWeCollect: "Informationen, die wir sammeln",
            weCollectFollowingInformation: "Wir sammeln die folgenden Informationen",
            customerAccountInformation: "Kundenkontoinformationen",
            customerAccountData:
                "Bei der Erstellung eines Supsis-Kontos sammeln wir die folgenden Daten: Vorname, Nachname, Telefonnummer und E-Mail-Adresse.",
            userInformation: "Benutzerinformationen",
            userProvidedInformation:
                "Von den Benutzern der Anwendung bereitgestellte Informationen, einschließlich Vorname, Nachname und E-Mail-Adresse.",
            dataDeletionProcess: "Datenlöschprozess",
            dataDeletionProcedures: "Wir folgen diesen Verfahren zur Datenlöschung",
            automaticDeletion: "Automatische Löschung",
            automaticDeletionInfo:
                "Kundenkonten werden automatisch gelöscht, wenn sie geschlossen werden oder nach sechs Monaten Inaktivität.",
            directRequest: "Direkte Anfrage",
            directRequestInfo:
                "Kunden können die Löschung aller ihrer Daten anfordern, indem sie uns direkt kontaktieren.",
            websiteVisitorDataDeletion: "Löschung von Daten von Website-Besuchern",
            websiteVisitorDataDeletionInfo:
                "Website-Besucher können ihre Daten, einschließlich Chatverlauf, Nachrichten und Dateien, direkt über die Web-Chat-Oberfläche löschen.",
            howToContactUs: "Wie Sie uns kontaktieren können",
            contactChannels: "Sie können uns über die folgenden Kanäle erreichen",
            dataProcessingAndSharing: "Datenverarbeitung und -weitergabe",
            handleCustomerData: "Wir verarbeiten Kundendaten wie folgt",
            noThirdPartySharing: "Keine Weitergabe an Dritte",
            noThirdPartySharingInfo:
                "Supsis gibt keine Kundendaten an Dritte, Organisationen oder Einzelpersonen weiter.",
            promotionalEmails: "Werbe-E-Mails",
            promotionalEmailsInfo:
                "Wir können Kunden Werbe-E-Mails senden; sie können sich von diesen E-Mails abmelden.",
            visitorAndConversationData: "Daten von Besuchern und Gesprächen",
            noSharingVisitorData: "Wir teilen oder verwenden keine Informationen über Kundenbesucher und Chats.",
            thirdPartyServices: "Dienste Dritter",
            googleOAuth: "Google OAuth",
            googleCalendar: "Google Kalender",
            googleCalendarInfo:
                "Supsis verwendet Google Kalender, um kalenderbezogene Funktionen innerhalb der Anwendung zu aktivieren. Daten, die aus Kalendern synchronisiert werden, werden nicht mit anderen geteilt und sind nur für den Benutzer sichtbar. Wenn Google OAuth abläuft, werden alle synchronisierten Ereignisse von Supsis und Google Kalender automatisch gelöscht.",
            googleAccountPublicProfile: "Öffentliches Profil des Google-Kontos",
            googleAccountPublicProfileInfo:
                "Supsis sammelt Name und E-Mail-Informationen, um Benutzer während der Anmeldung zu überprüfen und zu authentifizieren. Diese Informationen werden nach der Überprüfung nicht gespeichert.",
            changesToPrivacyPolicy: "Änderungen an dieser Datenschutzrichtlinie",
            privacyPolicyUpdateInfo:
                "Wir können diese Datenschutzrichtlinie von Zeit zu Zeit aktualisieren. Wenn wir wesentliche Änderungen vornehmen, werden wir Sie über unsere Website oder andere Kommunikationskanäle informieren.",
            privacyPolicyContactInfo:
                "Wenn Sie Fragen zu dieser Datenschutzrichtlinie haben, kontaktieren Sie uns bitte unter m@softcand.com.",
            termsOfServiceTitle: "Nutzungsbedingungen für Supsis Live Support & Chatbot-Systeme",
            lastUpdated: "Letzte Aktualisierung",
            inEffect: "In Kraft",
            importantTerms:
                "Wichtig: Diese Nutzungsbedingungen, die auch unsere Datenschutzrichtlinie enthalten, bilden einen verbindlichen Vertrag zwischen der Person, die im Registrierungsprozess als Benutzer des Dienstes bezeichnet wird („Sie“), und Softcand Yazılım Hizmetleri Anonim Şirketi (handelnd unter dem Namen Supsis oder Supsis Live Support oder Supsis Live Support und Chatbot-Systeme) („wir“) und regeln Ihre Nutzung unserer Websites, die sich auf supsis.com (Produkt-Startseite), softcand.com (Unternehmenswebsite) oder supsis.live (Produktanwendung) oder beta.supsis.live (Beta-Version der Produktanwendung) befinden. Aus diesem Grund sind diese Bedingungen wichtig, und Sie sollten sicherstellen, dass Sie sie sorgfältig lesen und uns bei Fragen vor der Nutzung des Dienstes kontaktieren.",
            termsDescription:
                "Diese Nutzungsbedingungen regeln Ihre Nutzung unserer Websites, die sich auf supsis.com (Produkt-Startseite), softcand.com (Unternehmenswebsite) oder supsis.live (Produktanwendung) oder beta.supsis.live (Beta-Version der Produktanwendung) befinden.",
            applicationOfTerms: "Anwendung der Bedingungen",
            termsApplyToAllUsers:
                "Diese Bedingungen gelten für alle Benutzer des Dienstes, unabhängig davon, ob Sie den Dienst in Ihrem eigenen Namen oder im Namen einer anderen Person oder Organisation nutzen.",
            termsUpdateNotice:
                "Wir können die Bedingungen jederzeit nach unserem Ermessen aktualisieren oder ändern. Wenn wir die Bedingungen ändern, werden wir Sie informieren, indem wir Sie über unsere Webplattform und per E-Mail benachrichtigen.",
            termsDisagreementNotice:
                "Sie müssen den aktualisierten Bedingungen zustimmen, indem Sie Ihre Zustimmung in der Ihnen vorgelegten Mitteilung anklicken, bevor Sie den Dienst weiterhin nutzen.",
            consumerRightsNotice:
                "Wenn Sie gemäß geltendem Recht als 'Verbraucher' eingestuft werden, haben Sie möglicherweise gesetzliche Rechte gemäß diesem lokalen Recht, die die Anwendung aller oder Teile einiger der in diesen Bedingungen festgelegten Einschränkungen und Ausschlüsse für Sie verbieten, und in diesem Fall gelten diese Teile nicht für Sie.",
            theService: "Der Dienst",
            serviceGrant:
                "Wir gewähren Ihnen ein nicht-exklusives, weltweites, nicht übertragbares, widerrufbares Recht zur Nutzung des Dienstes gemäß diesen Bedingungen.",
            serviceAccess:
                "Sie können auf den Dienst zugreifen und ihn nutzen (einschließlich aller zufälligen Kopien, die im Rahmen dieser Nutzung entstehen) gemäß diesen Bedingungen.",
            serviceAgentAppointment:
                "Wenn Sie sich in den Dienst einloggen und ein Social-Media-Konto mit dem Dienst verbinden, ernennen Sie uns zu Ihrem Vertreter in Bezug auf dieses Konto, um in Ihrem Namen und nach Ihren Anweisungen (z. B. um auf eine direkte Nachricht auf Instagram oder einer anderen Plattform zu antworten) zu handeln, um Ihnen den Dienst bereitzustellen.",
            additionalAccountsAppointment:
                "Wenn Sie zusätzliche Konten mit dem Dienst verbinden, ernennen Sie uns auch zu Ihrem Vertreter in Bezug auf diese Konten, um die Aktivitäten im Rahmen der Agentur durchzuführen.",
            accountControl:
                "Sie garantieren, dass Sie jedes Konto kontrollieren und dass Sie befugt sind, uns als Ihren Vertreter mit der Befugnis zu ernennen, die Aktivitäten im Rahmen der Agentur in Ihrem Namen für jedes Konto durchzuführen.",
            serviceAffiliation:
                "Sie erkennen an und stimmen zu, dass der Dienst nicht mit Instagram, Facebook, Twitter oder einem anderen sozialen Dienst verbunden oder von diesen autorisiert ist, für den wir den Dienst bereitstellen, und dass jeder Zugriff auf jede Plattform (einschließlich über den Dienst) durch die Nutzungsbedingungen der jeweiligen Plattform geregelt wird.",
            serviceLinks:
                "Der Dienst enthält Links zu anderen Websites sowie Inhalte, die von Personen erstellt wurden, die nicht wir sind. Wir unterstützen, sponsern oder genehmigen keinen solchen nutzergenerierten Inhalt oder Inhalte, die auf einer verlinkten Website verfügbar sind.",
            contentMonitoring:
                "Wir haben keine Verpflichtung, Inhalte zu überwachen, zu bearbeiten oder zu entfernen, die von unseren Benutzern in den Dienst hochgeladen oder veröffentlicht und dann auf einem Konto auf einer der Plattformen veröffentlicht werden.",
            serviceControl:
                "Sie erkennen an und stimmen zu, dass: (1) wir die Kontrolle über den Dienst behalten und den Dienst jederzeit nach unserem Ermessen ändern, ergänzen oder einstellen können (wir werden Sie angemessen über jede Änderung informieren, die die Funktionalität des Dienstes erheblich negativ beeinflusst); (2) der Dienst von Zeit zu Zeit nicht verfügbar sein kann (einschließlich zu Wartungszwecken), und soweit möglich werden wir Sie über geplante Ausfallzeiten informieren; und (3) wir können die Veröffentlichung von Inhalten, die Sie dem Dienst hinzufügen, ablehnen, wenn wir der Meinung sind, dass diese Inhalte, nach unserem Ermessen, nicht mit Abschnitt 3 dieser Bedingungen übereinstimmen.",
            yourRightsAndObligations: "Ihre Rechte und Pflichten",
            contentAdditionRestriction:
                "Sie dürfen keine Inhalte zum Dienst hinzufügen: (1) es sei denn, Sie besitzen alle erforderlichen Rechte, Lizenzen und Zustimmungen; (2) die dazu führen könnten, dass Sie oder wir gegen ein Gesetz oder eine Vorschrift oder eine andere rechtlich durchsetzbare Regel, einen Kodex oder eine andere Verpflichtung verstoßen; (3) die spam, obszön, unangemessen, verleumderisch, herabwürdigend, unanständig, aufrührerisch, beleidigend, pornografisch, bedrohlich, missbräuchlich, zu Hass aufstachelnd, rechtswidrig, diskriminierend, blasphemisch, das Vertrauen verletzend oder gegen ein Datenschutzgesetz verstoßend ist; (4) die uns oder den Dienst in Misskredit bringen würde; oder (5) die die geistigen Eigentumsrechte oder andere Rechte einer Person verletzen.",
            restrictionsOnServiceUse:
                "Sie dürfen Folgendes nicht tun: (1) versuchen, den Dienst, Inhalte, die wir in Bezug auf den Dienst veröffentlichen, oder anderes Material, das Sie nicht besitzen oder für das Sie keine entsprechende Lizenz haben, zu duplizieren, zu replizieren oder zu reproduzieren, zu ändern oder abgeleitete Werke zu erstellen; (2) Viren oder andere bösartige Codes zu verbreiten; (3) den Dienst zu nutzen, um irreführende oder täuschende Informationen zu veröffentlichen; (4) ohne Erlaubnis auf das Konto einer anderen Person in unserem Dienst zuzugreifen; (5) einen Aspekt des Dienstes zu ändern, zu deaktivieren, zu stören oder zu umgehen oder den Dienst zu testen oder zurückzuentwickeln, um Einschränkungen, Schwachstellen zu finden oder Filterfähigkeiten zu umgehen; oder (6) irgendetwas zu tun, das den Zugang zum Dienst oder die Integrität des Dienstes beeinträchtigen könnte.",
            payments: "Zahlungen",
            paymentAcknowledgment: "Sie erkennen an und stimmen zu, dass:",
            paymentMethodDebit:
                "Wir werden am angegebenen Rechnungsdatum (dem Tag, an dem Ihre Testphase endet) jeden Monat, Jahr oder anderen Rechnungszeitraum (sofern zutreffend) im Voraus von der von Ihnen angegebenen Zahlungsmethode abbuchen; und",
            cancellationPolicy:
                "Wenn Sie den Dienst kündigen, haben Sie bis zu Ihrem nächsten Rechnungsdatum weiterhin Zugang zum Dienst, und eine Rückerstattung von für den aktuellen Rechnungszeitraum gezahlten Beträgen liegt in unserem Ermessen (d. h. Zahlungen sind nicht erstattungsfähig, es sei denn, es liegt in unserem Ermessen).",
            intellectualProperty: "Geistiges Eigentum",
            contentDefinition:
                "In diesen Bedingungen umfasst 'Inhalt' Materialien in Text-, Audio-, Grafik-, Bild- und Videoform oder jede Kombination von Materialien in jeder Form.",
            intellectualPropertyRightsTransfer:
                "Nichts in diesen Bedingungen stellt eine Übertragung von Rechten an geistigem Eigentum dar. Sie erkennen an und stimmen zu, dass wir alle Rechte an geistigem Eigentum im Dienst besitzen (d. h. wir besitzen die Rechte an den Anwendungen, die wir Ihnen zur Verfügung stellen – wir besitzen keine Rechte an geistigem Eigentum an Ihrem Inhalt – siehe unten in 5(3)).",
            userContentRights:
                "Wir erkennen an, dass Sie zwischen Ihnen und uns alle Rechte an geistigem Eigentum an den Inhalten, die Sie dem Dienst zur Verfügung stellen oder uns anderweitig zur Verfügung stellen, um den Dienst bereitzustellen, besitzen oder eine Lizenz dafür haben.",
            grantLicense:
                "Sie gewähren uns ein unbefristetes, nicht-exklusives, lizenzfreies, unwiderrufliches, weltweites und übertragbares Recht und eine Lizenz zur Nutzung, auf jede Weise (einschließlich durch Veröffentlichung auf einem Konto auf einer Plattform, wie von Ihnen angewiesen): (a) Inhalte, die Sie dem Dienst hinzufügen; und (b) Profilinhalte auf sozialen Medienplattformen, die mit Ihrem Konto verbunden sind (einschließlich, aber nicht beschränkt auf, durch Vervielfältigung, Änderung oder Anpassung und öffentliche Kommunikation dieser Inhalte) zu Zwecken der Bereitstellung des Dienstes für Sie.",
            subLicense:
                "Wir können die Lizenz in Absatz 5(4) an Drittanbieter, die uns bei der Bereitstellung des Dienstes unterstützen, unterlizenzieren.",
            moralRights:
                "In einigen Ländern, in denen der Dienst betrieben wird, erkennt das lokale Recht an, dass Autoren von Inhalten möglicherweise 'moralische Rechte' in Bezug auf die Inhalte haben. Beispiele für moralische Rechte können das Recht umfassen, als Autor von Inhalten genannt zu werden, das Recht, gegen falsche Zuschreibungen der Urheberschaft von Inhalten Einspruch zu erheben, und das Recht, in bestimmten Fällen gegen herabwürdigende Behandlungen von Inhalten Einspruch zu erheben.",
            licenseSurvival: "Die Lizenz in Absatz 5(4) bleibt auch nach Beendigung dieser Bedingungen in Kraft.",
            rightsRepresentation:
                "Sie erklären und garantieren uns, dass Sie alle erforderlichen Rechte haben, um die in diesem Absatz 5 festgelegten Lizenzen und anderen Verpflichtungen zu gewähren.",
            warranties: "Garantien",
            warrantiesAcknowledgment: "Sie erklären und garantieren uns, dass:",
            accountOwnership:
                "Alle Konten, auf jeder Plattform, die dem Dienst hinzugefügt werden, gehören oder werden von Ihnen kontrolliert;",
            serviceUsageAgreement: "Sie werden den Dienst in Übereinstimmung mit diesen Bedingungen nutzen; und",
            legalCapacity: "Sie haben die rechtliche Fähigkeit und die Befugnis, diese Bedingungen einzugehen.",
            liability: "Haftung",
            liabilityForLoss:
                "Sie sind für jeden Verlust oder Schaden verantwortlich, der entsteht, wenn Sie Ihre Verpflichtungen aus diesen Bedingungen verletzen oder wenn Sie bei der Nutzung des Dienstes nicht die angemessene Sorgfalt walten lassen. Ihre Haftung wird in dem Maße reduziert, in dem wir diesen Verlust oder Schaden durch unser eigenes Verschulden oder unsere eigene Unterlassung bei der Bereitstellung des Dienstes verursachen oder dazu beitragen.",
            indemnification:
                "Sie stellen uns von allen Verlusten oder Schäden frei, die wir aufgrund Ihrer Verletzung dieser Bedingungen (einschließlich der Garantien, die Sie uns gemäß diesen Bedingungen geben) oder aufgrund von vorsätzlichem Fehlverhalten, rechtswidrigen Handlungen oder Fahrlässigkeit bei Ihrer Nutzung oder missbräuchlichen Nutzung des Dienstes erleiden.",
            exclusionOfLiability:
                "Soweit gesetzlich zulässig und vorbehaltlich der Bestimmungen 7(5) und 7(6) dieser Bedingungen schließen wir jegliche Haftung für alle Ansprüche, Ausgaben, Verluste, Schäden und Kosten aus, die gegen Sie geltend gemacht werden oder die Sie direkt oder indirekt im Zusammenhang mit Ihrer Nutzung des Dienstes oder Ihrer Unfähigkeit, den Dienst zu nutzen, erleiden, einschließlich wirtschaftlicher Verluste, Datenverluste, Betriebsunterbrechungen oder sonstige Folgeschäden.",
            totalLiabilityLimit:
                "Soweit gesetzlich zulässig und vorbehaltlich der Bestimmungen 7(5) und 7(6) dieser Bedingungen ist unsere Gesamthaftung Ihnen gegenüber für Vertragsverletzungen gemäß diesen Bedingungen, für Delikte (einschließlich Fahrlässigkeit) oder aus einem anderen Grund auf einen Betrag beschränkt, der der Gesamtsumme entspricht, die Sie für den Dienst im Monat vor dem Tag, an dem unsere Haftung entstanden ist, gezahlt oder zu zahlen haben.",
            exclusionOfTerms:
                "Soweit gesetzlich zulässig und vorbehaltlich der Bestimmungen 7(5) und 7(6) dieser Bedingungen schließen wir alle Bedingungen, Erklärungen, Garantien, Bedingungen, Zusicherungen oder Verpflichtungen (ob ausdrücklich oder stillschweigend) aus, die nicht ausdrücklich in diesen Bedingungen festgelegt sind.",
            statutoryObligations:
                "In einigen Rechtsordnungen kann das Gesetz verlangen, dass bestimmte Garantien, Bedingungen, Zusicherungen oder Verpflichtungen in Bezug auf den Dienst in diese Bedingungen aufgenommen oder unserer Bereitstellung des Dienstes auferlegt werden ('gesetzliche Verpflichtungen'). Darüber hinaus kann das Gesetz andere Bedingungen, die den Ausschluss, die Begrenzung oder die Änderung auferlegter Bedingungen oder die Ausübung von Rechten und Rechtsmitteln oder die Rückforderung von Entschädigungen, die Ihnen zur Verfügung stehen, wenn wir eine auferlegte Bedingung verletzen, verbieten oder für nichtig erklären ('gesetzliches Verbot').",
            statuteProhibition:
                "Wenn das in Absatz 7(6) genannte Gesetz auf diese Bedingungen, wie sie von Ihnen akzeptiert wurden, oder auf den Ihnen bereitgestellten Dienst anwendbar ist, ist nichts in diesen Bedingungen dazu bestimmt, ein gesetzliches Verbot zu sein oder zu wirken. Insbesondere ist kein Teil dieser Bedingungen dazu bestimmt, unsere Haftung zu beschränken, wo dieser Teil ein gesetzliches Verbot wäre.",
            termination: "Kündigung",
            terminationAutomatic:
                "Diese Bedingungen enden automatisch, wenn wir aus irgendeinem Grund den Dienst einstellen.",
            terminationNotice:
                "Wir können Ihren Zugang zum Dienst auch sofort kündigen oder aussetzen, wenn wir der Meinung sind, dass Sie diese Bedingungen in irgendeiner Weise verletzt haben.",
            cancelService:
                "Sie können den Dienst jederzeit kündigen, indem Sie uns benachrichtigen, und Sie können bis zum Ende Ihres aktuellen Abrechnungszeitraums weiterhin auf den Dienst zugreifen.",
            terminationRights: "Alle Ihnen in diesen Bedingungen gewährten Rechte enden mit der Kündigung.",
            assignmentRestriction:
                "Sie dürfen Ihre Rechte aus diesen Bedingungen nicht abtreten, unterlizenzieren oder anderweitig damit verfahren.",
            invalidProvision:
                "Wenn eine Bestimmung dieser Bedingungen ungültig oder nicht durchsetzbar ist, ist sie in dem erforderlichen Umfang zu lesen oder zu trennen, ohne die Gültigkeit oder Durchsetzbarkeit der verbleibenden Bestimmungen zu beeinträchtigen.",
            expenseResponsibility:
                "Jede Partei muss auf eigene Kosten alles tun, was vernünftigerweise erforderlich ist, um diesem Vertrag und den darin vorgesehenen Ereignissen volle Wirkung zu verleihen.",
            governingLaw:
                "Diese Bedingungen unterliegen den Gesetzen der Türkei, und jede Partei unterwirft sich der Gerichtsbarkeit der Gerichte der Türkei.",
            privacyPolicyTab: "Datenschutzrichtlinie",
            termsAndConditionsTab: "Nutzungsbedingungen",
            placeholders: "Platzhalter",
            deleteOperation: "Löschvorgang",
            deleteConfirmationMessage: "Sind Sie sicher, dass Sie diesen Filter löschen möchten?",
            deleteSuccess: "Filter erfolgreich gelöscht",
            filterSavedSuccessfully: "Der Filter wurde erfolgreich gespeichert",
            filterCreatedMessage:
                "Der soeben erstellte Filter {filterName} ist jetzt verfügbar und kann jederzeit verwendet werden.",
            copyImage: "Bild kopieren",
            copyText: "Text kopieren",
            translateVisitorMessage: "Nachricht übersetzen",
            replyMessage: "Antworten",
            filterName: "Filtername",
            enterFilterName: "Geben Sie den Filternamen ein",
            selectVisibility: "Sichtbarkeit auswählen",
            public: "Öffentlich",
            private: "Privat",
            includeExistingFilters: "Bestehende Filter einbeziehen",
            includeSearchTerm: "Suchbegriff einbeziehen",
            includeSortOrder: "Sortierreihenfolge einbeziehen",
            includeGroupingSelection: "Gruppierungsauswahl einbeziehen",
            saveFilter: "Filter speichern",
            ban: "Sperren",
            forwardToDepartmentAndAssign: "An Abteilung weiterleiten und zuweisen",
            storageSpace: "Speicherplatz",
            completed: "Abgeschlossen",
            failed: "Fehlgeschlagen",
            cancelled: "Storniert",
            running: "Läuft",
            paused: "Pausiert",
            queued: "In der Warteschlange",
            scheduled: "Geplant",
            metaLead: "Meta Lead",
            agent: "Agent",
            invoice: "Rechnung",
            whatsapp: "WhatsApp",
            reservation: "Reservierung",
            chatbot: "Chatbot",
            webhook: "Webhook",
            table: "Tabelle",
            tag: "Tag",
            low: "Niedrig",
            lowest: "Am niedrigsten",
            medium: "Mittel",
            high: "Hoch",
            highest: "Am höchsten",
            createDepartment: "Abteilung erstellen",
            goToLink: "Zum Link gehen",
            emailAddressYouProvide: "Mit der angegebenen E-Mail-Adresse wurde bereits ein Konto erstellt.",
            channelPrivacyPolicyNotMet: "Die Kanal-Datenschutzrichtlinie wird nicht erfüllt",
            userIsNotInDepartment: "Der Benutzer befindet sich nicht in dieser Abteilung",
            currentDepartment: "Aktuelles Departement",
            validDepartment: "Gültiges Departement",
            youCanForwardToThisDepartment: "Sie können die Konversation an dieses Departement weiterleiten",
            goToSettings: "Zu den Einstellungen gehen",
            changeDepartmentAndForward: "Abteilung ändern und weiterleiten",
            selectDepartmentToForwardAgent:
                "Bitte wählen Sie aus, durch welche Abteilung Sie das Gespräch für den Agenten mit dem Namen {selectAgentName} leiten möchten.",
            selectDepartmentToForward: "Bitte wählen Sie die Abteilung, an die Sie weitergeleitet werden möchten",
            packageConfirmationMessage:
                "Sind Sie sicher, dass Sie das Paket kaufen möchten? Das Paket, das Sie kaufen, unterliegt Echtzeitgebühren. Nach der Stornierung können Sie es ein Jahr lang weiter nutzen. Der Preis dieses Produkts ist ohne 20% MwSt.",
            packagePurchaseConfirmation:
                "Sind Sie sicher, dass Sie das Paket kaufen möchten? Monatlich abonnierte Pakete werden zu Beginn jedes Monats berechnet. Die Nutzung des Pakets endet nach dem Stornierungsdatum. Der Preis dieses Produkts ist ohne 20% MwSt.",
            annualPurchaseDiscount: "Nutzen Sie das 30%-Rabattangebot bei Jahreskäufen!",
            customerTables: "Kunden-Tabellen",
            formIntegration: "Formularintegration",
            automationIntegration: "Otomationsintegration",
            remainingAutomationTask: "Verbleibende Automatisierungsaufgabe",
            createUserError: "Ein Fehler ist beim Erstellen des Benutzers aufgetreten",
            sendTemplateMessage: "Vorlagennachricht senden",
            startChatWithDifferentChannel: "Chat mit anderem Kanal starten",
            whatsappChatStarter: "WhatsApp-Chat-Starter",
            pressEnterToJoin: "Drücken Sie Enter, um dem Chat beizutreten",
            pressEnterToStartChat: "Drücken Sie Enter, um den Chat zu starten",
            cannotSendMessage: "Sie können dieser Person keine Nachricht senden",
            cannotSendSessionMessage: "Sie können dieser Person keine Sitzungsnachricht senden",
            conversationNotInYourDepartments: "Diese Konversation gehört zu keiner Ihrer Abteilungen",
            customizeImage: "Wenn Sie das Bild anpassen möchten",
            clickToUpload: "Klicken Sie hier, um ein Bild hochzuladen",
            uploadNote: "Folgende Dateiformate und deren Größen werden für den Upload akzeptiert",
            imageSize: "Das Bild konnte nicht hochgeladen werden, da es größer als 2 MB ist",
            videoSize: "Das Video konnte nicht hochgeladen werden, da es größer als 20 MB ist",
            documentSize: "Das Dokument konnte nicht hochgeladen werden, da es größer als 2 MB ist",
            uploading: "Bild wird hochgeladen, bitte warten...",
            uploadSuccess: "Bild erfolgreich hochgeladen",
            note: "Hinweis",
            gridView: "Tabellenansicht",
            completedTasks: "Abgeschlossene Aufgaben",
            system: "System",
            destroyedBy: "Gelöscht von",
            brand: "Marke",
            channelCreatedSuccess: "Kanal erfolgreich erstellt",
            channelCreatedError: "Kanal konnte nicht erstellt werden",
            plans: {
                types: {
                    supsis: "Vertreterpakete",
                    chatbot: "Chatbot",
                    automation: "Automatisierung",
                    customer_tables: "Kundentabelle",
                    mail: "E-Mail",
                    tasks: "Aufgaben",
                    form: "Formular",
                    whatsapp: "WhatsApp Web (QR)",
                    whatsapp_business: "WhatsApp Business API",
                    instagram: "Instagram",
                    messenger: "Messenger",
                    meta_lead: "Meta Lead",
                    trendyol: "Trendyol",
                    artificial_intelligence: "Künstliche Intelligenz",
                    webhook: "Webhook",
                    telegram: "Telegram",
                    webphone: "Web Phone",
                },
            },
            vipCustomerDescription:
                "Das Markieren dieser Person als VIP-Kunde bringt sie an die Spitze der Warteschlange und sorgt dafür, dass sie prioritären Service erhält.",
            switchOn: "Ein",
            switchOff: "Aus",
            ownerDescription:
                "Diese Funktion zeigt den Besitzer eines Chats an. Unabhängig vom Status des Besitzers (online oder offline) werden Chats immer dem Besitzer zugewiesen. Besessene Chats können nur vom jeweiligen Besitzer angezeigt werden und können nicht vom Chatbot beantwortet werden.",
            permissionError: "Sie haben keine Berechtigung, diese Aktion auszuführen!",
            copySuccess: "Inhalt erfolgreich kopiert!",
            unowned: "Unbesessen",
            jsonPreview: "JSON-VORSCHAU",
            enterNewValue: "Neuen Wert eingeben",
            updatePreferredLanguage: "Bevorzugte Sprache aktualisieren",
            updateTags: "Tags aktualisieren",
            updateEmail: "E-Mail aktualisieren",
            enterNewEmail: "Neue E-Mail eingeben",
            deleteConfirmation: "Löschbestätigung",
            confirmDelete: "Sind Sie sicher, dass Sie diese Funktion löschen möchten?",
            yesDelete: "Ja, löschen",
            vipCustomer: "★ VIP-Kunde",
            takeControlFromChatbot: "Kontrol von Chatbot übernehmen",
            enterJoin: "Sie können der Konversation beitreten, indem Sie die Eingabetaste drücken",
            watchChat: "Konversation ansehen",
            untitledAutomation: "👉 Unbenanntes Profil Klick-Automatisierung",
            event: "Ereignis",
            chatbotSettings: "Chatbot-Routing-Einstellungen",
            chatbotScenarioNotFound: "Chatbot-Szenario nicht gefunden",
            noChatbotScenario: "Im System wurde kein Chatbot-Szenario gefunden.",
            scenarioNotFound: "Szenario nicht gefunden",
            descNotAvailable: "Beschreibung nicht verfügbar",
            lastRegulation: "Letzte Regelung",
            taskCreator: "Aufgabensteller",
            noPermission: "Sie haben keine Berechtigung, Aufgaben zu erstellen.",
            noPermissionDescription: "Sie haben keine Berechtigung, diese Aktion auszuführen.",
            notAppointed: "Nicht ernannt",
            changeStage: "Stufe ändern",
            selectedCandidates: "1 ausgewählter Kandidat(en)",
            coverPhotoRemove: "Titelbild entfernen",
            coverPhotoSet: "Als Titelbild festlegen",
            autoTransfer: "Kontakte automatisch nach Zoho übertragen",
            autoTransferDescription:
                "Kontakte, die über diesen Kanal eingehen, werden automatisch in das Zoho CRM-Kontaktmodul übertragen. Die an Zoho übertragenen Kontakte aktivieren Zoho-Widgets.",
            zohoChannelRequiredTitle: "Zoho CRM-Kanal erforderlich",
            zohoChannelRequiredContent:
                "Sie haben keinen Zoho CRM-Kanal. Klicken Sie hier, um sofort einen hinzuzufügen.",
            okText: "Zoho CRM-Kanal hinzufügen",
            cancelText: "Abbrechen",
            forceQueueForNoOwnerContacts: "Sahiplose Kontakte zwingen, in der Warteschlange zu warten",
            forceQueueDescription:
                "Nur besessene Kontakte werden automatisch zugewiesen, wodurch besitzlose Kontakte gezwungen werden, in der Warteschlange zu warten.",
            showNoOwnerContactsToAdmins: "Besitzlose Kontakte nur für Administratoren anzeigen",
            showNoOwnerContactsDescription: "Besitzlose Kontakte sind nur für Administratoren sichtbar.",
            autoAssignOwner: "Automatische Kontaktzuweisung",
            autoAssignOwnerDescription:
                "Wenn der Chat automatisch einem Vertreter zugewiesen wird, wird er auch als Eigentümer zugewiesen.",
            creator: "Ersteller",
            hideShow: "Ausblenden / Anzeigen",
            url: "URL",
            cannedMessages: "Vorgefertigte Nachrichten",
            templateMessages: "Vorlagen Nachrichten",
            chatbots: "Chatbots",
            noCannedMessages: "Keine vorgefertigten Nachrichten gefunden",
            filterToFindMore: "Sie können weitere vorgefertigte Nachrichten finden, indem Sie Ihre Filter ändern.",
            runPrompt: "Prompt Ausführen",
            noLeadsFound: "Keine Leads für diese Person gefunden",
            deals: "Deals",
            noDealsFound: "Keine Deals für diese Person gefunden",
            loadingDeals: "Deals werden geladen",
            zohoCRM: "Zoho CRM",
            viewContact: "Kontakt anzeigen",
            noNotesAdded: "Noch keine Notizen hinzugefügt",
            attachments: "Anhänge",
            addNewNote: "Neue Notiz hinzufügen",
            savingg: "Speichern...",
            warningFillFields: "Bitte füllen Sie die Felder Titel und Inhalt aus.",
            successNoteAdded: "Notiz erfolgreich hinzugefügt.",
            errorAddingNote: "Beim Hinzufügen der Notiz ist ein Fehler aufgetreten.",
            noteTitle: "Notiz Titel",
            noteContent: "Notiz Inhalt",
            selectPreferredAgent: "Wählen Sie den bevorzugten Agenten aus, den Sie dem Besucher zuweisen möchten.",
            postOperations: "Post-Operationen",
            loadingPostOperations: "Post-Operationen werden geladen",
            noPostOperations: "Keine Post-Operationen für diese Person gefunden",
            postOperationDetails: "Details zu Post-Operationen",
            noMediaDocuments: "Keine Medien oder Dokumente für diese Person verfügbar.",
            selectionLimitError: "Sie können maximal 30 Elemente auswählen.",
            showNote: "Notiz für alle anzeigen",
            hideNote: "Notiz ausblenden",
            updateNote: "Notiz aktualisieren",
            addUserNote: "Eine Notiz über den Benutzer hinzufügen",
            privateNote: "Private Notiz",
            metaReferrals: "Meta Empfehlungen",
            noMetaReferrals: "Keine Meta-Werbeinteraktionen gefunden.",
            searchPrompt: "Nach etwas suchen.",
            noRecentResults: "Keine aktuellen Ergebnisse gefunden.",
            contactInfo: "Kontaktinformationen",
            noPropertiesAdded: "Noch keine Eigenschaften hinzugefügt.",
            propertyAddedUpdated: "Eigenschaft erfolgreich hinzugefügt/aktualisiert.",
            propertyError: "Beim Hinzufügen/Aktualisieren der Eigenschaft ist ein Fehler aufgetreten.",
            propertyDeleted: "Eigenschaft erfolgreich gelöscht.",
            propertyDeleteError: "Beim Löschen der Eigenschaft ist ein Fehler aufgetreten.",
            zohoSynchronization: "Zoho-Synchronisierung",
            zohoSyncConfirmation: "Möchten Sie Änderungen an der Person in Zoho vornehmen?",
            hideOtherInfo: "Andere Informationen ausblenden",
            showOtherInfo: "Andere Informationen anzeigen",
            whatsappChatStart: "WhatsApp-Chat starten",
            ownership: "Kundenbesitz",
            countryAndLanguage: "Land, Sprache",
            calendarEvent: "Kalenderevent",
            contact: "Kontakt",
            user: "Benutzer",
            customerOwnership: "Kundenbesitz",
            ownerless: "Besitzlos",
            preferredDepartment: "Bevorzugte Abteilung",
            flowluTransfer: "Übertragung an Flowlu",
            mergeSuccess: "Zusammenführungsoperation erfolgreich abgeschlossen.",
            visitorOwnershipWarning: "Dieser Besucher gehört einem anderen Benutzer.",
            newAutomation: "Neue Automatisierung",
            automations: "Automatisierungen",
            createProfileAutomation: "Profilautomatisierung erstellen",
            profileButtonClicked: "Profilknopf wurde gedrückt",
            profileButtonDescription: "Diese Automatisierung wird ausgelöst, wenn ein Profilknopf gedrückt wird.",
            automationName: "Automatisierungsname",
            create: "Erstellen",
            dayRange: "Tagesbereich",
            hourRange: "Stundenbereich",
            last24Hours: "Letzte 24 Stunden",
            today: "Heute",
            yesterday: "Gestern",
            thisWeek: "Diese Woche",
            lastWeek: "Letzte Woche",
            last7Days: "Letzte 7 Tage",
            last30Days: "Letzte 30 Tage",
            thisMonth: "Diesen Monat",
            lastMonth: "Letzter Monat",
            startDateTime: "Startdatum und Uhrzeit",
            endDateTime: "Enddatum und Uhrzeit",
            complaint: "Beschwerde",
            opens: "Öffnungen",
            clicks: "Klicks",
            mockData: "(Testdaten)",
            forwardToDepartment: "An Abteilung weiterleiten",
            toMobileAgents: "Mobile Agenten",
            noMediaAndDocuments: "Dieser Benutzer hat keine Medien oder Dokumente",
            reportBug: "Fehler melden",
            waitingForReply: "Warten auf Antwort",
            memorySize: "Speichergröße",
            usedMemory: "Verwendeter Speicher",
            availableMemory: "Verfügbarer Speicher",
            memoryLimit: "Speicherlimit",
            memoryLimitPrice: "Preis für zusätzlichen Speicher",
            telegramBotIsReachable: "Telegram Bot Servisine erreichbar",
            telegramBotIsHealthy: "Telegram Bot Servis ist gesund",
            telegramBotIsUnhealthy: "Telegram Bot Servis hat einen Fehler",
            pieView: "Kreisdiagramm",
            chartView: "Diagrammansicht",
            tableView: "Tabellenansicht",
            lastUpdate: "letzte Aktualisierung",
            workflow: "workflow",
            Aufgabe: "Aufgabe",
            filterBy: "Nach Filter",
            watchAllLive: "Alle Liveübertragungen ansehen",
            sessionsUnique: "Sitzungen (Einzigartige Benutzer)",
            sessionsAll: "Sitzungen (Alle Benutzer)",
            moreFeaturesDesc:
                "Mehr Funktionen, mehr Integrationen, mehr Agenten! Ergreifen Sie jetzt Maßnahmen, um Ihr Team besser zu verwalten und Ihr Unternehmen auf sein maximales Potenzial zu bringen!",
            metaLeadForms: "Meta-Lead-Formulare",
            metaLeadsConnectedSucs: "Meta Leads erfolgreich verbunden",
            failedToConnectMetaLeads: "Verbindung zu Meta Leads fehlgeschlagen",
            forbiddenChannel: "Verbotener Kanal",
            forbiddenChannelDesc: "Sie sind nicht berechtigt, diesen Kanal zu sehen",
            firstContact: "Erster Kontakt",
            needsAnalysis: "Bedürfnisanalyse",
            offerSent: "Gesendetes Angebot",
            offerReview: "Angebotsüberprüfung",
            decisionPhase: "Entscheidungsphase",
            personDeleted: "Gelöschte Person",
            metaLeadsIntegration: "Meta Leads Integration",
            phoneNumberIsInvalid: "Telefonnummer ungültig",
            addAnItem: "Artikel hinzufügen",
            saveItem: "Artikel speichern",
            customItem: "Benutzerdefiniertes Element",
            backgroundPhoto: "Hintergrundbild",
            whenYouActivateFeature:
                "Wenn Sie diese Funktion aktivieren, wird sie nicht auf der Buchungsseite angezeigt",
            logo: "Logo",
            noLogo: "Kein Logo",
            addTeamMember: "Teammitglied hinzufügen",
            timezone: "Zeitzone",
            selectDayys: "Tag(e) auswählen",
            selectStartHour: "Startzeit auswählen",
            selectEndHour: "Endzeit auswählen",
            moveLeft: "Nach rechts bewegen",
            moveRight: "Nach links verschieben",
            reply: "Antwort",
            replyToAll: "Antwort an alle",
            deleteThreadMessage: "Nachricht zum Thema löschen",
            totalEmailsBounced: "Gesamtzahl der zurückgeschickten E-Mails",
            totalEmailsComplained: "Gesamtzahl der beanstandeten E-Mails",
            untilNowTotalEmailOpens: "Gesamtzahl der bisher geöffneten E-Mails",
            untilNowTotalEmailLinkClicks: "Gesamtzahl der bisherigen Klicks auf E-Mail-Links",
            uniqueClicks: "Einzigartige Klicks",
            untilNowTotalUniqueEmail: "Gesamtzahl der bisherigen eindeutigen Klicks auf E-Mail-Links (pro Empfänger)",
            emailCampaignTimeline: "Zeitleiste der E-Mail-Kampagne",
            receivedBroadcasts: "Empfangene Broadcasts",
            groupDeletedSuccessfully: "Gruppe erfolgreich gelöscht",
            verify: "Überprüfen",
            done: "Erledigt",
            pleaseSelectAnEmailAddress: "Bitte wählen Sie eine E-Mail-Adresse aus.",
            goBack: "Zurückgehen",
            show: "Anzeigen",
            vueEmailEditor: "Vue E-Mail-Editor (Demo)",
            saveDesign: "Entwurf speichern",
            exportHTML: "HTML exportieren",
            saveAsEmailCustomerGroup: "Als E-Mail-Kundengruppe speichern",
            saveAsWhatsappCustomerGroup: "Als Whatsapp-Kundengruppe speichern",
            deleteModalFormDesc:
                "Wenn Sie dieses Formular löschen, werden alle Daten des Formulars dauerhaft gelöscht. Sind Sie sicher, dass Sie fortfahren möchten?",
            todo: "Zu erledigende Dinge",
            inProgress: "In Bearbeitung",
            approval: "Genehmigung",
            transactionType: "Vorgangsart",
            previousBalance: "Vorheriger Saldo",
            nextBalance: "Nächster Saldo",
            amount: "Betrag",
            wpIntegrationChannelRequired: "Whatsapp Web-Integrationskanal erforderlich",
            wpIntegrationChannelRequiredDesc:
                "Chatbot + Whatsapp Web Integration erfordert Whatsapp Web Channel. Bitte erstellen Sie einen neuen Kanal.",
            wabaIntegrationChannelRequired: "Whatsapp Business Integration Channel Required.",
            wabaIntegrationChannelRequiredDesc:
                "Chatbot + Whatsapp Business API integration requires Whatsapp Web Channel. Bitte erstellen Sie einen neuen Kanal.",
            instaIntegrationChannelRequired: "Instagram-Integrationskanal erforderlich.",
            instaIntegrationChannelRequiredDesc:
                "Chatbot + Instagram-Integration erfordert Instagram-Kanal. Bitte erstellen Sie einen neuen Kanal.",
            createWpChannel: "Whatsapp Web-Kanal erstellen",
            createWabaChannel: "Whatsapp Business API-Kanal erstellen",
            createInstaChannel: "Instagram-Kanal erstellen",
            failedToDeleteGroup: "Gruppe konnte nicht gelöscht werden",
            failedToDeleteGroups: "Gruppen konnten nicht gelöscht werden",
            failedToFetchGroupContacts: "Gruppenkontakte konnten nicht abgerufen werden",
            mailAddressDeletedSuccessfully: "Mail-Adresse erfolgreich gelöscht",
            defaultMailAddressChangedSuccessfully: "Standard-E-Mail-Adresse erfolgreich geändert",
            mailAddressAlreadyRegistered: "Die Mailadresse darf nicht bereits registriert oder leer sein.",
            pleaseVerifyByClicking:
                "Bitte verifizieren Sie sich, indem Sie auf den an Ihre E-Mail-Adresse gesendeten Link klicken.",
            signSucsRegistered: "Signatur erfolgreich registriert",
            myContacts: "Meine Kontakte",
            unanswered: "Verpasst",
            emailBroadcasts: "E-Mail-Rundrufe",
            monthlyLimit: "Monatliches Limit",
            totalShipments: "Gesamte Sendungen",
            shippingStatus: "Versandstatus",
            lastAction: "Letzte Aktion",
            receiver: "Empfänger",
            delivered: "Ausgeliefert",
            opened: "Geöffnet",
            clicked: "Angeklickt",
            bounced: "Er ist zurück",
            clickedLinks: "Angeklickte Links",
            reason: "Grund",
            timer: "Zeitgeber",
            implemented: "Implementiert?",
            module: "Modul",
            excelDownload: "Excel-Download",
            serviceFeatures: "Dienstmerkmale",
            mailAddressDeletedSucs: "Mail-Adresse erfolgreich gelöscht",
            inputSearchText: "Suchtext eingeben",
            createRecord: "Datensatz erstellen",
            separatorCharacter: "Trennzeichen",
            exampleResultPreview: "Beispiel Ergebnisvorschau",
            importRecords: "Datensätze importieren",
            equals: "Gleich",
            notEquals: "Nicht gleich",
            startsWith: "Beginnt mit",
            endsWith: "Endet mit",
            greaterThan: "Mehr",
            lessThan: "Weniger als",
            before: "Vorher",
            after: "Nach",
            is: "O",
            isNot: "Nicht",
            empty: "Leer",
            notEmpty: "Nicht leer",
            isOneOff: "Einmalig",
            field: "Feld",
            records: "Datensatz",
            addIntegration: "Integration hinzufügen",
            chatbotScenarioReleased: "Chatbot-Szenario freigegeben",
            chatbotScenarioHasBeenCancelled: "Chatbot-Szenario wurde abgebrochen",
            titleAndDesc: "Titel und Beschreibung",
            templateAndMailSelection: "Vorlage & E-Mail-Auswahl",
            peopleToSend: "Zu versendende Personen",
            submissionPlans: "Übermittlungsplan",
            summary: "Zusammenfassung",
            broadcastTitle: "Titel der Sendung",
            sentByEmail: "Gesendete E-Mail",
            emailTemplate: "E-Mail-Vorlage",
            onlyPeopleWithEmail: "Nur Personen mit einer E-Mail-Adresse sind für den Versand gültig",
            sendNow: "Jetzt senden",
            plan: "Plan",
            senderEmail: "Absender-E-Mail",
            totalBuyer: "Gesamtkäufer",
            estimatedDuration: "Geschätzte Dauer",
            person: "Person",
            shippingIsNowComplete: "Der Versand ist abgeschlossen!",
            back: "Zurück",
            customerName: "Kundenname",
            customerEmail: "E-Mail des Kunden",
            customValue: "Benutzerdefinierter Wert",
            selectMailTemplate: "Sie müssen eine E-Mail-Vorlage auswählen.",
            youMustSelectSendingMailAddress: "Sie müssen die Absender-E-Mail-Adresse auswählen.",
            youMustSelectCustomerGroupSend: "Sie müssen die Kundengruppe auswählen, an die gesendet werden soll.",
            createBroadcast: "Rundruf erstellen",
            broadcastDetails: "Details zur Sendung",
            youCanCheckYourEmailStatus:
                "Sie können Ihren E-Mail-Status überprüfen, indem Sie Ihren Tarif aktualisieren. Sie können Ihren E-Mail-Status überprüfen, indem Sie Ihren Tarif aufrüsten.",
            sentDetails: "Gesendete Details",
            total: "Gesamt",
            totalEmailsProcessed: "Insgesamt verarbeitete E-Mails",
            totalEmailsDelivered: "Insgesamt gesendete E-Mails",
            toAvailableAgents: "Für verfügbare Agenten",
            toAvailableDepartments: "Für verfügbare Abteilungen",
            toWithAgentAndDepartment: "Mit Agent und Abteilung",
            toMobilAgents: "An mobile Vertreter",
            toPreferredAgents: "An bevorzugte Agenten",
            searchAgent: "Suchagent",
            searchDepartment: "Abteilung suchen",
            searchMobileAgent: "Mobiler Agent suchen",
            searchAgentOrDepartment: "Suchagent oder Abteilung",
            searchPreferredAgent: "Suche nach dem bevorzugten Agenten",
            noAgentsAvailableToForward: "Keine Agenten zum Weiterleiten verfügbar",
            noDepartmentsAvailableToForward: "Keine Abteilungen zur Weiterleitung verfügbar",
            noMobileAgentsAvailableToForward: "Keine mobilen Agenten zur Weiterleitung verfügbar",
            noPreferredAgentsAvailableToForward: "Keine bevorzugten Agenten zur Weiterleitung verfügbar",
            ifYouSendThisConversationToTheQueue:
                "Wenn Sie diese Unterhaltung an die Warteschlange senden, werden Sie aus dem Chat entfernt und die Unterhaltung wird in die Warteschlange gestellt. Wenn die automatische Chat-Zuweisung aktiviert ist, wird die Unterhaltung einem geeigneten Agenten zugewiesen und kann an Sie zurückgegeben werden.",
            ifAutomaticChatAssignmentIsDisabled:
                "Wenn die automatische Chat-Zuweisung deaktiviert ist, bleibt das Gespräch in der Warteschlange. Autorisierte Mitarbeiter können den Anruf aus der Warteschlange heraus annehmen.",
            sendQueue: "An Warteschlange senden",
            agentName: "Name des Agenten",
            departmentName: "Name der Abteilung",
            anWarteschlange: "Warteschlange",
            web: "Web",
            mobile: "Mobil",
            noGrouping: "Keine Gruppierung",
            groupByThis: "Nach diesem gruppieren",
            selectGroupingCriteria: "Gruppierungskriterien auswählen",
            activeUsers: "Aktive Benutzer",
            passiveUsers: "Passive Benutzer",
            noPlatform: "Keine Plattform angegeben",
            noRole: "Rolle nicht spezifiziert",
            noDepartment: "Keine Abteilung angegeben",
            noLanguage: "Keine Sprache angegeben",
            group2: "Gruppe",
            groupedByStatus: "Gruppiert nach Status",
            grouping: "Gruppierung",
            activeSubjects: "Aktive Fächer",
            passiveSubjects: "Passive Subjekte",
            groupSubjects: "Gruppenfächer",
            showAll: "Alle anzeigen",
            onlyActive: "Nur Aktive",
            onlyPassive: "Nur die passiven",
            selectTimezone: "Zeitzone auswählen",
            userFilter: "Benutzerfilter",
            confidenceScore: "Vertrauenswert",
            chatbotLanguage: "Chatbot-Sprache",
            botScenerio: "Bot-Szenario",
            selectTemplate: "Vorlage auswählen",
            importFromReadyTemplates: "Aus fertigen Vorlagen importieren",
            classification: "Klassifizierung",
            addClassification: "Klassifizierung hinzufügen",
            expressionClassified: "Zu klassifizierender Ausdruck",
            zohoModuleName: "Name des Zoho-Moduls",
            selectModule: "Modul auswählen",
            standardFields: "Standardfelder",
            selectStandardField: "Standardfeld auswählen",
            customFields: "Benutzerdefinierte Felder",
            selectCustomFields: "Benutzerdefiniertes Feld auswählen",
            aiFunction: "Funktion der Künstlichen Intelligenz",
            aiFunctionDesc:
                "Funktion der künstlichen Intelligenz zur Durchführung von Aktionen auf der Grundlage von Benutzereingaben",
            functionName: "Funktionsname",
            functionDesc: "Funktionsbeschreibung",
            addParameter: "Parameter hinzufügen",
            chooseAiStory: "Wählen Sie eine KI-Geschichte",
            chatbotAiPromptDesc:
                "Künstliche Intelligenz lernt und bestimmt, wie sie sich verhalten soll, indem sie mit Hilfe der 'Prompt'-Funktion Anweisungen zu einer bestimmten Aufgabe oder einem Problem erhält.",
            enterPrompt: "Eingabeaufforderung.",
            aiParameterTunings: "KI-Parameter-Abstimmungen",
            aiParameterTuningsDesc:
                "Sie können die KI-Parameter einstellen, um die KI reaktionsschneller und genauer zu machen. Diese Parameter werden verwendet, um das Verhalten der KI zu steuern und wie sie auf Benutzereingaben reagiert.",
            temperature: "Temperatur",
            temperatureDesc:
                "Welche Sampling-Temperatur verwendet werden soll, zwischen 0 und 2. Höhere Werte wie 0,8 machen die Ausgabe zufälliger, während niedrigere Werte wie 0,2 sie fokussierter und deterministischer machen.",
            topDesc:
                "Als Alternative zum Sampling nach Temperatur, dem sogenannten Kernel Sampling, berücksichtigt das Modell die Ergebnisse von Token mit der Wahrscheinlichkeitsmasse top_p. 0,1 bedeutet also, dass nur Token mit der obersten 10%igen Wahrscheinlichkeitsmasse berücksichtigt werden. Wir empfehlen in der Regel, dies oder die Temperatur zu ändern, aber nicht beides.",
            toolChoices: "Werkzeugoptionen",
            noneDesc: "None bedeutet, dass das Modell kein Werkzeug aufruft und stattdessen eine Meldung generiert.",
            autoDesc:
                "Der automatische Modus ist der Standardwert und bedeutet, dass das Modell zwischen der Generierung einer Nachricht oder dem Aufruf eines oder mehrerer Agenten wählen kann.",
            requiredDesc:
                "Der Modus 'Required' bedeutet, dass das Modell einen oder mehrere Agenten aufrufen muss, bevor es dem Benutzer antwortet.",
            createArticles: "Artikel erstellen",
            createArticlesDesc: "Erstellen Sie Artikel, die Ihren Nutzern helfen, Antworten auf ihre Fragen zu finden.",
            articlesTitle: "Artikel-Titel",
            articlesContent: "Artikelinhalt",
            createFaq: "Erstellen Sie eine häufig gestellte Frage (FAQ)",
            createFaqDesc:
                "Erstellen Sie eine neue FAQ für Ihren Chatbot. Dies wird Ihrem Chatbot helfen, die Fragen des Benutzers zu beantworten.",
            question: "Frage",
            saveAndClose: "Speichern und schließen",
            contentPreview: "Inhaltsvorschau",
            upgradePackageTitle: "Aktualisieren Sie Ihr Paket und vermeiden Sie Einschränkungen",
            upgradePackageDescription:
                "Mehr Funktionen, mehr Integrationen, mehr Agenten! Werden Sie jetzt aktiv, um Ihr Team besser zu verwalten und Ihr Geschäftspotenzial zu maximieren!",
            upgradePackage: "Upgrade",
            deleteSelected: "Ausgewählte Dateien löschen",
            newFolder: "Neuer Ordner",
            newFile: "Neue Datei",
            noFilesFound: "Es wurden keine Dateien in diesem Ordner gefunden",
            uploadFile: "Datei hochladen",
            enterFolderName: "Bitte Ordnernamen eingeben",
            folderName: "Ordnername",
            dropFileHere: "Dateien hier ablegen",
            createFolder: "Ordner erstellen",
            fileUploadingError: "Beim Hochladen einer Datei ist ein Fehler aufgetreten",
            fileUploadingSucs: "Ordner erfolgreich erstellt",
            folderNameNotEmpty: "Ordnername darf nicht leer sein",
            deleteFolder: "Ordner löschen",
            sureDeleteFolder:
                "Sind Sie sicher, dass Sie diesen Ordner und alle darin enthaltenen Dateien löschen wollen?",
            deletionSucs: "Löschung erfolgreich",
            deleteFile: "Datei löschen",
            sureDeleteFile: "Sind Sie sicher, dass Sie diese Datei löschen wollen?",
            deletionError: "Während des Löschvorgangs ist ein Fehler aufgetreten",
            selectFile: "Datei auswählen",
            moreThanOneSelect: "Sie können mehr als eine Datei auswählen",
            selectAnFile: "Wählen Sie eine Datei aus",
            bulkSms: "Bulk SMS",
            sendBulkSmsCustomers: "Senden Sie Massen-SMS an Ihre Kunden",
            writeYourMessage: "Schreiben Sie Ihre Nachricht hier.",
            sendSms: "SMS senden",
            sendSmsYourCustomers: "Senden Sie SMS an Ihre Kunden",
            manageChannelDetail: "Kanalinformationen verwalten",
            details: "Einzelheiten",
            teamGramChannels: "TeamGram-Kanäle",
            newTeamGramIntegration: "Neue TeamGram-Integration",
            teamGramIntegration: "TeamGram-Integration",
            notMoreThanOneTeamGramChannels: "Sie können nicht mehr als einen TeamGram-Kanal erstellen",
            teamGramDetail: "TeamGram Detail",
            manageYourTeamGramIntegration: "Verwalten Sie Ihre TeamGram-Integration",
            trendyolChannels: "Trendyol-Kanäle",
            trendyolStoreIntegration: "Trendyol Store-Integration",
            trenyolStoreConnection: "Verbinden Sie Ihren Trendyol-Store",
            deleteTrendyolIntegration: "Trendyol-Integration löschen",
            sureDeleteTrendyolIntegration:
                "Sind Sie sicher, dass Sie die Trendyol-Integration löschen möchten? Diese Aktion ist nicht umkehrbar.",
            trendyolStoreChannel: "Trendyol Store-Kanal",
            deleteTrendyolChannel: "Trendyol-Kanal löschen",
            channelUpdatedSucs: "Kanal erfolgreich aktualisiert",
            failedUpdateChannel: "Kanal konnte nicht aktualisiert werden.",
            trendyolStoreIntegrationDetail: "Trendyol Store Integration Detail",
            configureTrendyolStoreIntegrationDetail: "Konfigurieren Sie Ihre Trendyol Store Integration",
            trenyolStoreProductQuestManage: "Trendyol Store - Produktsuchverwaltung",
            trendyolStoreDesc:
                "Sie können die folgenden Einstellungen verwenden, um Anfragen zu Trendyol Store-Produkten zu verwalten.",
            zohoCrmChannels: "Zoho CRM-Kanäle",
            zohoPersonalChannel: "Zoho Personal-Kanäle",
            connectZoho: "Mit Zoho CRM verbinden",
            updateChannelDesc5: "Zoho CRM-Kanal aktualisieren",
            zohoCrmIntegration: "Zoho CRM Integration",
            sureDeleteZohoChannel: "Sind Sie sicher, dass Sie den Zoho CRM-Kanal löschen möchten?",
            createNotMoreThanOneZohoChannels: "Sie können nicht mehr als einen Zoho-Kanal erstellen",
            removeZohoLink: "Zoho Link entfernen",
            connectToZoho: "Mit Zoho verbinden",
            chatClosed: "Chat geschlossen",
            scoreChat: "Chat erzielt",
            createdTicket: "Ticket erstellt",
            updatedTicket: "Ticket aktualisiert",
            newUserCreated: "Neuer Benutzer erstellt",
            updateUser: "Aktualisierter Benutzer",
            deleteUsers: "Benutzer gelöscht",
            changeStatusRepresent: "Status des Vertreters hat sich geändert",
            incomingMessage: "Eingehende Nachricht",
            outgoingMessage: "Ausgehende Nachricht",
            createdNewTicket: "Neues Ticket erstellt",
            bitrix24Channels: "Bitrix24-Kanäle",
            sureDeleteBitrixChannel: "Sind Sie sicher, dass Sie den Bitrix24-Kanal löschen wollen?",
            bitrix24Integrations: "Bitrix24 Integration",
            notCreateMoreThenOneChannel: "Sie können nicht mehr als einen Ideasoft-Kanal erstellen",
            connectToBitrix24: "Mit Bitrix24 verbinden",
            connectToBitrix24Api: "Mit Bitrix24 Api verbinden",
            updateChannel: "Kanal aktualisieren",
            updateChannelDesc: "Bitrix24 Api Kanal aktualisieren",
            yourBitrix24Domain: "Ihr Bitrix24 Domain Name",
            bitrix24ConnectedSucs: "Bitrix24 erfolgreich verbunden",
            failedToConnectBitrix24: "Verbindung zu Bitrix24 fehlgeschlagen",
            channelCreatedSuccessfully: "Kanal erfolgreich erstellt",
            failedToCreateChannel: "Kanal konnte nicht erstellt werden",
            holidayPlusChannels: "Urlaub+ Kanäle",
            newHolidayPlusIntegration: "Neue Holiday+ Integration",
            holidayPlusIntegrations: "Holiday+ Integration",
            notCreateMoreThanOneHolidayChannel: "Sie können nicht mehr als einen Holiday+ Kanal erstellen",
            holidayPlusDetail: "Urlaub+ Detail",
            manageHolidayPlusIntegration: "Verwalten Sie Ihre Holiday+ Integration",
            ideasoftChannels: "Ideasoft-Kanäle",
            connectToIdeasoft: "Mit Ideasoft verbinden",
            connectToIdeasoftApi: "Mit der Ideasoft-Api verbinden",
            updateChannelDesc2: "Whatsapp Business api Kanal aktualisieren",
            ideasoftIntegration: "Ideasoft-Integration",
            sureDeleteIdeasoftChannel: "Sind Sie sicher, dass Sie den Ideasoft-Kanal löschen wollen?",
            moreThanOneChannelError: "Sie können nicht mehr als einen Ideasoft-Kanal erstellen",
            websiteAddress: "Website-Adresse",
            ideasoftConnectedSucs: "Ideasoft wurde erfolgreich verbunden",
            failedToConnectIdeasoft: "Es konnte keine Verbindung zu Ideasoft hergestellt werden",
            redirectURLcopiedToClipboard: "Umleitungs-URL in die Zwischenablage kopiert",
            openAIChannels: "ÖffneAI-Kanäle",
            newOpenAiChannel: "Neuer OpenAI-Kanal",
            createNewChannelOpenAi: "Erstelle einen neuen Kanal für OpenAI",
            updateChannelDesc3: "Whatsapp business api Kanal aktualisieren",
            openAiIntegration: "OpenAI-Integration",
            sureDeleteOpenAiChannel: "Sind Sie sicher, dass Sie den OpenAI-Kanal löschen wollen?",
            createMoreThenOneOpenAiChannel: "Sie können nicht mehr als einen OpenAI-Kanal erstellen",
            postaCellChannels: "PostaCell-Kanäle",
            newPostaCellChannel: "Neue PostaCell-Kanäle",
            createNewPostaCellChannel: "Neuen Kanal für PostaCell SMS-Anbieter erstellen",
            updateChannelDesc4: "Whatsapp Business API Kanal aktualisieren",
            leads: "Führt",
            ensureFacebookAccount: "Stellen Sie sicher, dass Sie ein Facebook-Konto und eine Facebook-Seite haben",
            ensureAdAccount: "Stellen Sie sicher, dass es ein Werbekonto gibt",
            page: "Seite",
            leadCount: "Anzahl der Leads",
            showLeads: "Leads anzeigen",
            syncLeeds: "Leeds synchronisieren",
            wpStartChat: "Whatsapp-Chat-Startprogramm",
            archivedIn: "Archiviert?",
            makeSelect: "Auswahl treffen",
            newLead: "Neue Leed",
            initalContact: "Erster Kontakt",
            needsAssessnment: "Bedürfnisanalyse",
            proposalSent: "Angebot gesendet",
            proposalReview: "Vorschlagsüberprüfung",
            negotiation: "Verhandlung",
            decisionStage: "Entscheidungsphase",
            closure: "Kanapnış",
            followUp: "Folgen",
            campagin: "Kampagne",
            adSet: "Anzeigensatz",
            ad: "Anzeige",
            inArchived: "Archiviert",
            deletedSelectedPerson: "Ausgewählte Personen löschen",
            sureDelSelectedPerson: "Sind Sie sicher, dass Sie die ausgewählten Personen löschen möchten?",
            deletePerson: "Person löschen",
            sureDeletePerson: "Sind Sie sicher, dass Sie die Person löschen wollen?",
            phoneNumberNotAvailable: "Rufnummer nicht verfügbar",
            statusSucsUpdated: "Status erfolgreich aktualisiert",
            statusUpdatedFailed: "Beim Aktualisieren des Status ist ein Fehler aufgetreten",
            archivedContact: "Kontakt archivieren",
            sureWantArchivePerson: "Sind Sie sicher, dass Sie diese Person archivieren wollen?",
            personArchived: "Person archiviert",
            personArchivedHead: "Archivierungsvorgang fehlgeschlagen",
            metaLeadChannels: "Meta-Lead-Kanäle",
            wpStartSpeech: "Whatsapp-Sprachstarter",
            pleaseSelectStartChat: "Bitte wählen Sie den Kanal, auf dem Sie den Chat starten möchten:",
            phoneNumber: "Telefonnummer",
            phoneNumberDesc: "Landesvorwahl mit nur Zahlen ohne Leerzeichen",
            channelDesc: "Auf welchem Kanal möchten Sie den Chat beginnen",
            pleaseSelectStartChatOn: "Bitte wählen Sie den Kanal, auf dem Sie den Chat beginnen möchten",
            notAuthorisedChannel: "Sie sind nicht berechtigt, auf diesen Kanal zuzugreifen",
            phoneNumberError: "Telefonnummer nicht korrekt",
            chatStartError: "Es ist ein Fehler beim Starten des Chats aufgetreten. Bitte versuchen Sie es erneut.",
            noRecordFailed: "Kein Datensatz gefunden",
            metaLeadsChannel: "Meta Leads Kanal",
            mlChannelDetails: "Meta Leads Kanal Details",
            manageMlChannel: "Verwalten Sie Ihre Meta Leads",
            deleteMetaLeadsChannelInfo: "Sind Sie sicher, dass Sie den Meta Leads-Kanal löschen möchten?",
            contactPage: "Kontaktseite",
            addRouted: "Geführt hinzufügen",
            otherEmailProviders: "Andere E-Mail-Anbieter",
            visitorScreenNaming: "Benennung des Besucherbildschirms",
            enterCatalogTitle: "Katalogtitel eingeben...",
            passwordUpdate: "Kennwort aktualisieren",
            showCenterScreen: "Anzeige in der Mitte des Bildschirms",
            skipNow: "Jetzt überspringen",
            confirm: "Bestätigen Sie",
            newTable: "Neue Tabelle",
            actions: "Transaktionen",
            integrationsTrendyol:
                "Verbinden Sie Ihren Trendyol-Shop und beantworten Sie automatisch die Anfragen Ihrer Kunden.",
            integrationsHoliday: "Integrieren Sie Holiday+, um Hotels und Zimmer über den Chatbot bereitzustellen!",
            integrationsTeamgram:
                "Übertragen Sie Ihre Kunden von Supsis zu Teamgram, um Ihr Kundenmanagement zu optimieren!",
            integrationsTicimax: "Senden Sie eine automatische Nachricht an segmentierte Ticimax-Mitglieder.",
            integrationsBitrix24:
                "Aktivieren Sie die Bitrix24-API für ein verbessertes Chatbot-Erlebnis für Ihre Kunden.",
            integrationsIdeasoft:
                "Aktivieren Sie die Ideasoft-API für ein verbessertes Chatbot-Erlebnis für Ihre Kunden.",
            integrationsOpenAI:
                "OpenAI-Dienste aktivieren, Chatbot-AI-Antwort, KI-Assistent CoPilot, Chatbot-AI-Wissensdatenbank.",
            integrationsSMSPostacell: "Aktivieren Sie das Senden von SMS über den PostaCELL SMS-Anbieter.",
            integrationsMetaLeads:
                "Verwalten Sie Ihre Meta-Leads über Supsis. Verbinden Sie Leads mit Tickets, Chatbot oder Live-Support.",
            integrationsZoho: "Integrieren Sie Ihre Geschäftsprozesse in Zoho CRM mit Supsis.",

            forward: "weiter",
            packUpRequired: "Paket-Upgrade erforderlich",
            upgradePack: "Upgrade-Paket",
            supsisMobilApp: "SUPSIS MOBIL APP",
            supsisMobilAppDesc: "IOS und Android App auf dem Markt!",
            sendEmail: "E-Mail senden",
            jumpToMessage: "Klicken Sie hier, um zur Nachricht zu springen",
            doesntMatter: "Spielt keine Rolle",
            events: "Kalender Ereignisse",
            reservations: "Buchungen",
            designer: "Designer",
            targetContacts: "Zielkontakte",
            scheduler: "Planer",
            planAndTask: "Plan & Aufgaben",
            insights: "Einblicke",
            createRole: "Rolle erstellen",
            createSubject: "Thema erstellen",
            createUser: "Benutzer erstellen",
            blockManuel: "Block Manuel",
            showHide: "anzeigen/ausblenden",
            contactSearch: "Kontakt Suche",
            favorites: "Favoriten",
            downloadAllData: "alle Daten herunterladen",
            downloadThePage: "Download der Seite",
            choosePoints: "Punkte auswählen",
            channel: "Kanal",
            createdAt: "Erstellt am",
            action: "Aktion",
            searchChannel: "Kanäle suchen",
            activeChannels: "Aktive Kanäle",
            deleteChannels: "Gelöschte Kanäle",
            selectChannel: "Kanal auswählen",
            channelFilter: "Kanalfilter",
            noConversationDesc: "Hier können Sie aktive Chats und Ihnen zugewiesene Chats sehen.",
            forMe: "Für mich",
            unAssigned: "Nicht zugewiesen",
            agentDetails: "Agentendetails",
            contactProperties: "Kontaktinformationen",
            goToProfile: "Zum Profil gehen",
            addNote: "Notiz hinzufügen",
            noPreferredAgent: "Noch kein bevorzugter Agent",
            toPrefer: "Bevorzugen",
            inChat: "Im Chat",
            watching: "Schaut zu",
            chatsTitle: "Chats",
            dealyTimeMaxValueError: "Die Verzögerungszeit kann maximal 15 betragen",
            dealyTimeTypeError: "Verzögerungszeitwert muss eine Zahl sein",
            passedTimeHm: "{hour} Stunden {min} Minuten",
            passedTimeMs: "{min} Minuten {sec} Sekunden",
            passedTimeSc: "{sec} Sekunden",
            translateMessage: "Ihre Nachricht wurde durch künstliche Intelligenz übersetzt.",
            toneChanged: "Nachrichtenton auf {tone} geändert",
            aiResponseAdded: "KI-Antwort zur Nachricht hinzugefügt",
            messageLonger: "Nachricht verlängert",
            grammarFixed: "Grammatik korrigiert",
            aiTranslate: "Übersetzung",
            other: "Andere",
            yourLanguage: "Ihre Sprache",
            contactLanguage: "Kundensprache",
            myLanguage: "Meine Sprache",
            forwardToChatbot: "An Chatbot Weiterleiten",
            friendly: "Freundlich",
            confident: "Selbstbewusst",
            straightForward: "Geradlinig",
            casual: "Lässig",
            professional: "Professionell",
            longSentence: "Langer Satz",
            changeTone: "Ton Ändern",
            fixGrammar: "Grammatik Korrigieren",
            aiResponse: "KI-Antwort",
            templateButtonNote:
                "Um den Kontakt zu sperren, verwenden Sie bitte die folgenden Texte auf der Sperrtaste. Unabhängig von Groß- oder Kleinbuchstaben",
            templateButtonTags: "#Nachricht senden# | #Abbestellen# | #Sperren# | #Blockieren# ",
            dashboard: "Dashboard",
            adminReports: "Admin Reports",
            calendarModule: "Kalendermodul",
            taskModule: "Aufgabenverwaltungsmodul",
            maxUrlButtonMessage: "You can add a maximum of 2 URL buttons.",
            noPreferredDepartment: "Keine bevorzugte Abteilung vorhanden",
            searchForDepartment: "Nach Abteilung suchen",
            departmentAssignedToTheVisitor: "Wählen Sie die Abteilung aus, die Sie dem Besucher zuweisen möchten.",
            assignPreferredDepartment: "Bevorzugte Abteilung zuweisen",
            smsChannel: "SMS-Kanal: ",
            whatsappv2Channel: "Whatsapp V2-Kanal: ",
            whatsappv1Channel: "Whatsapp V1-Kanal: ",
            wBChannel: "Whatsapp Business-Kanal: ",
            messengerChannel: "Messenger-Kanal: ",
            instagramChannel: "Instagram-Kanal: ",
            allPlatforms: "Alle Plattformen",
            cbStartMessage: "Chatbot-Startnachricht",
            cbStartMessageDesc:
                "Die erste vom Benutzer eingegebene Nachricht wird automatisch vom Chatbot verarbeitet und an die entsprechende Adresse weitergeleitet.",
            messengerUserProfile: "Messenger Benutzerprofil",
            instagramUserProfile: "Instagram Benutzerprofil",
            noEventFound: "Kein Ereignis gefunden",
            visitorMails: "Besucher-E-Mails",
            visitorActions: "Besucheraktionen",
            notVerified: "Nicht überprüft",
            visitorEvents: "Besucherereignisse",
            assignedTasks: "Zugewiesene Aufgaben",
            mails: "Mails",
            prefferedAgents: "Bevorzugte Agenten",
            createEvent: "Ereignis erstellen",
            blockManagement: "Blockmanagement",
            deleteUser: "Benutzer löschen",
            blocked: "Blockiert",
            profiles: "Profile",
            similiarProfiles: "Ähnliche Profile gefunden",
            ReplyAsAPm: "Als Privatnachricht antworten und schließen",
            replyAsAComment: "Als Kommentar antworten und schließen",
            messengerAddDesc:
                "Klicken Sie unten auf die Schaltfläche Verbinden und melden Sie sich bei Ihrem Facebook-Konto an.",
            instaAddPrivacyCheckDesc: "Ich habe die {Privacy} und {Terms and Conditions} gelesen und stimme ihnen zu",
            instaAddDesc5:
                "Klicken Sie unten auf die Schaltfläche Verbinden und melden Sie sich bei Ihrem Facebook-Konto an.",
            instaAddDesc4: "Registrieren Sie sich als Facebook-Entwickler",
            instaAddDesc3:
                "Stellen Sie sicher, dass der <b>'Zugriff auf Nachrichten erlauben'</b>-Schalter aktiviert ist",
            instaAddDesc2: "Stellen Sie sicher, dass Ihr Instagram-Profikonto mit Ihrer Facebook-Seite verbunden ist",
            instaAddDesc1:
                "Stellen Sie sicher, dass Ihr Instagram-Konto ein professionelles Instagram-Konto (Geschäftskonto) ist.",
            selectedDepartment: "Ausgewählte Abteilung",
            departmentForwardEnable: "Abteilungsweiterleitung aktiviert",
            departmentForwardRule: "Abteilungsweiterleitungsregel",
            departmentForwardDesc:
                "Wählen Sie aus, an welche Abteilung eingehende Chats im Kanal weitergeleitet werden sollen.",
            channelName: "Kanalname",
            forwardToLiveAgents: "👉 An Live-Agenten weiterleiten",
            manageIgChannel: "Verwalten Sie Ihren Instagram-Kanal",
            igDetail: "Instagram-Detail",
            manageVisibilityDesc: "Verwalten, wer diesen Kanal sehen kann",
            selectAnIgAccount: "Wählen Sie ein Instagram-Konto aus",
            connectToInsta: "Mit Instagram verbinden",
            connectToMetaLeads: "Connect to Meta Leads",
            deleteInstaChannelInfo: "Möchten Sie den Instagram-Kanal wirklich löschen?",
            instagramChannels: "Instagram-Kanäle",
            suspendedDescription: "Ihr Konto wurde aufgrund unbezahlter Rechnungen gesperrt",
            onlyChatbot: "Nur Chatbot",
            onlyAgents: "Nur Agenten",
            checkboxWarning: "Dieses Feld muss angekreuzt werden",
            sendingAllow: "Senden",
            receiving: "Empfang",
            platform: "Plattform",
            banModalTitle: "Besucher-Sperrbildschirm",
            selectDepartmentDesc: "Wählen Sie die Abteilungen aus, für die Sie die Sichtbarkeit ändern möchten",
            selectAgentDesc: "Wählen Sie die Agenten aus, für die Sie die Sichtbarkeit ändern möchten",
            selectDepartment: "Abteilung auswählen",
            selectAgent: "Agent auswählen",
            visibleDepartments: "Sichtbare Abteilungen",
            visibleAgents: "Sichtbare Agenten",
            visibilityInfoCont: "Alle Agenten und Abteilungen können diesen Kanal sehen",
            editDepartmentVisibility: "Abteilungssichtbarkeit bearbeiten",
            editAgentVisibility: "Agentensichtbarkeit bearbeiten",
            typeSTToSearch: "Geben Sie etwas ein, um nach Benutzern zu suchen",
            exportToCSV: "Als CSV exportieren",
            clear: "Löschen",
            usedSessionCount: "Verwendete Sitzungsanzahl",
            maxSessionCount: "Maximale Sitzungsanzahl",
            leftSessionCount: "Verbleibende Sitzungsanzahl",
            planManagement: "Planverwaltung",
            maxAutomationTask: "Maximale Automatisierungsaufgaben",
            teamChat: "Team-Chat",
            templateNameIsNotValid: "Vorlagenname ist ungültig",
            relatedAdvertisement: "Entsprechende Werbung",
            whatsappNumber: "WhatsApp-Nummer",
            integrationsWhatsappV1:
                "Für reibungslose Kommunikation zwischen Supsis und WhatsApp ist ein WhatsApp-Plan erforderlich.",
            integrationsWhatsappV2: "Sie können Chat-Informationen leicht zwischen Supsis und WhatsApp übertragen.",
            integrationsWhatsappBusiness:
                "Sie können Chat-Informationen schnell und bequem zwischen Supsis und WhatsApp übermitteln.",
            selectDays: "Tage auswählen",
            addTime: "Zeit hinzufügen",
            instagramContactList: "Instagram Kontaktliste",
            archiveAllRated: "Alle Konversationen mit Bewertungen abrufen.",
            allChannels: "alle Kanäle",
            comment: "Kommentar",
            news: "Was gibt es Neues?",
            conversation: "Teamgespräch",
            speechTermination: "Gespräch beenden",
            noSystemMessage: "Es sind noch keine Nachrichten im System!",
            supsisCustomerService: "Kundenservice von Supsis,",
            supsisClickExperience: "Sie können das Erlebnis ausprobieren, indem Sie darauf klicken.",
            customerPage: "Gehen Sie zur Kundenseite",
            buttonTitle: "Schaltflächentitel",
            buttonType: "Schaltflächentyp",
            buttonSendMessage: "Nachricht senden",
            buttonGoToBlock: "gehe zum Blog",
            buttonOpenUrl: "Öffne URL",
            buttonPhoneCall: "Anruf",
            buttonOpenMoment: "Offener Augenblick",
            buttonCloseChat: "Chat schließen",
            buttonTransferChat: "Chat übertragen",
            buttonCreateTicket: "Ticket erstellen",
            deleteVisitor:
                "Möchten Sie den Benutzer wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
            userProfile: "Profil",
            addCalendarEvent: "Veranstaltung +",
            you: "Du",
            and: "und",
            dndBlocked: "Dateisendeneinstellungen sind geschlossen.",
            tokenCopied: "Der Zugang wurde an Token kopiert.",
            apiIntegration: "Entwickler",
            generateToken: "Produktion von Token",
            copyToken: "Token -Kopie",
            labels: "Etiketten",
            noData: "Kein Inhalt",
            color: "Farbe",
            titleColor: "Titelfarbe",
            secondTitleColor: "Farbe des zweiten Titels",
            tag_name_indicator: "Verlinke den Namen",
            sendMessage: "Nachricht senden",
            removeFromG: "Aus der Gruppe entfernen",
            delChannel: "Möchten Sie diesen Kanal wirklich löschen?",
            new_name: "Neuer Name",
            set_group_info: "Gruppeninformationen bearbeiten",
            shortcut_desc_num: "Wechseln Sie zwischen aktiven Gesprächen mit numerischen Ziffern",
            copilot_desc_num: "Ermöglicht Ihnen, Copilot auf dem Chat-Bildschirm zu öffnen",
            typing_w_chat: "schreibt...",
            edit_group_info: "Gruppeninformationen bearbeiten",
            notif_sound: "Benachrichtigungstöne aktivieren",
            notif_mute: "Benachrichtigungen stummschalten",
            leave: "Verlassen",
            group: "Gruppe",
            updateTag: "Tag aktualisieren",
            ordered_desc: "Weist Chats in der Reihenfolge den Mitarbeitern zu.",
            random_desc: "Weist Chats zufällig den Mitarbeitern zu.",
            Rrobin_desc:
                "Weist Chats den Mitarbeitern im Round-Robin-Verfahren zu. (Bevorzugt die am wenigsten beschäftigten Mitarbeiter)",
            RrobinRev_desc:
                "Weist Chats den Mitarbeitern im umgekehrten Round-Robin-Verfahren zu. (Bevorzugt die am meisten beschäftigten Mitarbeiter)",
            algo_desc: "Wählen Sie den Algorithmus für die automatische Chat-Zuweisung aus",
            algorithm: "Algorithmus",
            os_browser: "Betriebssystem und Browser",
            CHAT: "Plaudern",
            addTag: "Etikett hinzufügen",
            tags: "Etiketten",
            searchRepresentative: "Vertreter suchen",
            preferredRepresentative: "Vertreter",
            voting: "Abstimmung",
            chatWidget: "SUPSIS -Chat -Ballon",
            webhooks: "Webhaken",
            selectHooks: "Wählen Sie Webhaken",
            planRequired: "{integratable} Plan ist erforderlich.",
            allIntegrations: "Alle Integrationen",
            disableAgentSystemMessages: "Repräsentative Systemnachrichten verbergen",
            disableAgentSystemMessagesDesc: "Agentensystemnachrichten ausblenden.",
            disableAutoTranslate: "Automatische Übersetzung",
            disableAutoTranslateDesc:
                "Übersetzt automatisch Nachrichten aus verschiedenen Sprachen. So können Sie einfacher mit Ihren Kunden kommunizieren.",
            shouldAddMethod: "Sie müssen das Feld Zahlungsmethode und Rechnungsadresse ausfüllen!",
            approveSelection: "Bestätigen Sie Ihre Wahl",
            trialDaysEndSelectPlan: "Bestätigen Sie die Planauswahl",
            trialDaysEndSelectPlanDesc:
                "Ihre Testversion ist vorbei. Sie müssen bestätigen, indem Sie den folgenden Plan auswählen.",
            infinitePlay: "Spielen Sie die ganze Zeit",
            hideBubbleOnMobile: "Verstecken Sie sich auf dem Handy",
            deleteSystemLanguage: "{code} Aus dem System löscht die Sprache",
            assignedChat: "Zugewiesener Chat",
            check: "Bestätigungsbox",
            systemStatus: "Systemstatus",
            chatAssignedToUser: "Neues Chat wurde ernannt",
            inactiveThresholdTime: "Passive Chat -Zeit (Minuten)",
            tippyInactiveThresholdTime:
                "Wenn innerhalb der in der Rede angegebenen Zeit keine Nachricht gesendet wird, wird die Rede als passiv angesehen. Geben Sie den Wert ein (Minuten). Mindestens 1 Minuten sollten höchstens 120 Minuten betragen.",
            inactiveTerminateTime: "Passive Chat Schließzeit (Minuten)",
            tippyInactiveTerminateTime:
                "Das Gespräch wird nach der angegebenen Zeit geschlossen. Geben Sie den Wert ein (Minuten). Es sollte mindestens 0 in den meisten 120 Minuten sein.",
            removePendingMessage: "Stornierung",
            disconnected: "Nicht verbunden",
            visitorWriteEmptyChatTippy: "Der Kunde kann schreiben, bevor der Vertreter mit dem Sprechen verbunden ist.",
            visitorWriteEmptyChat: "Der Kunde kann schreiben, ohne den Vertreter zu verbinden.",
            visitorConnectionEventSystemMessageEnabled:
                "Der Verbindungsstatus des Besuchers aktiviert Systemmeldungen.",
            visitorConnectionEventSystemMessageEnabledTippy:
                "Der Besucher links und der Besucher kam zurück und zeigte die Systemmeldungen.",
            openBubble: "Sprechen Ballloom offen",
            showHeaderImage: "Kopfbild anzeigen",
            changeLogo: "Ändern Sie das Logo",
            changePhoto: "Foto ändern",
            addPhoto: "Ein Foto hinzufügen",
            seePhoto: "Siehe das Foto",
            deletePhoto: "Das Foto löschen",
            askQuestion: "Frage stellen",
            locationPermsNeeded: "Die Standortgenehmigung für die Verwendung dieser Funktion erforderlich",
            useMyLocation: "Verwenden Sie meinen Standort",
            acceptingChat: "Der Chat -Kauf ist geöffnet",
            notAcceptingChat: "Chat -Einnahme geschlossen",
            websiteChatWidgetIntegration: "Website -Chat -Ballonintegration",
            loggedOut: "Offline",
            listStatuses: "Situationen",
            hideInactiveAgents: "Passive Vertreter verbergen",
            hideMinorValues: "Kleine Werte verbergen",
            agentActivities: "Repräsentative Aktivitäten",
            newHASHContent: "#Thete hinzufügen",
            hash: "Fahrkarte",
            languageRemovalQuestion: "Sie sind kurz davor, die {code} Sprache aus dem System zu löschen!",
            blockBy: "Vertreter",
            hashText: "Fahrkarte",
            exampleHash: "Bestellentakip",
            notValidHash: "Sollte keinen Lückencharakter enthalten",
            videoCallEnabledDesc: "Aktivieren Sie, um die Video -Suchfunktion zu aktivieren",
            videoCallEnabled: "Video -Suchfunktion",
            audioCallDesc: "Aktivieren Sie, um die Sprachsuchfunktion zu aktivieren",
            audioCallEnabled: "Sprachsuchfunktion",
            assignPreferredAgent: "Bevorzugter Vertreter",
            representativeAssignedToTheVisitor:
                "Wählen Sie den bevorzugten Agenten aus, den Sie dem Besucher zuweisen möchten.",
            agentFileSendEnabledDesc: "Aktiviert die Dateiversenden der Vertreterfunktionen",
            agentFileSendEnabled: "Vertreter können Dateien senden",
            visitorFileSendEnabledDesc:
                "Mit den Besuchern können Sie die Funktion zum Senden von Dateien öffnen und ausschalten",
            visitorFileSendEnabled: "Besucher können Dateien senden",
            visitorAutoLogin: "Besucher automatisch Anmeldung",
            visitorAutoLoginDesc: "Besucherballonklicks klicken, sobald Sie auf die Konversation klicken",
            agentVoiceRecordEnabledDesc: "Ermöglicht die Soundaufzeichnungsfunktion der Vertreter",
            agentVoiceRecordEnabled: "Vertreter können Ton aufnehmen",
            visitorVoiceRecordEnabledDesc: "Ermöglicht die Soundaufzeichnungsfunktion der Besucher",
            visitorVoiceRecordEnabled: "Besucher können Sound aufnehmen",
            startVideoCall: "Videoanruf",
            startAudioCall: "Gesangsanruf",
            visitorGDPRDeleteEnabledDesc: "Mit den Besuchern können Sie alle Informationen öffnen und ausschalten",
            visitorGDPRDeleteEnabled: "Besucher können alle Informationen löschen",
            visitorLocationEnabled: "Besucher können den Standort teilen",
            visitorLocationEnabledDesc:
                "Ermöglicht den Besuchern, die Freigabe der Standort zu öffnen oder zu schließen",
            customerLocationEnabled: "Vertreter können den Standort teilen",
            customerAutoMergeEnabled: "Verschmilzt automatisch die gleichen Personen",
            customerAutoMergeEnabledDesc:
                "Diese Funktion führt eine automatische Zusammenführung durch, um Daten effektiv von denselben Personen zu sammeln. Dadurch werden Benutzer mit ähnlichen Profilen in Datenbeständen konsistenter und geordneter repräsentiert.",
            chatAiCopilot: "Chat KI Copilot",
            chatAiCopilotDesc: "Beantworten Sie automatisch die Fragen Ihrer Kunden mit dem Chat KI Copilot",
            customerLocationEnabledDesc: "Ermöglicht den Vertretern, die Standortfreigabe zu öffnen oder zu schließen",
            thoesNotOwners: "Nicht-Besitzer in der Warteschlange halten",
            thoesNotOwnersDesc:
                "Sie aktivieren diese Funktion, um Personen, die nicht Eigentümer der Unterhaltung sind, in der Warteschlange zu halten.",
            hideContactInfo: "Kontaktinformationen ausblenden",
            hideContactInfoDesc:
                "Wenn Sie diese Funktion aktivieren, werden die Nummern und E-Mails Ihrer Kunden vor Agenten verborgen.",
            triggerAlreadyExists: "Es gibt bereits einen Auslöser für diesen Zustand.",
            ticketStatusForm: "Ticketstatusformular",
            statusFormTitle: "Ticketstatentitel",
            allStatus: "Alle Situationen",
            triggers: "Löst aus",
            trigger: "Abzug",
            noTrigger: "Sie haben noch keinen Auslöser hinzugefügt",
            triggerSkipLoginForm: "Anmeldeformular",
            triggerSkipLoginFormTrue: "Anmeldeformular anzeigen",
            triggerSkipLoginFormFalse: "Anmeldeformular überspringen und direkt zur Nachricht wechseln",
            noContent: "Kein Inhalt",
            toCreate: "Erschaffen",
            clickTheButton: "Drück den Knopf",
            triggerContent:
                "Schreiben Sie die Beschreibung, die Sie im Fenster sehen möchten, das sich öffnet. Schreiben Sie einfach in einer Sprache aus, um automatisch in andere Sprachen zu übersetzen.",
            triggerDrag: "Sie können die Nachrichtenzeit durch Ziehen oder Klicken auf die Leiste festlegen.",
            triggerNewCondition: "Sie können einen neuen Zustand mit Taste hinzufügen.",
            triggerNoConditionDescription1:
                "Sie können die gewünschten Bedingungen aus den Optionen erstellen. Wenn Sie keine Bedingungen für einen Auslöser erstellen, ist der Abzug in erster Linie aktiv.",
            triggerNoConditionDescription2:
                "Auf der Besucherseite ist nur einer der Auslöser mit den gleichen Bedingungen aktiv sichtbar.",
            triggerShowAndHide: "Sie können die Trigger zeigen oder verbergen, wenn Sie zeigen möchten.",
            countryLanguage: "Land/Sprache",
            addTrigger: "Trigger hinzufügen",
            yesPlease: "Ja bitte!",
            noThanks: "Nein danke.",
            firstAnswer: "Frage Dialog positive Antwort",
            secondAnswer: "Frage Dialog negative Antwort",
            noTitle: "Kein Titel",
            sumChat_MediaFile: "Medien und Dokumente",
            importantWarning: "WICHTIGE WARNUNG!",
            images: "Bilder",
            URLS: "Links",
            files: "Dateien",
            warning: "WARNUNG!",
            noCondition: "Nicht nötig! Sie können einen Zustand hinzufügen, indem Sie auf das Plus -Symbol klicken.",
            showTriggers: "Klicken Sie hier, um die Trigger anzuzeigen",
            showThisTrigger: "Klicken Sie hier, um diesen Auslöser anzuzeigen",
            hideTriggers: "Klicken Sie hier, um die Trigger auszublenden",
            hideThisTrigger: "Klicken Sie hier, um diesen Auslöser auszublenden",
            updateTrigger: "Aktualisieren Sie den Auslöser",
            conditions: "Bedingungen",
            messageDurationPerRow: "Nachrichtenzeit für jede Zeile",
            dayTime: "Stunde",
            weekDay: "Wochentag",
            spendTimePage: "Zeit auf der Seite verbracht",
            spendTimeSite: "Zeit auf der Website verbracht",
            pageUrl: "URL",
            pageTitle: "Seitentitel",
            equal: "Gleich",
            not_equal: "Nicht gleich",
            less_than: "Klein",
            greater_than: "Ist toll",
            less_than_or_equal: "Ist klein oder gleich",
            greater_than_or_equal: "Ist groß oder gleich",
            visitorName: "Besuchername",
            seconds10: "10 Sekunden",
            seconds30: "30 Sekunden",
            minute1: "1 Minute",
            minutes5: "5 Minuten",
            minutes10: "10 Minuten",
            minutes30: "30 Minuten",
            hour1: "1 Stunde",
            hours2: "2 Stunden",
            hours4: "4 Stunden",
            hours8: "8 Stunden",
            hours12: "12 Stunden",
            hours24: "24 Stunden",
            maxCondition: "Maximale Situation",
            doYouWishToDeleteTrigger: "Möchten Sie den Abzug löschen?",
            contains: "Enthält",
            not_contains: "Beteiligt",
            chatLanguage: "Sprechsprache",
            translating: "Übersetzung",
            liveSupportStartingWait: "Live -Unterstützung wird begonnen, bitte warten Sie",
            noConnection: "Keine Verbindung!",
            buyWhatsapp: "Kaufen Sie WhatsApp",
            integrations: "Integrationen",
            refundInvoiceSure: "Sind Sie sicher, dass Sie die Rechnung zurückgeben möchten?",
            invoiceMarkedAsPaidSuccess: "Die Rechnung wurde als bezahlt gekennzeichnet.",
            invoiceMarkedAsPaidError: "Der Fehler konnte nicht gekennzeichnet werden, da die Rechnung bezahlt wurde.",
            deleteConfirm: "Möchten Sie dieses {Objekt} wirklich löschen?",
            markPaidConfirm: "Sind Sie sicher, dass Sie diese Rechnung als bezahlt markieren möchten?",
            startChatDesc: "Sprache starten",
            addLink: "Verbindung",
            selectStep: "Wählen Sie einen Schritt aus:",
            addGOTO: "Gehen",
            sendFastLink: "Senden Sie den Anmeldelink ohne Passwort",
            or: "Oder",
            allTags: "Alle Tags",
            showDetail: "Detail anzeigen",
            hideDetail: "Detail ausblenden",
            weLlSendPhone: "Senden wir es an Ihr Telefon",
            weLlSendEmail: "Senden wir eine E-Mail",
            linkSentToPhone: "Der Link wurde als SMS gesendet",
            offerlinkSendToPhone: "Senden wir den Download -Link unserer Bewerbung mit SMS an Sie.",
            offerlinkSendToMail: "Senden wir den Download -Link unserer Bewerbung per Post an Sie.",
            theEmail: "Registrierte Email",
            differentEmail: "Andere E-Mails",
            linkSentToMailBox: "Link an Ihre Mail -Adresse gesendet",
            errorOccurred: "Ein Fehler ist aufgetreten !",
            clickStoreIcon:
                "Sie können die mobile Anwendung erreichen, indem Sie auf das Symbol klicken, das zu Ihrem Telefon passt",
            meetWithSupsis: "Möchten Sie unsere mobile SUPSIS -Anwendung treffen?",
            downloadMobileApps: "Laden Sie die mobile Anwendung herunter",
            getApps: "Bewerbungen erhalten",
            info: "Information",
            conversationHistory: "Sprachgeschichte",
            planInfoHeader: "Informationen planen",
            planInformation:
                "Ihr Plan {selectedPlan} Plan ({detailMaxagentCount} Repräsentant) ({freeAgent} Free Agent)",
            creditAvailable: "Ihr repräsentatives Darlehen in Ihrem Plan:",
            upDownGradePlan: "Wenn Sie Ihren Plan erhöhen/reduzieren möchten, bitte",
            click: "KLICKEN",
            all: "Alle",
            allDepartments: "Alle Abteilungen",
            preferredLanguage: "Bevorzugte Sprache",
            kmkAutoDepartmentBind: "KMK Automatische Abteilungsfindung",
            kmkAutoDepartmentBindDesc:
                "KMK findet den automatischen Speichernamen auf Kundenseiten und setzt ihn auf das Anmeldformular",
            visitorEmailUpdated: "Besucher -E -Mail -Adresse aktualisiert",
            visitorEmailIsNotValid: "Sie haben die E -Mail -Adresse eingegeben, ist nicht korrekt",
            visitorNameUpdated: "Name des Besuchers aktualisiert",
            clickToEdit: "Zum Bearbeiten anklicken",
            addEmail: "+ Fügen Sie die E -Mail -Adresse hinzu",
            addFullname: "+ Name hinzufügen",
            partner: "Ref?",
            isIntegrated: "Integration?",
            agentCount: "Anzahl der Vertreter",
            autoStartChat: "Automatischer Chat -Start",
            bubbleColor: "Chat -Ballonfarbe",
            openFolder: "Hungrig",
            preDefined: "Themen",
            customIcon: "Installieren Sie es von Ihrem Computer aus",
            theme: "Thema",
            themeSettings: "Themen Einstellungen",
            chatThemeSettings: "Chat Designeinstellungen",
            bubbleSettings: "Chat -Balloneinstellungen",
            inputHeightOfBubble: "Ballongröße",
            inputPixelsOfChatBubble:
                "Klicken Sie hier, um die Entfernung des Chat -Ballons an den Rändern zu regulieren",
            modalTitleIsMarginAsPixelInfo: "Die Entfernung des Chat -Ballons zu den Rändern:",
            inputPxOfXaxis: "Horizontale Lage",
            inputPxOfYaxis: "Vertikale Lage",
            inputPxOfMobileXaxis: "(Mobiler) horizontaler Standort",
            inputPxOfMobileYaxis: "(Mobiler) vertikaler Standort",
            animations: "Animationen",
            preferredAnimation: "Bevorzugte Animation",
            selectAnAnimation: "Wählen Sie eine Animation",
            inputOfBubbleMessage: "Fügen Sie Inhalte zu riesigen Chat-Blasen hinzu.\n{contentOfChatBubble} ",
            showChatBubbleOnlyLoggedUserToolTip:
                "Der Chat -Ballon ist die Versteck, abhängig vom Anmeldung der Protokollierung.",
            showChatBubbleOnlyLoggedUser: "Zeigen Sie den Ballon nur dem Benutzer, der sich angemeldet hat. (Ideenoft)",
            helloDoUNeedHelp: "Hallo, ich kann helfen!",
            bubbleIcon: "Chat -Ballonbild",
            overrideMargins: "Passen Sie die Kantenlücken an",
            autoHideBubble: "Verstecke deinen Chat -Ballon",
            vtippyAutoHideBubble: "Vertreter verstecken den Chat -Ballon, während sie online sind",
            hideBubble: "Отключить чат-пузырь",
            vtippyHideBubble: "Отключает пузырь чата.",
            overrideMobileMargin: "Passen Sie Mobile -Versionslücken an",
            vtippyMobileMargin: "Passen Sie den Chat -Ballon -Edge -Rand für mobile Version an",
            vtippyHideBubbleOnMobile: "Der Chat -Ballon ist in Besuchern mit Mobilgeräten versteckt.",
            isFabsActive: "Offene Menüs zeigen",
            isAlwaysActive: "Menü ist immer geöffnet",
            isAlwaysActiveDesc: "Möchten Sie, dass das Chatblasen-Menü in der Webansicht immer geöffnet bleibt?",
            bubbleOpenableMenu: "Der Chat -Ballon öffnet das Menü",
            vtippyIsFabsActive: "Es ist die Einstellung von Öffnungsmenüs / Verstecktätigkeiten",
            vtippyIsFabsAsIcon: "Es ist die Einstellung, ob die Symbole in den Pop -UP -Männern erscheinen.",
            vtippyTranslateButton: "Umwandle die ausgewählte Sprache in andere Sprachen.",
            vtippyTranslateClearButton: "Reinigt die Inhalte in anderen Sprachen.",
            vtippySelectnotification: "Sie können Benachrichtigungsklang auswählen.",
            vtippyVoiceLevel: "Sie können die Audioebene festlegen.",
            vtippyStartVoice: "Hören",
            vtippyInfiniteNotification:
                "Die neu angekommenen Chats werden weiter spielen, wenn Sie im Panel nicht aktiv sind. Sie können Active-Passive bearbeiten, indem Sie klicken.",
            vtippyNewVisitorNotification: "Sprachbenachrichtigungseinstellungen für Besucher Ihrer Website.",
            vtippyNewChatNotification:
                "Sprachbenachrichtigungseinstellungen für jeden neuen Chat, der zum System kommt.",
            vtippyNewConversationNotification:
                "Sprachbenachrichtigungseinstellungen für jeden neuen Chat, der Ihnen zugewiesen ist.",
            vtippyNewMessageNotification: "Nachrichtenbenachrichtigungseinstellungen aus den Ihnen zugewiesenen Chats.",
            vtippyPrivateMessageNotification: "Sprachbenachrichtigungseinstellungen für Nachrichten aus der Teamrede.",
            isFabsAsIcon: "Menüsymbole anzeigen.",
            setMarginAsPixel: "Pixel einstellen",
            returnDefaultMargins: "Standardkante Gap -Einstellungen",
            closePreviewColors: "Schließen Sie die Vorschau",
            previewColors: "Öffnen Sie die Vorschau",
            videoCalls: "Videointerviews",
            filterLost: "Entkommene Gespräche",
            vtipyCustomLogin:
                "Wenn Sie Ihre Besucher mit dem System anschließen, können Sie die Informationen hier im Eingabeformular anpassen.",
            vtipyLoginlessChat:
                "Das Anmeldeformular wird nicht angezeigt, wenn Sie Ihre Besucher mit dem System verbinden. Vertreter werden verwendet, indem sie nach den persönlichen Informationen der Besucher fragen.",
            loginlessChat: "Besucheranmeldeformular",
            imageUrl: "Bild",
            replied: "ANTWORTETE",
            solved: "Gelöst",
            openImage: "Hungrig",
            writeFeedback: "Hier können Sie Ihr Feedback zu Supsis schreiben.",
            feedbackFailed: "Während des Feedback -Senders gab es einen Fehler.",
            feedbackSuccessful: "Das Feedback -Senden ist erfolgreich.",
            sendFeedback: "Feedback abschicken",
            errorReport: "Sie können uns Feedback zu den Problemen geben, die Sie mit SUPSıs haben.",
            sendErrorFeedBack: "Geben Sie uns Feedback zu Ihrem Problem.",
            successImgUpload: "Ihr Bild ist erfolgreich Wolle",
            successImgDelete: "Bild wurde erfolgreich gelöscht.",
            errorImgUpload: "Beim Hochladen Ihres Bildes trat ein Fehler auf",
            errorImgDelete: "Beim Löschen des Bildes ist ein Fehler aufgetreten",
            chatBotEndStatics: "Chatbot Sprachabschlussrate",
            videoCallDist: "Videointerviewverteilung",
            deleteSite: "{sitename} kann gelöscht werden?",
            deleteThisSite: "Löschen Sie diese Seite",
            departmentInfo: "Abteilungsinformationen",
            infoAboutDepartment: "Kurze Informationen über die Abteilung",
            deleteDepartmentQuestion: "Möchten Sie diese Abteilung wirklich löschen?",
            departmentDeleted: "Die Abteilung wurde gelöscht",
            departmentTitle: "Abteilungstitel",
            updateDepartmentForm: "Abteilungs -Update -Formular",
            updateCompleted: "Update abgeschlossen",
            CatalogUpdatedSuccessfully: "Erfolgreich aktualisiert",
            integrateSupsiswithIntegratable: "Leicht die Chat Informationen zwischen SUPSIS und {integratable} leiten.",
            installationOK: "Geladen",
            newDepartmentForm: "Neue Abteilungsregistrierungsformular",
            newDepartment: "Neue Abteilung",
            departmentSaved: "Abteilung gespeichert",
            sameDepartment: "Es gibt eine Abteilung mit demselben Namen",
            sameValue: "Es gibt einen Wert mit demselben Namen!",
            sameTag: "Es gibt ein Tag mit diesem Namen!",
            departments: "Abteilungen",
            department: "Abteilung",
            announcements: "Ankündigungen",
            announcement: "Bekanntmachung",
            newAnnouncement: "Neue Ankündigung",
            announcementInfo: "Ankündigungsinformationen",
            infoAboutAnnouncement: "Kurze Informationen über die Ankündigung",
            deleteAnnouncementQuestion: "Möchten Sie diese Ankündigung wirklich löschen?",
            announcementDeleted: "Die Ankündigung wurde gelöscht",
            announcementTitle: "Ankündigungstitel",
            updateAnnouncementForm: "Ankündigungs -Update -Formular",
            newAnnouncementForm: "Neues Ankündigungsformular",
            announcementSaved: "Ankündigung aufgezeichnet.",
            chatTimingSettings: "Chat -Zeiteinstellungen",
            assetOversize: "Die Größe der Datei, die Sie senden möchten, sollte nicht größer als 10 MB sein.",
            assetOversizeMB: "Die Größe der Datei, die Sie senden möchten, sollte {mb} MB nicht überschreiten.",
            assetOversizeWithExt: "Die Dateigröße sollte kleiner als 10 MB und PNG, JPG -Format sein.",
            messageDeleted: "Diese Nachricht wurde gelöscht",
            filterVideoCall: "Zeigt Videogespräche",
            filterLostChat: "Lost Chats Filter",
            filterClosedByAgent: "Filter von repräsentativen Filtern geschlossen",
            notificationText: "Damit SUPSIS -Benachrichtigungen korrekt arbeiten können",
            notificationTitle: "Benachrichtigungen aus",
            deniedText:
                "Ihre Benachrichtigungen sind geschlossen, Sie müssen Ihre Benachrichtigungen öffnen, um Ihre Kunden nicht zu verpassen.",
            deniedTitle: "Klicken Sie hier, um Ihre Benachrichtigungen zu öffnen!",
            deniedHeader: "Um Ihre Kunden nicht zu verpassen, müssen Sie Ihre Benachrichtigungen aktivieren!",
            showNotificationGuide: "Für Einzelheiten anklicken",
            howToEnableNotification: "Wie kann ich Benachrichtigungen aktivieren?",
            notificationOK: "OK",
            notificationUnderstood: "Verstanden!",
            notificationCancel: "Stornieren",
            howToEnableNotificationInstruction1:
                "Klicken Sie in der Adressleiste des Browsers auf das Symbol für Sperre",
            howToEnableNotificationInstruction2:
                'Aktivieren Sie, wenn "Benachrichtigungen" im Abschnitt Genehmigungen passiv zu sein scheinen',
            howToEnableNotificationInstruction3:
                'Wenn "Benachrichtigungen" im Abschnitt Genehmigungen nicht angezeigt werden, klicken Sie auf "Site -Einstellungen".',
            howToEnableNotificationInstruction4:
                'Öffnen Sie die Berechtigung "Benachrichtigungen" aus dem Abschnitt "Genehmigungen" auf der Seite "Site -Einstellungen',
            checkPaymentMethod: "Bitte überprüfen Sie Ihre Zahlungsmethode",
            pushNotificationEnabled: "Großartige Benachrichtigungssendung ist aktiv.",
            pushNotificationDenied: "Sie haben die Benachrichtigungsgenehmigungen abgelehnt",
            suspendedMessage: "Ihr Konto wurde gesperrt",
            enableNotification: "Öffnen Sie Ihre Benachrichtigungen.",
            languageSettings: "Sprechsprache",
            problemsSound:
                'Wenn Sie Probleme mit den Benachrichtigungen haben, klicken Sie auf das Sperrsymbol der Adressleiste Ihres Browsers (im Bild angezeigt) und klicken Sie auf das Feld "Site -Einstellungen" und ändern Sie die "Audio" aus dem geöffneten Abschnitt.',
            betweenRepresentative: "Die neue Nachricht eines Vertreters.",
            desktopNotifications: "Benachrichtigungen",
            notificationDisable:
                "Sie können die Desktop -Benachrichtigungen aus den repräsentativen Einstellungen schließen.",
            notificationEnabled: "SUPSIS -Benachrichtigungen sind aktiv.",
            newMessageAlert: "Du hast eine neue Nachricht.",
            newConversationAlert: "Sie haben ein neues Gespräch.",
            chatBot: "Chatbot",
            ticketResponse: "Repressive Antwort:",
            archived: "Mit Archiven",
            chatbotChatCount: "Chatbot",
            closeChat: "Beende die Nachrichten",
            formStep: "Formschritt",
            menuStep: "Menüschritt",
            contentStep: "Inhaltsschritt",
            menuTitle: "Menükopf",
            messageContent: "Nachrichteninhalt",
            goToLive: "Übertragung zum Vertreter",
            prevStep: "Kehren Sie zu meinem vorherigen Schritt zurück",
            button: "Taste",
            addImage: "Bild",
            addText: "Text",
            stepTitle: "Schritt Titel",
            addTicket: "Tick",
            formDescription: "Frage",
            addInput: "Frage",
            addRandomText: "Zufälliger Text",
            changeTitle: "Ändern Sie den Titel",
            changeVisitorTitle: "Besuchertitel ändern",
            catalog: "Katalogentitel",
            openTheCatalog: "Öffnen Sie den Katalog",
            catalogNotOpen:
                "Die Katalogfunktion ist deaktiviert. Sie können die Catalok -Funktion öffnen, um Ihren Kunden vorbereitete Inhalte zu unterstützen.",
            showCatalogCategories: "Ändern Sie den Status des Erscheinens im Chat -Ballon des Katalogmenüs.",
            showChatBot: "Ändern Sie den Zustand des Erscheinens im Chat -Ballon des Chatbot -Menüs.",
            openCatalog: "Katalog",
            unreadMessages: "Ungelesene Beiträge",
            personalFirstMsg: "Repräsentant erster Reaktionszeitdurchschnitt (SN)",
            personalRating: "Personal Score ORT.",
            soundSettings: "Benachrichtigungseinstellungen",
            newPrivateMessage: "Private Nachricht",
            addNewGroup: "Eine neue Gruppe erstellen",
            newMessage: "Neue Nachricht",
            newConversation: "Neuer Chat",
            newVisitor: "Neuer Besucher",
            chatPosition: "Chat -Standort",
            bottomLeftCorner: "untere linke Ecke",
            leftDocked: "links angedockt",
            bottomRightCorner: "untere rechte Ecke",
            rightDocked: "rechts angedockt",
            chatPositionSelect: "Ort auswählen",
            teamChatGroup: "Gruppennachrichten",
            teamChatDepartment: "Nachrichten der Abteilung",
            teamChatTeam: "Team-Nachrichten",
            teamChatDm: "DM Nachrichten",
            bottomLeft: "Unten links",
            left: "Linkshändig",
            bottomRight: "Rechts unten",
            right: "Rechts -old",
            mailorname: "E-Mail oder Name",
            breaksByTime: "Schimmelpilzzahlen",
            clPlaceholder: "Der Name erscheint in Kundenform",
            fieldName: "Schlüsselname",
            value: "Wert",
            addSetting: "Fügen Sie eine neue Einstellung hinzu",
            globalSettings: "Allgemeine Einstellungen",
            target: "Lastprüfung",
            duration: "Lasttestzeit (SN)",
            arrivalCount: "Anzahl der Bots (Stück)",
            bootMaxLife: "Standzeit eines Bots (SN)",
            startLoadTest: "Starten Sie den Lasttest",
            noClusterInstanceFound: "Der Server nicht gefunden",
            stopLoadTest: "Beenden Sie den Lasttest",
            integrationDesc: "Fügen Sie einfach den folgenden Codes für einen Zeilen hinzu.",
            integrationDemoCode: "Beispielintegration Demo Code",
            integrationWindow: "Wie integriere ich meine Website?",
            notIntegrated: "Integration",
            help: "Hilfe",
            notIntegratedDesc:
                "Wir haben festgestellt, dass Sie das Chat -System nicht zu Ihrer Website hinzugefügt haben. Wenn Sie sich in Ihre Website integrieren und das erste Interview starten, haben Sie die Integration abgeschlossen. Klicken Sie auf den Integrationscode",
            backToLogin: "Nochmal anmelden",
            passwordlessLoginUnsuccessful: "Eintrag fehlgeschlagen.",
            passwordlessLogin: "Eindringung des Eintritts",
            loginWithEmail: "Melden Sie sich mit E -Mail an",
            loginWithPassword: "Melden Sie sich mit Passwort an",
            enteringPasswordless: "Der Eintrag erfolgt ohne Passwort ...",
            toMainPath: "Richtung zur Homepage",
            userRoleChanged:
                "Ihr Benutzergenehmigungen haben sich geändert. Sie werden auf die Hauptseite verwiesen, um fortzufahren.",
            passwordChangeSuccess: "Ihr Kennwortänderungsprozess ist erfolgreich ...",
            feedback: "Rückmeldung",
            showFeedbackHistory: "Feedback Senden Nachrichten anzeigen.",
            newSelfServiceSite: "Neue Self -Service -Site",
            subdomain: "Sub -Domain -Name",
            rootUserEmail: "Benutzer Email",
            rootUserName: "Ihren Namen",
            newVersion: "Neue Version verfügbar",
            closeLiveSupport: "Schließende Live -Unterstützung",
            newVersionShort: "Neue Version",
            bannedWordRestrict: "Verbotenes Wort Blockieren",
            ticketShow: "Erlauben Sie Kunden, Tickets zu erstellen",
            ticketShowDesc: "Aktivieren Sie die Option zur Ticketerstellung im Chat-Menü",
            autoLoadIframe: "Live -Verkehr",
            autoLoadIframeDesc: "Iframe lädt automatisch den gesamten Besucherverkehr",
            bannedWordRestrictDesc:
                "Wenn das verbotene Wortblockieren geöffnet ist, wird der Vertreter daran gehindert, den Besuchern verbotene Wörter zu schreiben.",
            agentDown: "Vertreter fiel",
            delayChat: "Verzögerte Konversation",
            tableSettingTippy: "Sie können die Informationen in der Tabelle von hier aus ändern.",
            tableSettings: "Tisch Einstellungen",
            tableSettingsInfo:
                "Sie können die Informationen in der Tabelle von hier aus ändern. Sie können bis zu 7 Spalten auswählen",
            privateParametry: "Benutzerdefinierte Benutzerparameter",
            systemOperetor: "System Information",
            cityAndDistrict: "Stadtteil",
            general: "Allgemein",
            availability: "Repräsentative Arbeitszeit",
            home: "Startseite",
            successful: "Erfolgreich",
            forgetPasswordSent: "Das Passwort Reset Mail wurde gesendet. Überprüfen Sie Ihre E-Mail.",
            saturday: "Samstag",
            friday: "Freitag",
            thursday: "Donnerstag",
            wednesday: "Mittwoch",
            tuesday: "Dienstag",
            monday: "Montag",
            sunday: "Sonntag",
            download: "Laden Sie die Datei herunter",
            calendarPassedTimeHour: "{hour} clock {name}",
            calendarPassedTime: "{hour} clock {min} min {name}",
            calendarPassedTimeMinSec: "{min} min {sec} sec {name}",
            calendarPassedTimeMin: "{value} dk {name}",
            calendarPassedTimeSec: "{hour} clock {min} min {sec} sn {name}",
            workScheduleOneDay: "{name} 'S {sDate} Day Work Calender",
            workSchedule: "{name} namens {sdate} - {edate}",
            noRating: "Es wurde keine Wertung erzielt",
            rateDist: "Bewertungsverteilung",
            distConversation: "Redeverteilung durch Vertreter",
            distributionConversa: "Punkteverteilung",
            distChatbotAgent: "Kommunikationskanäle",
            distAgent: "Chatbot & Agent",
            distFugitive: "Verpasste Rede und empfangene Rede",
            distLive: "Live-Chat",
            distChatbot: "Chatbot",
            distComplex: "Chatbot & Live-Chat",
            distHandled: "Chat beantwortet",
            distMissed: "unbeantworteter Chat",
            distWeb: "Webseite",
            distWhatsapp: "Whatsapp",
            distTelegram: "Telegram",
            distInstagram: "Instagram",
            totalWhatsappChatCount: "WhatsApp -Anzahl der Chats",
            statsByTime: "Anzahl der spricht rechtzeitig",
            selectRep: "Wählen Sie einen Vertreter",
            allRepresentatives: "Alle Vertreter",
            avgRating: "Punktverteilung ({punkt}) ({count} Evaluation)",
            avgFirstMessageTime: "Die durchschnittliche erste Zeit",
            totalBreakTime: "System Break -Zeit",
            totalBreakNum: "Anzahl der Molain",
            averageConTime: "Durchschnittliche Sprachzeit",
            multiWpReportTitle: "Mehrere WhatsApp-Konversationsnummern",
            multiWpReport: "Anzahl mehrerer WhatsApp-Chats",
            multiWpReportExplanation: "Sie können die Chat-Anzahl Ihrer Multi-WhatsApp-Kanäle sehen.",
            longestConTime: "Längste Gesprächszeit",
            shortestConTime: "Kürzeste Sprachzeit",
            refresh: "Aktualisierung",
            waitingReply: "Auf eine Antwort warten",
            organizationName: "Organisationsname",
            companySlogan: "Langer Name der Organisation",
            messageSentErr: "Keine Nachricht konnte nicht gesendet werden, versuchen Sie es erneut.",
            messageSent: "Die Nachricht wurde gesendet.",
            openPrivateChat: "Öffnen Sie das Gespräch zwischen Vertretern",
            escKey: "Aktive Konversation verbergen",
            archiveChatKey: "Ermöglicht es Ihnen, am Chat unten auf der Archivseite teilzunehmen.",
            chatCopilot: "Aktiviert Chat CoPilot",
            privateChat: "Konversationspanel zwischen Vertretern",
            multiModeAlertDesc:
                'SUPSIS ist in einem anderen Fenster geöffnet. Klicken Sie in diesem Fenster auf "Verwenden Sie hier", um SUPSIS zu verwenden.',
            useHereText: "Verwenden Sie es hier",
            brandVisibility: "SUPSIS -Brand -Label erscheint im Chat -Ballon",
            focusInput: "Konzentrieren Sie sich auf das Schreibfeld der Active Rede von Cursor",
            send: "Schicken",
            notYet: "Noch nicht",
            sending: "Gesendet",
            onlyRepresentative: "Ihre Nachricht wird nur von Vertretern gesehen.",
            yourMessage: "Ihre Nachricht",
            liveFabListDescription: "Live Support",
            messengerIntegrationDesc:
                "Chatten Sie mit Ihren Kunden über die Facebook-Seite, senden Sie automatisierte Nachrichten mit Chatbot.",
            checkDepartmentToAgent: "Abteilung auf Online-Agenten überprüfen",
            ifAllOfflineStory: "Story zur Weiterleitung, wenn alle offline sind",
            AssignMessagesToAgents: "Alle Nachrichten den Agenten zuweisen",
            firstChatbotAndAssign: "Zuerst antwortet der Chatbot und weist dann einem Agenten zu",
            hybridAssign:
                "Das System überprüft die Abteilung, um zu sehen, ob ein Online-Agent vorhanden ist, und weist es bei fehlendem Online-Agenten dem Chatbot zu.",
            ticketFabListDescription: "Tick",
            whatsappFabListDescription: "WhatsApp",
            phoneFabListDescription: "Telefon",
            emailFabListDescription: "Email",
            facebookFabListDescription: "Facebook",
            twitterFabListDescription: "Twitter",
            instagramFabListDescription: "Instagram",
            youtubeFabListDescription: "Youtube",
            linkedinFabListDescription: "Linkedin",
            telegramFabListDescription: "Telegram",
            typeYourChannelLink: "Sie können den Link Ihres {channelLink} -Kanals auf diesem Feld einsetzen.",
            typeYourAccountLink: "Sie können den Link Ihres {accountLink} -Konto in diesem Feld einfügen.",
            typeYourMessage: "Schreibe deine Nachricht hier",
            typeYourMessageMail:
                "Die in diesem Feld eingegebene Nachricht wird als erste Nachricht an die oben genannte E -Mail -Adresse gesendet.",
            typeYourMessageDesc:
                "Die in diesem Feld eingegebene Nachricht wird vom Kunden als erste Nachricht an die oben genannte Telefonnummer gesendet.",
            sendNumber: "Telefonnummer zum Senden der Nachricht: {path}",
            callNumber: "Telefonnummer zu Ihrem Kundenanruf: {phoneNumber}",
            numberIsNotCorrect: "Die fehlende Nummer wurde eingegeben !!",
            emailIsNotCorrect: "E-Mail ist falsch!",
            selectFab: "Wählen Sie eine Fabrik",
            notValid:
                "Sie können nur den Brief (ein Zeichen) eingeben. E, d, f, z, a, x, c, v, w, t, n Buchstaben sind ungültig",
            forMacUsers: "Mac -Benutzer können den Schlüsselsteuerschlüssel verwenden",
            basePriceValue: "Minimaler Preis",
            basePriceDiscount: "Rabatt",
            basePriceCurrency: "Währung",
            customerDBEnabled: "Datenbankauswahl: Verwenden Sie den eigenen Datenbankserver des Kunden",
            customerDBDisabled: "Datenbankauswahl: Verwenden Sie die SUPSIS -Datenbank Sucunus",
            mongoConnectionString: "Mongo -Verbindung",
            whatsappBasePriceValue: "WhatsApp -Grundpreis",
            whatsappPlusBasePriceValue: "WhatsApp plus Grundpreis",
            instagramBasePriceValue: "Instagram -Grundpreis",
            instagramPlusBasePriceValue: "Instagram plus Grundpreis",
            clientAddress: "Kundenadresse",
            customerClientAddress: "Kundenkundenadresse",
            apiAddress: "API -Adresse",
            socketAddress: "Sockeladresse",
            backendAddress: "Backend -Adresse",
            panelLogoUrl: "Panel -Logo -Adresse",
            panelCustomCssUrl: "Spezialpanel CSS -Adresse",
            customerLogoUrl: "Kundenlogo -Adresse",
            customerCssUrl: "Kunden -CSS -Adresse",
            siteAlias: "Standortname",
            language: "Sprache",
            features: "Merkmale",
            interactionPopularity: "Popularität von Interaktionen",
            interactionCount: "Anzahl der Interaktionen",
            uniqueUserCount: "Anzahl der eindeutigen Benutzer",
            allUserPercentage: "(%) Prozent aller Benutzer",
            represantativeSettings: "Repräsentative Einstellungen",
            documentTitle: "Verdächtigungsformular",
            supsisDocument: "Verdachtsdokument",
            ApiDoc: "API-Dokumentation",
            chatBalloonTehemeSettings: "Chat -Ballon- und Themeneinstellungen",
            customLoginFormSettingsTitle: "Passen Sie das Besucheranmeldeformular an",
            addNewField: "Neues Feld hinzufügen",
            editField: "Bearbeitungsfeld",
            typeHere: "Geben Sie hier ein",
            pco: "PCO",
            perPage: "/Buchseite",
            perPageInFilter: "Stück",
            noUserInfoFound: "Keine Benutzerinformationen gefunden",
            startFilter: "Fang an zu suchen",
            showMyChats: "Zeigen Sie mir die zugewiesenen",
            showOnlineAgents: "Nur online zeigen",
            showWaitingChats: "Repräsentative zeigen diejenigen, die erwarten",
            addNewStatus: "Status hinzufügen",
            newTitleContent: "Titel hinzufügen",
            roleName: "Rollenname",
            error: "Fehler",
            contentType: "Inhaltstyp",
            contentTitle: "Inhaltstitel",
            newSiteForm: "Neues Standortregistrierungsformular",
            updateSiteForm: "Site -Update -Formular",
            newBannedWordForm: "Neues Registrierungsformular für verbotenes Wort",
            updateBannedWordForm: "Formular für verbotenes Wort Update",
            newWelcomeMessageForm: "Neues Begrüßungsmeldungsformular",
            updateWelcomeMessageForm: "Formular zur Systemmeldung Aktualisierung",
            newDefaultContentForm: "Neues Bereitschafts -Inhaltsregistrierungsformular",
            updateDefaultContentForm: "Formular für das Ready Content -Update",
            newSubjectForm: "Neues Fachregistrierungsformular",
            updateSubjectForm: "Formular des Betreff -Update",
            showIntro: "Einführung zeigen",
            showChatColorMeaning: "Chatfarben",
            options: "Optionen",
            resetPassword: "Aktualisieren Sie das Passwort",
            audioLevel: "Sprachwarnschall Level",
            privateChatNotificationSound: "Benachrichtigungston",
            continue: "Weitermachen",
            newRoleForm: "Neues Rollenregistrierungsformular",
            updateRoleForm: "Rollen -Update -Formular",
            newUserForm: "Neues Benutzerregistrierungsformular",
            updateUserForm: "Benutzer aktualisieren",
            changeOSRForm: "Ändern Sie die Offline -Nachricht",
            tooltipOSRForm: "Sie können die Offline -Nachricht ändern.",
            newOSRForm: "Offline -Support -Formular",
            newOSRMessages: "Fügen Sie Offline -Post hinzu",
            newOsrMessageTitle: "Offline -Nachrichtentitel",
            updateOSRForm: "Offline -Update -Formular",
            osrTitle: "Titel",
            osrTitleDescription: "Sie können den Titel des Offline -Support -Formulars hinzufügen",
            osrContent: "Inhalt",
            osrContentDescription: "Sie können nicht -Online -Support -Formularinhalte hinzufügen",
            hello: "Hallo Welt",
            date: "Geschichte",
            startDate: "Anfangsdatum",
            finish: "Beenden",
            start: "Anfang",
            search: "Suche starten",
            endDate: "Endtermin",
            representative: "Vertreter",
            representative_: "Vertreter",
            star: "Stern",
            filter: "Filter",
            reset: "ZURÜCKSETZEN",
            dailyChatList: "Tägliche Sprachliste",
            dailyChatDuration: "Tägliche Sprachzeit",
            chatDuration: "Sprachzeit",
            dailyChatGraph: "Tägliche Gesprächsgrafik",
            ok: "OK",
            cancel: "aufgeben",
            chatCount: "Anzahl der Reden",
            shortest: "Kürzeste",
            longest: "Die längste",
            average: "Durchschnitt",
            count: "Stück",
            averagePoint: "Durchschnittliche Punktzahl",
            pointDist: "Bewertungsverteilung",
            point: "Punkt",
            filters: "Filter",
            totalCustomer: "Totaler Kunde",
            avResponseTime: "Abdeckung. Die erste Interventionszeit",
            breakDuration: "Pause",
            breakCount: "Bruch",
            active: "Aktiv",
            passive: "Passiv",
            userForm: "Benutzerform",
            startChat: "Chat beginnen",
            sender: "Absender",
            profile: "Profil",
            name: "Name",
            number: "Nummer",
            username: "Nutzername",
            updateUserName: "Benutzername aktualisieren",
            email: "Email",
            password: "Passwort",
            oldPassword: "Altes Passwort",
            newPassword: "Neues Kennwort",
            passwordAtLeast: "Passwort (mindestens {num} Zeichen)",
            passwordRepeat: "Passwort erneut",
            changePassword: "Kennwort ändern",
            status: "Situation",
            enableState: "Aktiv?",
            douYouWishToDeleteUser: "Möchten Sie diesen Benutzer wirklich löschen?",
            douYouWishToDeleteAnnouncement: "Möchten Sie diese Ankündigung wirklich löschen?",
            userDeleted: "Benutzer gelöscht",
            userSaved: "Benutzer gespeichert.",
            oldPasswordError: "Das alte Passwort ist falsch. Bitte überprüfen Sie.",
            chooseAnOption: "Bitte wählen Sie Ihren bevorzugten Benachrichtigungs -Sound aus.",
            userVolumeUpdated: "Die Schallanpassung wurde aktualisiert.",
            save: "Speichern",
            update: "Aktualisieren",
            addNewMenu: "Neues Menü hinzufügen",
            addNewContent: "Neue Inhalte hinzufügen",
            pleaseTitleEnter: "Bitte geben Sie den Titel ein",
            like: "Anerkennung",
            disLike: "Ungnade",
            users: "Benutzer",
            visitor: "Besucher",
            allContacts: "Alle Links",
            allUsers: "Alle Vertreter",
            allSites: "Alle Standorte",
            newUser: "Neuer Benutzer",
            noNewUser: "Es gibt noch keinen Benutzer.",
            noNewAdminUser: "Es gibt noch keinen Administratorbenutzer.",
            noNewAnnouncement: "Es gibt noch keine Ankündigung.",
            noRoleFound: "Es gibt noch keine Rolle.",
            noBannedWordFound: "Es gibt noch kein Verbot.",
            noWelcomeMessageFound: "Noch keine Systemnachricht.",
            noSubjectFound: "Es gibt noch kein Thema.",
            noVisitorFound: "Der Besucher wurde nicht gefunden.",
            noContactFound: "Der Leitfaden wurde nicht gefunden.",
            sendResponse: "Antwort schreiben",
            delete: "Löschen",
            duplicate: "Kopieren",
            makeDefault: "Machen Sie den Standard",
            checkMore: "Mehr",
            useReadyTemplates: "Verwenden Sie Bereitschaftsvorlagen",
            noRePresentativeFound: "Der Vertreter wurde nicht gefunden.",
            noLiveSupportFound: "Es gibt noch keine Live -Support -Aufzeichnungen.",
            noLiveSupportFoundWithDepartment: "Es gibt keine Chat -Aufzeichnung der Abteilung",
            noBannedVisitorFound: "Es gibt noch keine verbotenen Besucher.",
            removeBanDescription: "Das Verbot entfernen",
            editThisItem: "Aktualisieren Sie diesen Datensatz",
            removeThisItem: "Löschen Sie diesen Datensatz",
            role: "Rolle",
            newRolePlaceHolder: "Klicken Sie hier, um eine neue Rolle hinzuzufügen ...",
            autoChatAssignLimit: "Automatische Sprachzuweisungsgrenze",
            chatAssignInfo:
                "-1 = Systemannahme, 0 = kein Termin erfolgt,> 0 = Zuweisung ist bis zum angegebenen Wert bestanden.",
            relatedDepartments: "Die zuständigen Abteilungen",
            subjectInfo: "Alle Probleme sind zulässig, wenn das Thema nicht ausgewählt ist.",
            archive: "Archiv",
            offlineSupportRequests: "Offline -Unterstützung",
            offlineModeMessage: "Offline -Nachricht",
            offlineMode: "Offline-Modus",
            first: "Erste",
            last: "Ende",
            query: "Fang an zu suchen",
            clean: "Sauber",
            loading: "Wird geladen",
            loadMore: "Lade mehr hoch",
            noMessage: "Es gibt keine Nachricht ...",
            selectChat: "Wählen Sie Sprache",
            noMessageInChat: "In dieser Rede wurde keine Nachricht gefunden",
            noMediaToShow: "Keine Medien zu zeigen",
            firstSeen: "Zum ersten Mal gesehen",
            userInfo: "Nutzerinformation",
            chatId: "Sprachausweise",
            visitorId: "Besucher-ID",
            visitingPage: "Besuchte Seite",
            osAndBrowser: "Betriebssystem und Browser",
            customerClientVersion: "Kundenversion",
            visitorFeedback: "Kundenbewertung",
            notes: "Notizen",
            nameSurname: "Vorname Familienname",
            chats: "Reden",
            bannedVisitors: "Verbotte Besucher",
            country: "Land",
            city: "Stadt",
            cityDistrict: "Provinzbezirk",
            browser: "Scanner",
            os: "Betriebssystem",
            ipAddress: "IP Adresse",
            connectionDate: "Verbindungszeit",
            transaction: "Verfahren",
            banRemoved: "Die Blockierung wurde entfernt.",
            bannedWords: "Verbotene Worte",
            newBannedWord: "Neues verbotenes Wort",
            noBannedWord: "Es gibt noch kein Wort mit Behinderungen.",
            bannedWordForm: "Verbotene Wortform",
            word: "Wort",
            bannedWordAndWordGroup: "Verbotte Wort / Wortgruppe",
            doYouWishToDeleteBannedWord: "Möchten Sie dieses verbotene Wort wirklich löschen?",
            doYouWishToOfflineSupportRequest: "Möchten Sie diese Nachricht löschen?",
            bannedWordSaved: "Verbotenes Wort aufgezeichnet",
            deletedSuccessfully: "Erfolgt gelöscht",
            deleteErrorMsg: "Das Löschen des Prozesses konnte nicht realisiert werden, versuchen Sie es erneut",
            socketError: "Sochete Connection Problem. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut",
            socketConnecting: "Die Verbindung wird mit dem Server hergestellt",
            offlineModeDescription: "Das System ist geschlossen, Kunden können nicht auf Live -Support zugreifen.",
            offlineModeSettingsDescription: 'Überprüfen Sie im Menü Einstellungen die Funktion "Offline -Modus".',
            offlineModeUser: "Das System muss mindestens ein Online -Vertreter sein.",
            adminCannotConnectSocket: "Administratoren können nicht mit der Steckdose verbunden werden.",
            liveSupport: "Live Support",
            siteVisitors: "Site -Besucher",
            visitors: "Besucher",
            thoseConnectedToLiveSupport: "Diejenigen, die mit Live -Unterstützung verbunden sind",
            visitorHistory: "Besuchergeschichte",
            visitorHistoryDescription: "Sie können den Besucher-Chat-Verlauf anzeigen und herunterladen.",
            privateMessage: "Private Nachricht",
            addRepresentative: "Vertreter hinzufügen",
            forwardRepresentative: "Anweisung zum Vertreter",
            keyboardShortcuts: "Tastatürkürzel",
            chatColorMeanings: "Sprachfarbe Bedeutungen",
            connLostCheckInternet:
                "Ihre Verbindung ist gebrochen. Bitte stellen Sie sicher, dass Sie eine Internetverbindung haben.",
            wishToEndThisChat: "Möchten Sie dieses Treffen beenden?",
            defaultContents: "Bereites Inhalt",
            contents: "Inhalt",
            newDefaultContent: "Neue Bereitschaftsinhalte",
            newCTRLContent: "Fügen Sie Strg -Inhalt hinzu",
            newALTContent: "Fügen Sie den Sub -Conontent hinzu",
            newTABContent: "Registerkarte Inhalt hinzufügen",
            shortcutChar: "Verknüpfungscharakter",
            pickOne: "Wähle eins",
            writeSomething: "Schreiben Sie einen Charakter (a-z | 0-9)",
            letterSequence: "Briefreihe",
            exampleText: "Beispiel: fut -> Fußball",
            anyChar: "Jeder Charakter",
            shorcutKey: "Tastenkürzel",
            content: "Inhalt",
            shortcutName: "Verknüpfungsname",
            type: "Medizin",
            shortcut: "Abkürzung",
            deleteContentQuestion: "Möchten Sie diesen in den Bereit sich hergestellten Inhalt wirklich löschen?",
            defaultContentDeleted: "Bereites Inhalt wurde gelöscht.",
            defaultContentSaved: "Ready -hergestellte Inhalte aufgezeichnet.",
            defaultContentForm: "Bereitete Inhaltsform",
            titleContentForm: "Title in Content",
            contentMoved: "Der Inhalt wurde verschoben.",
            cannotMoveFullParent: "Sie können dieses Element nicht tragen",
            yourEmail: "E-Mail-Addresse",
            yourName: "Ihr Name und Nachname",
            lostPassword: "Ich habe mein Passwort vergessen",
            login: "Eingang",
            forgotPassword: "Ich habe mein Passwort vergessen",
            multipleSession: "Sie haben sich irgendwo anders angemeldet.",
            notAuthorizedToDisplayPage: "Sie haben keine Erlaubnis, diese Seite anzuzeigen!",
            permissions: "Genehmigung",
            newPermission: "Neuer Urlaub",
            permissionForm: "Erlaubnis von",
            displayTitle: "Bildgebungstitel",
            key: "Taste",
            keyToUseInSystem: "Der Schlüsselwert, der im System verwendet werden soll",
            deletePermissionQuestion: "Möchten Sie diese Erlaubnis wirklich löschen?",
            permissionDeleted: "Die Erlaubnis wurde gelöscht.",
            permissionSaved: "Erlaubnis wurde aufgezeichnet.",
            newRole: "Neue Rolle",
            selectARole: "Wählen Sie eine Rolle",
            yes: "Ja",
            no: "NEIN",
            fullAuth: "Volle Autorität",
            roleDeleted: "Die Rolle wurde gelöscht.",
            roleSaved: "Die Rolle wurde aufgezeichnet.",
            roleForm: "Rollenform",
            roles: "Rollen",
            settings: "Einstellungen",
            selectTopic: "Abteilungsauswahl",
            autoCallTransfer: "Automatische Interviewübertragung",
            customerTyping: "Benutzer schreiben",
            typing: "Er schreibt",
            agentTyping: "Vertreter schreibt",
            disconnectTime: "Kündigungszeit (SN)",
            tippyDissconnectTime:
                "Passt das Gespräch in der immer noch Situation nach wie vielen Sekunden an, die geschlossen werden wird",
            queueNumberVisibleFeature: "Zeigen Sie die Anzahl der Personen, die im Einklang mit dem Besucher warten",
            privateChatEnabled: "Chat zwischen Vertretern zeigen",
            delayedTalkTime: "Verzögerungszeit (SN)",
            employeeAverageChatCount: "Durchschnittliche Anzahl von Reden für das Personal -Chat -Verhältnis",
            customerDownTimeWhenRepExit: "Als der Vertreter ausgeht, verschwendete der Kunde Zeit (Mr.)",
            autoAssignLimit: "Automatische Zuordnungsgrenze",
            wasted: "V Verschwendung Zeit (SN)",
            settingsSaved: "Einstellungen aufgezeichnet.",
            settingsCannotSaved: "Einstellungen können nicht gespeichert werden",
            noAuthorization: "Keine Berechtigung",
            warningBadInput: "Es wird empfohlen, eine Zahl zwischen 0 und 70 einzugeben.",
            warningBadInputMarginY: "Warnung vor dem Auftritt der vertikalen Seitenhauptstadt ⚠️",
            warningBadInputMarginX: "Warnung vor dem Eingang des horizonalen Kapitals ⚠️",
            warningBadInputBubbleSize: "Warnung vor Ballongrößeneintrag ⚠️",
            settingFormWrong: "Die Daten, die Sie eingeben, sind falsch, überprüfen und versuchen Sie es erneut",
            delayTime: "Zeitverzögerungszeit (Mr.)",
            sites: "Standorte",
            newSite: "Neue Seite",
            noSiteYet: "Es gibt noch keine Website.",
            siteAddress: "Website-Adresse",
            turnBack: "Zurückdrehen",
            customerRepLimit: "Kundenvertreterlimit",
            siteSaved: "Die Seite wurde gerettet.",
            siteSaveError: "Es gab einen Fehler beim Erstellen einer Website.",
            subjects: "Themen",
            newSubject: "Neues Thema",
            noSubject: "Es gibt noch kein Thema.",
            subject: "Thema",
            subjectTitle: "Thementitel",
            infoAboutSubject: "Kurze Informationen zum Thema",
            deleteSubjectQuestion: "Möchten Sie dieses Thema wirklich löschen?",
            subjectDeleted: "Das Thema wurde gelöscht",
            subjectSaved: "Das Thema wurde gerettet.",
            osrFromMessageSaved: "Offline -Nachricht aufgezeichnet.",
            welcomeMessages: "Systemmeldungen",
            newWelcomeMessages: "Neue Begrüßungsnachricht",
            noWelcomeMessage: "Noch keine Systemnachricht.",
            welcomeMessageContent: "Systemnachrichteninhalt",
            makeChoice: "Entscheide dich ...",
            welcomeMessage: "Willkommensnachricht",
            repLoggedIn: "Vertreter unterzeichnet",
            loginMessage: "Signiernachricht",
            message: "Nachricht",
            deleteWelcomeMessageQuestion: "Möchten Sie diese Systemnachricht wirklich löschen?",
            welcomeMessageDeleted: "Systemnachricht gelöscht",
            welcomeMessageSaved: "Die Systemmeldung wurde aufgezeichnet.",
            welcomeMessageForm: "Systemnachrichtenformular",
            noRep: "Es gibt noch keinen Vertreter.",
            addChat: "Fügen Sie das Interview hinzu",
            forwardChat: "Leiten Sie das Interview",
            ago: "Vor",
            repName: "Repräsentativer Name",
            lastOnline: "Letzte Verbindung/Online -Zeit",
            lastStatusChange: "Letzte Falländerung",
            activeChat: "Aktive Rede",
            userMaxCapacity: "Max Chat -Kapazität",
            noActiveChat: "Keine aktive Rede.",
            watch: "BETRACHTEN",
            join: "VERBINDEN",
            open: "Öffne das Gespräch",
            directMessage: "PRIVATE NACHRICHT",
            block: "BLOCK",
            transactions: "Transaktionen",
            informations: "Informationen",
            visitStart: "Beginn des Besuchs",
            fullName: "Name und Nachname",
            waitChatTime: "Wartezeit/Chatzeit",
            blockUserConfirm: "Möchten Sie diese Person wirklich verhindern?",
            messaging: "Nachrichten",
            hideChat: "Verstecke das Gespräch",
            block_: "Block",
            privateMessage_: "Geheime Botschaft",
            assignRep: "Repräsentant ATA",
            joinChat: "Einbeziehung im Gespräch",
            forwardRep: "Orientierungshilfe",
            leaveChat: "Verlassen Sie das Interview",
            endChat: "Beenden Sie das Treffen",
            translatedTextDescription: "Amazon hat diese Nachricht {from} -> {to} übersetzt.",
            autoTranslate: "Automatische Übersetzung",
            translateThisMessage: "Drehen Sie diese Nachricht",
            autoTranslateDetectedDesc:
                "Besucher sprechen in {visitorLanguage}. Klicken Sie hier, um die automatische Übersetzung zu aktivieren",
            on: "Offen",
            off: "Geschlossen",
            copy: "Kopieren",
            prevChats: "Vorherige Reden",
            noShortCut: "Keine Verknüpfung",
            leaveChartConfirm: "Bist du sicher, dass du gehen willst, ohne zu reden?",
            endChatConfirm: "Möchten Sie dieses Treffen beenden?",
            chatBar: "Sprachanzeige",
            endConversation: "Beenden Sie das Treffen",
            onlyOneRep: "Sie sind der einzige Vertreter in diesem Gespräch!",
            chatList: "Sprachliste",
            unreadTitle: "Ungelesen",
            visitorLeftTitle: "Besucherausgabe",
            activeChatTitle: "Aktive Rede",
            autoAssignedTitle: "Automatisch zugewiesen",
            watchModeTitle: "Überwachungsmodus",
            lostChat: "Repräsentative Verbindung gebrochen",
            repLostConn: "Wenn der Vertreter aus der Rede ausbrach, wird das Gespräch rosa.",
            chatWidthDelay: "Verzögerung des Chats",
            repChatWidthDelay:
                "Wenn es keinen aktiven Vertreter im System gibt oder dass Besucher aufgrund der Dichte nicht genommen werden, ist der Hintergrund grün.",
            unreadMsg: "Wenn es eine ungelesene Nachricht gibt, wird der Hintergrund hellblau.",
            visitorLeftChat: "Wenn der Besucher die Rede verließ, wird der Hintergrund dunkelgrau.",
            activeChatMsg: "Wenn die Rede aktiv ist, wird der Hintergrund grün",
            autoAssignMsg:
                "Wenn er mit automatischer Aufgabe ernannt wurde und das Gespräch nicht betrachtet wurde, wird der Hintergrund Senf",
            watchModeMsg: "Wenn im Überwachungsmodus geöffnet wird, wird der Hintergrund rot",
            online: "Online",
            beRightBack: "Ich komme gleich wieder",
            away: "Ich komme gleich wieder",
            busy: "Beschäftigt",
            offline: "Offline",
            logout: "Ausloggen",
            forWindows: "Für Windows",
            forMac: "Für Mac",
            nextChatFromActive: "Gehen Sie zum nächsten Gespräch ohne aktive Gespräch",
            previousChatFromActive: "Übergeben Sie das vorherige Gespräch ohne aktive Rede",
            hideActiveChat: "Aktive Konversation verbergen",
            closeActiveChat: "Beenden Sie aktive Gespräche",
            firsthiddenChat: "Stellen Sie eine Verbindung zur Rede des am meisten gewarteten Kunden her",
            firstChatWaiting: "Wechseln Sie zur Sprache, die auf eine Antwort wartet",
            previousOpenedChat: "Wechseln Sie zu dem Gespräch, das zuvor geöffnet wurde",
            hashHintMessage: "Sie können schnell die Hashtag -Verknüpfungen eingeben",
            pmHintMessage: "Sie können eine geheime Nachricht mit (Beispiel PM: HI) senden",
            vtippyTicketNotification: "Benachrichtigungseinstellungen für jedes neue Ticket, das zu Ihnen kommt",
            newTicketSound: "Neues Ticket",
            vtippyDepartmentNotification:
                "Benachrichtigungseinstellungen für Nachrichten aus der Abteilungskonversation",
            vtippyGroupNotification: "Benachrichtigungseinstellungen für Nachrichten aus erstellten Gruppen",
            vtippyAnnouncemenNotification: "Benachrichtigungseinstellungen für neue Ankündigungen",
            languageSelection: "Sprachauswahl",
            shortcutHintMessage: "Sie wissen, dass Sie schnellere Nachrichten mit Abkürzungsnachrichten senden können.",
            switchBetweenConversations:
                "Wissen Sie, dass Sie schnell zwischen Verknüpfungen und Chats umschalten können?",
            atNameHintMessage: "Wissen Sie, dass Sie den Namen des Besuchers schnell schreiben können?",
            dndHintMessage: "Sie können die Datei mit Drag & Drop hochladen.",
            pasteFile: "Sie können Dateien mit senden.",
            atEmailHintMessage: "Wissen Sie, dass der Besucher die E-Mail schnell schreiben kann?",
            pastePlainText: "Es klebt den Ausdruck, den Sie als direkter Text ohne Stil kopieren.",
            pressAndTalk: "Press and talk",
            historyDetails: "Vergangene Details",
            chat: "Rede",
            chatNotFound: "Keine Sprache gefunden.",
            dataNotFound: "Daten nicht gefunden.",
            visitorInfo: "Besucherinformationen",
            timeSpent: "Die Zeit",
            noActiveVisitors: "Keine aktiven Besucher",
            select: "Öffnen Sie das Menü",
            fullname: "Vollständiger Name",
            text: "Text",
            numeric: "Digital",
            phone: "Telefon",
            optionsPlaceholder: "Optionswert",
            selectField: "Klicken Sie auf, wenn Sie ein Pop -up -Menü hinzufügen möchten",
            fullnameField: "Klicken Sie, wenn Sie einen vollständigen Namensraum hinzufügen möchten.",
            textField: "Klicken Sie, wenn Sie ein Textfeld hinzufügen möchten.",
            labelField: "Wenn Sie das Feld Beschreibung hinzufügen möchten, klicken Sie auf.",
            numericField: "Wenn Sie einen numerischen Bereich hinzufügen möchten, klicken Sie auf.",
            phoneField: "Klicken Sie, wenn Sie ein Telefonfeld hinzufügen möchten.",
            departmentField: "Klicken Sie auf, wenn Sie einen Abschnitt hinzufügen möchten",
            emailField: "Wenn Sie den E -Mail -Bereich hinzufügen möchten, klicken Sie auf.",
            visible: "Sichtbar",
            required: "Schwierigkeit",
            label: "Erläuterung",
            totalConnected: "Anzahl der Reden",
            missedChat: "Anzahl der Reden entkommen",
            workTime: "Arbeitszeit",
            closedChatCount: "Geschlossene Gespräche",
            activeConvo: "Aktiv gesprochen",
            notAnswered: "Noch nicht beantwortet",
            delayedConvo: "Verzögerte Gespräche",
            leavingRep: "Abfahrtsvertreter",
            staffRate: "Personal Arbeitsrate",
            customLoginAlert: "Es muss mindestens 1 sichtbarer Bereich in Ihrer Form sein.",
            atLeastOneLanguage: "Muss mindestens eine Sprache der Sprache sein.",
            requiredField: "Dieser Bereich ist obligatorisch.",
            notRequiredField: "Dieser Bereich ist nicht obligatorisch.",
            visibleField: "Dieses Feld erscheint in der Form.",
            notVisibleField: "Dieses Feld erscheint nicht in der Form.",
            connectServer: "Sie sind mit dem Server verbunden",
            disconnectServer: "Ihre Verbindung mit dem Server wurde abgeschnitten",
            liveChatOff: "Live -Unterstützung aus",
            visitorScreen: "Besucherbildschirm",
            viewOnTheSite: "Ansicht auf der Seite",
            viewOnTheSiteTippy: "Klicken Sie hier, um zu sehen, wie Ihre Änderungen stoppen.",
            showHint: "Tipp zeigen",
            dontShowHint: "Tipp zeigt",
            liveChatOn: "Live -Unterstützung ist offen",
            nightModeOff: "Nachtmodus aus",
            nightModeOn: "Der Nachtmodus ist offen",
            edit: "Bearbeiten",
            deleteField: "Löschen",
            arrow_upward: "Stromaufwärts",
            arrow_downward: "Stromabwärts",
            doubleClickEdit: "Klicken Sie zweimal, um die Schaltfläche Bearbeiten zu bearbeiten oder zu drücken.",
            newCatalogCategory: "Neue Katalogkategorie",
            childCreate: "Klicken Sie hier, um Sub -Incontent zu erstellen",
            updateCatalogCategoryFrom: "Katalogkategorie -Aktualisierungsformular",
            newCatalogCategoryFrom: "Neue Formular der Katalogkatalog",
            catalogMenu: "Speisekarte",
            catalogContent: "Inhalt",
            catalogCategoryName: "Katalogkategorie Name",
            newCatalogContentFrom: "Neues Kataloginhaltsformular",
            catalogContentName: "Kataloginhaltsname",
            catalogCategorySaved: "Katalogkategorie aufgezeichnet",
            catalogCategoryDeleted: "Die Katalogkategorie wurde gelöscht.",
            catalogCategoryRate: "Content Score",
            catalogContentFeature: "Katalogfunktion",
            vtipyAudioLevel: "Es wird verwendet, um Benachrichtigungsgeräusche zu schneiden oder zu öffnen.",
            vtipyOrganizationName: "Sie können den Organisationsnamen ändern und aktualisieren.",
            vtipyBrandVisibility: "Das SUPSIS -Tag ist die Einstellung, ob es im Chat -Ballon angezeigt wird.",
            vtipyBrandVisibilityForced: "Nur Proplan kann Benutzer ändern !!",
            vtipyClientDefault: "Sie können die repräsentative Seitensprache hier ändern.",
            vtipyCustomerClientDefault: "Hier können Sie die Sprache der Kundenseite (CHAT) ändern.",
            vtipyVisitorPreferredLang: "Sie können die Sprachsprache auf der Seite Kunden (CHAT) auswählen.",
            vtipyCustomerClientLanguageDetect:
                "Sie können automatisch die Sprache der Seite der Kunden (CHAT) erkennen.",
            vtipySelectTopic:
                "Nach den von den Kunden ausgewählten Themen müssen die Abteilungen (Fächer) geleitet werden.",
            vtipyAutoCallTransfer: "Es weist die Warteverträge automatisch den verfügbaren Vertretern zu.",
            vtipyCustomerTyping: "Sie können den Kunden auf dem Chat -Bildschirm auf dem Chat -Bildschirm sehen.",
            vtipyAgentTyping: "Der Vertreter zeigt den Schreibstatus beim Kundenballon.",
            vtipyQueueNumberVisibleFeature:
                "Es zeigt, was für Kunden, die sich verbinden möchten, wenn Vertreter intensiv sind.",
            vtipyPrivateChatEnabled: "Zeigt das Sprachgremium zwischen Vertretern.",
            vtipyDelayedTalkTime:
                'Während dieser Zeit ist kein Vertreter mit dem Sprechen als "verzögerte Rede" verbunden.',
            vtipyOfflineMode: "Mit dem System können Sie offline -Mode kaufen.",
            vtipyAutoAssignLimit: "Es bestimmt, wie viele Kundenterminer an den Vertreter vereinbart werden.",
            vtipyCustomerDownTimeWhenRepExit: "Als der Vertreter ausgeht, verschwendete der Kunde Zeit (Mr.)",
            tippyDisconnectTime: "Nachdem die Kundenverbindung unterbrochen wurde, ist die Schließzeit (SN).",
            changeSettings: "Ändern Sie die globale Einstellung",
            totalBg: "Gesamtzahl der Chats",
            activeBg: "Aktive Chats",
            watchBg: "Verfolgung",
            waitingBg: "Ausstehende Chats",
            lateBg: "vorbeiziehende Gespräche",
            freeBg: "Leerlauf",
            maxCapacityBg: "Max",
            addNewSettings: "Fügen Sie eine neue globale Einstellung hinzu",
            darkMode: "NACHT-MODUS",
            clientDefault: "Panel Standardsprache",
            customerClientDefault: "Kundenteil ist die Standardsprache",
            customerClientLanguageDetect: "Kundenteil der Sprache erkennt automatisch",
            visitorPreferredLang: "Kunde Wählen Sie die Sprachsprache",
            preferredThemeColor: "Sprachbildschirm -Themenpräferenz",
            detail: "Prüfen",
            langSetting: "Die Spracheinstellung",
            supportUs: "Kontaktieren Sie uns (Live -Unterstützung)",
            changeLang: "Sprache ändern",
            fontSizeSetting: "Einstellung der Bildschirmvergrößerung",
            changeLangDesc: "Legt die Anwendungssprache auf {code} fest.",
            trLang: "Türkisch",
            enLang: "Englisch",
            fieldRequired: "{field} Feld ist erforderlich.",
            selectALanguage: "Wählen Sie eine Sprache",
            selectATheme: "Wähle ein Thema",
            responseForm: "Antwortformular",
            clientRequestInfo: "Kundenbedarfsinformationen",
            createdDate: "Erstellungsdatum",
            descMessage: "Nachricht",
            new: "Neu",
            lastLoginPlatform: "Plattform",
            requiredFieldField: "Dieser Bereich ist obligatorisch",
            catalogCategoryMenu: "Fügen Sie das Katalogkategoriemenü hinzu",
            catalogCategoryLeaf: "Katalogkategorie Sub -Menu",
            selectAllPermission: "Wählen Sie Alle",
            catalogCategories: "Katalog",
            copiedClipboard: "In die Tafel kopiert",
            organizationLogo: "Firmenlogo",
            changePlan: "Plan ändern",
            close: "Schließen",
            vtipyUploadLogo:
                "Sie können Ihr eigenes Logo auf Customer Mails und Kundenseite verwenden, indem Sie Ihr Firmenlogo aus diesem Bereich installieren.",
            tagName: "Verlinke den Namen",
            tagDescription: "Etikettenbeschreibung",
            tagColor: "Etikettenfarbe",
            userInformations: "Nutzerinformation",
            incomingChat: "Eingehender Chat",
            support: "Unterstützung",
            team: "Satz",

            groups: "Gruppen",
            newConversationStarted: "Neues Gespräch begonnen",
            allHistoryLoaded: "Der gesamte Verlauf wurde hochgeladen",
            chatCreator: "Chat-Ersteller",
            enterGroupTitle: "Geben Sie den Gruppentitel ein",
            requiredTitle: "Sie können das Titelfeld nicht leer lassen",
            requiredChannel: "Der Kanalname darf nicht leer sein",
            next: "Bestätigen",
            selectPeople: "Wählen Sie Personen aus",
            textLimitAlertMessage:
                "Die Zeichenbeschränkung in WhatsApp beträgt 19 Zeichen und darüber hinaus wird es nicht angezeigt. Im Web werden jedoch Texte, die die 19-Zeichen-Grenze überschreiten, automatisch in die nächste Zeile verschoben und angezeigt.",
        },
        shouldAddMethod:
            "Sie müssen das Feld Zahlungsmethode & Rechnungsadresse ausfüllen!\nEs wird kein Geld von Ihrem Konto abgebucht..\n" +
            "Am Ende des Monats wird eine Rechnung entsprechend Ihrer Nutzungsmenge erstellt.",
        telegram: {
            typeInTelegramToken: "Geben Sie Telegram Token ein",
            token: "Zeichen",
            telegramTokenTitle: "Telegram Supsis Integration",
            telegramAlertForm: "Sie können Telegram Bot Token von erhalten",
            telegramAlertTitle: "Möchten Sie das Token wirklich löschen?",
            telegramAlertText: "Der Token geht dauerhaft verloren!",
        },
        wp: {
            sendingStatus: "In der Sendung",
            sent: "Gesendet",
            allErrors: "Alle Fehler",
            inProcess: "In Bearbeitung",
            sendingStatuses: "Sendestatus",
            downloadCSV: "CSV herunterladen",
            errorMessage: "Fehlermeldung",
            noNumbersAdded: "Keine Nummern hinzugefügt",
            sendAgain: "Erneut senden",
            shippingDetails: "Versanddetails",
            whatsapp: "WhatsApp",
            importContactsFromFile: "Kontakte aus Datei importieren",
            chatStartingWait: "Die Rede beginnt, bitte warten",
            chatStarted: "Die Sprache begann",
            chatNotStarted: "Sprache konnte nicht gestartet werden",
            contactSelected: "Die Person wurde ausgewählt",
            startChatWithAnyNo: "Chatten Sie mit einer beliebigen Zahl",
            toLittleChar: "Die fehlende Nummer wurde eingegeben!",
            typeInANumberDesc: "Schreiben Sie die Nummer, um einen Chat zu starten",
            wpPlusAndLicenceRequired: "WhatsApp Plus -Plan und Lizenz sind erforderlich.",
            wpPlusAndLicenceRequiredDesc:
                "Sie sollten Ihren WhatsApp -Plan erhöhen und eine Lizenz erhalten, damit Sie mit dem Chatten nach Nummern beginnen können, die nicht in Ihrem Leitfaden registriert sind.",
            agreement: "Vereinbarung",
            purchase: "Besorgen",
            activating: "WhatsApp -Dienst aktiviert",
            authenticating: "QR -Codeüberprüfung",
            ready: "Vollständig",
            activationTitle: "Aktivieren Sie die WhatsApp -Integration auf SUPSIS:",
            wpIntegrationInstruction1: "Öffnen Sie WhatsApp auf Ihrem Telefon",
            wpIntegrationInstruction2: "Wählen Sie Menü oder Einstellungen und klicken Sie auf Geräte.",
            wpIntegrationInstruction3: "Führen Sie Ihr Telefon auf diesem Bildschirm aus, um den Code zu scannen",
            qrGeneratingWait: "Der QR -Code wird erstellt, bitte warten ...",
            pleaseContinueToWaitUntilCompleted:
                "Nachdem der QR -Code überprüft wurde, wechselt er automatisch in den ausgefüllten Bereich. Warten Sie mal...",
            authenticatingWait: "Es loggt sich an, bitte warte ...",
            enableFeature: "Aktivieren Sie die WhatsApp -Funktion",
            unsubscribeWpInetgration: "WhatsApp -Integration beendet sein Abonnement",
            unsubscribeIGIntegration: "Beendigung von Instagram -Integration -Abonnements",
            wpBack: "Zurück",
            terminatelWpInetgration:
                "Wenn Sie auf die Abonnementschaltfläche klicken, wird Ihre WhatsApp -Integration beendet.",
            cancelWpInetgration: "Möchten Sie WhatsApp -Integration stornieren?",
            terminatelIGIntegration:
                "Wenn Sie auf die Abonnementschaltfläche klicken, wird Ihre Instagram -Integration beendet.",
            cancelIGIntgeration: "Möchten Sie die Instagram -Integration stornieren?",
            startChatWp: "Chat beginnen",
            readAndAgree: "Ich habe es gelesen, ich stimmte zu",
            subscribe: "Abonnieren",
            subscribed: "Gezeichnet",
            toEnableWpDescription: "Klicken Sie auf die Schaltfläche unten, um WhatsApp -Funktionen zu aktivieren.",
            waitForWpActivationDescription:
                "Der WhatsApp -Account -Service wird aktiv. Warten Sie mal. Es dauert ungefähr 30 Sekunden.",
            greatWpActivatedDescription: "WhatsApp -Kontodienst wurde aktiviert.",
            unsubscribe: "Aus dem Abonnement herauskommen",
            planDetails: "Merkmale",
            sendReceiveMessage: "Senden von Nachrichten und Empfangen",
            sendReceiveImage: "Bilder senden und empfangen",
            sendReceiveAudio: "Senden von Audioaufzeichnungen und Empfangen",
            sendReceiveGif: "GIF -Senden & Empfangen",
            startChat: "Chat beginnend in SUPSIS",
            supsisFunctionality: "Nützliche SUPSIS -Chat -Funktion",
            onePhoneMultiAgent: "Mehr als ein Vertreter mit einem einzelnen Telefon",
            basicIntegration: "Einfache Integration",
            purchaseHeader: "SUPSiS-WhatsApp-Integration Einkauf",
            wpServices: "WhatsApp -Service",
            wpServicesIntegrationCompleted: "WhatsApp -Integration ist abgeschlossen. Sie können es jetzt verwenden.",
            purchasePaymentDescription:
                "WhatsApp -Feature ist von Monat zu Monat in Rechnung gestellt. Nach der Annahme des Abonnements wird Ihr WhatsApp -Dienst aktiviert.",
            wpIntegrationFeatures: "WhatsApp -Integrationsfunktionen",
            saveChanges: "Änderungen speichern",
            contactList: "Personliste",
            broadcast: {
                broadcast: "Kollektive Nachricht",
                detail: "Detail",
                customer: "Kunde",
                phoneNumbers: "Kontaktnummern",
                showMore: "Zeig mehr",
                showLess: "Zeige weniger",
                groupName: "Gruppenname",
                messages: "Mitteilungen",
                status: "Situation",
                usageCost: "Nutzungskosten",
                sendingTime: "Zeit zu senden",
                progress: "Fortschritt",
                groupDetail: "Gruppendetail",
                messagesPerContact: "Anzahl der Nachrichten pro Kopf",
                successRatio: "Erfolgsrate",
                message: "Nachricht",
            },
            messages: "Mitteilungen",
            broadcastRequests: "Kollektive Nachrichtenanfragen",
            customerGroups: "Kundengruppen",
            messageTemplates: "Nachrichtenvorlagen",
            plans: "Pläne",
            wpIntegrationRequired: "WhatsApp -Integration erforderlich",
            wpRequiredIntegrationDescription:
                "Entschuldigung, die Seite, die Sie besuchen, wird aktiviert, wenn Sie Ihre WhatsApp integrieren.",
            integrateWp: "Komm schon, integrieren Sie WhatsApp",
            active: "Aktiv",
            archived: "Archiviert",
            createBroadcastMessage: "Erstellen Sie eine kollektive Nachricht",
            title: "Titel",
            description: "Erläuterung",
            createdAt: "Erstellungsdatum",
            numbers: "Zahlen",
            actions: "Bewegungen",
            action: "Aktion",
            createCustomerGroup: "Erstellen Sie eine spezielle Kundengruppe",
            search: "Forderung",
            name: "NAME",
            contacts: "Personen",
            noContactFound: "Die Person nicht gefunden",
            broadcastTitle: "Schreiben Sie einen Titel in Ihre kollektive Nachricht.",
            recipients: "Käufer",
            selectRecipients: "Wählen Sie Käufer",
            writeYourMessage: "Schreibe deine Nachricht.",
            schedule: "Mit Plan",
            scheduleNowOrLater: "Planen Sie jetzt oder später.",
            summary: "Zusammenfassung",
            cancel: "Stornieren",
            send: "Schicken",
            sending: "Gesendet",
            deleteCustomerGroup: "Sind Sie sicher, dass Sie diese Kundengruppe löschen möchten? {Name}",
            customerGroupDeleting: "Die Kundengruppe wird gelöscht ...",
            customerGroupDeletingSuccess: "Kundengruppe erfolgreich gelöscht",
            customerGroupDeletingError: "Die Kundengruppe ist beim Löschen aufgetreten",
            wpPlusRequired: "WhatsApp Plus -Plan ist erforderlich.",
            broadcastMessageArchived: "Archivarchive",
            broadcastMessageNotArchived: "Die Bulk Message Group wurde nicht archiviert",
            groupNameSearch: "Schreiben Sie den Kundengruppennamen",
            groupNameDesc: "Kundengruppenname Definieren Sie Ihre Kundengruppen",
            save: "Speichern",
            number: "NUMMER",
            addColumn: "Spalte hinzufügen",
            addColumnDesc: "Fügen Sie der Tabelle eine Spalte hinzu",
            addNewContact: "Neue Person hinzufügen",
            addNewContactDesc: "Person zur Tabelle hinzufügen",
            importFile: "Aus der Datei einführen",
            importFileDesc: "Befragte Personen aus der Excel- oder CSV -Datei",
            contactAdded: "Person hinzugefügt",
            updateCustomerGroup: "Die Kundengruppe wird aktualisiert ...",
            updateCustomerGroupSuccess: "Die Kundengruppe hat erfolgreich aktualisiert",
            sendBroadcastMessage: "Senden Sie eine kollektive Nachricht",
            columnName: "Spaltenname",
            columnType: "Spalte",
            defaultValue: "Standardwert",
            setDefaultValue: "Setzen Sie den Standardwert auf vorhandene Personen",
            age: "Alter",
            location: "Standort",
            gender: "Geschlecht",
            selectContactFile: "Wählen Sie die Datei mit Personen aus",
            selectContactCsvOrExcel: "Wählen Sie eine CSV- oder Excel -Datei aus.",
            importConfiguration: "Verbessern Sie Ihre Datei",
            customizeFile: "Bearbeiten Sie die Personen, die Sie hinzufügen.",
            sendMessageTo: "Wen möchten Sie die Nachricht senden?",
            allContact: "Alle Leute",
            messageTypes: "Nachrichtentypen",
            whenSendMessage: "Wann möchten Sie die Nachricht senden?",
            instantlyRightNow: "Im Augenblick",
            completed: "Vollendet",
            scheduleFuture: "Timing für ein zukünftiges Datum",
            messageDesc: "Ihre Nachricht wird sofort an alle Käufer gesendet",
            messageSendAt: "Es wird an alle Käufer unter Ihrer Nachrichtenadresse weitergeleitet:",
            estimatedPrice: "Schätzpreis",
            estimatedTime: "Geschätzte Zeit",
            now: "Jetzt",
            tenMinute: "10 Minuten",
            cancelled: "Es wird abgesagt",
            failed: "Erfolglos",
            running: "Geht weiter",
            queued: "Aufgereiht",
            scheduled: "Geplant",
            noNumberAdded: "Nummer nicht hinzugefügt",
            csvOrExcelFile: "CSV- oder Excel -Datei",
            broadcastMessagesToContactFile: "Senden von kollektiven Nachrichten an die Personliste",
            broadcastMessageTemplates: "Kollektive Nachrichtenvorlagen",
            messageFlow: "Nachrichtenfluss",
            textMessageSupport: "SMS -Unterstützung",
            imageMessageSupport: "Unterstützung bei Bildnachrichten",
            spamPreventions: "Spam -Nachrichtenprävention",
            includesAllBasicPlans: "Enthält alle Funktionen im WhatsApp -Paket",
            chatbotIntegration: "Chatbot -Integration",
            messageToNewNumbers: "Senden von Nachrichten an neue Zahlen",
            broadcastMessageToEveryone: "Senden einer kollektiven Nachricht an alle",
            personalizedBroadcastMessage: "Persönliche Massennachrichten",
            customerGroupSegmentation: "Kundengruppensegmentierung",
            scheduleBroadcastMessage: "Bulk -Nachrichtenplanung",
            locationMessageSupport: "Standortmeldungsunterstützung",
            advancedSpamPreventions: "Erweiterte Spam -Nachrichtenprävention",
            whatsappPlans: "WhatsApp -Pläne",
            selectBestPlan: "Wählen Sie den entsprechenden Plan für Sie",
            comingSoon: "Sehr bald...",
            selectFile: "Wähle eine Datei",
            created: "Erstellt",
            message: "Nachricht",
        },
        ig: {
            instagram: "Instagram",
        },
        ticket: {
            trendyolQandA: "Trendyol Fragen und Antworten",
            instagramComments: "Instagram Kommentare",
            messengerComments: "Messenger Kommentare",
            trendyolComments: "Trendyol Kommentare",
            facebookComments: "Facebook-Kommentare",
            offlineTickets: "Offline-Tickets",
            chatbotTickets: "Chatbot-Tickets",
            ticketSettings: "Ticket-Einstellungen",
            ticketSelection: "Ticket ausgewählt",
            bulkClose: "Massenabschluss",
            igComment: "Instagram-Kommentar",
            igMentioned: "Instagram-Erwähnungen",
            incomingReqChatbot: "Eingehende Anfragen mit Chatbot",
            incomingReqWebForm: "Anfragen von Web-Formular",
            incomingReqAutomation: "Anfragen von der Automatisierung",
            thisPersonEmailAnswered: "Diese Person möchte per E-Mail beantwortet werden",
            thisPersonWpAnswered: "Diese Person wartet auf eine Antwort über WhatsApp.",
            clickStartWpChat: "Klicken Sie, um einen WhatsApp-Chat zu starten",
            requestProgress: "Fortschritt anfordern",
            requestMessage: "Nachricht anfordern",
            clickAddMailAddress: "Klicken Sie, um eine Mailadresse hinzuzufügen",
            sendReplyCloseTicket: "Antwort senden und Ticket schließen",
            closeTicket: "Ticket schließen",
            selectEmailSender: "E-Mail-Absender auswählen",
            withEmailWillNotRecievice:
                "Sie können keine Antworten auf die E-Mail erhalten, wenn Sie mit dieser E-Mail-Adresse senden!",
            deleteCommentAndClose: "Kommentar löschen und schließen",
            sendReplyAndClose: "Antwort senden und schließen",
            startChatWp: "WhatsApp-Chat starten",
            sureWantToDeleteTicket: "Sind Sie sicher, dass Sie ein Ticket löschen wollen?",
            bulkDeleteConfirmation: "Massenlöschbestätigung",
            selectedTicketSucsDelete: "Ausgewählte Tickets wurden erfolgreich gelöscht.",
            thereErrorDeletingTicket: "Beim Löschen von Tickets ist ein Fehler aufgetreten.",
            deleteConfirm: "Löschung bestätigen",
            sureDeleteTicket: "Sind Sie sicher, dass Sie dieses Ticket löschen möchten?",
            ticketSucsDelete: "Ticket erfolgreich gelöscht.",
            represantiveSucsAppoint: "Der Bearbeiter wurde erfolgreich ernannt.",
            ticketClosedSucs: "Ticket erfolgreich geschlossen",
            ticketCloureFailed: "Ticketschließung fehlgeschlagen.",
            unprocessed: "Unverarbeitet",
            pleaseSelectValidStatus: "Bitte wählen Sie einen gültigen Status aus.",
            ticketStatusBeenUpdatd: "Der Ticketstatus wurde aktualisiert.",
            doYouWantCloseTicket: "Möchten Sie das Ticket schließen?",
            ticketWillMarkedClosed: "Das Ticket wird als geschlossen markiert und archiviert.",
            errorUpdatingTicketFailed: "Beim Aktualisieren des Ticketstatus ist ein Fehler aufgetreten.",
            igCommentDeleteIgPost: "Der Instagram-Kommentar wurde aus Ihrem IG-Post gelöscht.",
            igCommentHideChange: "Der Status des Ausblendens von Instagram-Kommentaren wurde geändert.",
            pleaseChooseRepresent: "Bitte wählen Sie einen Vertreter aus.",
            selectedTicketSucsDelegated: "Ausgewählte Tickets wurden erfolgreich delegiert.",
            errorOccuredDuringDelegation: "Während des Delegierungsvorgangs ist ein Fehler aufgetreten.",
            bulkTicketClosing: "Massenhaftes Schließen von Tickets",
            sureWantCloseTicket: "Sind Sie sicher, dass Sie das Ticket schließen möchten?",
            selectedTicketSucsClosed: "Die ausgewählten Tickets wurden erfolgreich geschlossen.",
            thereErrorClosingTicket: "Beim Schließen von Tickets ist ein Fehler aufgetreten.",
            changeFilterTicketPage: "Ändern Sie die Filter auf der Seite 'Tickets'",
            nameOfFilter: "Name des Filters.",
            filterValue: "Wert des Filters",
            deletesSelectedTickets: "Löscht die ausgewählten Tickets",
            idTicketBeDelete:
                "Die IDs der zu löschenden Tickets (ausgewählte Ticket-IDs oder alle aufgelisteten Ticket-IDs)",
            assignsAgentSelectedTickets: "Weist einem Vertreter die ausgewählten Tickets zu",
            idTicketBeAssigned:
                "Die IDs der Tickets, die zugewiesen werden sollen (IDs der ausgewählten Tickets oder IDs aller aufgeführten Tickets)",
            idAgentAssigned: "ID des Vertreters, der zugewiesen werden soll",
            changesStatusSelectedTicket: "Ändert den Status der ausgewählten Tickets",
            idTicketWhoseStatus:
                "Die IDs der Tickets, deren Status geändert werden soll (IDs der ausgewählten Tickets oder IDs aller aufgeführten Tickets)",
            newStatus: "Neuer Status",
            selectedTicketsSucsUpdated: "Der Status der ausgewählten Tickets wurde erfolgreich aktualisiert.",
            errorWhileChangingStatus: "Beim Ändern des Status der Tickets ist ein Fehler aufgetreten.",
            thisPageVoiceAssistant: "Diese Seite hat einen Sprachassistenten",
            hello: "Hallo!",
            voiceAssistantContent: `Wusstest du, dass es einen <strong>KI-Assistenten</strong> gibt, der dir auf dieser Seite hilft?
                Du kannst die folgenden Methoden ausprobieren, um den Assistenten zu verwenden:`,
            commandHoldingDownTheKey:
                "Du kannst einen Befehl geben, indem du die Tastenkombination gedrückt hältst und sprichst.",
            topRightContent: "obere rechte Ecke",
            clickOnTheIcon: "Du kannst den Assistenten starten, indem du auf das Symbol klickst.",
            sampleVoiceCommands: "Beispiele für Sprachbefehle:",
            showMyTickets: "Zeige meine Tickets",
            showMeZeynepsOpenTicket: "Zeige Zeyneps offene Tickets für heute",
            deleteTicketsScreen: "Tickets auf dem Bildschirm löschen",
            assigntLastTicketAli: "Weisen Sie Ali das letzte Ticket zu",
            changeStatusAllTicket: "Ändere den Status aller Tickets auf erledigt",
            setStatusTicketsScreen: "Setze den Status der Tickets auf dem Bildschirm auf .......",
            assigntUserTicketScreen: "Weisen Sie die Tickets auf dem Bildschirm dem Benutzer ..... zu",
            assigntFirstTicket: "Weisen Sie mir das erste Ticket zu.",
            showIgTickets: "Zeige die Instagram-Tickets des letzten Monats.",
            makeChoice: "Auswahl treffen",
            makeAssignment: "Zuweisung vornehmen",
            tickets: "Fahrkarten",
            instagramTickets: "Instagram-Tickets",
            facebookTickets: "Facebook-Tickets",
            trendyolTickets: "Trendyol-Tickets",
            automationTickets: "Automatisierungs-Tickets",
            supsisFormTickets: "Supsis-Formular-Tickets",
            columnSettings: "Spalteneinstellungen",
            ticketField: "Ticket-Bereich",
            contactPropertyFields: "Erreichen von Eigentumsbereichen",
            ticketFilterList: {
                archivedRequests: "Archivierte Anfragen",
                comingFromFacebook: "Von Facebook kommend",
                comingFromInstagram: "Von İnstagram kommend",
                unassignedOpenRequests: "Nicht zugewiesene offene Anträge",
                openRequests: "Offene Anfragen",
                requestsOpenedThisWeek: "Diese Woche eröffnete Anfragen",
                specialList: "Besondere Liste",
                creationDate: "Datum der Erstellung",
                supsisFromTheForm: "Supsis From The Form",
                fromTrendyol: "Von Trendyol",
                comesWithAutomation: "Kommt von der Automatisierung",
                label: "Etikett",
                status: "Status",
                subject: "Thema",
                email: "E-Mail",
                name: "Name",
                phone: "Telefon",
                type: "Typ",
                assignedUser: "Zugewiesener Benutzer",
            },
            appointingRepresentative: "Ernennen Sie einen Vertreter",
            ticketTagFilter: "Ticketfilter -Tag",
            ticketEmails: "E-Mail-Liste zu direkter",
            save: "Speichern",
            delete: "Löschen",
            transactions: "Transaktionen",
            noEmailTicketNotifications: "TES Ticket Eposta Verwandte Registrierung COYPENTIENT",
            emailIsNotValid: "Die e-mail Adresse ist ungültig",
            emailNotificationDeleted: "Ticket -Routing -Datensatz gelöscht",
            emailNotificationDeleteError: "Ticket -Routing -Datensatz konnte nicht gelöscht werden !!",
            tagFilterRequired:
                "Ticket -Betrefffilter -Tag ist erforderlich. Sie können das * (Wildcard) -Tag für alle Tickets verwenden!",
            emailsRequired: "Mindestens 1 E -Mail -Adresse sollte für die Ticketausrichtung eingegeben werden",
            emailNotificationCreated: "Ticket -Routing -Datensatz erstellt",
            emailNotificationCreateError: "Ticket -Routing -Datensatz konnte nicht erstellt werden !!",
            ticketForwarding: "Ticket -E -Mail -Anleitung",
            ticketTagFilterDesc:
                "Um ein Ticket zu filtern, verwendet der Chatbot die Tickets, die Sie im Design verwenden. Sie können ein anderes Etikett schreiben und die Eingabetaste drücken und hinzufügen. Wenn Sie das Tag '*' auswählen, wählen Sie alle Tickets aus",
            ticketEmailsDesc:
                "Die E -Mail -Liste wird durch Tickets gerichtet. Sie können die Adressen der Vertreter im System hinzufügen, indem Sie die Adressen auswählen. Sie können auch nicht -System -E -Mail/s hinzufügen.",
            ticketList: "Ticket -Routing -Regeln",
            ticketTagFilterPlaceHolder: "Ticketfilter, für alle * auswählen *",
            ticketEmailsPlaceHolder: "Routing -E -Mail -Liste",
        },
        theme: {
            headerColor1: "Titel (links)",
            headerColor1A: "Titelteilfarbe/Transparenz",
            headerColor2: "Titel (rechts)",
            headerColor2A: "Titelteil 2. Farbe/Transparenz",
            backgroundColor: "Hintergrund (links)",
            backgroundColorA: "Hintergrund 1. Farbe/Transparenz",
            backgroundColor2: "Hintergrund (rechts)",
            backgroundColor2A: "Hintergrund 2. Farbe/Transparenz",
            opacity: "Transparenz",
            textColor: "Allgemeine Textfarbe",
            errorTheme: "Fehlerfarbe",
            bubbleBackground: "Repräsentative Ballonfarbe",
            bubbleVisitorBackground: "Kundenballonfarbe",
            bubbleBackgroundA: "Repräsentative Ballontransparenz",
            bubbleVisitorBackgroundA: "Kundenballontransparenz",
            bubbleText: "Repräsentative Sprachfarbe",
            bubbleVisitorText: "Kundensprachfarbe",
            textFormColor: "Farbe bilden",
            selectCustom: "Wählen Sie ein besonderes Thema",
            headerColorSecond: "Kopffarbe oben",
            headerColorFirst: "Farbe des Titelbodens",
            backgroundColorFirst: "Hintergrundfarbe oben",
            formColor: "Formulartextfarbe",
            buttonColor: "Knopffarbe",
            backgroundColorSecond: "Hintergrundfarbe unten",
            chatBotButtonText: "Chatbot-Schriftfarbe",
            chatBotButtonColor: "Farbe der Chatbot-Schaltfläche",
        },
        billing: {
            paymentId: "Zahlungs-ID",
            billType: "Rechnungstyp",
            invoiceId: "Rechnungs-ID",
            invoiceAmount: "Rechnungsbetrag",
            invoiceDate: "Rechnungsdatum",
            invoiceStatus: "Rechnungsstatus",
            invalidBill: "Ungültige Rechnung",
            invalidBillNotPossible:
                "Diese Rechnung wurde noch nicht erstellt, daher kann sie nicht als ungültig markiert werden.",
            myInvoices: "Meine Rechnungen",
            allInvoices: "Alle Rechnungen",
            manualInvoices: "Manuelle Rechnungen",
            endOfPeriodInvoices: "Ende des Zeitraums Rechnungen",
            purchaseInvoices: "Kauf Rechnungen",
            paidInvoices: "Bezahlte Rechnungen",
            unpaidInvoices: "Unbezahlte Rechnungen",
            walletDeposit: "Geldschein einzahlen",
            updateBillingInfo: "Rechnungsadresse aktualisieren",
            notFoundSavedBillingAddress: "Keine gespeicherte Rechnungsadresse gefunden",
            notFoundSavedCard: "Keine gespeicherte Karte gefunden",
            cardInfoIsStoredSecurelyByIyzico: "Kartendaten werden von Iyzico in einer sicheren Weise gespeichert.",
            paymentMethodAndInvoiceAddress: "Zahlungsmethode und Rechnungsadresse",
            unpaidInvoiceBannerMessage: "Sie haben eine unbezahlte Rechnung. Bitte zahlen Sie Ihre Rechnung, um eine Dienstunterbrechung zu vermeiden.",
            unpaidInvoiceBannerMessageWithDate: "Sie haben eine unbezahlte Rechnung. Wenn Sie nicht vor dem {date} zahlen, wird Ihr Konto gesperrt.",
            clickToPay: "Zur Zahlungsseite gehen",
            packageDescriptions: {
                whatsapp: "Integrieren Sie Ihr reguläres WhatsApp-Konto, um Kunden über alle Kanäle zu erreichen.",
                whatsappBusiness:
                    "Integrieren Sie Ihr WhatsApp Business-Konto, um Kunden über alle Kanäle zu erreichen.",
                supsis: "Mit mehr Vertretern können Sie Ihre Kunden schneller und effizienter betreuen.",
                chatbot: "Die Integration eines Chatbots ermöglicht es Ihnen, Ihre Kunden rund um die Uhr zu bedienen.",
                instagram: "Integrieren Sie Ihr Instagram-Konto, um Kunden über alle Kanäle zu erreichen.",
                telegram: "Integrieren Sie Ihr Telegram-Konto, um Kunden über alle Kanäle zu erreichen.",
                custom: "Wählen Sie einen unserer individuellen Pläne, um maßgeschneiderte Lösungen für Ihr Unternehmen zu erhalten.",
                messenger: "Integrieren Sie Ihr Messenger-Konto, um Kunden über alle Kanäle zu erreichen.",
                trendyol: "Integrieren Sie Ihr Trendyol-Konto, um Kundenanfragen schnell zu beantworten.",
                metaLead: "Integrieren Sie Ihr Meta Lead-Konto, um Leads direkt über das Dashboard zu verwalten.",
                customerTables:
                    "Erstellen Sie dynamische Tabellen, um Kundendaten, Bestellungen und mehr zu verwalten.",
                form: "Erstellen Sie Formulare, um Informationen von Ihren Kunden zu sammeln und zu analysieren.",
                automation:
                    "Richten Sie Automatisierungen ein, um Arbeitsprozesse zu optimieren und Ihren Service zu verbessern.",
                mail: "Die E-Mail-Integration ermöglicht Ihnen das Senden und Empfangen von E-Mails mit Ihren Kunden.",
                tasks: "Erstellen Sie Aufgaben, um Ihre Arbeitsabläufe zu planen und zu verwalten.",
                artificialIntelligence:
                    "Die Integration künstlicher Intelligenz hilft Ihnen, schneller und effizienter auf Kundenanfragen zu reagieren.",
                webhook: "Integrieren Sie Ihre Anwendungen mit Supsis über Webhooks.",
                default: "Entdecken Sie unsere Pakete für weitere Details.",
            },
            autoRenew: "Automatische Erneuerung",
            purchased: "Gekauft",
            currentPlans: "Meine Pläne",
            individual: "Einzelperson",
            expirationDate: "VD",
            yourNameSurname: "Ihr Vor- und Nachname",
            editCardInformation: "Kartendaten bearbeiten",
            billingContactInfo: "Rechnungskontaktinformationen erfolgreich aktualisiert.",
            defaultRootEmail: "Standard: Basis-E-Mail",
            invoiceEmailAddress: "Rechnungs-E-Mail-Adresse",
            invoiceSettings: "Einstellungen für Rechnungen",
            updateChannelDesc6: "Whatsapp Business Api-Kanal aktualisieren",
            newWabaChannel: "Neuer Whatsapp-Business-Kanal",
            newWabaChannelDesc: "Neuen Kanal für Whatsapp business api erstellen",
            popular: "Beliebt",
            selectedPlan: "Ausgewählter Plan",
            editPlan: "Plan bearbeiten",
            removePlan: "Plan entfernen",
            showPlan: "Plan anzeigen",
            hiddenPlan: "Plan ausblenden",
            contactSales: "Vertrieb kontaktieren",
            showLess: "Weniger anzeigen",
            more: "Mehr",
            selectTransactionType: "Transaktionstyp",
            walletLogs: "Wallet-Protokolle",
            addBalance: "Saldo hinzufügen",
            availableBalance: "Verfügbarer Saldo",
            appsumoPack: "Appsumo Pack",
            updatePlan: "Plan aktualisieren",
            createPlan: "Plan erstellen",
            freePack: "Kostenloses Paket",
            instantFee: "Es wird eine Sofortgebühr erhoben",
            planSequence: "Plansequenz",
            requiredCodes: "Anzahl der erforderlichen Codes",
            subHeading: "Unterüberschrift",
            featureKey: "Schlüssel des Merkmals",
            customerKey: "Kundenschlüssel",
            monthlyPrice: "Monatlicher Preis",
            monthlyNonDiscounted: "Monatlicher nicht rabattierter Preis (nicht-funktionale Anzeige)",
            twoYearDiscount: "2-Jahres-Rabatt",
            yearDisccount: "Jahresrabatt",
            sixMonthDiscount: "6 Monate",
            threeMonthDiscount: "3 Monate",
            features: "Eigenschaften",
            sessionCount: "Anzahl der Sitzungen",
            subType: "Abonnement-Typ",
            skipTrialVersion: "Testversion überspringen",
            skipTrialVersionDesc:
                "Sie können die Testversion überspringen und mit der Auswahl des entsprechenden Pakets für Ihr Unternehmen fortfahren. Wenn Sie die Testversion überspringen, kann diese Aktion nicht rückgängig gemacht werden.",
            skipStep: "Diesen Schritt überspringen",
            switchToPay: "Zum Bezahlen wechseln",
            forward: "Weiter",
            pleaseFillInCard: "Bitte geben Sie die Kartendaten ein!",
            fillInTheBillingAddress: "Bitte geben Sie die Rechnungsadresse ein!",
            cardNumberWrong: "Die Kartennummer ist falsch!",
            pleaseConfirmTheUser: "Bitte bestätigen Sie die Benutzervereinbarung.",
            pleaseCheckYourCard: "Bitte überprüfen Sie Ihre Karte und Ihre Angaben.",
            site: "Site",
            period: "Zeitraum",
            billStatus: "Rechnungsstatus",
            totalPrice: "Gesamtpreis + MwSt.",
            depotMoneyWallet: "Einzahlung auf das Wallet",
            threeMonthly: "Alle 3 Monate",
            sixMonthly: "Alle 6 Monate",
            twoYearly: "2 Jahre",
            forever: "Für immer",
            extraPackage: "Extra-Paket",
            teamPackage: "Team-Pakete",
            adventPackage: "Vorteilspakete",
            cupponError: "Der Gutscheincode ist falsch oder abgelaufen.",
            enterYourCard: "Bitte geben Sie Ihre Kreditkarte ein.",
            invalidCard: "Ungültige Kreditkarte, Zahlung nicht erhalten.",
            calculateThis: "Berechnen Sie für:",
            adventageousPackage: "Vorteilhafte Paketrabatte!",
            cuponApplied: "Coupon erfolgreich angewendet",
            subStart: "Abonnement initiiert",
            subSuccessStart: "Ihr Abonnement wurde erfolgreich gestartet.",
            success: "Erfolgreich",
            succesDesc: "Erfolgreich erstelltes Abonnement.",
            successDesc: "Ihre Funktion wurde erfolgreich aktiviert.",
            maxNumber: "Maximale Anzahl von Vertretern, die das Wort ergreifen",
            currentAmountDetails: "Details zum aktuellen Betrag",
            endOfMonthForecastDetails: "Details der Monatsendprognose",
            totalAmount: "Gesamtbetrag",
            vatAmount: "Mehrwertsteuer-Betrag (20%)",
            totalAmountIncludingVAT: "Gesamtbetrag einschließlich Mehrwertsteuer",
            hideDetails: "Details ausblenden",
            createInvoice: "Rechnung erstellen",
            reimbursementMade: "Erstattete Erstattung",
            invalidInvoice: "Ungültige Rechnung",
            balanceTopUp: "WhatsApp-Guthabenaufladung",
            paidSuccesfully: "Die Rechnung wurde erfolgreich bezahlt.",
            paymentFailed: "Der Zahlungsvorgang der Rechnung ist fehlgeschlagen.",
            areYouSurePaid: "Sind Sie sicher, dass Sie diese Rechnung als bezahlt markieren möchten?",
            invoiceMarkedPaid: "Die Rechnung wurde als bezahlt markiert.",
            invoiceMarkedFailed:
                "Es ist ein Fehler aufgetreten, und die Rechnung konnte nicht als bezahlt markiert werden.",
            areYouSoreRefundInvoice: "Sind Sie sicher, dass Sie eine Erstattung für diese Rechnung vornehmen möchten?",
            youMustFillInEmpty: "Sie müssen alle Leerstellen ausfüllen.",
            createdNewInvoice: "Eine neue Rechnung wurde erfolgreich erstellt.",
            createdNewInvoiceFailed: "Beim Erstellen der Rechnung ist ein Fehler aufgetreten.",
            invoiceUpdated: "Der Rechnungsbetrag wurde erfolgreich aktualisiert...",
            invoiceUpdatedFailed: "Beim Aktualisieren der Rechnung ist ein Problem aufgetreten.",
            plans: "Pläne",
            companyName: "Name des Unternehmens",
            compony: "Unternehmen",
            person: "Person",
            invoiceAddressInfo: "Informationen zur Rechnungsadresse",
            idNo: "Türkische ID",
            taxOffice: "Finanzamt",
            taxNumber: "Steuernummer",
            packageCanNotDownSupsis:
                "Ihr Paket kann nicht herabgestuft werden. Bitte entfernen oder deaktivieren Sie mehrere Ihrer Agenten, um Ihr Paket herabzustufen.",
            packageCanNotDownWp:
                "Ihr Paket kann nicht herabgestuft werden. Bitte löschen Sie mehrere Ihrer Whatsapp-Kanäle, um Ihr Paket herabzustufen.",
            packageCanNotDownWPBussiness:
                "Ihr Paket kann nicht herabgestuft werden. Bitte löschen Sie mehrere Ihrer Whatsapp-Geschäftskanäle, um Ihren Paketstatus herabzustufen.",
            chooseYourPlan: "Wählen Sie Ihren Plan.",
            numberOfRepresentatives: "Anzahl der Repräsentanten",
            numberOfChannels: "Anzahl der Kanäle",
            wpNumberOfChannels: "Anzahl der Whatsapp-Kanäle",
            igNumberOfChannels: "Anzahl der Instagram-Kanäle",
            msNumberOfChannels: "Anzahl der Messenger-Kanäle",
            cancelIt: "Abbrechen",
            activePlan: "Aktiver Plan",
            activate: "Aktivieren",
            noTransition: "Kein Übergang",
            daysLater: "Tage später",
            payBack: "Zurückzahlen",
            paid: "Bezahlt",
            unPaid: "Unbezahlt",
            editPrice: "Preis bearbeiten",
            payNow: "jetzt bezahlen",
            youAreCurrentlyOnTrial:
                "Sie befinden sich derzeit im Probebetrieb. Sie können die Probezeit jetzt überspringen, um exklusive Pakete zu sehen.",
            youAreCurrentlyLimited:
                "Sie sind derzeit vom System eingeschränkt, weil Ihre Pakete nicht den Bedingungen entsprechen.",
            youHaveOneRepresentative: "Sie haben einen Vertreter.",
            deactivateOrDeleteYourPiece:
                "Deaktivieren oder löschen Sie Ihren Piece Representative oder kaufen Sie einen Vertreter.",
            youHaveOneWhatsappQRChannel: "Sie haben einen Whatsapp-QR-Kanal.",
            deleteYourWhatsAppQR: "Löschen Sie Ihren Whatsapp-QR-Kanal oder kaufen Sie einen Kanal.",
            youHaveAWhatsappBusiness: "Sie haben einen Whatsapp Business-Kanal.",
            deleteYourWhatsapp: "Löschen Sie Ihren Whatsapp Business-Kanal oder kaufen Sie einen Kanal.",
            youHaveAnInstagram: "Sie haben einen Instagram-Kanal.",
            deleteYourInstagram: "Löschen Sie Ihren Instagram-Kanal oder kaufen Sie einen Kanal.",
            youHaveAMessenger: "Sie haben einen Messenger-Kanal.",
            deleteYourMessenger: "Löschen Sie Ihren Messenger-Kanal oder kaufen Sie einen Kanal.",
            additionalPackages: "Zusätzliche Pakete",
            availablePackages: "Verfügbare Pakete",
            buyNow: "Jetzt kaufen",
            invoiceInformation: "Rechnungsinformationen",
            invoiceAddress: "Rechnungsadresse",
            invoiceType: "Rechnungstyp",
            review: "Überprüfung",
            viewDetails: "Details anzeigen",
            addNewAddress: "Neue Adresse hinzufügen",
            enterYourBillingAddress: "Geben Sie Ihre Rechnungsadresse ein",
            selectPlan: "Plan auswählen",
            paymentStatus: "Zahlungsstatus",
            amount: "Betrag",
            invoiceID: "Rechnungs-ID",
            expected: "Erwartet..",
            currentAmount: "Aktueller Betrag",
            monthlyEstimatedAmount: "Monatlicher geschätzter Betrag",
            creationDate: "Erstellungsdatum",
            invoiceStatus: "Rechnungsstatus",
            invoicePeriod: "Rechnungszeitraum",
            newPaymentMethod: "Neue Zahlungsmethode",
            channelCount: "Kanalanzahl",
            remainingTime: "Verbleibende Zeit",
            chatbotLimit: "Chatbot-Limit",
            free: "Kostenlos",
            maxChatbotSession: "Maximale Chatbot-Sitzungen",
            buyIt: "Kaufen",
            renewalDate: "Verlängerungsdatum",
            monthly: "Monatlich",
            yearly: "Jährlich",
            packagePeriod: "Paketperiode",
            packageType: "Pakettyp",
            packageManagement: "Paketverwaltung",
            invoiceManagement: "Rechnungsmanagement",
            futureInvoice: "Zukünftige Rechnung",
            pastInvoices: "Vergangene Rechnungen",
            creditCard: "Kreditkarte",
            invoice: "Rechnung",
            mustBeUpgradePlanForChatBot: "Sie müssen zum Pro -Plan wechseln, um die Chatbot -Funktion zu aktivieren!",
            cardInfo: "Karteninformationen",
            billingDetails: "Rechnungs-Details",
            addCardIyzico:
                "Sie haben keine registrierte Karte. Sie müssen Karten hinzufügen, um Ihre monatlichen Gebührengebühren zu bezahlen.",
            billingPlanSettings: "Rechnungsmethode und Zahlungsmethode",
            paymentMethod: "Bezahlverfahren",
            billingDate: "Rechnungsdatum",
            isPaid: "Wird es bezahlt?",
            markPaid: "Als bezahlt festgelegt",
            paymentDate: "Zahlungsdatum",
            pay: "Die Rechnung bezahlen",
            newInvoice: "Rechnung erstellen",
            updateBilling: "Ändern Sie Ihre Rechnungsadresse",
            updateCard: "Ändern Sie Ihre Kreditkarte",
            paymentBilling: "Zahlungsmethode und Rechnungsadresse",
            price: "Rechnungsbetrag",
            billingAddress: "Offene Adresse",
            billingCity: "Stadt",
            billingCountry: "Land",
            contactName: "Rechnungsname",
            expireMonth: "Ende verwenden Sie T. Ay",
            expireYear: "Ablauf T. Jahr",
            expireDate: "Ablaufdatum",
            cardNumber: "Kartennummer",
            cardHolderName: "Nennen Sie den Nachnamen auf der Karte",
            cardAlias: "Kartenstopfenname",
            identityNumber: "ID/Steuernummer",
            name: "Name",
            surname: "Nachname",
            email: "Email",
            addCard: "Karte hinzufügen",
            update: "Aktualisieren",
            cancel: "aufgeben",
            save: "Speichern",
            saving: "Gerettet",
            noInvoiceFound: "Rechnungsaufzeichnung nicht gefunden",
            year: "Jahr",
            updating: "Aktualisierung",
            newInvoiceForm: "Neue Rechnung erstellen Form",
            error: "Fehler",
            transactions: "Transaktionen",
            paymentMethodAdded: "Zahlungsmethode erfolgreich hinzugefügt",
            paymentMethodAddError: "Die Zahlungsmethode konnte nicht hinzugefügt werden, ein Fehler trat auf",
            creditCardChanged: "Ihre Kreditkarte wurde geändert",
            errorOccurred: "Es gab einen Fehler, versuchen Sie es erneut.",
            billingDetailUpdated: "Ihre Rechnungsinformationen wurden aktualisiert",
            invoiceCreated: "Rechnungsregistrierungserfolg erstellt",
            paymentSuccess: "Ihre Rechnung wurde erfolgreich bezahlt, danke",
            paymentFail: "Wenn Ihre Rechnung bezahlt wird, trat der Fehler auf und versuchen Sie es erneut.",
            startWith: "{cardFamily} Karte beginnend mit {binNumber}",
            billingAddressChanged: "Rechnungsinformationen aktualisiert",
            hidePlan: "Den Plan verstecken",
            informationShopping:
                "Ihre Zahlungsinformationen, Rechnungsinformationen und Kreditkarteninformationen werden von Shopify überprüft.",
            trialTimeInformation:
                "{dayCount} hat die Testversion verlassen. Wenn Sie die Zahlungsmethode erst Ende dieses Zeitpunkts eingeben, wechselt das System automatisch zum freien Plan.",
            trialTimeInformationShort: "Last {dayCount} Tag",
            currentPlanLabel: "Aktueller Plan: {planName} Plan ({agentCount} Repräsentant)",
            changeCancelPlan: "Den Plan ändern/stornieren",
            oneAgent: "Vertreter",
            agent: "Vertreter",
            yourCurrentPlan: "Bestehender Plan",
            month: "Mond",
            billedMonthToMonth: "(Monatliche Abrechnung)",
            selectAgentCount: "Wählen Sie die Anzahl der Vertreter aus",
            selectFreePlan: "Wählen Sie kostenlosen Plan",
            planDetails: "Planen Sie Details",
            multiAgent: "(Sehr repräsentativ)",
            selectProPlan: "Wählen Sie den Pro -Plan",
            foreverFree: "Unbestimmt frei",
            websiteIntegration: "Website -Integration",
            websiteIntegrationUnlimited: "Website -Integration",
            ChatBotUnlimited: "Chatbot",
            videoCallUnlimited: "Videosuche",
            multiAgentUpTo: "Mehrere Vertreter ({agentCount} zu Repräsentant)",
            audioCallUnlimited: "Sprachanruf",
            screenSharingUnlimited: "Bildschirm teilen",
            fileTransferUnlimited: "Datenaustausch",
            autoChatAssignerUnlimited: "Automatische Chatzuweisung",
            multiLanguageTranslationUnlimited: "Automatischer Sprachwandler",
            detailedReporting: "Berichterstattung",
            days30TrialsAvailable: "30-tägige kostenlose Testversion",
            limitedArchiveLookupLastMo: "Limited Archivsuche (letztes {monatCount} -ay)",
            fullCustomizationUnlimited: "Anpassen",
            planUpdated: "Ihr Plan wurde erfolgreich aktualisiert.",
            planUpdating: "Ihr Plan aktualisiert ...",
            planUpdatingDescription: "Bitte warten Sie während des Update!",
            done: "Vollendet",
            freePlanUpdated: "Ihr Plan wurde als kostenloser Plan aktualisiert. (Maximale Anzahl von Vertretern: 1)",
            proPlanUpdated:
                "Ihr Plan wurde als Pro -Plan aktualisiert. (Maximale Anzahl von Vertretern: {proPlanUpdated})",
            canNotDwnGrade:
                "Ihr Plan kann nicht von PRO {agentCountFirst} Agents auf {valNewPlnToUppr} {agentCountSecond} heruntergestuft werden!. Ihre Agenten-Credits werden verwendet.",
            deleteWarning: "{valdif} Sie müssen den Vertreter löschen.",
            warnMessage: "Der ausgewählte Plan sollte sich vom aktuellen Plan unterscheiden",
            add: "Hinzufügen",
            cancelYourPlan: "Stornieren Sie Ihren Plan",
            upgradeYourPlan: "Aktualisieren Sie Ihren Plan",
            downgradeYourPlan: "Reduzieren Sie Ihren Plan",
            agree: "GIB ES ZU",
            disagree: "AUFGEBEN",
            invoices: "Rechnungen",
            priceIntervals: "Betragsbereich",
            selectSiteAlias: "Geben Sie den Site -Namen ein oder wählen Sie",
            selectPriceInterval: "Geben Sie den Betragbereich ein oder wählen Sie den Betragsbereich aus",
            isRefunded: "Wurde erstattet?",
            invoiceId: "Rechnungsnummer",
            siteId: "Standort Nr",
            createdDate: "Das Datum des Seins",
            failCount: "Fehlgeschlagener Schießversuch",
            failDate: "Zahlungsdatum, der nicht erfolgt ist",
            Dashboard: "Armaturenbrett",
            Agents: "Vertreter",
            Integration: "Integration",
            Settings: "Einstellungen",
            Contacts: "Links",
            Domain: "Domain",
            lastActivity: "Letzte Aktivität",
            basePrice: "Minimaler Preis",
            packagePrice: "Paketpreis",
            whatsappPrice: "WhatsApp -Preis",
            realtimeVisitorCount: "Sofortiger Besucher",
            suspend: "Verdächtig",
            partner: "Partner",
            plan: "Planen",
            trialDay: "Probetag",
            mobile: "Handy, Mobiltelefon",
            webSite: "Webseite",
            websiteOrigins: "Website -Quelle",
            ownerName: "Der Name des Besitzers",
            ownerEmailAddress: "Die E -Mail des Besitzers",
            discount: "Rabatt",
            daysLeft: "Der verbleibende Tag",
            newTrialPopUp: "Wie viele Tage wird die neue Testzeit sein",
            newWpPricePopUp: "Wie viel kostet die neue WhatsApp -Gebühr?",
            newIGPricePopUp: "Wie viel kostet die neue Instagram -Gebühr?",
            newBasePricePopUp: "Wie viel kostet der neue SUPSIS -Grundpreis?",
            siteInfoUpdated: "Standortinformationen aktualisiert",
            siteInfoNotUpdated: "Standortinformationen nicht aktualisiert",
            siteInfoNotUpdatedErr: "Ein Fehler ist aufgetreten! Site -Informationen wurden nicht aktualisiert.",
        },
        tour: {
            representativeTab: "Vertreter",
            stats: "Statistisches Panel",
            chats: "Chat -Panel",
            settings: "EINSTELLUNGEN",
            status: "SITUATION",
            prevStep: "Vorheriger Schritt",
            nextStep: "Nächster Schritt",
            finish: "Beende es",
            skip: "Springen",
            skip2: "Ich kenne das System, zeige nicht wieder",
            startTour: "Beginnen Sie die Tour",
            firstTimeIntro: "Ich entdeckte, dass es zum ersten Mal in das System eingegeben wurde.",
            hi: "Hallo",
            welcomeTo: "Willkommen bei Supsis Live Support",
            statsPanel:
                "Es ist die Statusleiste, die die gesamten aktiven Chat -Nummern zeigt, die sofort mit dem System warten.",
            sidebarMenu: "Speisekarte",
            sidebarMenuContent: "Hier können Sie Übergänge zwischen den Seiten durchführen.",
            representativePrivateMessage: "Konversationspanel zwischen Vertretern",
            representativePrivateMessageContent: "Hier sehen Sie spezielle Gespräche zwischen Vertretern.",
            helpMenu: "Hilfsmenü",
            helpMenuContent: "Hier finden Sie die Hilfeinformationen zum System.",
            settingsMenu: "Einstellungsmenü",
            settingsMenuContent:
                "Sie können die Schritte für Sprache, Nachtmodus und Bildschirmvergrößerung hier ausführen.",
            startChat: "Chat beginnen",
            profileMenu: "Profilmenü",
            profileMenuContent:
                "Sie können Ihren verfügbaren Status ändern und Ihre repräsentativen Einstellungen hier vornehmen.",
            visitorsTab: "Besucher",
            visitorsTabContent: "Hier können Sie Besucher sehen.",
            visitorTabHistory: "Besuchergeschichte",
            visitorTabHistoryContent: "Sie können die Besuchergeschichte hier sehen.",
            representativ_eTab: "Vertreter",
            representativeTabContent: "Sie können die Vertreter hier sehen.",
            liveSupport: "Live Support",
            liveSupportContent: "Sie können die Anzahl der Kunden sehen, die hier Live -Support erhalten.",
            siteVisitors: "Site -Besucher",
            siteVisitorsContent: "Sie können die Anzahl der Besucher hier sehen.",
            tableSettings: "Tisch Einstellungen",
            tableSettingsContent: "In der Tabelle können Sie hier eine Spalte anzeigen oder ausblenden.",
            watchModeButton: "Publikumsknopf",
            watchModeContent: "Sie können dem Publikum als Modus beitreten und zeigen nur, was geschrieben ist.",
            popoverInfo: "Besucherdetail",
            popoverInfoContent: "Gibt Informationen über den Besucher.",
            popoverButton: "Erweiterte Spracheinstellungen",
            popoverButtonContent:
                "Sie können ein Gespräch öffnen, eine direkte Nachricht an den Vertreter senden oder den Besucher blockieren.",
            openChat: "Sprachschaltfläche anschließen",
            openChatContent: "Sie können das Gespräch hier öffnen",
            pagination: "Paging -Menü.",
            paginationContent: "Sie können die Anzahl der Seiten hier erhöhen.",
            chatwindow: {
                chatWindowSettingsButtons: "Sprachfenstereinstellungen Schaltfläche",
                chatWindowActionButtons: "Sprachfenster allgemeiner Prozessschaltfläche",
                chatPanelActions: "Sprachpanel Verfahren",
                otherPanels: "Andere Panels",
                settingsButton: "Sie können Sprachblockierung, Anleitung, geheime Nachrichten und Vertretern zuweisen.",
                chatColorButton: "Sie können lernen, welche Farbe im Gespräch Ballons hier bedeutet",
                keyboardShortcutButton:
                    "Sie finden die Abkürzungen von Funktionen, die während der Korrespondenz oder anderer Funktionen, die Sie hier verwenden, Komfort bieten.",
                hideButton: "Es reduziert das offene Gespräch darunter weiterhin offen im Hintergrund",
                closeButton: "Beendet die offene Rede und geht ohne das Gespräch",
                ellipsisButton:
                    "Hier finden Sie weitere Vorgänge. Operationen wie das Senden von privaten Nachrichten, das Ziyaratci -Verbot, die repräsentative Ernennung finden Sie hier.",
                userInfoWidget: "Detaillierte Informationen zum Besucher werden hier enthalten sein",
                preparedContentWidget:
                    "Hier gibt es bereit -hergestellte Inhaltsvorlagen. Sie können schnell referenzierte Inhalte hinzufügen, indem Sie im Feld Schreibfeld auf die Verknüpfung klicken, indem Sie auf den Sprachbildschirm klicken.",
                chatHistoryWidget:
                    "Dies wird hier aufgeführt, wenn der Besucher frühere Gespräche führt. Sie können die alten Sprachdetails hier untersuchen",
                chatBarButton:
                    "Sie können hier aktive Gespräche verhindern, eine geheime Nachricht an den Vertreter senden und das Interview verlassen.",
            },
        },
        adminUser: {
            newAdminUserForm: "Neues Administratorregistrierungsformular",
            updateAdminUserForm: "Administrator -Benutzer -Aktualisierungsformular",
            adminUsers: "Administrator Benutzer",
            newAdminUser: "Neuer Administrator Benutzer",
            noAdminUser: "Es gibt noch keinen Administratorbenutzer.",
            adminUserName: "Administratorbenutzername",
        },
        report: {
            channel: "Kanal",
            channelType: "Kanaltyp",
            contactCount: "Anzahl der Kontakte",
            tag: "Tag",
            owner: "Besitzer",
            email: "E-Mail",
            language: "Sprache",
            approvalCount: "Anzahl der Genehmigungen",
            adTitle: "Anzeigentitel",
            sourceType: "Quelltyp",
            contactDistributions: "Kontaktverteilungen",
            mostUsedTag: "Meistgenutzter Tag",
            leastUsedTag: "Am wenigsten genutzter Tag",
            timeDistribution: "Kontaktverteilung nach Zeit",
            channelDistribution: "Kontaktverteilung nach Kanal",
            tagDistribution: "Kontaktverteilung nach Tags",
            platformDistribution: "Kontaktverteilung nach Plattform",
            ownerDistribution: "Kontaktverteilung nach Besitzer",
            languageDistribution: "Kontaktverteilung nach Sprache",
            adsDistribution: "Kontaktverteilung nach Werbung",
            contactPropertyDistribution: "Kontaktverteilung nach Kontakteigenschaften",
            totalPersonCount: "Gesamtanzahl der Kontakte",
            averagePersonCount: "Durchschnittliche Kontaktanzahl",
            personCount: "Kontaktanzahl",
            person: "Kontakt",
            mostEffectiveAd: "Effektivste Werbung",
            leastEffectiveAd: "Am wenigsten effektive Werbung",
            mostUsedChannel: "Meistgenutzter Kanal",
            leastUsedChannel: "Am wenigsten genutzter Kanal",
            columnChart: "Säulendiagramm",
            pieChart: "Kreisdiagramm",
            mostUsed: "Am meisten verwendet",
            leastUsed: "Am wenigsten verwendet",
            mostUsedLanguage: "Meistgenutzte Sprache",
            leastUsedLanguage: "Am wenigsten genutzte Sprache",
            mostAssigned: "Am häufigsten zugewiesen",
            leastAssigned: "Am wenigsten zugewiesen",
            mostUsedPlatform: "Meistgenutzte Plattform",
            leastUsedPlatform: "Am wenigsten genutzte Plattform",
            commentAnalysis: "Kommentaranalyse",
            whatsappChannelDistribution: "Chat-Verteilung nach WhatsApp-Kanälen",
            instagramChannelDistribution: "Chat-Verteilung nach Instagram-Kanälen",
            messengerChannelDistribution: "Chat-Verteilung nach Messenger-Kanälen",
            trendyolChannelDistribution: "Chat-Verteilung nach Trendyol-Kanälen",
            metaLeadsChannelDistribution: "Chat-Verteilung nach Meta Leads-Kanälen",
            chatDistributionByTelegramChannels: "Chat-Verteilung nach Telegram-Kanälen",
            chatDistributionByLinkedinChannels: "Chat-Verteilung nach Linkedin-Kanälen",
            channelTimeseries: "Kanal-Zeitverlauf",
            channelPies2: "Kanalverteilung",
            date: "Datum",
            incomingMessages: "Eingehende Nachrichten",
            outgoingMessages: "Ausgehende Nachrichten",
            customerCount: "Kundenzahl",
            mailCount: "Anzahl der Mails",
            answered: "Antwortet",
            unanswered: "Unbeantwortet",
            selectaChannel: "einen Kanal auswählen",
            sentMails: "Gesendete Mails",
            sentMailCount: "Anzahl der gesendeten Mails",
            eventCount: "Anzahl der Ereignisse",
            ticketDistribution: "Ticket-Verteilung",
            selectWorkflow: "Wählen Sie Ihren Workflow",
            distributionOfTasks: "Verteilung der Aufgaben",
            mostMissioned: "Meist bearbeitete Aufgabe",
            leastTask: "Am wenigsten bearbeitete Aufgaben",
            totalNumberTasks: "Gesamtzahl der Aufgaben",
            errorFetchingTask: "Fehler beim Empfangen von Aufgabendaten:",
            pipelinePhase: "Pipeline-Phase",
            status: "Status",
            numberOfTasks: "Anzahl der Aufgaben",
            insufficientData: "Nicht genügend Daten",
            hourly: "(Stündlich)",
            hourlyAverage: "Stündlicher Durchschnitt",
            hourlyMax: "Stündliches Maximum",
            hourlyMin: "Stündliches Minimum",
            totalAmount: "Gesamtbetrag",
            averageAmount: "Durchschnittsbetrag",
            minAmount: "Mindestbetrag",
            maxAmount: "Höchstbetrag",
            siteCount: "site Count",
            agentCount: "Agent Count",
            channelsTimeSeries: "Kanäle Zeitreihen",
            channelPies: "Kanal-Torten",
            pieView: "Kreisdiagramm",
            topVisitorCountry: "Top-Besucherland",
            websiteTrafficByCountry: "Website-Traffic nach Ländern",
            visitorCount: "Besucheranzahl",
            websiteVisitorTraffic: "Website-Besuchertraffic",
            websiteTraffic: "Website-Traffic",
            author: "Autor",
            topWorstComments: "Top Schlechteste Kommentare",
            topBestComments: "Top Beste Kommentare",
            topComments: "Top-Kommentare",
            noComment: "Noch keine Kommentare",
            minWaitingTime: "Minimale Wartezeit",
            maxWaitingTime: "Maximale Wartezeit",
            averageWaitTime: "Durchschnittliche Wartezeit",
            waitTime: "Wartezeit (Sekunden)",
            agentWaitDurationTitle: "Wartezeitdiagramm des Agents",
            incomingMessage: "Eingehende Nachricht(en)",
            outgoingMessage: "Ausgehende Nachricht(en)",
            totalSpent: "Gesamtausgaben",
            avgSpent: "Durchschnittsausgaben",
            totalPayment: "Gesamtzahlung",
            walletStatus: "Wallet-Status",
            walletBalanceStatus: "Wallet-Saldo-Status",
            messageTraffic: "Nachrichtenverkehr",
            breakCount: "Pausenanzahl",
            agentBreakTime: "Anzahl der Pausen der Agenten ☕",
            agentStatusHour: "Agentenstatus Stunde",
            agentWorkTimeCalendar: "Kalender für die Arbeitszeit des Agenten",
            agentActivity: "Aktivität des Agenten",
            noEnoughtData: "Nicht genug Daten",
            averageFirstResponse: "Durchschnittliche Erstantwortzeit",
            slowestResponser: "Langsamster Responder",
            fastestResponder: "Schnellster Responder",
            firstAnswerTimeSec: "Erstnachrichtenzeit (in Sekunden)",
            firstAnswerByAgent: "Erstnachrichtenzeit durch Agent",
            averageSolutionTime: "Durchschnittliche Lösungszeit",
            slowestSolver: "Langsamster Löser",
            fastestSolver: "Schnellster Löser",
            averageChat: "Durchschnittlicher Chat",
            leastChatReceiver: "Am wenigsten aktiver Chat-Empfänger",
            mostChatRecipients: "Meiste Chat-Empfänger",
            averageTicket: "Average Ticket",
            leastTicketReceiver: "Least Ticket Least",
            mostTicketRecipients: "Most Ticket Recipients",
            resolveTime: "Auflösungszeit (Min)",
            resolveTimeByUser: "Chat-Auflösungszeit nach Benutzer (in Minuten)",
            chatResolveTimeByAgent: "Chat-Auflösungszeit nach Agenten",
            chatDistByHandleType: "Chat-Verteilung nach Handler",
            chatDistByHandDesc: "Wie viele Chats wurden von Agenten, Chatbots und Hybrid bearbeitet?",
            chatCountsByHandleType: "Chatanzahl nach Bearbeitungstyp",
            missed: "Verpasst",
            chatDistByAnsDesc: "Wie viele Chats wurden beantwortet oder verpasst?",
            chatCountsByAns: "Chatanzahl nach Antwort",
            chatCountByPlatform: "Chatanzahl nach Plattform",
            chatDistByPDesc: "Wie viele Chats kamen auf welche Plattform?",
            chatDistByPlatform: "Chat-Verteilung nach Plattform",
            ticketCountByUser: "Anzahl der Tickets nach Agenten",
            ticketCountByStatus: "Anzahl der Tickets nach Antwortstatus",
            user: "Benutzer",
            saveAsImage: "Als Bild speichern",
            fullScreen: "Vollbild",
            download: "Herunterladen",
            tableView: "Tabellenansicht",
            chartView: "Diagrammansicht",
            chatDistByUsers: "Chat-Verteilung nach Benutzern",
            chatCountsByUsers: "Chatanzahl nach Benutzern",
            minDuration: "Mindestdauer",
            maxDuration: "Maximaldauer",
            totalDurationByAgent: "Gesamtdauer der Sitzung nach Agent",
            averageDurationByAgent: "Durchschnittliche Dauer der Sitzung nach Agent",
            totalDurationByCB: "Gesamtdauer der Sitzung nach Chatbot",
            averageDurationByCB: "Durchschnittliche Dauer der Sitzung nach Chatbot",
            viewUnitAs: "Einheit anzeigen als",
            hybrid: "Hybrid",
            handledBy: "Bearbeitet von",
            sessionDurationOverall: "Gesamte Sitzungsdauer",
            allChannels: "Alle Kanäle",
            sessionsDurationOverall: "Gesamtdauer der Sitzungen",
            sessionsOverall: "Gesamtsitzungen",
            calendarEvents: "Kalenderereignisse",
            reservationEvents: "Reservierungsereignisse",
            incomingMails: "Eingehende E-Mails",
            incomingMailCount: "Anzahl eingehender E-Mails",
            reservation: "Reservierung",
            event: "Veranstaltung",
            reservationEventCount: "Anzahl der Reservierungsereignisse",
            channelBreakdown: "Kanalübersicht",
            websiteAnalysis: "Website-Analyse",
            customerSatisfaction: "Kundenzufriedenheit",
            teamBreakAnalysis: "Team-Break-Analyse",
            dailyAgentActivity: "Tägliche Agentenaktivität",
            agentPerformance: "Agentenleistung",
            chatDistributions: "Chat-Verteilung",
            users: "Benutzer",
            segmentTimeseries: "Segment-Zeitreihe",
            segmentsOverall: "Gesamtsegmente",
            unmatchRatio: "Nichtübereinstimmungsverhältnis",
            totalMatchCount: "Gesamtanzahl der Übereinstimmungen",
            totalUnmatchCount: "Gesamtanzahl der Nichtübereinstimmungen",
            matchRatio: "Übereinstimmungsverhältnis",
            matched: "Übereinstimmend",
            trainingOverall: "Gesamtschulung",
            trainingStatusTimeseries: "Schulungsstatus-Zeitreihe",
            duration: "Dauer",
            totalSessionDuration: "Gesamtdauer der Sitzung",
            averageSessionDuration: "Durchschnittliche Sitzungsdauer",
            second: "Sekunde",
            minute: "Minute",
            hour: "Stunde",
            aggregateAs: "Aggregieren als",
            chatbotSessionDurationOverall: "Gesamtdauer der Chatbot-Sitzung",
            ratingTimeSeries: "Bewertungszeitreihe",
            chatCountTimeseries: "Chat-Zählzeitreihe",
            notRated: "Nicht bewertet",
            totalRatingCount: "Gesamtanzahl der Bewertungen",
            averageRating: "Durchschnittliche Bewertung",
            weightedAverageRating: "Gewichteter Durchschnitt der Bewertung",
            rate: "Bewerten",
            ratingOverall: "Kundenbewertungen insgesamt",
            session: "Sitzung",
            total: "Gesamt",
            average: "Durchschnitt",
            max: "Maximal",
            min: "Minimal",
            sessionCount: "Sitzungszähler",
            uniqueUsers: "Eindeutige Benutzer",
            viewAs: "Anzeigen als:",
            overall: "Insgesamt",
            detailReport: "Ausführlicher Bericht",
            dailyReports: "Tagesberichte",
            pointBasedReports: "Punktbasierte Berichte",
            personDateBasedPointReport: "Person und täglicher Punktbericht",
            personDateBasedReport: "Person und Tagesbericht",
            personBasedReport: "Personenbasierte Berichte",
            personAndDateBasedGraph: "Person und tägliche Grafik",
            noReport: "Kein Bericht",
            reports: "Berichte",
            totalBar: "Gesamt",
            ticketCount: "Ticket Count",
        },
        announcements: {
            menu: "Ankündigungen",
            newAnnouncementForm: "Neues Ankündigungsformular",
            updateAnnouncementForm: "Ankündigungs -Update -Formular",
        },
        stats: {
            total: "Die Anzahl der aktiven Gespräche im System.",
            active: "Es ist die Anzahl der aktiven Gespräche, die Ihnen gehören.",
            waiting: "Der Vertreter ist die Anzahl der neuen aktiven Reden, die darauf warten, ernannt zu werden.",
            late: "Es ist die Anzahl der neuen Reden, die für einen bestimmten Zeitraum verabschiedet wurden und darauf warten, zum Vertreter ernannt zu werden.",
            free: "Der Vertreter ist die Anzahl der Reden, die darauf warten, nach der Veröffentlichung einen neuen Vertreter zu ernennen.",
            pco: "[Personal Arbeitsverhältnis]: Dies ist die Belegungsrate der Anzahl der Reden, in denen die Online -Vertreter im System erhalten können.",
            maxCapacity:
                "Ist die maximale Anzahl von Chats, die das System einen Vertreter ernennen kann, ohne zu warten",
            chatbot: "Chatbots aktive Reden Nummer",
        },
        time: {
            lastYear: "Letztes Jahr",
            thisYear: "Dieses Jahr",
            last3Months: "Letzte 3 Monate",
            last7: "Letzte 7 Tage",
            today: "Heute",
            yesterday: "Gestern",
            lastWeek: "Letzte Woche",
            currentWeek: "Diese Woche",
            currentMonth: "Diesen Monat",
            lastMonth: "Im vergangenen Monat",
            last30Day: "Letzte 30 Tage",
            allTime: "Jederzeit",
            custom: "Eine andere Zeit",
        },
        fastWizard: {
            generalColors: "Allgemeine Farben",
            tellUsMore: "Geben Sie uns mehr Informationen, damit wir Ihre Erfahrungen personalisieren können",
            moreInfo: "Allgemeine Einstellungen",
            display: "Themen Einstellungen",
            availability: "Repräsentative Arbeitszeit",
            preview: "Vorschau",
            installCode: "Aufstellen",
            previous: "Vorheriger Schritt",
            setupSupsisLiveChat: "SUPSIS Live Fast Setting",
            continue: "Nächster Schritt",
            completeInitialize: "Führen Sie die schnelle Installation ab",
            completedMessage: "Supsis Live Quick Installation wurde erfolgreich durchgeführt.",
            websiteIntegration: "Adresse Ihrer Website für die Live -Integration von Supsis",
            customizeLiveChat: "Passen Sie Ihren Live -Chat an",
            createBrandedExperience: "Erstellen Sie ein Marken -Chat -Erlebnis für Ihre Besucher.",
            chatColor: "Chatfarbe",
            chooseChatColor: "Wähle eine Farbe.",
            chatBubble: "Chat -Ballon",
            selectBubble: "Wählen Sie einen Chat -Ballon",
            chatBubbleColor: "Chat -Ballonfarbe",
            selectChatBubbleColor: "Wählen Sie die Chat -Ballonfarbe",
            customSelection: "Besondere Wahl:",
            onlineSupportVisitorTime: "In welchen Zeitintervallen bieten Sie Ihren Besuchern an?",
            channelAvailability: "Zykluszeitpunkt",
            availability724: "7/24 kontinuierlicher Service",
            basedOnTeam: "Vertreter innerhalb der Arbeitszeiten",
            basedOnTeamExplanation:
                "Wenn es mindestens 1 Vertreter online gibt, erscheint der Chat online. Wenn es keinen Online -Vertreter gibt, erscheint es als offline",
            customHours: "Besondere Arbeitszeiten",
            customHoursExplanation: "Bestimmen Sie Ihre eigenen Arbeitszeiten",
            customHoursTimezone: "Regionale Zeitzone:",
            customHoursFrom: "Anfang:",
            customHoursTo: "Beenden:",
            customHoursAddHours: "+Uhr hinzufügen",
            previewDesktop: "Desktop",
            previewIpad: "Tablette",
            installationAndInstructions: "Installationsanleitung",
            installationTrackingCode: "Laden Sie die Tracking -Nummer auf Ihre Website hoch",
            installationTrackingCodePlease:
                "Bitte fügen Sie den Code gemäß den folgenden Anweisungen kurz vor dem Ende des {bodyTag} -Tags auf einer beliebigen Seite ein, die SUPSıs Live -Chat aktivieren möchten.",
            installationInstructionsJavascript:
                "Fügen Sie den oben genannten Integrationscode kurz vor dem Schließen im {bodyTag} -Label ein.",
            installationInstructionsShopify1: "1. Melden Sie sich bei Ihrem Shopify -Panel an",
            installationInstructionsCopy: "Kopieren",
            installationInstructionsCoppyMessage: "Integrationsbefehle an die Karte kopiert",
            installationInstructionsShopify2:
                "2. Gehen Sie zum Online -Shop> Themen> Aktionen im POP -UP -Menü unter dem aktuellen Thema> Code bearbeiten> thema.liquid",
            installationInstructionsShopify3:
                "3. Platzieren Sie den Integrationscode vor dem {bodyTag} -Label am Ende von Theme.liquid Skript.",
            installationInstructionsIdeaSoft1: "1. Melden Sie sich bei Ihrem Händlerpanel an.",
            installationInstructionsIdeaSoft2:
                "2. Einstellungen -> SEO -> Befolgen Sie den Schritt der Suchmaschinendienste.",
            installationInstructionsIdeaSoft3:
                "3. Platzieren Sie den oben angegebenen Integrationscode direkt vor dem {bodyTag} Tag am Ende des theme.liquid-Skripts.",
            installationInstructionsIdeaSoft4:
                "4. Kopieren Sie den oben genannten Integrationscode in das geöffnete Feld.",
            installationInstructionsIdeaSoft5:
                '5. Einstellungen -> Optimierungen -> Drücken Sie die Taste "Davtur". Die Integration wurde abgeschlossen.',
            installationInstructionsWordPress1: "1. Melden Sie sich in Ihrem WordPress Admin -Bereich an",
            installationInstructionsWordPress2: "2. anzeigen> gehen zum Thema redaktionell",
            installationInstructionsWordPress3:
                "3. Suchen und wählen Sie den Footprint (footer.php) unter den Themendateien (rechts) (rechts).",
            installationInstructionsWordPress4:
                "4. Fügen Sie den obigen Integrationscode vor dem {bodyTag} -Tag unten ein.",
            installationInstructionsWordPress5:
                "5. Aktualisieren Sie die Datei, um Änderungen zu speichern. Klicken Sie auf",
            installationInstructionsOpenCart1: "1. Melden Sie sich in Ihrem OpenCart -Administratorfeld an",
            installationInstructionsOpenCart2: "2. Design> Gehen Sie zu Tema Editorial",
            installationInstructionsOpenCart3:
                '3. Wählen Sie den Ordner "Common" aus und öffnen Sie die Datei "Header.twig" darin.',
            installationInstructionsOpenCart4:
                "4. Fügen Sie den obigen Integrationscode vor dem {headtag} -Tag unten ein.",
            installationInstructionsOpenCart5: "5. Klicken Sie auf die Schaltfläche Speichern",
            installationInstructionsTicimax1: "1. Melden Sie sich in Ihrem Ticimax -Management -Panel an",
            installationInstructionsTicimax2: "2. Design> Konstruktionseinstellungen> Headerfußzeile Design Open",
            installationInstructionsTicimax3: "3. Klicken Sie im Abschnitt Logo -Design auf 'Source'Buton.",
            installationInstructionsTicimax4: "4. Fügen Sie den obigen Integrationscode unter den HTML -Code ein.",
            installationInstructionsEticaretteyim1: "1. Melden Sie sich bei Ihrem E-Commerce-Administrationsbereich an",
            installationInstructionsEticaretteyim2:
                "2. Benennen Sie einfach SUPSIS aus Plugins > HTML generieren > und kopieren Sie den Code.",
            installationInstructions: "Anweisungen",
            installationVerify: "Überprüfen Sie die SUPSIS -Installation Ihrer Website",
            installationVerifyChecking: "Kontrolliert",
            installationVerifyCheck: "prüfen Sie",
            installationVerifyCheckingStatus: "Der SUPSIS -Integrationsstatus von {website} prüft",
            installationCheckingStatusMessageYes: "SUPSıs Live wurde in {website} integriert.",
            installationCheckingStatusMessageNo:
                "SUPSIS ist derzeit nicht mit der Website {website} integriert. Sie können Ihren Integrationsprozess jetzt oder später abschließen.",
            vtippyPreferredLanguage: "Bevorzugte Sprache",
        },
        akinon: {
            typeOrSelectSKU: "Schreiben oder wählen Sie SKU",
            akinonUserId: "Akinon User ID",
            userEmail: "Benutzer Email",
            userEmailDesc: "Schreiben oder wählen Sie die Benutzer -E -Mail ...",
            send: "Schicken",
            selectCity: "Wählen Sie den Distrikt",
            city: "Bezirk",
            selectState: "Wählen Sie Ihre Provinz",
            state: "Provinz",
            useMap: "Verwenden Sie die Karte",
            chooseAddress: "Adresse auswählen",
            selectCountry: "Land auswählen",
            country: "Land",
            productIdDesc: "Schreiben oder wählen Sie das Produkt ...",
            productId: "Produkt ID",
            userIdDesc: "Schreiben Sie die Akinon -Benutzer -ID ...",
            productSKU: "Produkt SKU",
            latitudeDesc: "Schreiben oder wählen Sie den Zielort der Zielort ...",
            longitudeDesc: "Schreiben oder wählen Sie die Länge der Zielposition ...",
            orderNumber: "Ihre Auftragsnummer",
            orderDesc: "Schreiben Sie die Bestellnummer ...",
            longitude: "Längengrad",
            latitude: "Breite",
        },
        probel: {
            branchCode: "Branchencode",
            branchCodeDesc: "Schreiben oder wählen Sie den Zweig -Code ...",
            hospitalBranchCode: "Branchencode",
            hospitalBranchCodeDesc: "Schreiben oder wählen Sie den Zweig -Code ...",
            clinicCode: "Polyclinic Code",
            clinicCodeDesc: "Schreiben oder wählen Sie den Polyclinic Code ...",
            date: "Termin",
            dateDesc: "Geben Sie das Datum des Termins ein oder wählen Sie ...",
            patientToken: "Patient Token",
            patientTokenDesc: "Schreiben oder wählen Sie das Patient -Token ...",
            appointmentId: "Termin -ID",
            appointmentIdDesc: "Schreiben oder wählen Sie die Termin -ID ...",
            identityType: "Identitätstyp",
            identityNumber: "Identifikationsnummer",
            name: "Patientenname",
            surname: "Nachname des Patienten",
            gender: "Kranker Sex",
            birthDay: "Patientendatum der Geburtsdatum",
            phoneNumber: "Patientennummer",
            identityTypeDesc: "Schreiben oder wählen Sie die Art der Identität ...",
            identityNumberDesc: "Schreiben oder wählen Sie die ID -Nummer ...",
            nameDesc: "Schreiben oder wählen Sie den Patientennamen ...",
            surnameDesc: "Schreiben oder wählen Sie den Nachnamen des Patienten ...",
            genderDesc: "Schreiben oder wählen Sie Patientensex ...",
            birthDayDesc: "Schreiben oder wählen Sie das Geburtsdatum ...",
            phoneNumberDesc: "Geben Sie die Patientennummer ein oder wählen Sie die Patientennummer ...",
        },
        headBar: {
            source: "Quelle",
            label: "Etikett",
            completed: "Abgeschlossen?",
            email: "Email",
            phone: "Telefon",
            name: "Name",
            date: "Geschichte",
            subject: "Thema",
            situation: "Situation",
            representative: "Vertreter",
            transactions: "Transaktionen",
            channel: "Kontaktkanal",
        },
        login: {
            loginTitle1: "Willkommen bei",
            loginTitle2: "Supsis AI",
            email: "Deine E-Mail Adresse",
            emailPlaceholder: "Geben Sie bitte Ihre Email-Adresse ein.",
            emailError: "Bitte eine gültige E-Mail-Adresse eintragen",
            password: "Ihr Passwort",
            passwordLogin: "Passwortfreies Login",
            passwordAndLogin: "Login mit Passwort",
            passwordNew: "Setze mein Passwort zurück",
            loginAnd: "Oder",
            passwordPlaceholder: "Bitte geben Sie Ihr Passwort ein.",
            loginMemory: "erinnern Sie sich an dieses Gerät",
            passwordForget: "Ich habe mein Passwort vergessen",
            passwordNewAgain: "Neues Kennwort",
            passwordNewAgainTwo: "Neues Passwort wiederholen",
            passwordNewAgainPlaceholder: "Bitte geben Sie Ihr neues Passwort ein.",
            passwordNewAgainPlaceholderTwo: "Bitte geben Sie Ihr neues Passwort erneut ein.",
            login: "Anmeldung",
            loginFooter: "Oder melden Sie sich mit E-Mail an",
            emailLogin: "Melden Sie sich mit E-Mail an",
            welcomeTitle: "Willkommen",
            welcomeMorning: "Guten Morgen",
            welcomeAfternoon: "Guten Tag",
            welcomeEvening: "Guten Abend",
            welcomeNight: "Gute Nacht",
        },
        settings: {
            loadMore: "Mehr laden...",
            detectIpAddress: "Meine IP-Adresse erkennen",
            addWighteListAddress: "IP-Adresse zur Whitelist hinzufügen",
            accessControlSubTitles:
                "Die Zugangskontrolle bietet eine zusätzliche Sicherheitsebene, die nur autorisierten IPs den Systemzugriff ermöglicht",
            companyInformation: "Unternehmensinformationen",
            ipAddress: "Meine IP-Adresse",
            whiteList: "Sichere IP-Liste",
            whiteListAdd: "Zugangskontrolle hinzufügen",
            whiteListDeletedSuccessfully: "Zugangskontrolle erfolgreich gelöscht",
            whiteListDeletedFailed: "Zugangskontrolle nicht gelöscht",
            whiteListAddedSuccessfully: "Zugangskontrolle erfolgreich hinzugefügt",
            whiteListAddedFailed: "Zugangskontrolle nicht hinzugefügt",
            deleteWhiteListTitle: "Sind Sie sicher, dass Sie diesen Whitelist löschen möchten?",
            talkSettings: "Spracheinstellungen",
            talkSubtitles: "Verwalten Ihrer Spracheinstellungen",
            changeSettings: "Einstellungen für die automatische Chat-Zuweisung ändern",
            dateAndTime: "Datum und Uhrzeit",
            actor: "Akteur",
            event: "Ereignis",
            accessControl: "Zugangskontrolle",
            organizationLongName: "Langer Name der Organisation",
            visitorNewDesc: "Sie können die neue Version des Besucherthemas verwenden.",
            transactionType: "Transaktionsart",
            priorBalance: "Vorheriger Saldo",
            nextBalance: "Nächster Saldo",
            amount: "Betrag",
            phoneNumber: "Telefonnummer",
            profileInfoRemoved: "Profilinformationen entfernt",
            newValueUpdated: "Neuer Wert aktualisiert.",
            balanceToTransferred: "Zu übertragendes Guthaben",
            availableBalance: "Verfügbarer Saldo",
            balanceReceived: "Empfangener Saldo",
            totalBalance: "Gesamtsaldo",
            paymentCard: "Zahlungskarte",
            wpPhoneNumber: "Whatsapp-Telefonnummer",
            wpSendingMessage: "Whatsapp sendet erste Nachricht",
            auditlogs: "Prüfprotokolle",
            myaccount: "Mein Konto",
            notifications: "Benachrichtigungen",
            company: "Firma",
            features: "Eigenschaften",
            general: "Allgemeines",
            chat: "Plaudern",
            wallet: "Brieftasche",
            timings: "Zeitmessung",
            language: "Sprache",
            "bubble-settings": "Blaseneinstellungen",
            "bubble-actions": "Blasenaktionen",
            "theme-settings": "Thema Einstellungen",
            visitorLoginForm: "Besucher Login Formular",
            visitorAttribute: "Informationen zum Besucherprofil",
            timing_settings: "Chat Timing Einstellungen",
            auto_assign: "Auto Assign",
            availability: "Verfügbarkeit",
            "website-integration": "Website Integration",
            General: "Allgemeines",
            Chat: "Plaudern",
            Timings: "Zeitmessung",
            Integration: "Integration",
            developer: "Entwickler",
            visitorNew: "Neuer Besucher",
            companySubtitles: "Verwalten Sie Ihre Unternehmensinformationen.",
            featuresSubtitles: "Verwalten Sie Ihre Funktionen.",
            languageSubtitles: "Legen Sie die bevorzugte Sprache und Zeitzone Ihres Unternehmens fest.",
            bubbleSettings: "Blaseneinstellungen",
            bubbleSettingsSubtitles: "Verwalten Sie Ihre Blaseneinstellungen.",
            bubbleActionsSubtitles: "Verwalten Sie Ihre Blasenaktionen.",
            chatThemeSettingsSubtitles: "Verwalten Sie Ihre Chat -Thema -Einstellungen.",
            visitorLoginFormSubtitles: "Verwalten Sie Ihre Besucher -Login -Formular -Einstellungen.",
            chatTimingSettingsSubtitles: "Verwalten Sie Ihre Chat -Timing -Einstellungen.",
            webSiteIntegrationSubtitles: "Verwalten Sie Ihre Website -Integration.",
            apiAccessTitle: "API Zugriff",
            apiAccessSubtitles: "Verwalten Sie Ihre API -Zugriff.",
            youTubeActionForm: "Fügen Sie Ihren YouTube -Kanal hinzu",
            linkedinActionForm: "Fügen Sie Ihr LinkedIn-Konto hinzu",
            telegramActionForm: "Telegram-Konto hinzufügen",
            facebookActionForm: "Fügen Sie Ihre Facebook -Seite hinzu",
            tiwitterActionForm: "Fügen Sie Ihren Twitter -Kanal hinzu",
            instagramActionForm: "Fügen Sie Ihren Instagram -Kanal hinzu",
            liveSupportDescription: "Aktivieren Sie den Live -Support -Modus, um Ihre Besucher zu unterstützen.",
            ticketDescription: "Aktivieren Sie den Ticket -Modus, um Ihre Besucher zu unterstützen.",
            whatsappDescription: "Aktivieren Sie den Whatsapp -Modus, um Ihre Besucher zu unterstützen.",
            phoneDescription: "Aktivieren Sie den Telefon -Modus, um Ihre Besucher zu unterstützen.",
            emailDescription: "Aktivieren Sie den E-Mail -Modus, um Ihre Besucher zu unterstützen.",
            facebookDescription: "Aktivieren Sie den Facebook -Modus, um Ihre Besucher zu unterstützen.",
            twitterDescription: "Aktivieren Sie den Twitter -Modus, um Ihre Besucher zu unterstützen.",
            instagramDescription: "Aktivieren Sie den Instagram -Modus, um Ihre Besucher zu unterstützen.",
            youtubeDescription: "Aktivieren Sie den Youtube -Modus, um Ihre Besucher zu unterstützen.",
            linkedinDescription: "Ermöglichen Sie Ihren Kunden, Sie mit LinkedIn zu erreichen",
            telegramDescription: "Lassen Sie Ihre Kunden mit Telegram an Größe gewinnen",
            whatsappModalTitle: "WhatsApp-Transaktionsformular",
            whatsappModalDescription: "Bitte füllen Sie das Formular unten aus, um Ihr WhatsApp-Konto zu verbinden.",
            phoneModalTitle: "Telefontransaktionsformular",
            phoneModalDescription: "Bitte füllen Sie das Formular unten aus, um Ihr Telefonkonto zu verbinden.",
            emailModalTitle: "E-Mail Transaktionsformular",
            emailModalDescription: "Bitte füllen Sie das Formular unten aus, um Ihr E-Mail-Konto zu verbinden.",
            facebookModalTitle: "Facebook Transaktionsformular",
            facebookModalDescription: "Bitte füllen Sie das Formular unten aus, um Ihr Facebook-Konto zu verbinden.",
            twitterModalTitle: "Twitter-Transaktionsformular",
            twitterModalDescription:
                "Bitte füllen Sie das untenstehende Formular aus, um Ihr Twitter-Konto zu verbinden.",
            instagramModalTitle: "Instagram-Transaktionsformular",
            instagramModalDescription: "Bitte füllen Sie das Formular unten aus, um Ihr Instagram-Konto zu verbinden.",
            youtubeModalTitle: "Youtube Transaktionsformular",
            youtubeModalDescription: "Bitte füllen Sie das Formular unten aus, um Ihr Youtube-Konto zu verbinden.",
            linkedinModalTitle: "LinkeIn-Transaktionsformular",
            linkedinModalDescription:
                "Bitte füllen Sie das untenstehende Formular aus, um Ihr LinkedIn-Konto zu verknüpfen.",
            telegramModalTitle: "Telegram-Transaktionsformular",
            telegramModalDescription:
                "Geben Sie Ihren Telegram-Profillink in das untenstehende Formular ein, um Ihr Telegram-Konto zu verknüpfen",
            instagramAlertTitle: "Instagram-Integration erforderlich",
            instagramAlertDesc:
                "Entschuldigung, die von Ihnen besuchte Seite wird aktiviert, wenn Sie Ihr Instagram integrieren.",
            instagramActivateText: "Los geht's, integriere Instagram",
            remove: "Entfernen",
            edit: "Bearbeiten",
            connected: "Verbunden",
            add: "Hinzufügen",
            themeDescription: "Wählen Sie ein Thema für Ihren Chat aus.",
            fontDescription: "Wählen Sie eine Schriftart für Ihren Chat aus.",
            isFabsAsIcon: "Menüsymboltexte anzeigen.",
            chatBubbleTextSetting: "Chat-Blasentext-Einstellung",
            textOnChatBubble: "Sie können die Texteinstellungen anpassen, die in der Chat-Blase angezeigt werden.",
            textToAppearOnChatBubble: "Text, der in der Chat-Blase angezeigt wird",
            newVisitorProfileInformation: "Neue Besucherprofilinformationen",
            newVisitorProfileInformationDescription: "Fügt den Besucherprofilinformationen einen neuen Wert hinzu",
            create: "Erstellen",
            newAdd: "Neue hinzufügen",
            toInform: "Informieren",
            toInformDescription:
                "Sie können die Werte, die Sie auf dieser Seite hinzufügen, mit dem Besucher-Anmeldeformular abgleichen.",
            showVisitor: "Besucher anzeigen",
            label: "Fahrkarte",
            text: "Schreiben",
            email: "Email",
            phone: "Telefon",
            number: "Nummer",
            url: "URL",
            date: "Zeit",
            dropdown: "wählbar",
            languageTimeZone: "Sprache und Region",
            timeZoneTitle: "Region und Zeitzone",
            timeZoneDescription: "Regions- und Zeitzoneneinstellungen",
        },
        userInfoWidget: {
            zohoInfo: "Zoho-Informationen",
            messageSearch: "Nachricht suchen",
            userInformation: "Nutzerinformation",
            fullName: "Name und Nachname",
            newValue: "Neuer Wert",
            newProfileInfo: "Neue Profilinformationen",
            affiliatedRepresentatives: "Vertreter",
            preferredAgents: "Bevorzugter Agent",
            labels: "Etiketten",
            agentNotes: "Agentennotizen",
            newNote: "Neue Notiz",
            note: "Notiz",
            available: "Es sind Notizen vorhanden.",
            systemInformation: "System Information",
            speechID: "Sprach-ID",
            customerVersion: "Kundenversion",
            IPAddress: "IP Adresse",
            pageVisited: "Seite besucht",
            systemAndBrowser: "Betriebssystem und Browser",
            countryAndLanguage: "Land und Sprache",
            clickToEdit: "Bearbeiten Klicken Sie in den Beitrag",
            adsYouAreInterestedIn: "Anzeigen, an denen Sie interessiert sind",
            detail: "Detail",
            adsTitle: "Titel",
            adUrl: "Anzeigen-URL",
            sourceID: "Quell-ID",
            resourceType: "Ressourcentyp",
            adsBody: "Inhalt",
            adsCreateDate: "Erstellungsdatum",
            adsUpdateDate: "Aktualisierungsdatum",
        },
        newWizartV2: {
            generalSettings: "Allgemeine Einstellungen",
            themeSettings: "Themen Einstellungen",
            representativeWorkingHours: "Repräsentative Arbeitszeiten",
            preview: "Repräsentative Arbeitszeiten",
            setup: "Aufstellen",
            formStepTitle: "Geben Sie uns weitere Informationen, damit wir Ihr Erlebnis individuell gestalten können",
            supsisEntergation: "Wo werden Sie Supsis auf Ihrer Website verwenden?:",
            goToNextStep: "Machen Sie den nächsten Schritt",
            readytemplate: "Verwenden Sie eine fertige Farbvorlage",
            customSettings: "Benutzerdefinierte Einstellungen",
            customerMessageView: "Kundennachrichtenansicht",
            backcgroundColor: "Hintergrundfarbe",
            textColor: "Schriftfarbe",
            agentMessageView: "Agentennachrichtenansicht",
            workingHours: "In welchen Zeitabständen bieten Sie Ihren Besuchern Dienstleistungen an?",
            continuousService: "Kontinuierlicher Service",
            continuousServiceDescription: "Die Chat-Blase ist immer aktiv. Auch wenn Sie nicht im System sind.",
            vote: "Treffen Sie Ihre Wahl",
            representativeWorking: "Repräsentative Arbeitszeiten",
            representativeWorkingDescription:
                "Der Chat erscheint online, wenn mindestens 1 Agent online ist. Wenn kein Online-Vertreter vorhanden ist, wird er als offline angezeigt.",
            computer: "Computer",
            tablet: "Tablette",
            uploadTrackingCodeToYourWebsite: "Laden Sie den Tracking-Code auf Ihre Website hoch",
            password: "Neues Passwort festlegen",
        },
        whatsappChannel: {
            whatsappTitleV1: "Whatsapp V1 Kanäle (QR)",
            whatsappTitleV2: "Whatsapp V2 Kanäle (QR)",
            channelName: "Channel",
            phoneNumber: "Telefonnummer",
            forwardToChatbot: "An Chatbot weiterleiten",
            forwardingChatbotOrLiveAgent: "Weiterleitung (Chatbot oder Live-Agent)",
            addChannel: "Kanal hinzufügen",
            newWhatsappChannel: "Neuer WhatsApp-Kanal",
            newWhatsappChannelDescription: "Erstellen Sie einen neuen WhatsApp-Kanal, indem Sie den QR-Code scannen",
            editWhatsappChannel: "WhatsApp-Kanal bearbeiten",
            editWhatsappChannelDescription: "WhatsApp-Kanal bearbeiten",
            whatsappChannel: "WhatsApp-Kanal",
            deleteWhatsappChannelDescription: "Sind Sie sicher, dass Sie diesen Kanal löschen möchten?",
            whatsappIntegration: "WhatsApp-Integration",
            deleteChannel: "Kanal löschen",
            restartChannel: "Kanal neu starten",
            wantRestartChannel: "Möchten Sie den Kanal neu starten?",
            deleteSMSChannelDescription: "Sind Sie sicher, dass Sie den SMS-Kanal löschen möchten?",
            smsChannel: "SMS-Kanal",
            maxChannelCount: "Sie können nicht mehr als einen SMS-Kanal erstellen!",
            smsModalText:
                "Unsere Integration mit modernen Kommunikationslösungen bietet Ihnen die Möglichkeit, SMS einfach und effektiv zu versenden. Beseitigen Sie Grenzen in der Kommunikation, treten Sie direkt mit Ihren Kunden in Kontakt!",
            smsModalBtn: "Klicken Sie hier, um den SMS-Kanal zu öffnen...",
            postaCellDetail: "PostaCell-Kanaldetails",
        },
        noPermission: "Sie haben keine Berechtigung, diese Aktion auszuführen.",
        mail_integration_detail: {
            title: "E-Mail-Detail",
            integration: "Integration",
            sender: "Absender-E-Mail",
            signature: "Unterschrift",
            inbox: "Posteingang",
            medias: "Medien",
            visibility: "Sichtbarkeit",
            settings_group: "Einstellungen",
            contacts: "Kontakte",
        },
        whatsapp_business_api: {
            userVisibility: "Benutzer-Sichtbarkeit",
            userVisibilityDesc:
                "Die Kanäle, auf die Benutzer zugreifen können, hängen von ihrer Rolle und den Sichtbarkeitseinstellungen des Kanals ab. Benutzer mit der Rolle Full Admin oder root können alle Channels sehen. Wenn die Sichtbarkeitseinstellungen eines Channels leer sind, ist der Channel öffentlich. Wenn der Channel jedoch für bestimmte Benutzer oder Abteilungen definiert ist, können nur diese Benutzer oder Abteilungsmitglieder den Channel sehen.",
            searchTemplate: "Suchvorlage...",
            forwardToChatbot: "Weiterleitung an Chatbot",
            forwarding: "Weiterleitung (Chatbot oder Live-Agent)",
            forwardLiveAgents: "👉 Weiterleitung an Live-Support",
            forwardingToDepartment: "Weiterleitung an Abteilung",
            selectDepartment: "Abteilung auswählen",
            createWbChannel:
                "Um einen Whatsapp Business-Kanal zu erstellen, müssen Sie ein Whatsapp Business-Paket erwerben. Sie können sofort auf günstige Pakete zugreifen.",
            wbCreateChannelMax:
                "Sie haben das Limit für die Erstellung von Whatsapp Business-Kanälen erreicht. Maximun",
            wbContinue:
                "Sie können einen Whatsapp Business Channel erstellen. Um fortzufahren, aktualisieren Sie Ihr Paket oder löschen Sie einige Ihrer Whatsapp Business Channels.",
            chatInitiatorTemplate: "Chatinitiator-Vorlage",
            selectChatInitiatorTemplate: "Wählen Sie Ihre Chatinitiator-Vorlage aus.",
            dailyUsageReport: "Täglicher Nutzungsbericht",
            freeChat: "Kostenloser Chat",
            paidChat: "Bezahlter Chat",
            templateMessage: "Vorlage Nachricht",
            outgoingSession: "Ausgehende Sitzung",
            incomingSession: "Kommende Sitzung",
            totalCost: "Gesamtkosten",
            allOptNumbers: "Alle Opt-in-Nummern",
            startChat: "Chat starten",
            lastMessageDate: "Datum der letzten Nachricht",
            sureDeleteTemplate: "Sind Sie sicher, dass Sie diese Vorlage löschen wollen?",
            manageWhoChannelChat: "Verwalten, wer diese Channel-Chats sehen kann",
            profileImageDesc: "This will be a WhatsApp screenshot of your business",
            businessDescription: "Business Description",
            descOfWork: "Description of your business in a few words (maximum 512 characters)",
            accountStatus: "Account Status",
            dockerStatus: "Docker Status",
            phoneQuality: "Phone Quality",
            customersOrDay: "Customers/Day",
            messagingLimit: "Messaging Limit",
            canSendMessage: "Message Can Be Sent",
            officialDetails: "Official Details",
            officialDetailsDesc:
                "These addresses will always be shown in the profile section to users who chat with you on WhatsApp. After editing, we will send them to WhatsApp for approval.",
            addressLine: "Address Line",
            stateIfApplicable: "State (if applicable)",
            zipCodeOrPostCode: "Zip Code/Postal Code",
            selectCountry: "Select Country",
            selectBusinessVertical: "Select Business Area",
            saveInfo: "Save Information",
            active: "Active",
            banned: "Banned",
            low: "Low",
            medium: "Medium",
            high: "High",
            connected: "Connected",
            disConnected: "Disconnected",
            flagged: "Flagged",
            pending: "Pending",
            restricted: "Restricted",
            unknown: "Unknown",
            available: "Available",
            limited: "Limited",
            blocked: "Blocked",
            success: "Success",
            successDesc: "Your profile information was successfully updated.",
            wabaOverview: "WABA Health Overview",
            manageChannelDetail: "Manage your channel information",
            wpBussChannelDetail: "WhatsApp Business Channel Detail",
            manageWpBussChannel: "Manage your WhatsApp business channel",
            channelName: "Channel Name",
            phoneNumberE164: "Phone Number",
            phoneNumberE164Place: "Phone Number e.g. 908501234455",
            channelUpdatedSucs: "Channel updated successfully",
            failedUpdateChannel: "Failed to update channel",
            title: "Whatsapp Business API Kanäle",
            integration: "Integration",
            detail: "Detail",
            visibility: "Sichtbarkeit",
            templates: "Alle Vorlagen-Nachrichten",
            settings_group: "Einstellung",
            template_message_group: "Vorlagen-Nachrichten",
            chat_initiator_template: "Chat-Initiierungsvorlage",
            contacts: "Kontakte",
            numbers: "Zahlen",
            all_contacts: "Alle Kontakte",
            new_template: "Neue Vorlage erstellen",
            broadcast_group: "Rundsendung",
            broadcast_requests: "Rundsende-Anfragen",
            customer_groups: "Kundengruppen",
            businessChannelDetail: "Whatsapp Business Kanaldetails",
            wallet: "Wallet",
            postacellMessage: "SMS senden",
            postacellAllMessage: "Massen-SMS senden",
            message_group: "Nachricht",
            createNewTemplate: "Neue Vorlagennachricht erstellen",
            templateName: "Vorlagenname",
            templateNameDesc: "Geben Sie Ihrem Nachrichtenvorlagen einen Namen.",
            templateInfo: "Informationen zur Vorlage",
            viewTemplates: "Vorlagen anzeigen",
            templateNameRules: "Der Vorlagenname darf nur Kleinbuchstaben, Zahlen und Unterstriche enthalten.",
            category: "Kategorie",
            categoryDesc: "Wählen Sie aus, welche Art von Vorlage Sie erstellen möchten",
            categoryUtility: "Dienstprogramm",
            categoryUtilityDesc:
                "Senden Sie nützliche Informationen wie Kontoupdates, Bestellupdates, Warnungen und mehr.",
            categoryMarketing: "Marketing",
            categoryMarketingDesc:
                "Senden Sie Werbeangebote, Produktangebote und mehr, um die Aufmerksamkeit und Interaktion zu erhöhen.",
            categoryAuth: "Authentifizierung",
            categoryAuthDesc: "Senden Sie Codes, damit Ihre Kunden auf ihre Konten zugreifen können.",
            optional: "Optional",
            languageDesc: "Wählen Sie die Sprache aus, in der Ihre Vorlagennachricht gesendet wird",
            header: "Header",
            headerRules:
                "Fügen Sie Ihrer Nachricht einen 60 Zeichen langen Header hinzu. Im Header wird nur eine Variable unterstützt.",
            headerOptionMedia: "Medien",
            headerOptionText: "Text",
            none: "Keiner",
            headerType: "Headertyp",
            headerText: "Headertext",
            body: "Körper",
            bodyRules: "Geben Sie den Text in der von Ihnen für Ihre Nachricht ausgewählten Sprache ein",
            addVariable: "Variable hinzufügen",
            variables: "Variablen",
            variable: "Variable",
            defaultVariableName: "Standardvariablenname",
            defaultVariableToolTip:
                "Ihre Variable erscheint im Template mit diesem Namen. <br><br> Darüber hinaus wird dieser Wert als Standardwert gesendet, falls andere Situationen auftreten.",
            selectATemplate: "Wählen Sie eine Nachrichtenvorlage",
            variableSettings: "Variablen-Einstellungen",
            example: "Beispiel",
            footer: "Fußzeile",
            footerDesc:
                "Fügen Sie Ihrer Nachricht eine Fußzeile mit 60 Zeichen hinzu. Variablen werden in der Fußzeile nicht unterstützt.",
            buttons: "Schaltflächen",
            buttonType: "Schaltflächentyp",
            buttonTypeReply: "Antworten",
            submit: "Speichern",
            submitting: "Wird übermittelt",
            addButton: "Schaltfläche hinzufügen",
            rejectWhatsapp: "Von Whatsapp abgelehnt.",
            approvedWhatsapp: "Von Whatsapp genehmigt.",
            pendingWhatsapp: "Ausstehende Genehmigung",
            daily_usages: "Tägliche Verbräuche",
        },
        multi_whatsapp_api: {
            profile: "Profil",
            integration: "Integration",
            detail: "Detail",
            visibility: "Sichtbarkeit",
            templates: "Alle Vorlagenmeldungen",
            settings_group: "Einstellung",
            template_message_group: "Vorlagennachrichten",
            new_template: "Neue Vorlage erstellen",
            broadcast_group: "Bulk-Nachricht",
            broadcast_requests: "Massenversand von Nachrichten",
            customer_groups: "Kundengruppen",
            chat_initiator_template: "Chat-Initiator-Vorlage",
            contacts: "Kontakte",
            numbers: "Nummern",
            all_contacts: "Alle Kontakte",
        },
        archive: {
            destroyedBy: {
                agent: "Vertreter",
                visitor: "Besucher",
                system: "System",
                chatbot: "Chatbot",
            },
        },
        upgradeMessages: {
            ticket: "Auch wenn Sie offline sind, werden Ihre Anfragen sofort mit künstlicher Intelligenz und Chatbot erfasst. Halten Sie Ihre Kunden immer zufrieden!",
            tasks: "Verwalten Sie Ihre Aufgaben und Projekte einfach. Arbeiten Sie mit Ihren Teammitgliedern zusammen und liefern Sie Ihre Projekte rechtzeitig!",
            calendar:
                "Planen Sie Ihre Termine und Besprechungen einfach. Synchronisieren Sie sich mit Ihren Teammitgliedern und nutzen Sie Ihre Zeit effizienter!",
            mail_integration:
                "Verwalten Sie Ihre E-Mails einfach. Stärken Sie die Kommunikation mit Ihren Kunden und steigern Sie die Zusammenarbeit!",
            team_integration:
                "Kommunizieren Sie schneller und effektiver mit Ihrem Team. Steigern Sie die Zusammenarbeit und liefern Sie Ihre Projekte rechtzeitig!",
            webhook_integration:
                "Verknüpfen Sie Ihre Anwendungen mit Webhook-Integration und erleichtern Sie den Datenaustausch!",
            whatsapp_v2: "Kommunizieren Sie schneller und effektiver mit Ihren Kunden über WhatsApp-Integration!",
            whatsapp: "Kommunizieren Sie schneller und effektiver mit Ihren Kunden über WhatsApp-Integration!",
            whatsapp_business_api:
                "Kommunizieren Sie schneller und effektiver mit Ihren Kunden über WhatsApp-Integration!",
            instagram: "Kommunizieren Sie schneller und effektiver mit Ihren Kunden über Instagram-Integration!",
            messenger: "Kommunizieren Sie schneller und effektiver mit Ihren Kunden über Messenger-Integration!",
            sms_postacell: "Kommunizieren Sie schneller und effektiver mit Ihren Kunden über SMS-Integration!",
            ready_contents:
                "Mit fertigen Inhalten können Sie die Kommunikation mit Ihren Kunden schneller und effektiver gestalten.",
            automation:
                "Automatisieren Sie Ihre Aufgaben mit Automatisierung. Verwalten Sie Ihre Arbeit schneller und effektiver!",
            form: "Formularerstellung ermöglicht eine schnellere und effektivere Kommunikation mit Ihren Kunden. Sammeln Sie mehr Informationen von Ihren Kunden und steigern Sie die Zusammenarbeit!",
            customer_tables:
                "Erstellen Sie mit Customer Tables Ihre eigene Tabelle und speichern und verwalten Sie Kundeninformationen schnell und einfach!",
            trendyol: "Kommunizieren Sie schneller und effektiver mit Ihren Kunden über Trendyol-Integration!",
            access_control: "Schützen Sie Ihre Daten und blockieren Sie böswillige Benutzer mit Access Control!",
            upgrade: "Mein Abonnement upgraden",
            upgradeFeature: "Zusätzliches Paket kaufen",
            featureNotAvailable: "Ihre Funktion ist nicht verfügbar.",
            usageLimitExceeded: "Nutzungsgrenze überschritten.",
            maxAgentCount: "Erweitern Sie Ihr Paket, um mehr Kunden durch zusätzliche Agenten zu betreuen.",
            maxTriggerCount: "Erweitern Sie Ihr Paket, um mehr Interaktionen durch zusätzliche Trigger zu erstellen.",
            visitorStartChat:
                "Erweitern Sie Ihr Paket, um Chats mit Besuchern zu starten, die zuvor nicht interagiert haben.",
            voiceCalling: "Erweitern Sie Ihr Paket, um effektiver mit Kunden per Sprachanruf zu kommunizieren.",
            videoCalling: "Erweitern Sie Ihr Paket, um effektiver mit Kunden per Videoanruf zu kommunizieren.",
            fileAndVoiceMessage: "Erweitern Sie Ihr Paket, um Dateien und Sprachnachrichten an Ihre Kunden zu senden.",
            autoTranslation: "Erweitern Sie Ihr Paket, um mit automatischer Übersetzung mehr Kunden zu erreichen.",
            telegramEntegration: "Erweitern Sie Ihr Paket, um die Telegram-Integration zu aktivieren.",
            chatCopilot: "Erweitern Sie Ihr Paket, um besseren Service mit dem KI-gestützten Chat Copilot zu bieten.",
            calenderEntegration:
                "Erweitern Sie Ihr Paket, um andere Anwendungen über die Kalenderintegration zu synchronisieren.",
            mailEntegration:
                "Erweitern Sie Ihr Paket, um E-Mails effizienter zu verwalten und die Kundenkommunikation zu verbessern.",
            smsEntegration: "Erweitern Sie Ihr Paket, um Kunden schneller über SMS zu erreichen.",
            ticketSystem: "Erweitern Sie Ihr Paket, um Kundenanfragen effizienter mit einem Ticketsystem zu verwalten.",
            taskManagementEntegration:
                "Erweitern Sie Ihr Paket, um Arbeitsabläufe mit Aufgabenmanagement-Integration zu optimieren.",
            webhookEntegration:
                "Erweitern Sie Ihr Paket, um andere Anwendungen über Webhook-Integration zu synchronisieren.",
            readyContents:
                "Erweitern Sie Ihr Paket, um die Kundenkommunikation mit vorgefertigten Inhalten zu verbessern.",
            automationEntegration:
                "Erweitern Sie Ihr Paket, um Arbeitsabläufe mit Automatisierungsintegration zu optimieren.",
            customerTablesEntegration:
                "Erweitern Sie Ihr Paket, um Kundendaten effizienter mit Kundentabellen zu verwalten.",
            formEntegration: "Erweitern Sie Ihr Paket, um Kundenanfragen effizienter mit Formularen zu verwalten.",
            maxFormLimit:
                "Erweitern Sie Ihr Paket, um mehr Formulare zu erstellen und Kundenanfragen effizienter zu verwalten.",
            maxFormFieldLimit:
                "Erweitern Sie Ihr Paket, um mehr Formularfelder hinzuzufügen und Kundenanfragen besser zu verwalten.",
            maxCustomerTableCount: "Erweitern Sie Ihr Paket, um mehr Kundentabellen hinzuzufügen.",
            maxCustomerTableFieldCount: "Erweitern Sie Ihr Paket, um mehr Felder in Kundentabellen hinzuzufügen.",
            maxCustomerTableViewCount: "Erweitern Sie Ihr Paket, um mehr Ansichten für Kundentabellen zu speichern.",
            maxCustomerTableRecordCount: "Erweitern Sie Ihr Paket, um mehr Einträge in Kundentabellen hinzuzufügen.",
            maxAutomationButton: "Erweitern Sie Ihr Paket, um mehr Automatisierungsblöcke hinzuzufügen.",
            automationTimerBase: "Erweitern Sie Ihr Paket, um Automatisierungstimer zu verwenden.",
            automationEventBase: "Erweitern Sie Ihr Paket, um Automatisierungsereignisse zu nutzen.",
            automationWebhookBase: "Erweitern Sie Ihr Paket, um Automatisierungs-Webhooks zu verwenden.",
            automationButtonBase: "Erweitern Sie Ihr Paket, um Automatisierungsschaltflächen zu verwenden.",
            liveScore: "Erweitern Sie Ihr Paket, um die Live-Überwachungsfunktion zu aktivieren.",
            multipleChatWindow: "Erweitern Sie Ihr Paket, um mehrere Chatfenster gleichzeitig zu öffnen.",
            maxTaskWorkflowLimit: "Erweitern Sie Ihr Paket, um mehr Aufgaben-Workflows hinzuzufügen.",
            maxTaskColumnLimit: "Erweitern Sie Ihr Paket, um mehr Aufgabenspalten hinzuzufügen.",
            maxTaskRowLimit: "Erweitern Sie Ihr Paket, um mehr Aufgabenreihen hinzuzufügen.",
            maxDepartmentLimit: "Erweitern Sie Ihr Paket, um mehr Abteilungen hinzuzufügen.",
            maxRoleLimit: "Erweitern Sie Ihr Paket, um mehr Rollen hinzuzufügen.",
            maxReadyContentsLimit: "Erweitern Sie Ihr Paket, um mehr vorgefertigte Inhalte hinzuzufügen.",
            excelDownload: "Erweitern Sie Ihr Paket, um die Excel-Download-Funktion zu aktivieren.",
            customerGroup: "Erweitern Sie Ihr Paket, um die Kundengruppen-Funktion zu nutzen.",
            maxMailCount: "Erweitern Sie Ihr Paket, um mehr E-Mails zu senden.",
            maxWhatsappChannel: "Erweitern Sie Ihr Paket, um mehr WhatsApp-Kanäle hinzuzufügen.",
            maxBusinessWhatsappChannel: "Erweitern Sie Ihr Paket, um mehr WhatsApp-Business-Kanäle hinzuzufügen.",
            maxInstagramChannel: "Erweitern Sie Ihr Paket, um mehr Instagram-Kanäle hinzuzufügen.",
            maxMessengerChannel: "Erweitern Sie Ihr Paket, um mehr Messenger-Kanäle hinzuzufügen.",
            maxTelegramChannel: "Erweitern Sie Ihr Paket, um mehr Telegram-Kanäle hinzuzufügen.",
            maxTrendyolChannel: "Erweitern Sie Ihr Paket, um mehr Trendyol-Kanäle hinzuzufügen.",
            maxMetaLeadChannel: "Erweitern Sie Ihr Paket, um mehr Meta-Lead-Kanäle hinzuzufügen.",
        },
        setupWizard: {
            finishModalVideos: "Schulungsvideos",
            finishModalDoc: "Dokumentation",
            finsihModalLiveSupport: "Live-Support",
            completed: "Alles klar, verstanden",
            completedWarning: "Klicken Sie auf die Schaltfläche, um die Einrichtung abzuschließen und den Leitfaden zu beenden",
            supsisSetupGuide: "Supsis Einrichtungshandbuch",
            supsisSetupGuideDescription: "Bitte führen Sie diese Schritte aus, um Supsis vollständig zu nutzen.",
            goToSetup: "Zur Einrichtung gehen",
            completionPercentageDescription: "Sie nutzen nur % {percentage} der von Supsis angebotenen Funktionen.",
            aiChatbot: {
                title: "KI-Chatbot",
                content: "Antworten Sie automatisch, sofort und intelligent auf eingehende Nachrichten mit dem Supsis KI-Chatbot.",
                steps: {
                    step1: {
                        title: "Chatbot erstellen",
                        content: "Verwenden Sie diese Schaltfläche, um ein neues <b>Chatbot-Szenario</b> zu erstellen. Sie können entweder schnell mit einer der speziell für Sie vorbereiteten Vorlagen beginnen oder ein völlig originelles Szenario von Grund auf entwerfen, um einen Chatbot zu erstellen, der Ihren Geschäftsanforderungen vollständig entspricht."
                    },
                    step2: {
                        title: "Vorgefertigte Szenarien",
                        content: "Verstehen Sie die grundlegende Arbeitslogik des Chatbots einfach mit den <b>vorgefertigten Vorlagen</b> hier. Sparen Sie Zeit, indem Sie diese Vorlagen nach Ihren Bedürfnissen anpassen und maßgeschneiderte Lösungen entwickeln. Sie können mit einer der unten aufgeführten Vorlagen beginnen, die für verschiedene Anwendungsfälle geeignet sind."
                    },
                    step3: {
                        title: "Chatbot-Integrationen",
                        content: "Integrieren Sie Ihren vorbereiteten Chatbot mit <b>beliebten sozialen Medienplattformen wie WhatsApp, Instagram und Facebook</b>. Auf diese Weise können Sie Ihren Chatbot direkt auf den Kanälen aktivieren, die Ihre Kunden nutzen, und Ihre Erreichbarkeit und Engagement-Raten erhöhen."
                    },
                    step4: {
                        title: "Chatbot-Analysen",
                        content: "Sehen und analysieren Sie die <b>Leistung Ihres Chatbots mit detaillierten Diagrammen und Statistiken</b>. Durch Filterung nach bestimmten Zeiträumen oder den Plattformen, die Sie integriert haben, können Sie die Wirksamkeit Ihres Chatbots messen, Verbesserungsbereiche identifizieren und Ihre Strategien optimieren."
                    }
                }
            },
            aiAssistant: {
                title: "KI-Assistent",
                content: "Aktivieren Sie den digitalen Assistenten, um Ihrem Support-Team zu helfen.",
                steps: {
                    step1: {
                        title: "OpenAI-Integration",
                        content: "<p>Etablieren Sie eine <b>nahtlose Integration</b> zwischen OpenAI und Supsis KI, um Ihre Geschäftseffizienz zu steigern. Auf diese Weise wird Ihr leistungsstarker KI-Assistent aktiviert und beginnt, Ihre Prozesse zu optimieren. Um die Integration abzuschließen, müssen Sie nur Ihren OpenAI API-Schlüssel eingeben. <br> <br> <b>Um Ihren OpenAI API-Schlüssel zu erhalten, <a href='https://platform.openai.com/account/api-keys' target='_blank'>klicken Sie hier</a>.</b></p>"
                    }
                }
            },
            aiLiveSupport: {
                title: "KI Live-Support",
                content: "Aktivieren Sie das KI-gestützte Live-Chat-System.",
                steps: {
                    step1: {
                        title: "Gespräche filtern",
                        content: "Verwalten Sie <b>alle Kundengespräche</b> einfach aus diesem Bereich. Sie können Gespräche priorisieren, indem Sie sie in verschiedene Kategorien wie ungelesen, ausstehend oder solche, die mit dem Chatbot laufen, filtern und sicherstellen, dass keine Anfrage übersehen wird."
                    },
                    step2: {
                        title: "Detailliertere Ansicht",
                        content: "Verwenden Sie diese Optionen, um Kundengespräche tiefgreifender zu untersuchen. Sie können <b>detailliertere Filter</b> wie unbeantwortete Gespräche von gestern oder bestimmte Kunden, die Sie kontaktiert haben, anwenden oder Ihre eigenen benutzerdefinierten Filter erstellen, um Ihren Arbeitsablauf zu personalisieren."
                    },
                    step3: {
                        title: "Live-Support-Bildschirm",
                        content: "Wechseln Sie zu dieser Ansicht, um <b>alle Ihre Live-Support-Gespräche effizient von einem zentralisierten Bildschirm aus zu verwalten</b>. Sehen Sie alle Nachrichten, Agenten-Antworten, aktuelle Status und Datumsinformationen für jedes Gespräch an einem Ort und treffen Sie schnelle und genaue Entscheidungen."
                    },
                    step4: {
                        title: "Testseite",
                        content: "Greifen Sie auf diesen Bereich zu, um die Leistung und den Betrieb Ihres erstellten Chatbots in Echtzeit zu testen. Indem Sie Nachrichten als Besucher senden, können Sie <b>die Antworten und Verhaltensweisen Ihres Chatbots genau beobachten</b> und alle notwendigen Verbesserungen vornehmen, bevor Sie ihn den Endbenutzern präsentieren."
                    }
                }
            },
            aiAutomation: {
                title: "KI-Automatisierung",
                content: "Automatisieren Sie Ihre Support-Prozesse und sparen Sie Zeit.",
                steps: {
                    step1: {
                        title: "Neue Automatisierung erstellen",
                        content: "Verwenden Sie diese Schaltfläche, um eine neue Automatisierung zu erstellen und Ihre Geschäftsprozesse zu rationalisieren. Sie können Automatisierungen entwerfen, die ereignisbasiert (z.B. wenn eine neue Nachricht ankommt), zeitbasiert (z.B. jeden Morgen zu einer bestimmten Zeit) oder <b>Webhook-basiert</b> sind, um Ihre Arbeitsabläufe intelligenter zu gestalten."
                    },
                    step2: {
                        title: "Automatisierungskategorien",
                        content: "Wenn Sie viele Automatisierungen haben, erstellen Sie <b>Automatisierungskategorien</b> aus diesem Bereich, um die Verwaltung zu erleichtern. Die Kategorisierung hilft Ihnen, Ihre Automatisierungen organisiert zu halten und sie bei Bedarf schnell zu finden. Verwenden Sie diese Schaltfläche, um eine neue Kategorie zu erstellen."
                    },
                    step3: {
                        title: "Ausgeführte Aufgaben",
                        content: "Nachdem Sie Ihre Automatisierungen erstellt und veröffentlicht haben, können Sie <b>sofort verfolgen, wie viele Aufgaben Ihre Automatisierungen ausgeführt haben</b> aus diesem Bereich. Dies ermöglicht es Ihnen zu beobachten, wie aktiv Ihre Automatisierungen sind und welche Prozesse sie beeinflussen."
                    },
                    step4: {
                        title: "Automatisierungsstatistiken",
                        content: "Überprüfen Sie <b>umfassende Leistungsstatistiken</b> Ihrer Automatisierungen in diesem Bereich. Sehen Sie, wie oft jede Automatisierung läuft, die Anzahl erfolgreicher Aufgaben, die Erfolgsrate und eventuelle Fehlerquoten, um Ihre Automatisierungsstrategien zu optimieren."
                    }
                }
            },
            aiDynamicCrm: {
                title: "KI-CRM",
                content: "Analysieren und verwalten Sie Ihre Kundeninteraktionen mit künstlicher Intelligenz.",
                steps: {
                    step1: {
                        title: "Besucher filtern",
                        content: "Filtern Sie <b>Besucher</b> in Ihrer Kundendatenbank einfach. Sie können nach Besuchern anhand von Name, E-Mail-Adresse, Telefonnummer, Tag oder benutzerdefinierten Profilfeldern suchen. Sie können auch auf diesen Bereich für eine detailliertere Anzeige und Analyse zugreifen."
                    },
                    step2: {
                        title: "Besucher anzeigen",
                        content: "Alle Ihre Besucher sind in dieser Tabelle aufgelistet. <b>Doppelklicken Sie auf die entsprechende Zeile, um weitere Informationen zu erhalten und Aktionen für einen Besucher durchzuführen</b>. Im geöffneten Fenster können Sie auf die Kommunikationshistorie, Notizen und andere detaillierte Informationen des Besuchers zugreifen."
                    },
                    step3: {
                        title: "Manuelles Blockieren",
                        content: "Sie können <b>Besucher manuell blockieren</b>, die unerwünschtes oder unangemessenes Verhalten zeigen. Blockierte Besucher werden in einer separaten Liste angezeigt, und Sie können die Blockierung bei Bedarf aus diesem Bereich entfernen."
                    },
                    step4: {
                        title: "Tags",
                        content: "Machen Sie Ihr CRM organisierter und verwaltbarer, indem Sie <b>Ihre Besucher mit Tags kategorisieren</b>. Um Besuchern Tags zuzuweisen, müssen Sie zunächst Ihre eigenen Tags erstellen. Verwenden Sie diese Schaltfläche, um ein neues Tag zu erstellen."
                    },
                    step5: {
                        title: "Profilfelder",
                        content: "<b>Profilfelder</b> ermöglichen es Ihnen, zusätzliche Informationen über Ihre Besucher zu sammeln und diese Informationen organisiert zu verwalten. Auf diese Weise können Sie Ihre Kundensegmentierung vertiefen, personalisierten Service anbieten und Ihre Kundenbeziehungen effektiver gestalten."
                    }
                },
            },
            whatsappBusiness: {
                title: "WhatsApp Business",
                content: "Verwalten Sie Ihre Support-Nachrichten, indem Sie Ihr WhatsApp Business-Konto verbinden.",
                steps: {
                    step1: {
                        title: "WhatsApp Business-Integration",
                        content: "<p><b>Verbinden Sie Ihr WhatsApp Business-Konto mit Supsis</b> und verwalten Sie alle Ihre Kundensupport-Nachrichten von einem einzigen zentralen Panel aus. Mit dieser Integration können Sie Sofortnachrichten über WhatsApp senden, Massenmitteilungen machen, automatisierte Antworten einrichten und Ihre Kundeninteraktionen umfassend verfolgen.</p>"
                    }
                }
            },
            whatsappWeb: {
                title: "WhatsApp Web",
                content: "Verwalten Sie über WhatsApp Web empfangene Nachrichten mit Supsis KI.",
                steps: {
                    step1: {
                        title: "WhatsApp Web-Integration",
                        content: "<p><b>Verwalten Sie nahtlos alle über WhatsApp Web empfangenen Nachrichten mit Supsis KI.</b> Mit dieser Integration können Sie Sofortnachrichten über WhatsApp senden, Massennachrichten erstellen, automatisierte Antworten einrichten und Ihre Kundeninteraktionen einfach verfolgen. Auf diese Weise machen Sie Ihre Kundenkommunikation effizienter.</p>"
                    }
                }
            },
            instagram: {
                title: "Instagram",
                content: "Antworten Sie auf Instagram-DMs über Supsis KI.",
                steps: {
                    step1: {
                        title: "Instagram-Integration",
                        content: "<p><b>Zentralisieren Sie Ihre Kundenkommunikation, indem Sie direkt auf Instagram-DMs über Supsis KI antworten.</b> Mit dieser Integration können Sie Sofortnachrichten über Instagram senden, Massenmitteilungen machen, automatisierte Antworten einrichten und Ihre Kundeninteraktionen umfassend verfolgen.</p>"
                    }
                }
            },
            facebook: {
                title: "Facebook",
                content: "Verwalten Sie Nachrichten von Ihrer Facebook-Seite in einem einzigen Panel.",
                steps: {
                    step1: {
                        title: "Facebook-Integration",
                        content: "<p><b>Verwalten Sie alle Nachrichten von Ihrer Facebook-Seite effektiv mit Supsis KI.</b> Mit dieser Integration können Sie Sofortnachrichten über Facebook Messenger senden, Massennachrichten erstellen, automatisierte Antworten einrichten und Ihre Kundeninteraktionen verfolgen.</p>"
                    }
                }
            },
            telegram: {
                title: "Telegram",
                content: "Integrieren Sie Telegram-Nachrichten mit Supsis KI.",
                steps: {
                    step1: {
                        title: "Telegram-Integration",
                        content: "<p><b>Integrieren Sie Telegram-Nachrichten mit Supsis KI</b> und verwalten Sie Ihre Kundenkommunikation von einem einzigen Panel aus. Mit dieser Integration können Sie Sofortnachrichten über Telegram senden, Massennachrichten erstellen, automatisierte Antworten einrichten und alle Ihre Kundeninteraktionen mühelos verfolgen.</p>"
                    }
                }
            },
            mail: {
                title: "E-Mail",
                content: "Integrieren Sie Ihre Support-E-Mails in das Supsis KI-System.",
                steps: {
                    step1: {
                        title: "Neue E-Mail erstellen",
                        content: "<p>Verwenden Sie diese Schaltfläche, um eine neue E-Mail zu senden. <b>Durch Ausfüllen des E-Mail-Inhalts, der Empfänger und anderer notwendiger Informationen</b> können Sie Ihre persönlichen oder Massen-E-Mails schnell versenden.</p>"
                    },
                    step2: {
                        title: "E-Mail-Vorlagen",
                        content: "<p><b>Verwalten Sie</b> Ihre E-Mail-Vorlagen aus diesem Bereich. Sie können Vorlagen bearbeiten, löschen oder neue erstellen. Durch die Verwendung vorgefertigter Vorlagen können Sie Ihre E-Mail-Versandprozesse beschleunigen und eine konsistente Kommunikation gewährleisten.</p>"
                    },
                    step3: {
                        title: "Massen-E-Mails senden",
                        content: "<p>Verwenden Sie diesen Bereich, um <b>Massen-E-Mails zu senden</b> und große Zielgruppen zu erreichen. Durch Ausfüllen der erforderlichen Felder können Sie einfach Massen-E-Mails an Ihre Kundenliste oder bestimmte Gruppen in Supsis senden.</p>"
                    },
                    step4: {
                        title: "Verwalten Sie Ihre Kundengruppen",
                        content: "<p><b>Verwalten Sie effektiv</b> Ihre Kundengruppen aus diesem Bereich. Sie können Gruppen bearbeiten, löschen oder neue erstellen. Mit diesen Gruppen können Sie gezielte E-Mail-Kampagnen organisieren und Ihre Kommunikation noch mehr personalisieren.</p>"
                    }
                }
            },
            metaLead: {
                title: "Meta Lead",
                content: "Verwalten Sie Formulare, die von Ihren Facebook- und Instagram-Anzeigen empfangen wurden.",
                steps: {
                    step1: {
                        title: "Meta Lead-Integration",
                        content: "<p>Mit der <b>Meta Lead-Integration</b> verwalten Sie potenzielle Kundenformulare, die von Ihren Facebook- und Instagram-Anzeigen empfangen wurden, direkt über Supsis. Dank dieser Integration können Sie die Leads, die Sie aus Ihren Werbekampagnen erhalten, effizienter verfolgen, Ihre Kommunikation mit potenziellen Kunden beschleunigen und Ihre Konversionsraten erhöhen.</p>"
                    }
                }
            },
            trendyol: {
                title: "Trendyol",
                content: "Verwalten Sie Ihre Trendyol-Bestellungen und Kundennachrichten.",
                steps: {
                    step1: {
                        title: "Trendyol-Integration",
                        content: "<p>Dank der <b>Trendyol-Integrationsvorgänge</b> verwalten Sie Ihre über Trendyol erhaltenen Bestellungen zentral über Supsis. Nach Abschluss dieser Integration können Sie Ihre Bestellprozesse effizienter gestalten, Ihre Kundenkommunikation erleichtern und Ihre operative Arbeitsbelastung reduzieren.</p>"
                    }
                }
            },
            formSurvey: {
                title: "Formular-Umfragen",
                content: "Erstellen Sie Formulare, um Feedback von Kunden zu sammeln.",
                steps: {
                    step1: {
                        title: "Neues Formular erstellen",
                        content: "<p>Verwenden Sie diese Schaltfläche, um <b>ein neues Formular oder eine Umfrage zu erstellen</b>, um Feedback von Ihren Kunden zu sammeln. Mit den Formularen, die Sie erstellen, können Sie wertvolles Kundenfeedback sammeln und Ihre Kommunikation effizienter gestalten.</p>"
                    },
                    step2: {
                        title: "Verwalten Sie Ihre Formulare",
                        content: "<p><b>Verwalten Sie alle Ihre Formulare effektiv</b> aus diesem Bereich. Sie können Formulare bearbeiten, archivieren, löschen oder neue erstellen. Sie können auch die Leistung Ihrer veröffentlichten Formulare verfolgen, Antwortquoten anzeigen und bei Bedarf sofortige Bearbeitungen vornehmen. Mit der Formularverwaltung können Sie Kundenfeedback effektiver sammeln und analysieren.</p>"
                    }
                }
            },
            processManagement: {
                title: "Prozessmanagement",
                content: "Planen und verwalten Sie Ihre Support-Prozesse Schritt für Schritt.",
                steps: {
                    step1: {
                        title: "Verwalten Sie Ihre Geschäftsprozesse",
                        content: "<p>Dieser Bereich ermöglicht es Ihnen, alle Ihre Geschäftsprozesse effektiv zu verwalten. <b>Sie können Aufgaben erstellen, sie Ihren Teammitgliedern zuweisen und Ihre Arbeitsabläufe optimieren.</b> Auf diese Weise können Sie Ihre Prozesse effizienter gestalten, den Status von Aufgaben sofort verfolgen und die Leistung Ihres Teams steigern.</p>"
                    },
                    step2: {
                        title: "Aufgaben auflisten",
                        content: "<p><b>Zeigen Sie alle Ihre Aufgaben in einer Listenansicht</b> aus diesem Bereich an. Sie können Aufgaben filtern, löschen oder neue erstellen. Verfolgen Sie Ihre Arbeitsbelastung einfach mit einer umfassenden Listenansicht.</p>"
                    },
                    step3: {
                        title: "Aufgaben-Labels",
                        content: "<p><b>Erstellen Sie Labels</b>, um Ihre Aufgaben besser zu organisieren und zu verwalten. Durch die Verwendung dieser Labels können Sie Aufgaben einfach kategorisieren und Ihre Suchprozesse beschleunigen. Sie können diese Schaltfläche verwenden, um Labels zu erstellen.</p>"
                    },
                    step4: {
                        title: "Aufgaben archivieren",
                        content: "<p><b>Archivieren Sie abgeschlossene oder inaktive Aufgaben, um Ihren Arbeitsbereich organisiert zu halten</b>. Archivierte Aufgaben werden hier aufgelistet und können bei Bedarf einfach wiederhergestellt werden.</p>"
                    },
                    step5: {
                        title: "Abgeschlossene Aufgaben",
                        content: "<p>Zeigen Sie Ihre <b>abgeschlossenen Aufgaben</b> aus diesem Bereich an. Sie können den Status abgeschlossener Aufgaben ändern und sie bei Wunsch archivieren. Auf diese Weise können Sie eine Aufzeichnung Ihrer abgeschlossenen Arbeit führen und vergangene Leistungen analysieren.</p>"
                    }
                }
            },
            calendar: {
                title: "Kalender",
                content: "Verwalten Sie Ihren Besprechungs- und Aufgabenkalender.",
                steps: {
                    step1: {
                        title: "Kalender",
                        content: "<p>Planen Sie Ihre Besprechungen täglich einfach mit diesem interaktiven <b>Kalender</b>. Sie können neue Termine erstellen, bestehende Besprechungen über den Kalender aktualisieren oder sie absagen. Optimieren Sie Ihr Terminmanagement und kontrollieren Sie effektiv Ihren Zeitplan.</p>"
                    },
                    step2: {
                        title: "Reservierungswebsite",
                        content: "<p>Ermöglichen Sie Ihren Kunden, einfach Termine zu vereinbaren, indem Sie Ihre eigene <b>Reservierungswebsite</b> verwenden. Ihre Kunden können Reservierungen vornehmen, ihre bestehenden Termine anzeigen, aktualisieren oder stornieren über diese Seite.</p>"
                    },
                    step3: {
                        title: "Ihre Website anzeigen",
                        content: "<p>Verwenden Sie diese Schaltfläche, um die von Ihnen erstellte Reservierungswebsite sofort anzuzeigen. <b>Überprüfen Sie die endgültige Version Ihrer Website</b> und erleben Sie, wie Ihre Kunden ihre Reservierungen sehen werden. Alle Ihre aktiven Reservierungen werden auf Ihrer Website aufgelistet.</p>"
                    },
                    step4: {
                        title: "Neue Reservierung erstellen",
                        content: "<p>Verwenden Sie diese Schaltfläche, um <b>manuell eine neue Reservierung zu erstellen</b>. Durch Ausfüllen aller notwendigen Informationen können Sie den Termin schnell zu Ihrem Kalender hinzufügen und Ihre Besprechungen mit Ihren Kunden planen.</p>"
                    }
                }
            },
            websiteAnalysis: {
                title: "Website-Analyse",
                content: "Analysieren Sie das Besucherverhalten und gewinnen Sie Erkenntnisse.",
                steps: {
                    step1: {
                        title: "Gesamtbesucher",
                        content: "<p>Zeigen Sie die <b>Gesamtzahl der Besucher</b> Ihrer Website aus diesem Bereich an. Diese Metrik zeigt die Gesamtzahl der eindeutigen Besucher Ihrer Seite innerhalb eines bestimmten Zeitraums und hilft Ihnen, die Gesamtreichweite Ihrer Seite zu verstehen.</p>"
                    },
                    step2: {
                        title: "Durchschnittliche Besucher",
                        content: "<p>Verfolgen Sie die <b>durchschnittliche tägliche oder periodische Anzahl der Besucher</b> Ihrer Website hier. Diese Metrik ist ein kritischer Indikator für die Bewertung der konsistenten Leistung Ihrer Seite über die Zeit.</p>"
                    },
                    step3: {
                        title: "Maximale Besucher",
                        content: "<p>Beobachten Sie die <b>Zeiten, in denen Ihre Website die höchste Anzahl von Besuchern erreicht hat</b> mit dieser Metrik. Sie zeigt die höchste Anzahl von Besuchern Ihrer Seite innerhalb eines bestimmten Zeitraums und hilft Ihnen, Spitzenzeiten für Kampagnen oder Inhalte zu identifizieren.</p>"
                    },
                    step4: {
                        title: "Minimale Besucher",
                        content: "<p>Verfolgen Sie die <b>Zeiten, in denen Ihre Website die wenigsten Besucher erhalten hat</b> mit dieser Metrik. Sie zeigt die niedrigste Anzahl von Besuchern Ihrer Seite innerhalb eines bestimmten Zeitraums und hilft Ihnen, leistungsschwache Perioden zu identifizieren und notwendige Maßnahmen zu ergreifen.</p>"
                    }
                }
            },
            ticketSystem: {
                title: "Support-Ticket-System",
                content: "Organisieren Sie Kundenanfragen mit einem Ticket-System.",
                steps: {
                    step1: {
                        title: "Neuer Status",
                        content: '<p><b>Erstellen Sie neue Status</b>, um die Verwaltung Ihrer Support-Anfragen zu erleichtern. Zum Beispiel können Sie durch die Definition angepasster Status wie "In Bearbeitung", "Gelöst", "Ausstehend" den Ablauf von Anfragen transparenter gestalten.</p>'
                    },
                    step2: {
                        title: "Status",
                        content: '<p><b>Zeigen Sie die aktuellen Status</b> für jede hier geöffnete Support-Anfrage an. Durch die Verfolgung von Status wie "Gelesen", "Beantwortet", "Storniert" können Sie die aktuellen Phasen von Anfragen einfach sehen und ein effektives Prozessmanagement ermöglichen.</p>'
                    },
                    step3: {
                        title: "Ansichtsmodus",
                        content: "<p>Sie können zwischen <b>Listen- oder Kanban-Ansicht</b> wechseln, um Ihre Support-Anfragen effektiver zu verwalten. Durch Ändern des Ansichtsmodus können Sie die Status von Anfragen visuell verfolgen und das Layout wählen, das am besten zu Ihrem Arbeitsablauf passt.</p>"
                    }
                }
            },
            dynamicTables: {
                title: "Dynamische Tabellen",
                content: "Passen Sie Ihre Daten durch Filterung an und verwalten Sie sie.",
                steps: {
                    step1: {
                        title: "Kategorie erstellen",
                        content: "<p><b>Organisieren und verwalten Sie Ihre Daten besser, indem Sie Ihre Tabellen kategorisieren</b>. Durch die Verwendung der Kategorie-Erstellungsschaltfläche können Sie neue Kategorien definieren, Ihre Tabellen gruppieren und schneller auf die gesuchten Daten zugreifen.</p>"
                    },
                    step2: {
                        title: "Neue Tabelle erstellen",
                        content: "<p>Verwenden Sie diese Schaltfläche, um <b>eine neue dynamische Tabelle zu erstellen, die auf Ihre Bedürfnisse zugeschnitten ist</b>. Durch Ausfüllen der erforderlichen Informationen auf dem Tabellenerstellungsbildschirm können Sie Ihre Daten in einer personalisierten Struktur speichern und verwalten.</p>"
                    },
                    step3: {
                        title: "Tabelle mit KI erstellen",
                        content: "<p>Verwenden Sie diese Schaltfläche, um <b>schnell neue Tabellen mit KI-Unterstützung zu erstellen</b>. Es reicht aus, die relevanten Informationen einzugeben, um eine Tabelle mit KI zu erstellen; das System hilft Ihnen dabei, effiziente Tabellen mit intelligenten Vorschlägen zu entwerfen.</p>"
                    }
                }
            },
            aiVoice: {
                title: "KI-Sprach-Agent",
                content: "Verwalten Sie die Gespräche Ihrer Benutzer mit KI-gestützten Sprach-Agenten.",
                steps: {
                    step1: {
                        title: "KI-Sprach-Agent-Integration",
                        content: "<p><b>Integrieren Sie Ihren KI-Sprach-Agent in Supsis</b>, um Ihre Kundenkommunikationsprozesse zu automatisieren und zu verbessern. Nach Abschluss der Integration können Sie Sprachinteraktionen effizienter verwalten und die Kundenzufriedenheit steigern.</p>"
                    }
                }
            }
        }
    },
};

export default messagesDE;
